// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Author         : G-axon
Template Name  : Jumbo React - Admin Template
Version        : 1.0
*/
/*=============================================================
    Table of Contents:
    =============================
    A. Globals
        01. Custom Animation
    B. Base
        01. Base Styles
        02. Typography Styles
    C. Layouts
        01. App Layout Styles
        02. Sidebar Styles
        03. Header Styles
        04. Main Content Styles
        05. Footer Styles
        06. Right Sidebar Styles
    D. UI Components
        01. Alert Styles
        02. Avatar Styles
        03. Badges Styles
        04. Blockquotes Styles
        05. Bottom Navigation Styles
        06. Breadcrumb Styles
        07. Button Styles
        08. Button Group Styles
        09. Callout Styles
        10. Cards Styles
        11. Charts Styles
        12. Chips Styles
        13. Carousel Styles
        14. Color Picker Styles
        15. Drawer Styles
        16. E-commerce Styles
        17. Grids List Styles
        18. Icons Styles
        19. Label Styles
        20. List Styles
        21. Nav Style
        22. Pricing Styles
        23. Progressbar Styles
        24. Popover Styles
        25. React Joyride Styles
        26. Tables Styles
        27. Tabs Styles
        28. Testimonial Styles
        29. Time Lines Style
        30. Joyride Tour Styles
        31. Form Styles
    E. Pages
        01. Login Styles
        02. Error Styles
        03. Editor Styles
        04. Contact Page Styles
        05. Portfolio Styles
        06. Faqs Styles
        07. Dashboard Styles
    F. Slider
    G. Modules
        01. App Module Style
        02. Chat Module Styles
        03. Mails Module Styles
        04. Contact Module Styles
        05. Calendar Module Style
  =============================================================*/
/* Globals
   ========================================================================== */
.jr-menu-icon .menu-icon {
  position: relative;
  width: 70%;
  height: 1px;
  min-height: 1px;
  color: inherit;
  background-color: #808080;
  display: block;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  margin: 6px 0;
  cursor: pointer; }
  .jr-menu-icon .menu-icon:after, .jr-menu-icon .menu-icon:before {
    position: absolute;
    display: block;
    color: inherit;
    background-color: inherit;
    left: 0;
    height: 1px;
    min-height: 1px;
    content: "";
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease; }
  .jr-menu-icon .menu-icon:after {
    width: 120%;
    bottom: -6px; }
  .jr-menu-icon .menu-icon:before {
    width: 130%;
    top: -6px; }

.jr-menu-icon:hover .menu-icon {
  width: 100%; }
  .jr-menu-icon:hover .menu-icon:after, .jr-menu-icon:hover .menu-icon:before {
    width: 100%; }

.size-50, .user-avatar, .jr-fab-btn, .user-list .user-avatar, .timeline-badge {
  height: 50px !important;
  width: 50px !important;
  line-height: 50px; }

.size-60, .jr-btn-fab-lg {
  height: 60px !important;
  width: 60px !important;
  line-height: 60px; }

.size-80 {
  height: 80px !important;
  width: 80px !important;
  line-height: 80px; }

.size-100 {
  height: 100px !important;
  width: 100px !important;
  line-height: 100px; }

.size-20 {
  height: 20px !important;
  width: 20px !important;
  line-height: 20px; }

.size-30, .jr-menu-icon, .jr-btn-fab-xs, .icon {
  height: 30px !important;
  width: 30px !important;
  line-height: 30px; }

.size-40, .jr-btn-fab-sm {
  height: 40px !important;
  width: 40px !important;
  line-height: 40px; }

.size-120, .profile-intro img.avatar-circle {
  height: 120px !important;
  width: 120px !important;
  line-height: 120px; }

.icon-addon {
  display: inline-block;
  text-align: center;
  background-color: inherit; }

.jr-card {
  padding: 24px 30px;
  margin-bottom: 34px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #ced4da;
  position: relative; }

/* Ripple magic */
.ripple-effect {
  position: relative;
  overflow: hidden; }
  .ripple-effect:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 5px;
    height: 5px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 0;
    border-radius: 100%;
    transform: scale(1, 1) translate(-50%);
    transform-origin: 50% 50%; }
  .ripple-effect:hover:after {
    animation: ripple 1s ease-out; }

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5; }
  20% {
    transform: scale(60, 60);
    opacity: 0.3; }
  100% {
    opacity: 0;
    transform: scale(100, 100); } }

@-webkit-keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 0.5; }
  20% {
    transform: scale(60, 60);
    opacity: 0.3; }
  100% {
    opacity: 0;
    transform: scale(100, 100); } }

.quick-menu .icon-alert:after {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -moz-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  -o-box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  box-shadow: 0 0 0 rgba(244, 67, 54, 0.4);
  animation: pulse 2s infinite; }

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4); }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0); }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0); } }

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4); }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 10px rgba(244, 67, 54, 0); }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0); } }

.chat-avatar-mode .chat-mode.online, .chat-avatar-mode .chat-mode.offline {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  -moz-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  -o-box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
  animation: online 2s infinite; }

@-webkit-keyframes online {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4); }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); } }

@keyframes online {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4); }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); } }

.chat-avatar-mode .chat-mode.away {
  display: block;
  -webkit-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  -moz-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  -o-box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  box-shadow: 0 0 0 rgba(255, 193, 7, 0.4);
  animation: away 2s infinite; }

@-webkit-keyframes away {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4); }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(255, 193, 7, 0); }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0); } }

@keyframes away {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4); }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
    box-shadow: 0 0 0 10px rgba(255, 193, 7, 0); }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0); } }

/*Different size images set in Equal block height and width*/
.grid-thumb-equal, .brand-logo {
  position: relative;
  padding-bottom: 68%;
  height: 0;
  width: 100%;
  overflow: hidden; }

.grid-thumb-cover, .brand-logo .brand-logo-inner {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%; }

.grid-thumb-cover img {
  height: auto;
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  width: 100%; }

a.btn-info, a.btn-danger, a.btn-warning, a.btn-success, a.btn-dark, a.badge-success, a.badge-danger, a.badge-warning, a.badge-info, a.badge-dark {
  color: #fff !important; }
  a.btn-info:hover, a.btn-danger:hover, a.btn-warning:hover, a.btn-success:hover, a.btn-dark:hover, a.badge-success:hover, a.badge-danger:hover, a.badge-warning:hover, a.badge-info:hover, a.badge-dark:hover, a.btn-info:focus, a.btn-danger:focus, a.btn-warning:focus, a.btn-success:focus, a.btn-dark:focus, a.badge-success:focus, a.badge-danger:focus, a.badge-warning:focus, a.badge-info:focus, a.badge-dark:focus {
    color: #fff !important; }

.carousel-control-prev, .carousel-control-next {
  cursor: pointer; }

.btn:not([disabled]):not(.disabled):active,
.btn-info:not([disabled]):not(.disabled):active,
.btn-success:not([disabled]):not(.disabled):active,
.btn-warning:not([disabled]):not(.disabled):active,
.btn-danger:not([disabled]):not(.disabled):active,
.btn-light:not([disabled]):not(.disabled):active,
.btn-dark:not([disabled]):not(.disabled):active,
.btn-primary:not([disabled]):not(.disabled):active,
.btn-secondary:not([disabled]):not(.disabled):active, .btn:not([disabled]):not(.disabled).active,
.btn-info:not([disabled]):not(.disabled).active,
.btn-success:not([disabled]):not(.disabled).active,
.btn-warning:not([disabled]):not(.disabled).active,
.btn-danger:not([disabled]):not(.disabled).active,
.btn-light:not([disabled]):not(.disabled).active,
.btn-dark:not([disabled]):not(.disabled).active,
.btn-primary:not([disabled]):not(.disabled).active,
.btn-secondary:not([disabled]):not(.disabled).active {
  background-image: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none; }
  .btn:not([disabled]):not(.disabled):active:focus,
  .btn-info:not([disabled]):not(.disabled):active:focus,
  .btn-success:not([disabled]):not(.disabled):active:focus,
  .btn-warning:not([disabled]):not(.disabled):active:focus,
  .btn-danger:not([disabled]):not(.disabled):active:focus,
  .btn-light:not([disabled]):not(.disabled):active:focus,
  .btn-dark:not([disabled]):not(.disabled):active:focus,
  .btn-primary:not([disabled]):not(.disabled):active:focus,
  .btn-secondary:not([disabled]):not(.disabled):active:focus, .btn:not([disabled]):not(.disabled).active:focus,
  .btn-info:not([disabled]):not(.disabled).active:focus,
  .btn-success:not([disabled]):not(.disabled).active:focus,
  .btn-warning:not([disabled]):not(.disabled).active:focus,
  .btn-danger:not([disabled]):not(.disabled).active:focus,
  .btn-light:not([disabled]):not(.disabled).active:focus,
  .btn-dark:not([disabled]):not(.disabled).active:focus,
  .btn-primary:not([disabled]):not(.disabled).active:focus,
  .btn-secondary:not([disabled]):not(.disabled).active:focus {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    -o-box-shadow: none;
    box-shadow: none; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.mw-25 {
  max-width: 25% !important; }

.mw-50 {
  max-width: 50% !important; }

.mw-75 {
  max-width: 75% !important; }

.mw-100 {
  max-width: 100% !important; }

.mh-25 {
  max-height: 25% !important; }

.mh-50 {
  max-height: 50% !important; }

.mh-75 {
  max-height: 75% !important; }

.mh-100 {
  max-height: 100% !important; }

.bg-primary {
  background-color: #3f51b5 !important; }

.text-primary {
  color: #3f51b5 !important; }
  .text-primary.icon-outline {
    border-color: #3f51b5 !important; }

.bg-primary.lighten-5 {
  background-color: #e8eaf6 !important; }

.text-primary.text-lighten-5 {
  color: #e8eaf6 !important; }
  .text-primary.text-lighten-5.icon-outline {
    border-color: #e8eaf6 !important; }

.bg-primary.lighten-4 {
  background-color: #c5cae9 !important; }

.text-primary.text-lighten-4 {
  color: #c5cae9 !important; }
  .text-primary.text-lighten-4.icon-outline {
    border-color: #c5cae9 !important; }

.bg-primary.lighten-3 {
  background-color: #9fa8da !important; }

.text-primary.text-lighten-3 {
  color: #9fa8da !important; }
  .text-primary.text-lighten-3.icon-outline {
    border-color: #9fa8da !important; }

.bg-primary.lighten-2 {
  background-color: #7986cb !important; }

.text-primary.text-lighten-2 {
  color: #7986cb !important; }
  .text-primary.text-lighten-2.icon-outline {
    border-color: #7986cb !important; }

.bg-primary.lighten-1 {
  background-color: #5c6bc0 !important; }

.text-primary.text-lighten-1 {
  color: #5c6bc0 !important; }
  .text-primary.text-lighten-1.icon-outline {
    border-color: #5c6bc0 !important; }

.bg-primary.darken-1 {
  background-color: #3949ab !important; }

.text-primary.text-darken-1 {
  color: #3949ab !important; }
  .text-primary.text-darken-1.icon-outline {
    border-color: #3949ab !important; }

.bg-primary.darken-2 {
  background-color: #303f9f !important; }

.text-primary.text-darken-2 {
  color: #303f9f !important; }
  .text-primary.text-darken-2.icon-outline {
    border-color: #303f9f !important; }

.bg-primary.darken-3 {
  background-color: #283593 !important; }

.text-primary.text-darken-3 {
  color: #283593 !important; }
  .text-primary.text-darken-3.icon-outline {
    border-color: #283593 !important; }

.bg-primary.darken-4 {
  background-color: #1a237e !important; }

.text-primary.text-darken-4 {
  color: #1a237e !important; }
  .text-primary.text-darken-4.icon-outline {
    border-color: #1a237e !important; }

.bg-primary.accent-1 {
  background-color: #8c9eff !important; }

.text-primary.text-accent-1 {
  color: #8c9eff !important; }
  .text-primary.text-accent-1.icon-outline {
    border-color: #8c9eff !important; }

.bg-primary.accent-2 {
  background-color: #536dfe !important; }

.text-primary.text-accent-2 {
  color: #536dfe !important; }
  .text-primary.text-accent-2.icon-outline {
    border-color: #536dfe !important; }

.bg-primary.accent-3 {
  background-color: #3d5afe !important; }

.text-primary.text-accent-3 {
  color: #3d5afe !important; }
  .text-primary.text-accent-3.icon-outline {
    border-color: #3d5afe !important; }

.bg-primary.accent-4 {
  background-color: #304ffe !important; }

.text-primary.text-accent-4 {
  color: #304ffe !important; }
  .text-primary.text-accent-4.icon-outline {
    border-color: #304ffe !important; }

.bg-red {
  background-color: #F44336 !important; }

.text-red {
  color: #F44336 !important; }
  .text-red.icon-outline {
    border-color: #F44336 !important; }

.bg-red.lighten-5 {
  background-color: #FFEBEE !important; }

.text-red.text-lighten-5 {
  color: #FFEBEE !important; }
  .text-red.text-lighten-5.icon-outline {
    border-color: #FFEBEE !important; }

.bg-red.lighten-4 {
  background-color: #FFCDD2 !important; }

.text-red.text-lighten-4 {
  color: #FFCDD2 !important; }
  .text-red.text-lighten-4.icon-outline {
    border-color: #FFCDD2 !important; }

.bg-red.lighten-3 {
  background-color: #EF9A9A !important; }

.text-red.text-lighten-3 {
  color: #EF9A9A !important; }
  .text-red.text-lighten-3.icon-outline {
    border-color: #EF9A9A !important; }

.bg-red.lighten-2 {
  background-color: #E57373 !important; }

.text-red.text-lighten-2 {
  color: #E57373 !important; }
  .text-red.text-lighten-2.icon-outline {
    border-color: #E57373 !important; }

.bg-red.lighten-1 {
  background-color: #EF5350 !important; }

.text-red.text-lighten-1 {
  color: #EF5350 !important; }
  .text-red.text-lighten-1.icon-outline {
    border-color: #EF5350 !important; }

.bg-red.darken-1 {
  background-color: #E53935 !important; }

.text-red.text-darken-1 {
  color: #E53935 !important; }
  .text-red.text-darken-1.icon-outline {
    border-color: #E53935 !important; }

.bg-red.darken-2 {
  background-color: #D32F2F !important; }

.text-red.text-darken-2 {
  color: #D32F2F !important; }
  .text-red.text-darken-2.icon-outline {
    border-color: #D32F2F !important; }

.bg-red.darken-3 {
  background-color: #C62828 !important; }

.text-red.text-darken-3 {
  color: #C62828 !important; }
  .text-red.text-darken-3.icon-outline {
    border-color: #C62828 !important; }

.bg-red.darken-4 {
  background-color: #B71C1C !important; }

.text-red.text-darken-4 {
  color: #B71C1C !important; }
  .text-red.text-darken-4.icon-outline {
    border-color: #B71C1C !important; }

.bg-red.accent-1 {
  background-color: #FF8A80 !important; }

.text-red.text-accent-1 {
  color: #FF8A80 !important; }
  .text-red.text-accent-1.icon-outline {
    border-color: #FF8A80 !important; }

.bg-red.accent-2 {
  background-color: #FF5252 !important; }

.text-red.text-accent-2 {
  color: #FF5252 !important; }
  .text-red.text-accent-2.icon-outline {
    border-color: #FF5252 !important; }

.bg-red.accent-3 {
  background-color: #FF1744 !important; }

.text-red.text-accent-3 {
  color: #FF1744 !important; }
  .text-red.text-accent-3.icon-outline {
    border-color: #FF1744 !important; }

.bg-red.accent-4 {
  background-color: #D50000 !important; }

.text-red.text-accent-4 {
  color: #D50000 !important; }
  .text-red.text-accent-4.icon-outline {
    border-color: #D50000 !important; }

.bg-pink {
  background-color: #e91e63 !important; }

.text-pink {
  color: #e91e63 !important; }
  .text-pink.icon-outline {
    border-color: #e91e63 !important; }

.bg-pink.lighten-5 {
  background-color: #fce4ec !important; }

.text-pink.text-lighten-5 {
  color: #fce4ec !important; }
  .text-pink.text-lighten-5.icon-outline {
    border-color: #fce4ec !important; }

.bg-pink.lighten-4 {
  background-color: #f8bbd0 !important; }

.text-pink.text-lighten-4 {
  color: #f8bbd0 !important; }
  .text-pink.text-lighten-4.icon-outline {
    border-color: #f8bbd0 !important; }

.bg-pink.lighten-3 {
  background-color: #f48fb1 !important; }

.text-pink.text-lighten-3 {
  color: #f48fb1 !important; }
  .text-pink.text-lighten-3.icon-outline {
    border-color: #f48fb1 !important; }

.bg-pink.lighten-2 {
  background-color: #f06292 !important; }

.text-pink.text-lighten-2 {
  color: #f06292 !important; }
  .text-pink.text-lighten-2.icon-outline {
    border-color: #f06292 !important; }

.bg-pink.lighten-1 {
  background-color: #ec407a !important; }

.text-pink.text-lighten-1 {
  color: #ec407a !important; }
  .text-pink.text-lighten-1.icon-outline {
    border-color: #ec407a !important; }

.bg-pink.darken-1 {
  background-color: #d81b60 !important; }

.text-pink.text-darken-1 {
  color: #d81b60 !important; }
  .text-pink.text-darken-1.icon-outline {
    border-color: #d81b60 !important; }

.bg-pink.darken-2 {
  background-color: #c2185b !important; }

.text-pink.text-darken-2 {
  color: #c2185b !important; }
  .text-pink.text-darken-2.icon-outline {
    border-color: #c2185b !important; }

.bg-pink.darken-3 {
  background-color: #ad1457 !important; }

.text-pink.text-darken-3 {
  color: #ad1457 !important; }
  .text-pink.text-darken-3.icon-outline {
    border-color: #ad1457 !important; }

.bg-pink.darken-4 {
  background-color: #880e4f !important; }

.text-pink.text-darken-4 {
  color: #880e4f !important; }
  .text-pink.text-darken-4.icon-outline {
    border-color: #880e4f !important; }

.bg-pink.accent-1 {
  background-color: #ff80ab !important; }

.text-pink.text-accent-1 {
  color: #ff80ab !important; }
  .text-pink.text-accent-1.icon-outline {
    border-color: #ff80ab !important; }

.bg-pink.accent-2 {
  background-color: #ff4081 !important; }

.text-pink.text-accent-2 {
  color: #ff4081 !important; }
  .text-pink.text-accent-2.icon-outline {
    border-color: #ff4081 !important; }

.bg-pink.accent-3 {
  background-color: #f50057 !important; }

.text-pink.text-accent-3 {
  color: #f50057 !important; }
  .text-pink.text-accent-3.icon-outline {
    border-color: #f50057 !important; }

.bg-pink.accent-4 {
  background-color: #c51162 !important; }

.text-pink.text-accent-4 {
  color: #c51162 !important; }
  .text-pink.text-accent-4.icon-outline {
    border-color: #c51162 !important; }

.bg-purple {
  background-color: #9C27B0 !important; }

.text-purple {
  color: #9C27B0 !important; }
  .text-purple.icon-outline {
    border-color: #9C27B0 !important; }

.bg-purple.lighten-5 {
  background-color: #f3e5f5 !important; }

.text-purple.text-lighten-5 {
  color: #f3e5f5 !important; }
  .text-purple.text-lighten-5.icon-outline {
    border-color: #f3e5f5 !important; }

.bg-purple.lighten-4 {
  background-color: #e1bee7 !important; }

.text-purple.text-lighten-4 {
  color: #e1bee7 !important; }
  .text-purple.text-lighten-4.icon-outline {
    border-color: #e1bee7 !important; }

.bg-purple.lighten-3 {
  background-color: #ce93d8 !important; }

.text-purple.text-lighten-3 {
  color: #ce93d8 !important; }
  .text-purple.text-lighten-3.icon-outline {
    border-color: #ce93d8 !important; }

.bg-purple.lighten-2 {
  background-color: #ba68c8 !important; }

.text-purple.text-lighten-2 {
  color: #ba68c8 !important; }
  .text-purple.text-lighten-2.icon-outline {
    border-color: #ba68c8 !important; }

.bg-purple.lighten-1 {
  background-color: #ab47bc !important; }

.text-purple.text-lighten-1 {
  color: #ab47bc !important; }
  .text-purple.text-lighten-1.icon-outline {
    border-color: #ab47bc !important; }

.bg-purple.darken-1 {
  background-color: #8e24aa !important; }

.text-purple.text-darken-1 {
  color: #8e24aa !important; }
  .text-purple.text-darken-1.icon-outline {
    border-color: #8e24aa !important; }

.bg-purple.darken-2 {
  background-color: #7b1fa2 !important; }

.text-purple.text-darken-2 {
  color: #7b1fa2 !important; }
  .text-purple.text-darken-2.icon-outline {
    border-color: #7b1fa2 !important; }

.bg-purple.darken-3 {
  background-color: #6a1b9a !important; }

.text-purple.text-darken-3 {
  color: #6a1b9a !important; }
  .text-purple.text-darken-3.icon-outline {
    border-color: #6a1b9a !important; }

.bg-purple.darken-4 {
  background-color: #4a148c !important; }

.text-purple.text-darken-4 {
  color: #4a148c !important; }
  .text-purple.text-darken-4.icon-outline {
    border-color: #4a148c !important; }

.bg-purple.accent-1 {
  background-color: #ea80fc !important; }

.text-purple.text-accent-1 {
  color: #ea80fc !important; }
  .text-purple.text-accent-1.icon-outline {
    border-color: #ea80fc !important; }

.bg-purple.accent-2 {
  background-color: #e040fb !important; }

.text-purple.text-accent-2 {
  color: #e040fb !important; }
  .text-purple.text-accent-2.icon-outline {
    border-color: #e040fb !important; }

.bg-purple.accent-3 {
  background-color: #d500f9 !important; }

.text-purple.text-accent-3 {
  color: #d500f9 !important; }
  .text-purple.text-accent-3.icon-outline {
    border-color: #d500f9 !important; }

.bg-purple.accent-4 {
  background-color: #aa00ff !important; }

.text-purple.text-accent-4 {
  color: #aa00ff !important; }
  .text-purple.text-accent-4.icon-outline {
    border-color: #aa00ff !important; }

.bg-deep-purple {
  background-color: #673ab7 !important; }

.text-deep-purple {
  color: #673ab7 !important; }
  .text-deep-purple.icon-outline {
    border-color: #673ab7 !important; }

.bg-deep-purple.lighten-5 {
  background-color: #ede7f6 !important; }

.text-deep-purple.text-lighten-5 {
  color: #ede7f6 !important; }
  .text-deep-purple.text-lighten-5.icon-outline {
    border-color: #ede7f6 !important; }

.bg-deep-purple.lighten-4 {
  background-color: #d1c4e9 !important; }

.text-deep-purple.text-lighten-4 {
  color: #d1c4e9 !important; }
  .text-deep-purple.text-lighten-4.icon-outline {
    border-color: #d1c4e9 !important; }

.bg-deep-purple.lighten-3 {
  background-color: #b39ddb !important; }

.text-deep-purple.text-lighten-3 {
  color: #b39ddb !important; }
  .text-deep-purple.text-lighten-3.icon-outline {
    border-color: #b39ddb !important; }

.bg-deep-purple.lighten-2 {
  background-color: #9575cd !important; }

.text-deep-purple.text-lighten-2 {
  color: #9575cd !important; }
  .text-deep-purple.text-lighten-2.icon-outline {
    border-color: #9575cd !important; }

.bg-deep-purple.lighten-1 {
  background-color: #7e57c2 !important; }

.text-deep-purple.text-lighten-1 {
  color: #7e57c2 !important; }
  .text-deep-purple.text-lighten-1.icon-outline {
    border-color: #7e57c2 !important; }

.bg-deep-purple.darken-1 {
  background-color: #5e35b1 !important; }

.text-deep-purple.text-darken-1 {
  color: #5e35b1 !important; }
  .text-deep-purple.text-darken-1.icon-outline {
    border-color: #5e35b1 !important; }

.bg-deep-purple.darken-2 {
  background-color: #512da8 !important; }

.text-deep-purple.text-darken-2 {
  color: #512da8 !important; }
  .text-deep-purple.text-darken-2.icon-outline {
    border-color: #512da8 !important; }

.bg-deep-purple.darken-3 {
  background-color: #4527a0 !important; }

.text-deep-purple.text-darken-3 {
  color: #4527a0 !important; }
  .text-deep-purple.text-darken-3.icon-outline {
    border-color: #4527a0 !important; }

.bg-deep-purple.darken-4 {
  background-color: #311b92 !important; }

.text-deep-purple.text-darken-4 {
  color: #311b92 !important; }
  .text-deep-purple.text-darken-4.icon-outline {
    border-color: #311b92 !important; }

.bg-deep-purple.accent-1 {
  background-color: #b388ff !important; }

.text-deep-purple.text-accent-1 {
  color: #b388ff !important; }
  .text-deep-purple.text-accent-1.icon-outline {
    border-color: #b388ff !important; }

.bg-deep-purple.accent-2 {
  background-color: #7c4dff !important; }

.text-deep-purple.text-accent-2 {
  color: #7c4dff !important; }
  .text-deep-purple.text-accent-2.icon-outline {
    border-color: #7c4dff !important; }

.bg-deep-purple.accent-3 {
  background-color: #651fff !important; }

.text-deep-purple.text-accent-3 {
  color: #651fff !important; }
  .text-deep-purple.text-accent-3.icon-outline {
    border-color: #651fff !important; }

.bg-deep-purple.accent-4 {
  background-color: #6200ea !important; }

.text-deep-purple.text-accent-4 {
  color: #6200ea !important; }
  .text-deep-purple.text-accent-4.icon-outline {
    border-color: #6200ea !important; }

.bg-indigo {
  background-color: #3f51b5 !important; }

.text-indigo {
  color: #3f51b5 !important; }
  .text-indigo.icon-outline {
    border-color: #3f51b5 !important; }

.bg-indigo.lighten-5 {
  background-color: #e8eaf6 !important; }

.text-indigo.text-lighten-5 {
  color: #e8eaf6 !important; }
  .text-indigo.text-lighten-5.icon-outline {
    border-color: #e8eaf6 !important; }

.bg-indigo.lighten-4 {
  background-color: #c5cae9 !important; }

.text-indigo.text-lighten-4 {
  color: #c5cae9 !important; }
  .text-indigo.text-lighten-4.icon-outline {
    border-color: #c5cae9 !important; }

.bg-indigo.lighten-3 {
  background-color: #9fa8da !important; }

.text-indigo.text-lighten-3 {
  color: #9fa8da !important; }
  .text-indigo.text-lighten-3.icon-outline {
    border-color: #9fa8da !important; }

.bg-indigo.lighten-2 {
  background-color: #7986cb !important; }

.text-indigo.text-lighten-2 {
  color: #7986cb !important; }
  .text-indigo.text-lighten-2.icon-outline {
    border-color: #7986cb !important; }

.bg-indigo.lighten-1 {
  background-color: #5c6bc0 !important; }

.text-indigo.text-lighten-1 {
  color: #5c6bc0 !important; }
  .text-indigo.text-lighten-1.icon-outline {
    border-color: #5c6bc0 !important; }

.bg-indigo.darken-1 {
  background-color: #3949ab !important; }

.text-indigo.text-darken-1 {
  color: #3949ab !important; }
  .text-indigo.text-darken-1.icon-outline {
    border-color: #3949ab !important; }

.bg-indigo.darken-2 {
  background-color: #303f9f !important; }

.text-indigo.text-darken-2 {
  color: #303f9f !important; }
  .text-indigo.text-darken-2.icon-outline {
    border-color: #303f9f !important; }

.bg-indigo.darken-3 {
  background-color: #283593 !important; }

.text-indigo.text-darken-3 {
  color: #283593 !important; }
  .text-indigo.text-darken-3.icon-outline {
    border-color: #283593 !important; }

.bg-indigo.darken-4 {
  background-color: #1a237e !important; }

.text-indigo.text-darken-4 {
  color: #1a237e !important; }
  .text-indigo.text-darken-4.icon-outline {
    border-color: #1a237e !important; }

.bg-indigo.accent-1 {
  background-color: #8c9eff !important; }

.text-indigo.text-accent-1 {
  color: #8c9eff !important; }
  .text-indigo.text-accent-1.icon-outline {
    border-color: #8c9eff !important; }

.bg-indigo.accent-2 {
  background-color: #536dfe !important; }

.text-indigo.text-accent-2 {
  color: #536dfe !important; }
  .text-indigo.text-accent-2.icon-outline {
    border-color: #536dfe !important; }

.bg-indigo.accent-3 {
  background-color: #3d5afe !important; }

.text-indigo.text-accent-3 {
  color: #3d5afe !important; }
  .text-indigo.text-accent-3.icon-outline {
    border-color: #3d5afe !important; }

.bg-indigo.accent-4 {
  background-color: #304ffe !important; }

.text-indigo.text-accent-4 {
  color: #304ffe !important; }
  .text-indigo.text-accent-4.icon-outline {
    border-color: #304ffe !important; }

.bg-blue {
  background-color: #2196F3 !important; }

.text-blue {
  color: #2196F3 !important; }
  .text-blue.icon-outline {
    border-color: #2196F3 !important; }

.bg-blue.lighten-5 {
  background-color: #E3F2FD !important; }

.text-blue.text-lighten-5 {
  color: #E3F2FD !important; }
  .text-blue.text-lighten-5.icon-outline {
    border-color: #E3F2FD !important; }

.bg-blue.lighten-4 {
  background-color: #BBDEFB !important; }

.text-blue.text-lighten-4 {
  color: #BBDEFB !important; }
  .text-blue.text-lighten-4.icon-outline {
    border-color: #BBDEFB !important; }

.bg-blue.lighten-3 {
  background-color: #90CAF9 !important; }

.text-blue.text-lighten-3 {
  color: #90CAF9 !important; }
  .text-blue.text-lighten-3.icon-outline {
    border-color: #90CAF9 !important; }

.bg-blue.lighten-2 {
  background-color: #64B5F6 !important; }

.text-blue.text-lighten-2 {
  color: #64B5F6 !important; }
  .text-blue.text-lighten-2.icon-outline {
    border-color: #64B5F6 !important; }

.bg-blue.lighten-1 {
  background-color: #42A5F5 !important; }

.text-blue.text-lighten-1 {
  color: #42A5F5 !important; }
  .text-blue.text-lighten-1.icon-outline {
    border-color: #42A5F5 !important; }

.bg-blue.darken-1 {
  background-color: #1E88E5 !important; }

.text-blue.text-darken-1 {
  color: #1E88E5 !important; }
  .text-blue.text-darken-1.icon-outline {
    border-color: #1E88E5 !important; }

.bg-blue.darken-2 {
  background-color: #1976D2 !important; }

.text-blue.text-darken-2 {
  color: #1976D2 !important; }
  .text-blue.text-darken-2.icon-outline {
    border-color: #1976D2 !important; }

.bg-blue.darken-3 {
  background-color: #1565C0 !important; }

.text-blue.text-darken-3 {
  color: #1565C0 !important; }
  .text-blue.text-darken-3.icon-outline {
    border-color: #1565C0 !important; }

.bg-blue.darken-4 {
  background-color: #0D47A1 !important; }

.text-blue.text-darken-4 {
  color: #0D47A1 !important; }
  .text-blue.text-darken-4.icon-outline {
    border-color: #0D47A1 !important; }

.bg-blue.accent-1 {
  background-color: #82B1FF !important; }

.text-blue.text-accent-1 {
  color: #82B1FF !important; }
  .text-blue.text-accent-1.icon-outline {
    border-color: #82B1FF !important; }

.bg-blue.accent-2 {
  background-color: #448AFF !important; }

.text-blue.text-accent-2 {
  color: #448AFF !important; }
  .text-blue.text-accent-2.icon-outline {
    border-color: #448AFF !important; }

.bg-blue.accent-3 {
  background-color: #2979FF !important; }

.text-blue.text-accent-3 {
  color: #2979FF !important; }
  .text-blue.text-accent-3.icon-outline {
    border-color: #2979FF !important; }

.bg-blue.accent-4 {
  background-color: #2962FF !important; }

.text-blue.text-accent-4 {
  color: #2962FF !important; }
  .text-blue.text-accent-4.icon-outline {
    border-color: #2962FF !important; }

.bg-light-blue {
  background-color: #03a9f4 !important; }

.text-light-blue {
  color: #03a9f4 !important; }
  .text-light-blue.icon-outline {
    border-color: #03a9f4 !important; }

.bg-light-blue.lighten-5 {
  background-color: #e1f5fe !important; }

.text-light-blue.text-lighten-5 {
  color: #e1f5fe !important; }
  .text-light-blue.text-lighten-5.icon-outline {
    border-color: #e1f5fe !important; }

.bg-light-blue.lighten-4 {
  background-color: #b3e5fc !important; }

.text-light-blue.text-lighten-4 {
  color: #b3e5fc !important; }
  .text-light-blue.text-lighten-4.icon-outline {
    border-color: #b3e5fc !important; }

.bg-light-blue.lighten-3 {
  background-color: #81d4fa !important; }

.text-light-blue.text-lighten-3 {
  color: #81d4fa !important; }
  .text-light-blue.text-lighten-3.icon-outline {
    border-color: #81d4fa !important; }

.bg-light-blue.lighten-2 {
  background-color: #4fc3f7 !important; }

.text-light-blue.text-lighten-2 {
  color: #4fc3f7 !important; }
  .text-light-blue.text-lighten-2.icon-outline {
    border-color: #4fc3f7 !important; }

.bg-light-blue.lighten-1 {
  background-color: #29b6f6 !important; }

.text-light-blue.text-lighten-1 {
  color: #29b6f6 !important; }
  .text-light-blue.text-lighten-1.icon-outline {
    border-color: #29b6f6 !important; }

.bg-light-blue.darken-1 {
  background-color: #039be5 !important; }

.text-light-blue.text-darken-1 {
  color: #039be5 !important; }
  .text-light-blue.text-darken-1.icon-outline {
    border-color: #039be5 !important; }

.bg-light-blue.darken-2 {
  background-color: #0288d1 !important; }

.text-light-blue.text-darken-2 {
  color: #0288d1 !important; }
  .text-light-blue.text-darken-2.icon-outline {
    border-color: #0288d1 !important; }

.bg-light-blue.darken-3 {
  background-color: #0277bd !important; }

.text-light-blue.text-darken-3 {
  color: #0277bd !important; }
  .text-light-blue.text-darken-3.icon-outline {
    border-color: #0277bd !important; }

.bg-light-blue.darken-4 {
  background-color: #01579b !important; }

.text-light-blue.text-darken-4 {
  color: #01579b !important; }
  .text-light-blue.text-darken-4.icon-outline {
    border-color: #01579b !important; }

.bg-light-blue.accent-1 {
  background-color: #80d8ff !important; }

.text-light-blue.text-accent-1 {
  color: #80d8ff !important; }
  .text-light-blue.text-accent-1.icon-outline {
    border-color: #80d8ff !important; }

.bg-light-blue.accent-2 {
  background-color: #40c4ff !important; }

.text-light-blue.text-accent-2 {
  color: #40c4ff !important; }
  .text-light-blue.text-accent-2.icon-outline {
    border-color: #40c4ff !important; }

.bg-light-blue.accent-3 {
  background-color: #00b0ff !important; }

.text-light-blue.text-accent-3 {
  color: #00b0ff !important; }
  .text-light-blue.text-accent-3.icon-outline {
    border-color: #00b0ff !important; }

.bg-light-blue.accent-4 {
  background-color: #0091ea !important; }

.text-light-blue.text-accent-4 {
  color: #0091ea !important; }
  .text-light-blue.text-accent-4.icon-outline {
    border-color: #0091ea !important; }

.bg-cyan {
  background-color: #00bcd4 !important; }

.text-cyan {
  color: #00bcd4 !important; }
  .text-cyan.icon-outline {
    border-color: #00bcd4 !important; }

.bg-cyan.lighten-5 {
  background-color: #e0f7fa !important; }

.text-cyan.text-lighten-5 {
  color: #e0f7fa !important; }
  .text-cyan.text-lighten-5.icon-outline {
    border-color: #e0f7fa !important; }

.bg-cyan.lighten-4 {
  background-color: #b2ebf2 !important; }

.text-cyan.text-lighten-4 {
  color: #b2ebf2 !important; }
  .text-cyan.text-lighten-4.icon-outline {
    border-color: #b2ebf2 !important; }

.bg-cyan.lighten-3 {
  background-color: #80deea !important; }

.text-cyan.text-lighten-3 {
  color: #80deea !important; }
  .text-cyan.text-lighten-3.icon-outline {
    border-color: #80deea !important; }

.bg-cyan.lighten-2 {
  background-color: #4dd0e1 !important; }

.text-cyan.text-lighten-2 {
  color: #4dd0e1 !important; }
  .text-cyan.text-lighten-2.icon-outline {
    border-color: #4dd0e1 !important; }

.bg-cyan.lighten-1 {
  background-color: #26c6da !important; }

.text-cyan.text-lighten-1 {
  color: #26c6da !important; }
  .text-cyan.text-lighten-1.icon-outline {
    border-color: #26c6da !important; }

.bg-cyan.darken-1 {
  background-color: #00acc1 !important; }

.text-cyan.text-darken-1 {
  color: #00acc1 !important; }
  .text-cyan.text-darken-1.icon-outline {
    border-color: #00acc1 !important; }

.bg-cyan.darken-2 {
  background-color: #0097a7 !important; }

.text-cyan.text-darken-2 {
  color: #0097a7 !important; }
  .text-cyan.text-darken-2.icon-outline {
    border-color: #0097a7 !important; }

.bg-cyan.darken-3 {
  background-color: #00838f !important; }

.text-cyan.text-darken-3 {
  color: #00838f !important; }
  .text-cyan.text-darken-3.icon-outline {
    border-color: #00838f !important; }

.bg-cyan.darken-4 {
  background-color: #006064 !important; }

.text-cyan.text-darken-4 {
  color: #006064 !important; }
  .text-cyan.text-darken-4.icon-outline {
    border-color: #006064 !important; }

.bg-cyan.accent-1 {
  background-color: #84ffff !important; }

.text-cyan.text-accent-1 {
  color: #84ffff !important; }
  .text-cyan.text-accent-1.icon-outline {
    border-color: #84ffff !important; }

.bg-cyan.accent-2 {
  background-color: #18ffff !important; }

.text-cyan.text-accent-2 {
  color: #18ffff !important; }
  .text-cyan.text-accent-2.icon-outline {
    border-color: #18ffff !important; }

.bg-cyan.accent-3 {
  background-color: #00e5ff !important; }

.text-cyan.text-accent-3 {
  color: #00e5ff !important; }
  .text-cyan.text-accent-3.icon-outline {
    border-color: #00e5ff !important; }

.bg-cyan.accent-4 {
  background-color: #00b8d4 !important; }

.text-cyan.text-accent-4 {
  color: #00b8d4 !important; }
  .text-cyan.text-accent-4.icon-outline {
    border-color: #00b8d4 !important; }

.bg-teal {
  background-color: #009688 !important; }

.text-teal {
  color: #009688 !important; }
  .text-teal.icon-outline {
    border-color: #009688 !important; }

.bg-teal.lighten-5 {
  background-color: #e0f2f1 !important; }

.text-teal.text-lighten-5 {
  color: #e0f2f1 !important; }
  .text-teal.text-lighten-5.icon-outline {
    border-color: #e0f2f1 !important; }

.bg-teal.lighten-4 {
  background-color: #b2dfdb !important; }

.text-teal.text-lighten-4 {
  color: #b2dfdb !important; }
  .text-teal.text-lighten-4.icon-outline {
    border-color: #b2dfdb !important; }

.bg-teal.lighten-3 {
  background-color: #80cbc4 !important; }

.text-teal.text-lighten-3 {
  color: #80cbc4 !important; }
  .text-teal.text-lighten-3.icon-outline {
    border-color: #80cbc4 !important; }

.bg-teal.lighten-2 {
  background-color: #4db6ac !important; }

.text-teal.text-lighten-2 {
  color: #4db6ac !important; }
  .text-teal.text-lighten-2.icon-outline {
    border-color: #4db6ac !important; }

.bg-teal.lighten-1 {
  background-color: #26a69a !important; }

.text-teal.text-lighten-1 {
  color: #26a69a !important; }
  .text-teal.text-lighten-1.icon-outline {
    border-color: #26a69a !important; }

.bg-teal.darken-1 {
  background-color: #00897b !important; }

.text-teal.text-darken-1 {
  color: #00897b !important; }
  .text-teal.text-darken-1.icon-outline {
    border-color: #00897b !important; }

.bg-teal.darken-2 {
  background-color: #00796b !important; }

.text-teal.text-darken-2 {
  color: #00796b !important; }
  .text-teal.text-darken-2.icon-outline {
    border-color: #00796b !important; }

.bg-teal.darken-3 {
  background-color: #00695c !important; }

.text-teal.text-darken-3 {
  color: #00695c !important; }
  .text-teal.text-darken-3.icon-outline {
    border-color: #00695c !important; }

.bg-teal.darken-4 {
  background-color: #004d40 !important; }

.text-teal.text-darken-4 {
  color: #004d40 !important; }
  .text-teal.text-darken-4.icon-outline {
    border-color: #004d40 !important; }

.bg-teal.accent-1 {
  background-color: #a7ffeb !important; }

.text-teal.text-accent-1 {
  color: #a7ffeb !important; }
  .text-teal.text-accent-1.icon-outline {
    border-color: #a7ffeb !important; }

.bg-teal.accent-2 {
  background-color: #64ffda !important; }

.text-teal.text-accent-2 {
  color: #64ffda !important; }
  .text-teal.text-accent-2.icon-outline {
    border-color: #64ffda !important; }

.bg-teal.accent-3 {
  background-color: #1de9b6 !important; }

.text-teal.text-accent-3 {
  color: #1de9b6 !important; }
  .text-teal.text-accent-3.icon-outline {
    border-color: #1de9b6 !important; }

.bg-teal.accent-4 {
  background-color: #00bfa5 !important; }

.text-teal.text-accent-4 {
  color: #00bfa5 !important; }
  .text-teal.text-accent-4.icon-outline {
    border-color: #00bfa5 !important; }

.bg-green {
  background-color: #4CAF50 !important; }

.text-green {
  color: #4CAF50 !important; }
  .text-green.icon-outline {
    border-color: #4CAF50 !important; }

.bg-green.lighten-5 {
  background-color: #E8F5E9 !important; }

.text-green.text-lighten-5 {
  color: #E8F5E9 !important; }
  .text-green.text-lighten-5.icon-outline {
    border-color: #E8F5E9 !important; }

.bg-green.lighten-4 {
  background-color: #C8E6C9 !important; }

.text-green.text-lighten-4 {
  color: #C8E6C9 !important; }
  .text-green.text-lighten-4.icon-outline {
    border-color: #C8E6C9 !important; }

.bg-green.lighten-3 {
  background-color: #A5D6A7 !important; }

.text-green.text-lighten-3 {
  color: #A5D6A7 !important; }
  .text-green.text-lighten-3.icon-outline {
    border-color: #A5D6A7 !important; }

.bg-green.lighten-2 {
  background-color: #81C784 !important; }

.text-green.text-lighten-2 {
  color: #81C784 !important; }
  .text-green.text-lighten-2.icon-outline {
    border-color: #81C784 !important; }

.bg-green.lighten-1 {
  background-color: #66BB6A !important; }

.text-green.text-lighten-1 {
  color: #66BB6A !important; }
  .text-green.text-lighten-1.icon-outline {
    border-color: #66BB6A !important; }

.bg-green.darken-1 {
  background-color: #43A047 !important; }

.text-green.text-darken-1 {
  color: #43A047 !important; }
  .text-green.text-darken-1.icon-outline {
    border-color: #43A047 !important; }

.bg-green.darken-2 {
  background-color: #388E3C !important; }

.text-green.text-darken-2 {
  color: #388E3C !important; }
  .text-green.text-darken-2.icon-outline {
    border-color: #388E3C !important; }

.bg-green.darken-3 {
  background-color: #2E7D32 !important; }

.text-green.text-darken-3 {
  color: #2E7D32 !important; }
  .text-green.text-darken-3.icon-outline {
    border-color: #2E7D32 !important; }

.bg-green.darken-4 {
  background-color: #1B5E20 !important; }

.text-green.text-darken-4 {
  color: #1B5E20 !important; }
  .text-green.text-darken-4.icon-outline {
    border-color: #1B5E20 !important; }

.bg-green.accent-1 {
  background-color: #B9F6CA !important; }

.text-green.text-accent-1 {
  color: #B9F6CA !important; }
  .text-green.text-accent-1.icon-outline {
    border-color: #B9F6CA !important; }

.bg-green.accent-2 {
  background-color: #69F0AE !important; }

.text-green.text-accent-2 {
  color: #69F0AE !important; }
  .text-green.text-accent-2.icon-outline {
    border-color: #69F0AE !important; }

.bg-green.accent-3 {
  background-color: #00E676 !important; }

.text-green.text-accent-3 {
  color: #00E676 !important; }
  .text-green.text-accent-3.icon-outline {
    border-color: #00E676 !important; }

.bg-green.accent-4 {
  background-color: #00C853 !important; }

.text-green.text-accent-4 {
  color: #00C853 !important; }
  .text-green.text-accent-4.icon-outline {
    border-color: #00C853 !important; }

.bg-light-green {
  background-color: #8bc34a !important; }

.text-light-green {
  color: #8bc34a !important; }
  .text-light-green.icon-outline {
    border-color: #8bc34a !important; }

.bg-light-green.lighten-5 {
  background-color: #f1f8e9 !important; }

.text-light-green.text-lighten-5 {
  color: #f1f8e9 !important; }
  .text-light-green.text-lighten-5.icon-outline {
    border-color: #f1f8e9 !important; }

.bg-light-green.lighten-4 {
  background-color: #dcedc8 !important; }

.text-light-green.text-lighten-4 {
  color: #dcedc8 !important; }
  .text-light-green.text-lighten-4.icon-outline {
    border-color: #dcedc8 !important; }

.bg-light-green.lighten-3 {
  background-color: #c5e1a5 !important; }

.text-light-green.text-lighten-3 {
  color: #c5e1a5 !important; }
  .text-light-green.text-lighten-3.icon-outline {
    border-color: #c5e1a5 !important; }

.bg-light-green.lighten-2 {
  background-color: #aed581 !important; }

.text-light-green.text-lighten-2 {
  color: #aed581 !important; }
  .text-light-green.text-lighten-2.icon-outline {
    border-color: #aed581 !important; }

.bg-light-green.lighten-1 {
  background-color: #9ccc65 !important; }

.text-light-green.text-lighten-1 {
  color: #9ccc65 !important; }
  .text-light-green.text-lighten-1.icon-outline {
    border-color: #9ccc65 !important; }

.bg-light-green.darken-1 {
  background-color: #7cb342 !important; }

.text-light-green.text-darken-1 {
  color: #7cb342 !important; }
  .text-light-green.text-darken-1.icon-outline {
    border-color: #7cb342 !important; }

.bg-light-green.darken-2 {
  background-color: #689f38 !important; }

.text-light-green.text-darken-2 {
  color: #689f38 !important; }
  .text-light-green.text-darken-2.icon-outline {
    border-color: #689f38 !important; }

.bg-light-green.darken-3 {
  background-color: #558b2f !important; }

.text-light-green.text-darken-3 {
  color: #558b2f !important; }
  .text-light-green.text-darken-3.icon-outline {
    border-color: #558b2f !important; }

.bg-light-green.darken-4 {
  background-color: #33691e !important; }

.text-light-green.text-darken-4 {
  color: #33691e !important; }
  .text-light-green.text-darken-4.icon-outline {
    border-color: #33691e !important; }

.bg-light-green.accent-1 {
  background-color: #ccff90 !important; }

.text-light-green.text-accent-1 {
  color: #ccff90 !important; }
  .text-light-green.text-accent-1.icon-outline {
    border-color: #ccff90 !important; }

.bg-light-green.accent-2 {
  background-color: #b2ff59 !important; }

.text-light-green.text-accent-2 {
  color: #b2ff59 !important; }
  .text-light-green.text-accent-2.icon-outline {
    border-color: #b2ff59 !important; }

.bg-light-green.accent-3 {
  background-color: #76ff03 !important; }

.text-light-green.text-accent-3 {
  color: #76ff03 !important; }
  .text-light-green.text-accent-3.icon-outline {
    border-color: #76ff03 !important; }

.bg-light-green.accent-4 {
  background-color: #64dd17 !important; }

.text-light-green.text-accent-4 {
  color: #64dd17 !important; }
  .text-light-green.text-accent-4.icon-outline {
    border-color: #64dd17 !important; }

.bg-lime {
  background-color: #cddc39 !important; }

.text-lime {
  color: #cddc39 !important; }
  .text-lime.icon-outline {
    border-color: #cddc39 !important; }

.bg-lime.lighten-5 {
  background-color: #f9fbe7 !important; }

.text-lime.text-lighten-5 {
  color: #f9fbe7 !important; }
  .text-lime.text-lighten-5.icon-outline {
    border-color: #f9fbe7 !important; }

.bg-lime.lighten-4 {
  background-color: #f0f4c3 !important; }

.text-lime.text-lighten-4 {
  color: #f0f4c3 !important; }
  .text-lime.text-lighten-4.icon-outline {
    border-color: #f0f4c3 !important; }

.bg-lime.lighten-3 {
  background-color: #e6ee9c !important; }

.text-lime.text-lighten-3 {
  color: #e6ee9c !important; }
  .text-lime.text-lighten-3.icon-outline {
    border-color: #e6ee9c !important; }

.bg-lime.lighten-2 {
  background-color: #dce775 !important; }

.text-lime.text-lighten-2 {
  color: #dce775 !important; }
  .text-lime.text-lighten-2.icon-outline {
    border-color: #dce775 !important; }

.bg-lime.lighten-1 {
  background-color: #d4e157 !important; }

.text-lime.text-lighten-1 {
  color: #d4e157 !important; }
  .text-lime.text-lighten-1.icon-outline {
    border-color: #d4e157 !important; }

.bg-lime.darken-1 {
  background-color: #c0ca33 !important; }

.text-lime.text-darken-1 {
  color: #c0ca33 !important; }
  .text-lime.text-darken-1.icon-outline {
    border-color: #c0ca33 !important; }

.bg-lime.darken-2 {
  background-color: #afb42b !important; }

.text-lime.text-darken-2 {
  color: #afb42b !important; }
  .text-lime.text-darken-2.icon-outline {
    border-color: #afb42b !important; }

.bg-lime.darken-3 {
  background-color: #9e9d24 !important; }

.text-lime.text-darken-3 {
  color: #9e9d24 !important; }
  .text-lime.text-darken-3.icon-outline {
    border-color: #9e9d24 !important; }

.bg-lime.darken-4 {
  background-color: #827717 !important; }

.text-lime.text-darken-4 {
  color: #827717 !important; }
  .text-lime.text-darken-4.icon-outline {
    border-color: #827717 !important; }

.bg-lime.accent-1 {
  background-color: #f4ff81 !important; }

.text-lime.text-accent-1 {
  color: #f4ff81 !important; }
  .text-lime.text-accent-1.icon-outline {
    border-color: #f4ff81 !important; }

.bg-lime.accent-2 {
  background-color: #eeff41 !important; }

.text-lime.text-accent-2 {
  color: #eeff41 !important; }
  .text-lime.text-accent-2.icon-outline {
    border-color: #eeff41 !important; }

.bg-lime.accent-3 {
  background-color: #c6ff00 !important; }

.text-lime.text-accent-3 {
  color: #c6ff00 !important; }
  .text-lime.text-accent-3.icon-outline {
    border-color: #c6ff00 !important; }

.bg-lime.accent-4 {
  background-color: #aeea00 !important; }

.text-lime.text-accent-4 {
  color: #aeea00 !important; }
  .text-lime.text-accent-4.icon-outline {
    border-color: #aeea00 !important; }

.bg-yellow {
  background-color: #ffeb3b !important; }

.text-yellow {
  color: #ffeb3b !important; }
  .text-yellow.icon-outline {
    border-color: #ffeb3b !important; }

.bg-yellow.lighten-5 {
  background-color: #fffde7 !important; }

.text-yellow.text-lighten-5 {
  color: #fffde7 !important; }
  .text-yellow.text-lighten-5.icon-outline {
    border-color: #fffde7 !important; }

.bg-yellow.lighten-4 {
  background-color: #fff9c4 !important; }

.text-yellow.text-lighten-4 {
  color: #fff9c4 !important; }
  .text-yellow.text-lighten-4.icon-outline {
    border-color: #fff9c4 !important; }

.bg-yellow.lighten-3 {
  background-color: #fff59d !important; }

.text-yellow.text-lighten-3 {
  color: #fff59d !important; }
  .text-yellow.text-lighten-3.icon-outline {
    border-color: #fff59d !important; }

.bg-yellow.lighten-2 {
  background-color: #fff176 !important; }

.text-yellow.text-lighten-2 {
  color: #fff176 !important; }
  .text-yellow.text-lighten-2.icon-outline {
    border-color: #fff176 !important; }

.bg-yellow.lighten-1 {
  background-color: #ffee58 !important; }

.text-yellow.text-lighten-1 {
  color: #ffee58 !important; }
  .text-yellow.text-lighten-1.icon-outline {
    border-color: #ffee58 !important; }

.bg-yellow.darken-1 {
  background-color: #fdd835 !important; }

.text-yellow.text-darken-1 {
  color: #fdd835 !important; }
  .text-yellow.text-darken-1.icon-outline {
    border-color: #fdd835 !important; }

.bg-yellow.darken-2 {
  background-color: #fbc02d !important; }

.text-yellow.text-darken-2 {
  color: #fbc02d !important; }
  .text-yellow.text-darken-2.icon-outline {
    border-color: #fbc02d !important; }

.bg-yellow.darken-3 {
  background-color: #f9a825 !important; }

.text-yellow.text-darken-3 {
  color: #f9a825 !important; }
  .text-yellow.text-darken-3.icon-outline {
    border-color: #f9a825 !important; }

.bg-yellow.darken-4 {
  background-color: #f57f17 !important; }

.text-yellow.text-darken-4 {
  color: #f57f17 !important; }
  .text-yellow.text-darken-4.icon-outline {
    border-color: #f57f17 !important; }

.bg-yellow.accent-1 {
  background-color: #ffff8d !important; }

.text-yellow.text-accent-1 {
  color: #ffff8d !important; }
  .text-yellow.text-accent-1.icon-outline {
    border-color: #ffff8d !important; }

.bg-yellow.accent-2 {
  background-color: #ffff00 !important; }

.text-yellow.text-accent-2 {
  color: #ffff00 !important; }
  .text-yellow.text-accent-2.icon-outline {
    border-color: #ffff00 !important; }

.bg-yellow.accent-3 {
  background-color: #ffea00 !important; }

.text-yellow.text-accent-3 {
  color: #ffea00 !important; }
  .text-yellow.text-accent-3.icon-outline {
    border-color: #ffea00 !important; }

.bg-yellow.accent-4 {
  background-color: #ffd600 !important; }

.text-yellow.text-accent-4 {
  color: #ffd600 !important; }
  .text-yellow.text-accent-4.icon-outline {
    border-color: #ffd600 !important; }

.bg-amber {
  background-color: #ffc107 !important; }

.text-amber {
  color: #ffc107 !important; }
  .text-amber.icon-outline {
    border-color: #ffc107 !important; }

.bg-amber.lighten-5 {
  background-color: #fff8e1 !important; }

.text-amber.text-lighten-5 {
  color: #fff8e1 !important; }
  .text-amber.text-lighten-5.icon-outline {
    border-color: #fff8e1 !important; }

.bg-amber.lighten-4 {
  background-color: #ffecb3 !important; }

.text-amber.text-lighten-4 {
  color: #ffecb3 !important; }
  .text-amber.text-lighten-4.icon-outline {
    border-color: #ffecb3 !important; }

.bg-amber.lighten-3 {
  background-color: #ffe082 !important; }

.text-amber.text-lighten-3 {
  color: #ffe082 !important; }
  .text-amber.text-lighten-3.icon-outline {
    border-color: #ffe082 !important; }

.bg-amber.lighten-2 {
  background-color: #ffd54f !important; }

.text-amber.text-lighten-2 {
  color: #ffd54f !important; }
  .text-amber.text-lighten-2.icon-outline {
    border-color: #ffd54f !important; }

.bg-amber.lighten-1 {
  background-color: #ffca28 !important; }

.text-amber.text-lighten-1 {
  color: #ffca28 !important; }
  .text-amber.text-lighten-1.icon-outline {
    border-color: #ffca28 !important; }

.bg-amber.darken-1 {
  background-color: #ffb300 !important; }

.text-amber.text-darken-1 {
  color: #ffb300 !important; }
  .text-amber.text-darken-1.icon-outline {
    border-color: #ffb300 !important; }

.bg-amber.darken-2 {
  background-color: #ffa000 !important; }

.text-amber.text-darken-2 {
  color: #ffa000 !important; }
  .text-amber.text-darken-2.icon-outline {
    border-color: #ffa000 !important; }

.bg-amber.darken-3 {
  background-color: #ff8f00 !important; }

.text-amber.text-darken-3 {
  color: #ff8f00 !important; }
  .text-amber.text-darken-3.icon-outline {
    border-color: #ff8f00 !important; }

.bg-amber.darken-4 {
  background-color: #ff6f00 !important; }

.text-amber.text-darken-4 {
  color: #ff6f00 !important; }
  .text-amber.text-darken-4.icon-outline {
    border-color: #ff6f00 !important; }

.bg-amber.accent-1 {
  background-color: #ffe57f !important; }

.text-amber.text-accent-1 {
  color: #ffe57f !important; }
  .text-amber.text-accent-1.icon-outline {
    border-color: #ffe57f !important; }

.bg-amber.accent-2 {
  background-color: #ffd740 !important; }

.text-amber.text-accent-2 {
  color: #ffd740 !important; }
  .text-amber.text-accent-2.icon-outline {
    border-color: #ffd740 !important; }

.bg-amber.accent-3 {
  background-color: #ffc400 !important; }

.text-amber.text-accent-3 {
  color: #ffc400 !important; }
  .text-amber.text-accent-3.icon-outline {
    border-color: #ffc400 !important; }

.bg-amber.accent-4 {
  background-color: #ffab00 !important; }

.text-amber.text-accent-4 {
  color: #ffab00 !important; }
  .text-amber.text-accent-4.icon-outline {
    border-color: #ffab00 !important; }

.bg-orange {
  background-color: #ff9800 !important; }

.text-orange {
  color: #ff9800 !important; }
  .text-orange.icon-outline {
    border-color: #ff9800 !important; }

.bg-orange.lighten-5 {
  background-color: #fff3e0 !important; }

.text-orange.text-lighten-5 {
  color: #fff3e0 !important; }
  .text-orange.text-lighten-5.icon-outline {
    border-color: #fff3e0 !important; }

.bg-orange.lighten-4 {
  background-color: #ffe0b2 !important; }

.text-orange.text-lighten-4 {
  color: #ffe0b2 !important; }
  .text-orange.text-lighten-4.icon-outline {
    border-color: #ffe0b2 !important; }

.bg-orange.lighten-3 {
  background-color: #ffcc80 !important; }

.text-orange.text-lighten-3 {
  color: #ffcc80 !important; }
  .text-orange.text-lighten-3.icon-outline {
    border-color: #ffcc80 !important; }

.bg-orange.lighten-2 {
  background-color: #ffb74d !important; }

.text-orange.text-lighten-2 {
  color: #ffb74d !important; }
  .text-orange.text-lighten-2.icon-outline {
    border-color: #ffb74d !important; }

.bg-orange.lighten-1 {
  background-color: #ffa726 !important; }

.text-orange.text-lighten-1 {
  color: #ffa726 !important; }
  .text-orange.text-lighten-1.icon-outline {
    border-color: #ffa726 !important; }

.bg-orange.darken-1 {
  background-color: #fb8c00 !important; }

.text-orange.text-darken-1 {
  color: #fb8c00 !important; }
  .text-orange.text-darken-1.icon-outline {
    border-color: #fb8c00 !important; }

.bg-orange.darken-2 {
  background-color: #f57c00 !important; }

.text-orange.text-darken-2 {
  color: #f57c00 !important; }
  .text-orange.text-darken-2.icon-outline {
    border-color: #f57c00 !important; }

.bg-orange.darken-3 {
  background-color: #ef6c00 !important; }

.text-orange.text-darken-3 {
  color: #ef6c00 !important; }
  .text-orange.text-darken-3.icon-outline {
    border-color: #ef6c00 !important; }

.bg-orange.darken-4 {
  background-color: #e65100 !important; }

.text-orange.text-darken-4 {
  color: #e65100 !important; }
  .text-orange.text-darken-4.icon-outline {
    border-color: #e65100 !important; }

.bg-orange.accent-1 {
  background-color: #ffd180 !important; }

.text-orange.text-accent-1 {
  color: #ffd180 !important; }
  .text-orange.text-accent-1.icon-outline {
    border-color: #ffd180 !important; }

.bg-orange.accent-2 {
  background-color: #ffab40 !important; }

.text-orange.text-accent-2 {
  color: #ffab40 !important; }
  .text-orange.text-accent-2.icon-outline {
    border-color: #ffab40 !important; }

.bg-orange.accent-3 {
  background-color: #ff9100 !important; }

.text-orange.text-accent-3 {
  color: #ff9100 !important; }
  .text-orange.text-accent-3.icon-outline {
    border-color: #ff9100 !important; }

.bg-orange.accent-4 {
  background-color: #ff6d00 !important; }

.text-orange.text-accent-4 {
  color: #ff6d00 !important; }
  .text-orange.text-accent-4.icon-outline {
    border-color: #ff6d00 !important; }

.bg-deep-orange {
  background-color: #ff5722 !important; }

.text-deep-orange {
  color: #ff5722 !important; }
  .text-deep-orange.icon-outline {
    border-color: #ff5722 !important; }

.bg-deep-orange.lighten-5 {
  background-color: #fbe9e7 !important; }

.text-deep-orange.text-lighten-5 {
  color: #fbe9e7 !important; }
  .text-deep-orange.text-lighten-5.icon-outline {
    border-color: #fbe9e7 !important; }

.bg-deep-orange.lighten-4 {
  background-color: #ffccbc !important; }

.text-deep-orange.text-lighten-4 {
  color: #ffccbc !important; }
  .text-deep-orange.text-lighten-4.icon-outline {
    border-color: #ffccbc !important; }

.bg-deep-orange.lighten-3 {
  background-color: #ffab91 !important; }

.text-deep-orange.text-lighten-3 {
  color: #ffab91 !important; }
  .text-deep-orange.text-lighten-3.icon-outline {
    border-color: #ffab91 !important; }

.bg-deep-orange.lighten-2 {
  background-color: #ff8a65 !important; }

.text-deep-orange.text-lighten-2 {
  color: #ff8a65 !important; }
  .text-deep-orange.text-lighten-2.icon-outline {
    border-color: #ff8a65 !important; }

.bg-deep-orange.lighten-1 {
  background-color: #ff7043 !important; }

.text-deep-orange.text-lighten-1 {
  color: #ff7043 !important; }
  .text-deep-orange.text-lighten-1.icon-outline {
    border-color: #ff7043 !important; }

.bg-deep-orange.darken-1 {
  background-color: #f4511e !important; }

.text-deep-orange.text-darken-1 {
  color: #f4511e !important; }
  .text-deep-orange.text-darken-1.icon-outline {
    border-color: #f4511e !important; }

.bg-deep-orange.darken-2 {
  background-color: #e64a19 !important; }

.text-deep-orange.text-darken-2 {
  color: #e64a19 !important; }
  .text-deep-orange.text-darken-2.icon-outline {
    border-color: #e64a19 !important; }

.bg-deep-orange.darken-3 {
  background-color: #d84315 !important; }

.text-deep-orange.text-darken-3 {
  color: #d84315 !important; }
  .text-deep-orange.text-darken-3.icon-outline {
    border-color: #d84315 !important; }

.bg-deep-orange.darken-4 {
  background-color: #bf360c !important; }

.text-deep-orange.text-darken-4 {
  color: #bf360c !important; }
  .text-deep-orange.text-darken-4.icon-outline {
    border-color: #bf360c !important; }

.bg-deep-orange.accent-1 {
  background-color: #ff9e80 !important; }

.text-deep-orange.text-accent-1 {
  color: #ff9e80 !important; }
  .text-deep-orange.text-accent-1.icon-outline {
    border-color: #ff9e80 !important; }

.bg-deep-orange.accent-2 {
  background-color: #ff6e40 !important; }

.text-deep-orange.text-accent-2 {
  color: #ff6e40 !important; }
  .text-deep-orange.text-accent-2.icon-outline {
    border-color: #ff6e40 !important; }

.bg-deep-orange.accent-3 {
  background-color: #ff3d00 !important; }

.text-deep-orange.text-accent-3 {
  color: #ff3d00 !important; }
  .text-deep-orange.text-accent-3.icon-outline {
    border-color: #ff3d00 !important; }

.bg-deep-orange.accent-4 {
  background-color: #dd2c00 !important; }

.text-deep-orange.text-accent-4 {
  color: #dd2c00 !important; }
  .text-deep-orange.text-accent-4.icon-outline {
    border-color: #dd2c00 !important; }

.bg-brown {
  background-color: #795548 !important; }

.text-brown {
  color: #795548 !important; }
  .text-brown.icon-outline {
    border-color: #795548 !important; }

.bg-brown.lighten-5 {
  background-color: #efebe9 !important; }

.text-brown.text-lighten-5 {
  color: #efebe9 !important; }
  .text-brown.text-lighten-5.icon-outline {
    border-color: #efebe9 !important; }

.bg-brown.lighten-4 {
  background-color: #d7ccc8 !important; }

.text-brown.text-lighten-4 {
  color: #d7ccc8 !important; }
  .text-brown.text-lighten-4.icon-outline {
    border-color: #d7ccc8 !important; }

.bg-brown.lighten-3 {
  background-color: #bcaaa4 !important; }

.text-brown.text-lighten-3 {
  color: #bcaaa4 !important; }
  .text-brown.text-lighten-3.icon-outline {
    border-color: #bcaaa4 !important; }

.bg-brown.lighten-2 {
  background-color: #a1887f !important; }

.text-brown.text-lighten-2 {
  color: #a1887f !important; }
  .text-brown.text-lighten-2.icon-outline {
    border-color: #a1887f !important; }

.bg-brown.lighten-1 {
  background-color: #8d6e63 !important; }

.text-brown.text-lighten-1 {
  color: #8d6e63 !important; }
  .text-brown.text-lighten-1.icon-outline {
    border-color: #8d6e63 !important; }

.bg-brown.darken-1 {
  background-color: #6d4c41 !important; }

.text-brown.text-darken-1 {
  color: #6d4c41 !important; }
  .text-brown.text-darken-1.icon-outline {
    border-color: #6d4c41 !important; }

.bg-brown.darken-2 {
  background-color: #5d4037 !important; }

.text-brown.text-darken-2 {
  color: #5d4037 !important; }
  .text-brown.text-darken-2.icon-outline {
    border-color: #5d4037 !important; }

.bg-brown.darken-3 {
  background-color: #4e342e !important; }

.text-brown.text-darken-3 {
  color: #4e342e !important; }
  .text-brown.text-darken-3.icon-outline {
    border-color: #4e342e !important; }

.bg-brown.darken-4 {
  background-color: #3e2723 !important; }

.text-brown.text-darken-4 {
  color: #3e2723 !important; }
  .text-brown.text-darken-4.icon-outline {
    border-color: #3e2723 !important; }

.bg-blue-grey {
  background-color: #607d8b !important; }

.text-blue-grey {
  color: #607d8b !important; }
  .text-blue-grey.icon-outline {
    border-color: #607d8b !important; }

.bg-blue-grey.lighten-5 {
  background-color: #eceff1 !important; }

.text-blue-grey.text-lighten-5 {
  color: #eceff1 !important; }
  .text-blue-grey.text-lighten-5.icon-outline {
    border-color: #eceff1 !important; }

.bg-blue-grey.lighten-4 {
  background-color: #cfd8dc !important; }

.text-blue-grey.text-lighten-4 {
  color: #cfd8dc !important; }
  .text-blue-grey.text-lighten-4.icon-outline {
    border-color: #cfd8dc !important; }

.bg-blue-grey.lighten-3 {
  background-color: #b0bec5 !important; }

.text-blue-grey.text-lighten-3 {
  color: #b0bec5 !important; }
  .text-blue-grey.text-lighten-3.icon-outline {
    border-color: #b0bec5 !important; }

.bg-blue-grey.lighten-2 {
  background-color: #90a4ae !important; }

.text-blue-grey.text-lighten-2 {
  color: #90a4ae !important; }
  .text-blue-grey.text-lighten-2.icon-outline {
    border-color: #90a4ae !important; }

.bg-blue-grey.lighten-1 {
  background-color: #78909c !important; }

.text-blue-grey.text-lighten-1 {
  color: #78909c !important; }
  .text-blue-grey.text-lighten-1.icon-outline {
    border-color: #78909c !important; }

.bg-blue-grey.darken-1 {
  background-color: #546e7a !important; }

.text-blue-grey.text-darken-1 {
  color: #546e7a !important; }
  .text-blue-grey.text-darken-1.icon-outline {
    border-color: #546e7a !important; }

.bg-blue-grey.darken-2 {
  background-color: #455a64 !important; }

.text-blue-grey.text-darken-2 {
  color: #455a64 !important; }
  .text-blue-grey.text-darken-2.icon-outline {
    border-color: #455a64 !important; }

.bg-blue-grey.darken-3 {
  background-color: #37474f !important; }

.text-blue-grey.text-darken-3 {
  color: #37474f !important; }
  .text-blue-grey.text-darken-3.icon-outline {
    border-color: #37474f !important; }

.bg-blue-grey.darken-4 {
  background-color: #263238 !important; }

.text-blue-grey.text-darken-4 {
  color: #263238 !important; }
  .text-blue-grey.text-darken-4.icon-outline {
    border-color: #263238 !important; }

.bg-grey {
  background-color: #9e9e9e !important; }

.text-grey {
  color: #9e9e9e !important; }
  .text-grey.icon-outline {
    border-color: #9e9e9e !important; }

.bg-grey.lighten-5 {
  background-color: #fafafa !important; }

.text-grey.text-lighten-5 {
  color: #fafafa !important; }
  .text-grey.text-lighten-5.icon-outline {
    border-color: #fafafa !important; }

.bg-grey.lighten-4 {
  background-color: #f5f5f5 !important; }

.text-grey.text-lighten-4 {
  color: #f5f5f5 !important; }
  .text-grey.text-lighten-4.icon-outline {
    border-color: #f5f5f5 !important; }

.bg-grey.lighten-3 {
  background-color: #eeeeee !important; }

.text-grey.text-lighten-3 {
  color: #eeeeee !important; }
  .text-grey.text-lighten-3.icon-outline {
    border-color: #eeeeee !important; }

.bg-grey.lighten-2 {
  background-color: #e0e0e0 !important; }

.text-grey.text-lighten-2 {
  color: #e0e0e0 !important; }
  .text-grey.text-lighten-2.icon-outline {
    border-color: #e0e0e0 !important; }

.bg-grey.lighten-1 {
  background-color: #bdbdbd !important; }

.text-grey.text-lighten-1 {
  color: #bdbdbd !important; }
  .text-grey.text-lighten-1.icon-outline {
    border-color: #bdbdbd !important; }

.bg-grey.darken-1 {
  background-color: #757575 !important; }

.text-grey.text-darken-1 {
  color: #757575 !important; }
  .text-grey.text-darken-1.icon-outline {
    border-color: #757575 !important; }

.bg-grey.darken-2 {
  background-color: #616161 !important; }

.text-grey.text-darken-2 {
  color: #616161 !important; }
  .text-grey.text-darken-2.icon-outline {
    border-color: #616161 !important; }

.bg-grey.darken-3 {
  background-color: #424242 !important; }

.text-grey.text-darken-3 {
  color: #424242 !important; }
  .text-grey.text-darken-3.icon-outline {
    border-color: #424242 !important; }

.bg-grey.darken-4 {
  background-color: #212121 !important; }

.text-grey.text-darken-4 {
  color: #212121 !important; }
  .text-grey.text-darken-4.icon-outline {
    border-color: #212121 !important; }

.bg-black {
  background-color: #000000 !important; }

.text-black {
  color: #000000 !important; }
  .text-black.icon-outline {
    border-color: #000000 !important; }

.bg-white {
  background-color: #FFFFFF !important; }

.text-white {
  color: #FFFFFF !important; }
  .text-white.icon-outline {
    border-color: #FFFFFF !important; }

.bg-transparent {
  background-color: transparent !important; }

.text-transparent {
  color: transparent !important; }
  .text-transparent.icon-outline {
    border-color: transparent !important; }

/*Custom Animation*/
@keyframes flipCenter {
  0% {
    animation-timing-function: ease-in;
    opacity: 0;
    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg); }
  40% {
    animation-timing-function: ease-in;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg); }
  60% {
    opacity: 1;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg); }
  80% {
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg); }
  100% {
    transform: perspective(100000px); } }

@-webkit-keyframes flipCenter {
  0% {
    animation-timing-function: ease-in;
    opacity: 0;
    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg); }
  40% {
    animation-timing-function: ease-in;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg); }
  60% {
    opacity: 1;
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg); }
  80% {
    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg); }
  100% {
    transform: perspective(100000px); } }

.flipCenter {
  animation-name: flipCenter;
  backface-visibility: visible; }

@keyframes desployDown {
  0% {
    transform: scaleY(0);
    transform-origin: center top 0; }
  100% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: center top 0; } }

@-webkit-keyframes desployDown {
  0% {
    transform: scaleY(0);
    transform-origin: center top 0; }
  100% {
    opacity: 1;
    transform: scaleY(1);
    transform-origin: center top 0; } }

.desployDown {
  animation-name: desployDown;
  backface-visibility: visible; }

@keyframes fadeInRightTiny {
  0% {
    opacity: 0;
    transform: translate3d(30%, 0px, 0px); }
  100% {
    opacity: 1;
    transform: none; } }

@-webkit-keyframes fadeInRightTiny {
  0% {
    opacity: 0;
    transform: translate3d(30%, 0px, 0px); }
  100% {
    opacity: 1;
    transform: none; } }

.fadeInRightTiny {
  animation-name: fadeInRightTiny; }

@keyframes fadeInLeftTiny {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0px, 0px); }
  100% {
    opacity: 1;
    transform: none; } }

@-webkit-keyframes fadeInLeftTiny {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0px, 0px); }
  100% {
    opacity: 1;
    transform: none; } }

.fadeInLeftTiny {
  animation-name: fadeInLeftTiny; }

@keyframes slideInRightTiny {
  0% {
    transform: translate3d(30%, 0px, 0px); }
  100% {
    transform: none; } }

@-webkit-keyframes slideInRightTiny {
  0% {
    transform: translate3d(30%, 0px, 0px); }
  100% {
    transform: none; } }

.slideInRightTiny {
  animation-name: slideInRightTiny; }

@keyframes slideInLeftTiny {
  0% {
    transform: translate3d(-30%, 0px, 0px); }
  100% {
    transform: none; } }

@-webkit-keyframes slideInLeftTiny {
  0% {
    transform: translate3d(-30%, 0px, 0px); }
  100% {
    transform: none; } }

.slideInLeftTiny {
  animation-name: slideInLeftTiny; }

@keyframes slideInUpTiny {
  0% {
    transform: translate3d(0px, 5%, 0px); }
  100% {
    transform: none; } }

@-webkit-keyframes slideInUpTiny {
  0% {
    transform: translate3d(0px, 5%, 0px); }
  100% {
    transform: none; } }

.slideInUpTiny {
  animation-name: slideInUpTiny; }

/*Animation Durations*/
.animation-duration-1 {
  animation-duration: 0.1s; }

.animation-duration-2 {
  animation-duration: 0.2s; }

.animation-duration-3 {
  animation-duration: 0.3s; }

.animation-duration-4 {
  animation-duration: 0.4s; }

.animation-duration-5 {
  animation-duration: 0.5s; }

.animation-duration-6 {
  animation-duration: 0.6s; }

.animation-duration-7 {
  animation-duration: 0.7s; }

.animation-duration-8 {
  animation-duration: 0.8s; }

.animation-duration-9 {
  animation-duration: 0.9s; }

.animation-duration-10 {
  animation-duration: 1s; }

.animation-duration-11 {
  animation-duration: 1.1s; }

.animation-duration-12 {
  animation-duration: 1.2s; }

.animation-duration-13 {
  animation-duration: 1.3s; }

.animation-duration-14 {
  animation-duration: 1.4s; }

.animation-duration-15 {
  animation-duration: 1.5s; }

.animation-duration-16 {
  animation-duration: 1.6s; }

.animation-duration-17 {
  animation-duration: 1.7s; }

.animation-duration-18 {
  animation-duration: 1.8s; }

.animation-duration-19 {
  animation-duration: 1.9s; }

.animation-duration-20 {
  animation-duration: 2s; }

.animation-duration-21 {
  animation-duration: 2.1s; }

.animation-duration-22 {
  animation-duration: 2.2s; }

.animation-duration-23 {
  animation-duration: 2.3s; }

.animation-duration-24 {
  animation-duration: 2.4s; }

.animation-duration-25 {
  animation-duration: 2.5s; }

.animation-duration-26 {
  animation-duration: 2.6s; }

.animation-duration-27 {
  animation-duration: 2.7s; }

.animation-duration-28 {
  animation-duration: 2.8s; }

.animation-duration-29 {
  animation-duration: 2.9s; }

.animation-duration-30 {
  animation-duration: 3s; }

.animation-duration-31 {
  animation-duration: 3.1s; }

.animation-duration-32 {
  animation-duration: 3.2s; }

.animation-duration-33 {
  animation-duration: 3.3s; }

.animation-duration-34 {
  animation-duration: 3.4s; }

.animation-duration-35 {
  animation-duration: 3.5s; }

.animation-duration-36 {
  animation-duration: 3.6s; }

.animation-duration-37 {
  animation-duration: 3.7s; }

.animation-duration-38 {
  animation-duration: 3.8s; }

.animation-duration-39 {
  animation-duration: 3.9s; }

.animation-duration-40 {
  animation-duration: 4s; }

.animation-delay-1 {
  animation-delay: 0.1s; }

.animation-delay-2 {
  animation-delay: 0.2s; }

.animation-delay-3 {
  animation-delay: 0.3s; }

.animation-delay-4 {
  animation-delay: 0.4s; }

.animation-delay-5 {
  animation-delay: 0.5s; }

.animation-delay-6 {
  animation-delay: 0.6s; }

.animation-delay-7 {
  animation-delay: 0.7s; }

.animation-delay-8 {
  animation-delay: 0.8s; }

.animation-delay-9 {
  animation-delay: 0.9s; }

.animation-delay-10 {
  animation-delay: 1s; }

.animation-delay-11 {
  animation-delay: 1.1s; }

.animation-delay-12 {
  animation-delay: 1.2s; }

.animation-delay-13 {
  animation-delay: 1.3s; }

.animation-delay-14 {
  animation-delay: 1.4s; }

.animation-delay-15 {
  animation-delay: 1.5s; }

.animation-delay-16 {
  animation-delay: 1.6s; }

.animation-delay-17 {
  animation-delay: 1.7s; }

.animation-delay-18 {
  animation-delay: 1.8s; }

.animation-delay-19 {
  animation-delay: 1.9s; }

.animation-delay-20 {
  animation-delay: 2s; }

.animation-delay-21 {
  animation-delay: 2.1s; }

.animation-delay-22 {
  animation-delay: 2.2s; }

.animation-delay-23 {
  animation-delay: 2.3s; }

.animation-delay-24 {
  animation-delay: 2.4s; }

.animation-delay-25 {
  animation-delay: 2.5s; }

.animation-delay-26 {
  animation-delay: 2.6s; }

.animation-delay-27 {
  animation-delay: 2.6s; }

.animation-delay-28 {
  animation-delay: 2.8s; }

.animation-delay-29 {
  animation-delay: 2.9s; }

.animation-delay-30 {
  animation-delay: 3s; }

.animation-delay-31 {
  animation-delay: 3.1s; }

.animation-delay-32 {
  animation-delay: 3.2s; }

.animation-delay-33 {
  animation-delay: 3.3s; }

.animation-delay-34 {
  animation-delay: 3.4s; }

.animation-delay-35 {
  animation-delay: 3.5s; }

.animation-delay-36 {
  animation-delay: 3.6s; }

.animation-delay-37 {
  animation-delay: 3.7s; }

.animation-delay-38 {
  animation-delay: 3.8s; }

.animation-delay-39 {
  animation-delay: 3.9s; }

.animation-delay-40 {
  animation-delay: 4s; }

.animation-delay-41 {
  animation-delay: 4.1s; }

.animation-delay-42 {
  animation-delay: 4.2s; }

.animation-delay-43 {
  animation-delay: 4.3s; }

.animation-delay-44 {
  animation-delay: 4.4s; }

.animation-delay-45 {
  animation-delay: 4.5s; }

.animation-delay-46 {
  animation-delay: 4.6s; }

.animation-delay-47 {
  animation-delay: 4.7s; }

.animation-delay-48 {
  animation-delay: 4.8s; }

.animation-delay-49 {
  animation-delay: 4.9s; }

.animation-delay-50 {
  animation-delay: 5s; }

/* Base
   ========================================================================== */
/*Base Styles*/
html {
  height: 100%; }

body {
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #5c5c5c;
  background-color: #fff;
  height: 100%;
  overflow: hidden; }

body.ios-mobile-view-height {
  height: auto !important;
  overflow: visible !important; }

#nprogress .bar {
  z-index: 5000 !important;
  background: #3f51b5 !important; }

#nprogress .peg {
  -webkit-box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
  -moz-box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
  -o-box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important;
  box-shadow: 0 0 10px #3f51b5, 0 0 5px #3f51b5 !important; }

#nprogress .spinner {
  z-index: 5000 !important; }

#nprogress .spinner-icon {
  border-top-color: #3f51b5 !important;
  border-left-color: #3f51b5 !important; }

.text-transform-none {
  text-transform: none; }

.br-break {
  word-break: break-all !important; }

.font-weight-semibold {
  font-weight: 500 !important; }

.z-index-20 {
  z-index: 20; }

.border-bottom {
  border-bottom: solid 1px #dee2e6; }

.col-with-divider div[class*="col-"] {
  border-left: solid 1px #dee2e6; }
  .col-with-divider div[class*="col-"]:first-child {
    border: 0 none; }

.height-100 {
  height: 100px !important; }

.height-150 {
  height: 150px !important; }

.height-130 {
  height: 130px !important; }

.height-200 {
  height: 200px !important; }

.max-width-100 {
  max-width: 100px !important; }

.max-height-120 {
  max-height: 120px !important; }

.right-arrow {
  display: inline-block;
  color: #3f51b5;
  text-transform: capitalize; }
  .right-arrow:after {
    content: "\\f30f";
    font-family: "Material-Design-Iconic-Font";
    color: #3f51b5;
    margin-left: 8px;
    font-size: 20px;
    vertical-align: middle; }
  .right-arrow:hover, .right-arrow:focus {
    text-decoration: none; }

.letter-spacing-base {
  letter-spacing: 3px; }

.letter-spacing-lg {
  letter-spacing: 6px; }

.letter-spacing-xl {
  letter-spacing: 8px; }

.page-heading {
  margin-bottom: 38px; }
  .page-heading .title {
    text-transform: capitalize;
    font-weight: 600; }
  .page-heading .breadcrumb {
    padding: 0;
    background-color: transparent;
    margin-bottom: 0; }
  @media screen and (max-width: 575px) {
    .page-heading {
      margin-bottom: 18px; } }

.sub-heading {
  font-size: 13px;
  color: #adb5bd;
  margin-bottom: 0; }
  .sub-heading:not(:last-child) {
    margin-bottom: 16px !important; }

.manage-margin {
  margin-bottom: 0; }
  .manage-margin > * {
    margin-bottom: 6px; }
    .manage-margin > *:not(:last-child) {
      margin-right: 16px; }

.no-shadow {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important; }

.shadow-sm {
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15); }

.shadow {
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15); }

.shadow-lg {
  -webkit-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 8px -1px rgba(0, 0, 0, 0.2); }

.shadow-xl {
  -webkit-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.2); }

.avatar-shadow {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  -o-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5); }

.remove-table-border td, .remove-table-border th {
  border: 0 none; }

.media-list {
  margin-bottom: 10px; }
  .media-list:not(:last-child) {
    border-bottom: solid 1px #e9ecef;
    padding-bottom: 15px;
    margin-bottom: 20px;
    position: relative; }

.border-2 {
  border: 2px solid #ced4da !important; }

.border-w2 {
  border-width: 2px; }

.border-primary {
  border-color: #3f51b5 !important; }

.border-red {
  border-color: #F44336 !important; }

.border-pink {
  border-color: #e91e63 !important; }

.border-purple {
  border-color: #9C27B0 !important; }

.border-deep-purple {
  border-color: #673ab7 !important; }

.border-indigo {
  border-color: #3f51b5 !important; }

.border-blue {
  border-color: #2196F3 !important; }

.border-light-blue {
  border-color: #03a9f4 !important; }

.border-cyan {
  border-color: #00bcd4 !important; }

.border-teal {
  border-color: #009688 !important; }

.border-green {
  border-color: #4CAF50 !important; }

.border-light-green {
  border-color: #8bc34a !important; }

.border-lime {
  border-color: #cddc39 !important; }

.border-yellow {
  border-color: #ffeb3b !important; }

.border-amber {
  border-color: #ffc107 !important; }

.border-orange {
  border-color: #ff9800 !important; }

.border-deep-orange {
  border-color: #ff5722 !important; }

.border-brown {
  border-color: #795548 !important; }

.border-blue-grey {
  border-color: #607d8b !important; }

.border-grey {
  border-color: #9e9e9e !important; }

.center-crop-img {
  position: relative;
  width: 100%;
  min-height: 120px;
  overflow: hidden; }
  .center-crop-img img {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 100%;
    width: auto;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); }
  .center-crop-img img.portrait {
    width: 100%;
    height: auto; }

.pointer {
  cursor: pointer; }

.icon-btn {
  height: 48px;
  display: flex;
  align-items: center;
  width: 48px;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  color: #6c757d; }
  .header-notifications .icon-btn {
    padding: 0 4px; }

.avatar {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  color: #fafafa; }

.avatar-lg {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #fafafa; }

.avatar-sm {
  width: 40px;
  height: 40px;
  text-align: center;
  color: #fafafa; }

.animated {
  -webkit-animation-fill-mode: none !important;
  animation-fill-mode: none !important; }

.overflow-hidden {
  overflow: hidden; }

.icons-showcase > div {
  cursor: pointer;
  padding: 7px 15px;
  border-radius: 4px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap; }

.text-decoration {
  text-decoration: none !important; }

.row-5 {
  margin-left: -5px;
  margin-right: -5px; }
  .row-5 > [class*='col-'] {
    padding-left: 5px;
    padding-right: 5px; }

.font-size-16 {
  font-size: 16px !important; }

.material-icons {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  text-align: center;
  padding-bottom: 3px; }

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px; }

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-image: linear-gradient(to bottom right, #ebebeb, #bebebe);
  border: solid 1px #ababab; }

::selection {
  background-color: #006FC9;
  color: #fff; }

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 2px 30px 2px 2px;
  border: none;
  cursor: pointer; }

.my-tooltip > .tooltip-inner {
  background-color: #fff;
  color: #808080;
  border: 1px solid #d8dcdf; }

.my-tooltip [class\$="arrow"] {
  display: none; }

::-ms-clear {
  display: none; }

.hs-button {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  margin: 0;
  cursor: pointer;
  display: inline-block;
  font-weight: 700;
  line-height: 12px;
  position: relative;
  text-align: center;
  transition: all .15s linear;
  background-color: #ff7a59;
  border-color: #ff7a59;
  color: #fff;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  font-size: 14px;
  padding: 12px 24px; }

.hs-button:hover, .hs-button:focus {
  background-color: #ff8f73;
  border-color: #ff8f73; }

.hs-button:active {
  background-color: #e66e50;
  border-color: #e66e50; }

label {
  font-size: 14px;
  width: 130px;
  text-align: right;
  color: #33475b;
  display: block;
  float: none;
  width: auto;
  font-weight: 500;
  text-align: left;
  line-height: 20px;
  padding-top: 0;
  margin-bottom: 4px;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif; }

.hs-video-form label {
  color: #fff !important; }

.hs-video-form .hs-back-button {
  background-color: #fff;
  width: 20%;
  height: 38px;
  margin-right: 10px;
  border: 1px solid;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px; }

.hs-video-form .hs-button {
  width: 70%; }

.hs-video-form .hs-button span {
  font-size: 15px; }

.hs-video-form .hs-richtext {
  color: #fff !important; }

.hs-video-form .legal-consent-container {
  max-height: 180px !important;
  overflow-y: scroll !important; }

.hs-video-form .legal-consent-container:after {
  content: "";
  display: block;
  height: 100px;
  width: 100%; }

.hs-video-form .legal-consent-wrapper {
  position: relative; }

.hs-video-form .legal-consent-overlay {
  position: absolute;
  pointer-events: none;
  left: 0;
  bottom: 0;
  height: 100px;
  width: 100%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #292929 100%); }

.hs-error-msgs label {
  color: #f2545b; }

.hs-input {
  display: inline-block;
  width: 90%;
  max-width: 500px;
  height: 40px;
  padding: 9px 10px;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 16px;
  font-weight: normal;
  line-height: 22px;
  color: #33475b;
  border: 1px solid #cbd6e2;
  box-sizing: border-box;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px; }

.hs-input:not([type=file]) {
  background-color: #f5f8fa; }

.hs-input[type=checkbox], .hs-input[type=radio] {
  cursor: pointer;
  width: auto;
  height: auto;
  padding: 0;
  margin: 3px 5px 3px 0px;
  line-height: normal;
  border: none; }

.hs-input[type=file] {
  padding: initial;
  border: initial;
  line-height: initial;
  box-shadow: none; }

select.is-placeholder {
  color: #bfbfbf; }

select.is-placeholder:focus {
  color: #33475b; }

.hs-input:-moz-placeholder {
  color: #bfbfbf; }

.hs-input::-webkit-input-placeholder {
  color: #bfbfbf; }

.hs-input option:disabled {
  color: #bfbfbf; }

.hs-input input, .hs-input textarea {
  transition: border .2s linear; }

.hs-input:focus {
  outline: none;
  border-color: rgba(82, 168, 236, 0.8); }

textarea.hs-input {
  height: auto; }

select[multiple].hs-input {
  height: inherit; }

input.hs-input.error, div.field.error input, div.field.error textarea, div.field.error .chzn-choices, textarea.hs-input.error, select.hs-input.error {
  border-color: #c87872 !important; }

input.hs-input.error:focus, div.field.error input:focus, div.field.error textarea:focus, div.field.error .chzn-choices:focus, textarea.hs-input.error:focus, select.hs-input.error:focus {
  border-color: #b9554d !important; }

.actions {
  margin-top: 18px;
  margin-bottom: 18px;
  padding: 17px 0px; }

.inputs-list {
  margin: 0 0 5px;
  width: 100%;
  padding-left: 5px; }

.inputs-list > li {
  display: block;
  padding: 0;
  width: 100%;
  padding-top: 0; }

.inputs-list label {
  display: block;
  float: none;
  width: auto;
  padding: 0;
  line-height: 18px;
  text-align: left;
  white-space: normal;
  font-weight: normal; }

.inputs-list:first-child {
  padding-top: 6px; }

.inputs-list > li + li {
  padding-top: 2px; }

ul.no-list {
  list-style: none; }

.field {
  margin-bottom: 18px; }

.hs-field-desc {
  color: #7c98b6;
  margin: 0px 0px 6px;
  font-size: 14px;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif; }

.hs-form-required {
  color: red; }

.hs-richtext {
  margin-bottom: 3px;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  line-height: 24px;
  font-size: 14px;
  color: #33475b; }

.hs-richtext hr {
  text-align: left;
  margin-left: 0;
  width: 91%; }

.email-correction, .email-validation {
  padding-top: 3px;
  font-size: 12px;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif; }

.email-correction a, .email-validation a {
  cursor: pointer; }

@media (max-width: 400px), (min-device-width: 320px) and (max-device-width: 480px) {
  .email-correction form .form-columns-2 .hs-form-field, .email-correction form .form-columns-3 .hs-form-field, .email-validation form .form-columns-2 .hs-form-field, .email-validation form .form-columns-3 .hs-form-field {
    float: none;
    width: 100%; }
  .email-correction form .form-columns-2 .hs-form-field .hs-input, .email-correction form .form-columns-3 .hs-form-field .hs-input, .email-validation form .form-columns-2 .hs-form-field .hs-input, .email-validation form .form-columns-3 .hs-form-field .hs-input {
    width: 90%; }
  .email-correction form .form-columns-2 .hs-form-field input[type=checkbox], .email-correction form .form-columns-2 .hs-form-field input[type=radio], .email-correction form .form-columns-3 .hs-form-field input[type=checkbox], .email-correction form .form-columns-3 .hs-form-field input[type=radio], .email-validation form .form-columns-2 .hs-form-field input[type=checkbox], .email-validation form .form-columns-2 .hs-form-field input[type=radio], .email-validation form .form-columns-3 .hs-form-field input[type=checkbox], .email-validation form .form-columns-3 .hs-form-field input[type=radio] {
    width: 24px; } }

.hs-button, .hs-form-field input[type=text], .hs-form-field input[type=email], .hs-form-field input[type=phone], .hs-form-field input[type=number], .hs-form-field input[type=tel], .hs-form-field input[type=date], .hs-form-field textarea {
  -webkit-appearance: none;
  -moz-appearance: none; }

.hs-default-font-element, .hs-main-font-element {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif; }

.hs-form label {
  margin: 0 !important;
  font-family: "Poppins", sans-serif !important; }

.hs-form input[type="checkbox"] {
  margin: 0 10px 0 0 !important; }

.hs-form fieldset {
  max-width: unset !important; }

.hs-input {
  max-width: unset !important;
  font-family: "Poppins", sans-serif !important; }

.hs-form .input textarea {
  width: 100% !important; }

.hs-form .input select {
  width: 100% !important; }

.hs-form select {
  margin: 0 !important; }

.hs-form textarea {
  margin: 0 !important; }

.hs-form input[type="text"], .hs-form input[type="email"], .hs-form input[type="tel"] {
  margin: 0 !important; }

.hs-form input[type="file" i]::-webkit-file-upload-button {
  cursor: pointer !important; }

.hs-form ::placeholder {
  color: #bfbfbf !important;
  font-weight: 400 !important;
  font-size: 14px !important; }

.hs-form .input input[type="file"] {
  width: 100% !important;
  margin: 0 !important; }

.hs-form .input input[type="text"] {
  width: 100% !important;
  border: 1px solid #cbd6e2;
  border-radius: 3px !important; }

.hs-form .input input[type="text"]::placeholder {
  font-size: 14px !important; }

.hs-field-desc {
  text-align: left !important; }

.hs-form body .hs-button.primary, body input[type="submit"], body input[type="button"] {
  float: none !important;
  margin: 0 !important; }

.hs-form .actions {
  margin: 0 !important;
  text-align: left !important; }

/* OVERRIDE DEFAULT REACT-DATES STYLES */
/*# sourceMappingURL=app.css.map */
/* Will edit everything selected including everything between a range of dates */
.CalendarDay__selected_span {
  background: #3392E6 !important;
  border: 1px double #3392E6 !important;
  color: white !important; }

/* Will edit selected date or the endpoints of a range of dates */
.CalendarDay__selected {
  background: #3392E6 !important;
  border: 1px double #3392E6 !important;
  color: white !important; }

/* Will edit when hovered over. _span style also has this property */
.CalendarDay__selected:hover {
  opacity: 0.8 !important; }

/* Will edit when the second date (end date) in a range of dates */
/* is not yet selected. Edits the dates between your mouse and said date */
.CalendarDay__hovered_span:hover,
.CalendarDay__hovered_span {
  background: #3392E6 !important; }

.DayPickerKeyboardShortcuts_show__bottomRight::before {
  border-right: 33px solid #3392E6 !important;
  border-right-color: #3392E6 !important; }

.SingleDatePicker_picker {
  z-index: 100 !important; }

.SingleDatePicker {
  display: block !important; }

.SingleDatePickerInput {
  display: block !important; }

.DateInput {
  display: block !important;
  width: 100% !important; }

.DateInput_input {
  font-size: 14px !important;
  color: #808080 !important;
  border: 1px solid #ced4da !important;
  box-shadow: none !important;
  border-radius: .25rem !important;
  padding: 10px 0 5px 10px !important;
  font-weight: 400 !important;
  display: block !important;
  width: 100% !important;
  height: calc(2.25rem + 2px) !important; }

.DateInput_input__focused {
  border: 1px solid #ced4da !important;
  border-radius: .25rem !important; }

.DateRangePicker {
  display: block !important; }

.DateRangePickerInput {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important; }

.DateRangePickerInput_arrow {
  padding: 0 10px !important; }

.DateInput_input__disabled {
  font-style: normal !important; }

.hs-form input[type="text"], .hs-form input[type="email"], .hs-form input[type="tel"] {
  border: none;
  box-shadow: none;
  border-radius: 5;
  padding: '5px 0 5px 0';
  font-weight: 400;
  font-size: 14px;
  font-family: 'Roboto';
  letter-spacing: 2;
  line-height: 1.5;
  margin: 5px 0 10px 0;
  color: #0071B9;
  padding-bottom: 5px;
  border: 1px solid #cbd6e2;
  width: 100%; }

.hs-form input[type="checkbox"] {
  margin: 10px 10px 10px 0; }

.hs-form input[type="text"]:focus {
  outline: 0; }

.hs-form input[type="email"]:focus {
  outline: 0; }

.hs-form input[type="tel"]:focus {
  outline: 0; }

.hs-form label {
  font-family: 'Roboto';
  margin: 10px 0; }

.hs-form .hs-form-field > label {
  color: #0071B9;
  font-family: 'Roboto';
  margin: 10px 0; }

.hs-form .hs-field-desc {
  color: #33475b;
  font-family: 'Roboto';
  margin: 5px 0; }

.hs-form select {
  background: whitesmoke;
  margin: 15px 0 25px 0;
  color: #5e7993;
  border-radius: 3px;
  font-family: 'Roboto'; }

.hs-form select:focus {
  outline: none; }

.hs-form select:active {
  outline: none; }

.hs-form .hs-richtext {
  color: #5e7993;
  font-family: 'Roboto';
  margin: 5px 0 20px 0;
  font-size: 14px; }

.hs-form textarea {
  margin: 10px 0;
  color: #0071B9;
  border: 1px solid #d8dcdf;
  border-radius: 0.2rem;
  width: 100%; }

.hs-form textarea:focus {
  outline: none; }

body .hs-button.primary,
body input[type="submit"],
body input[type="button"] {
  background: #0071B9;
  color: #ffffff;
  border-radius: .2rem;
  padding: 1em;
  font-size: 14px;
  font-weight: 400;
  padding: 10px 20px;
  margin-bottom: -70px;
  font-family: 'Roboto';
  border: 1px solid #0071B9;
  -webkit-transition: all .3s ease-in-out;
  -moz-transition: all .3s ease-in-out;
  -ms-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out;
  margin: 30px 0 0 10px; }

body .hs-button.primary:hover,
body input[type="submit"]:hover,
body input[type="button"]:hover {
  cursor: pointer;
  opacity: .8; }

body input[type="file"] {
  margin: 25px 0 25px 0;
  font-family: 'Roboto'; }

.hs-form .hs-error-msgs label {
  color: #d8000c;
  font-size: 13px;
  padding-bottom: 5px; }

.material-icons {
  user-select: none; }

.d-inline-block {
  user-select: none; }

/*Typography Styles*/
h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  font-weight: 400;
  margin: 0 0 12px;
  color: inherit; }

h1, .h1 {
  font-size: 24px;
  font-family: 'Poppins', sans-serif; }

h2, .h2 {
  font-size: 18px;
  font-family: 'Poppins', sans-serif; }

h3, .h3 {
  font-size: 16px; }

h4, .h4 {
  font-size: 15px; }

h5, .h5 {
  font-size: 13px; }

h6, .h6 {
  font-size: 12px; }

.text-strikethrough {
  text-decoration: line-through !important; }

@media screen and (max-width: 991px) {
  h1, .h1 {
    font-size: 18px;
    font-family: 'Poppins', sans-serif; }
  h2, .h2 {
    font-size: 16px;
    font-family: 'Poppins', sans-serif; }
  h3, .h3 {
    font-size: 15px; } }

.desc-list {
  margin-bottom: 0; }
  .desc-list li {
    padding: 24px 30px;
    border-bottom: 1px solid #ced4da;
    margin-left: -30px;
    margin-right: -30px; }
    .desc-list li:last-child {
      border-bottom: 0 none; }
    .desc-list li .card-title {
      margin-bottom: 6px; }
  .desc-list.even-odd li {
    border-bottom: 0 none; }
    .desc-list.even-odd li:nth-child(2n) {
      background-color: #dee2e6; }

/* Layouts
   ========================================================================== */
/*App Layout Styles*/
#app-site,
.app-main {
  display: flex;
  width: 100%;
  height: 100%; }

.app-container {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%; }

.app-sidebar {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 200px;
  min-width: 200px;
  max-width: 200px; }

.app-main-container {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  overflow: hidden;
  position: relative; }

.app-header {
  min-height: 60px;
  z-index: 99;
  position: relative; }

.app-main-content-wrapper {
  flex: 1;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto; }

.app-container.fixed-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important; }

.app-container.collapsible-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important; }

.app-container.collapsible-drawer .app-main-container {
  position: relative; }

.app-container.mini-drawer .app-main-header {
  width: auto !important;
  -webkit-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: all 0.5s cubic-bezier(0, 0, 0.2, 1) !important; }

.app-container.mini-drawer .app-sidebar {
  width: 80px;
  min-width: 80px;
  max-width: 80px; }

/*Sidebar Styles*/
.side-nav {
  width: 200px;
  background-color: #f5f7f9 !important;
  color: #868e96 !important;
  border-right: solid 1px #e9ecef !important;
  z-index: 1250 !important;
  height: 100%; }
  .side-nav .user-profile {
    background-color: #ebeff3;
    padding: 13px 20px !important; }
  .side-nav .user-avatar {
    margin: 0 15px 0 0 !important;
    height: 44px !important;
    width: 44px !important;
    line-height: 44px; }
  .side-nav .user-detail .user-name {
    color: #3f51b5;
    cursor: pointer;
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap; }

.user-detail .user-name {
  cursor: pointer; }

/*Navbar Styles*/
ul.nav-menu {
  position: relative;
  font-size: 13px;
  list-style: outside none none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%; }

ul.nav-menu li {
  position: relative;
  margin-bottom: 1px; }

ul.nav-menu li.menu + .nav-header {
  margin-top: 40px; }

ul.nav-menu li.menu .sub-menu {
  display: none; }

ul.nav-menu li.menu.open > .sub-menu {
  display: block; }

ul.nav-menu li.menu.open .menu.active > .sub-menu {
  display: block; }

ul.nav-menu li a {
  color: #868e96;
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  border-radius: 0; }
  ul.nav-menu li a .badge {
    margin-bottom: 0;
    padding: 3px 8px 2px; }

ul.nav-menu .nav-header {
  color: #868e96;
  padding: 4px 22px;
  font-size: 11px;
  text-transform: uppercase; }
  ul.nav-menu .nav-header:first-child {
    margin-top: 30px; }

ul.nav-menu > li.selected > a,
ul.nav-menu > li.open > a,
ul.nav-menu > li > a:hover,
ul.nav-menu > li > a:focus {
  color: #3f51b5; }

ul.nav-menu li.menu > a {
  padding: 16px 20px;
  border-left: 2px solid transparent; }

ul.nav-menu li.menu.open > a {
  border-color: transparent; }

ul.nav-menu li.menu > a:focus:before,
ul.nav-menu li.menu > a:hover:before {
  color: #3f51b5; }

ul.nav-menu li i {
  margin-right: 12px;
  font-size: 15px; }

ul.nav-menu li ul {
  list-style: outside none none;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden; }

ul.nav-menu li ul.sub-menu li > a {
  padding: 7px 20px 7px 56px; }

ul.nav-menu li ul.sub-menu > li > ul > li > a {
  padding-left: 76px; }

ul.nav-menu li ul.sub-menu > li > ul > li > ul > li > a {
  padding-left: 96px; }

ul.nav-menu li ul.sub-menu > li > ul > li > ul > li > ul > li > a {
  padding-left: 116px; }

ul.nav-menu li.menu > a:before {
  color: #868e96;
  content: "\\f2fb";
  display: inline-block;
  float: right;
  font-family: 'Material-Design-Iconic-Font';
  font-size: 15px;
  margin-left: 10px;
  position: relative;
  -webkit-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
  font-weight: normal; }

ul.nav-menu li.menu.no-arrow > a:before {
  display: none; }

ul.nav-menu li.menu.selected > a:before,
ul.nav-menu li.menu.open > a:before,
ul.nav-menu li.menu > a:focus:before,
ul.nav-menu li.menu li > a:hover:before {
  background-color: transparent;
  color: #3f51b5; }

ul.nav-menu li.menu.open > a:before,
ul.nav-menu li.menu.active > a:before {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg); }

ul.nav-menu li.menu .sub-menu li > a.active .nav-text {
  padding: 3px 7px;
  margin-left: -7px;
  background-color: #3f51b5;
  color: #fff;
  border-radius: 4px;
  display: inline-block; }

ul.nav-menu li.menu .sub-menu li > a:hover,
ul.nav-menu li.menu .sub-menu li > a:focus,
ul.nav-menu li.menu.open .sub-menu li > a.active:before,
ul.nav-menu li.menu .sub-menu li > a:focus:before,
ul.nav-menu li.menu .sub-menu li > a:hover:before {
  color: #3f51b5; }

.app-container.mini-drawer .side-nav {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  width: 80px; }
  .app-container.mini-drawer .side-nav .nav-menu li span.nav-text,
  .app-container.mini-drawer .side-nav .customizer {
    display: none; }
  .app-container.mini-drawer .side-nav .user-profile .user-detail {
    display: none !important; }
  .app-container.mini-drawer .side-nav .nav-menu .menu.open > .sub-menu {
    display: none !important; }
  .app-container.mini-drawer .side-nav .nav-menu li {
    text-align: center; }
    .app-container.mini-drawer .side-nav .nav-menu li i {
      margin-right: 0; }
    .app-container.mini-drawer .side-nav .nav-menu li.nav-header {
      padding: 4px 5px; }
  .app-container.mini-drawer .side-nav ul.nav-menu li a {
    padding: 16px 20px; }
  .app-container.mini-drawer .side-nav ul.nav-menu ul.sub-menu li a {
    padding-left: 30px; }
  .app-container.mini-drawer .side-nav ul.nav-menu > li > a:before {
    display: none; }
  .app-container.mini-drawer .side-nav .mini-logo-img-hover {
    display: none; }

.app-container.mini-drawer .side-nav:hover {
  width: 200px; }
  .app-container.mini-drawer .side-nav:hover .nav-menu li span.nav-text {
    display: inline-block !important; }
  .app-container.mini-drawer .side-nav:hover .user-profile .user-detail {
    display: flex !important; }
  .app-container.mini-drawer .side-nav:hover .nav-menu .menu.open > .sub-menu {
    display: block !important; }
  .app-container.mini-drawer .side-nav:hover .customizer {
    display: flex !important; }
  .app-container.mini-drawer .side-nav:hover ul.nav-menu li {
    text-align: left; }
    .app-container.mini-drawer .side-nav:hover ul.nav-menu li i {
      margin-right: 16px; }
    .app-container.mini-drawer .side-nav:hover ul.nav-menu li a {
      padding: 16px 20px; }
    .app-container.mini-drawer .side-nav:hover ul.nav-menu li.nav-header {
      padding: 4px 22px; }
  .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu li a {
    padding: 7px 20px 7px 56px; }
  .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > a {
    padding-left: 76px; }
  .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > ul > li > a {
    padding-left: 96px; }
  .app-container.mini-drawer .side-nav:hover ul.nav-menu ul.sub-menu > li > ul > li > ul > li > ul > li > a {
    padding-left: 116px; }
  .app-container.mini-drawer .side-nav:hover ul.nav-menu > li > a:before {
    display: block; }
  .app-container.mini-drawer .side-nav:hover .mini-logo-img {
    display: none; }
  .app-container.mini-drawer .side-nav:hover .mini-logo-img-hover {
    display: block; }

.customizer {
  padding: 20px 35px; }
  .customizer img {
    padding: 5px;
    cursor: pointer; }

.user-info ul li {
  font-size: 15px; }

.rmc-drawer-left .rmc-drawer-sidebar,
.rmc-drawer-right .rmc-drawer-sidebar {
  height: 100%; }

.rmc-drawer-sidebar {
  position: fixed;
  transition: -webkit-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
  overflow: hidden; }
  .rmc-drawer.rmc-drawer-left .rmc-drawer-sidebar {
    left: 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    z-index: 903; }
  .rmc-drawer.rmc-drawer-right .rmc-drawer-sidebar {
    right: 0;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    z-index: 903; }
  .rmc-drawer.rmc-drawer-top .rmc-drawer-sidebar {
    z-index: 903; }
  .rmc-drawer.rmc-drawer-bottom .rmc-drawer-sidebar {
    z-index: 903; }

@media (max-width: 1025px) {
  .rmc-drawer-draghandle {
    background-color: transparent; } }

.drawer-container {
  position: relative; }
  .drawer-container .main {
    position: relative;
    padding: 10px;
    box-sizing: border-box; }

.rmc-drawer-overlay {
  z-index: 902;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.3);
  height: 100%;
  min-width: 100% !important; }

.app-sidebar.rmc-drawer.rmc-drawer-docked {
  position: relative; }

/*Header Styles*/
.jr-menu-icon {
  outline: none !important;
  -webkit-justify-content: flex-start !important;
  justify-content: flex-start !important;
  padding: 0 5px !important;
  margin-right: 15px;
  display: flex;
  cursor: pointer;
  align-items: center; }

.app-main-header {
  background-color: #fff;
  color: #808080;
  max-height: 70px;
  position: relative; }
  .app-main-header .search-bar input {
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    background-color: transparent;
    color: #808080;
    font-weight: 200; }
    .app-main-header .search-bar input + .search-icon {
      top: 0; }
      .app-main-header .search-bar input + .search-icon i {
        color: rgba(128, 128, 128, 0.8);
        font-size: 32px; }
    .app-main-header .search-bar input::placeholder {
      color: grey; }
    .app-main-header .search-bar input:focus {
      background-color: #fff;
      color: #808080; }
      .app-main-header .search-bar input:focus + .search-icon i {
        color: rgba(128, 128, 128, 0.8); }
  .jr-card .app-main-header {
    border: 1px solid #ced4da;
    border-radius: 8px; }

.app-logo {
  margin-right: 12px; }
  .app-logo img {
    height: 35px; }
    @media screen and (max-width: 575px) {
      .app-logo img {
        height: 28px; } }
  .app-header .app-logo {
    margin-right: 20px; }
    @media screen and (max-width: 991px) {
      .app-header .app-logo {
        margin-right: auto; } }

.react-logo-white.d-block {
  display: none !important; }

@media screen and (min-width: 992px) {
  .react-logo-white.d-lg-block {
    display: none !important; } }

.sidebar-header {
  min-height: 70px;
  padding: 10px 22px; }

.app-toolbar {
  min-height: 60px;
  padding: 0 17px 0 0; }
  .app-toolbar .search-bar {
    margin-right: auto;
    max-width: 320px;
    width: 300px; }
    @media screen and (max-width: 1199px) {
      .app-toolbar .search-bar {
        width: 240px; } }
    @media screen and (max-width: 1099px) {
      .app-toolbar .search-bar {
        width: 200px; } }
    @media screen and (max-width: 767px) {
      .app-toolbar .search-bar {
        margin-left: 40px;
        width: 180px; } }
  @media screen and (max-width: 575px) {
    .app-toolbar {
      padding: 0 17px; } }
  @media screen and (max-width: 1199px) {
    .app-toolbar {
      padding: 0 17px; } }
  .app-top-nav .app-toolbar {
    min-height: 40px; }

@media screen and (max-width: 1199px) {
  .app-header-horizontal .app-toolbar .search-bar {
    margin-right: 10px; } }

.app-toolbar-special .search-bar {
  width: 200px; }
  @media screen and (max-width: 991px) {
    .app-toolbar-special .search-bar {
      width: 280px; } }
  @media screen and (max-width: 767px) {
    .app-toolbar-special .search-bar {
      width: 200px; } }

.app-toolbar .nav-searchbox .search-bar {
  margin-left: 0;
  width: 100%; }

.app-toolbar .nav-searchbox .search-bar input {
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  color: #5c5c5c; }
  .app-toolbar .nav-searchbox .search-bar input + .search-icon i {
    color: rgba(92, 92, 92, 0.8); }
  .app-toolbar .nav-searchbox .search-bar input:focus {
    background-color: transparent;
    color: #5c5c5c; }
    .app-toolbar .nav-searchbox .search-bar input:focus + .search-icon i {
      color: rgba(92, 92, 92, 0.8); }

.header-notifications {
  margin-bottom: 0; }
  .header-notifications li {
    vertical-align: middle; }
  @media screen and (max-width: 449px) {
    .header-notifications .list-inline-item:not(:last-child) {
      margin-right: 0; } }

.dropdown-menu {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none; }

.quick-menu .dropdown-menu {
  padding: 5px 10px;
  width: 350px; }
  .quick-menu .dropdown-menu .jr-card-header {
    margin: -5px -10px 5px;
    padding: 10px 10px 10px 20px;
    border-bottom: 1px solid #dee2e6;
    z-index: 10; }
  .quick-menu .dropdown-menu:after {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #fff;
    top: -9px;
    content: "";
    height: 9px;
    position: absolute;
    right: 8px;
    width: 10px; }
  .quick-menu .dropdown-menu:before {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #000;
    top: -10px;
    content: "";
    height: 10px;
    position: absolute;
    right: 8px;
    width: 10px; }
  @media screen and (max-width: 449px) {
    .quick-menu .dropdown-menu {
      width: 230px; } }
  @media screen and (max-width: 359px) {
    .quick-menu .dropdown-menu {
      width: 180px; } }

.quick-menu .messages-list .user-avatar {
  position: relative; }

.quick-menu .messages-list .badge {
  position: absolute;
  left: -4px;
  top: -4px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  padding: 0; }

.app-header .nav-searchbox.quick-menu .dropdown-menu {
  width: 200px;
  left: 0 !important;
  right: auto !important; }

.app-header .nav-searchbox.quick-menu .dropdown-menu:after {
  right: auto;
  left: 8px; }

.app-header .nav-searchbox.quick-menu .dropdown-menu:before {
  right: auto;
  left: 8px; }

@media screen and (max-width: 400px) {
  .app-header .nav-searchbox.quick-menu {
    display: none; } }

@media screen and (max-width: 575px) {
  .app-header .nav-searchbox.quick-menu .dropdown-menu {
    width: 200px; } }

@media screen and (max-width: 399px) {
  .app-header .nav-searchbox.quick-menu .dropdown-menu {
    width: 100px; } }

.language-list li {
  display: block !important; }

.messages-list.language-list ul li {
  padding: 7px 6px 6px; }

.messages-list ul li {
  position: relative;
  padding: 20px 10px 14px;
  border-bottom: 1px solid #dee2e6; }
  .messages-list ul li .user-name a {
    color: #3f51b5; }
  .messages-list ul li .sub-heading {
    font-size: 11px;
    margin-bottom: 6px !important; }
    .messages-list ul li .sub-heading.mb-0 {
      margin-bottom: 0 !important; }
  .messages-list ul li:last-child {
    border-bottom: 0 none; }
  .messages-list ul li .jr-btn {
    margin-right: 0 !important; }
  .messages-list ul li .jr-btn-xs {
    font-size: 11px !important;
    padding: 5px !important; }

.quick-menu .icon-btn {
  color: #808080; }

.quick-menu .icon-alert {
  position: relative; }
  .quick-menu .icon-alert:after {
    display: block;
    position: absolute;
    content: "";
    right: 0;
    top: 0;
    z-index: 10;
    width: 8px;
    height: 8px;
    background-color: #f44336;
    border-radius: 50%; }

.quick-menu i.animated.infinite {
  -moz-animation-iteration-count: 25;
  -webkit-animation-iteration-count: 25;
  -o-animation-iteration-count: 25;
  animation-iteration-count: 25; }

.quick-menu .dropdown-menu {
  display: block;
  visibility: hidden;
  left: auto !important;
  right: 0 !important;
  opacity: 0;
  transform: translate3d(0px, 100px, 0px) !important;
  -webkit-transition: all 200ms linear 0ms;
  -o-transition: all 200ms linear 0ms;
  transition: all 200ms linear 0ms; }

.quick-menu.show .dropdown-menu {
  opacity: 1;
  transform: translate3d(0px, 30px, 0px) !important;
  visibility: visible; }

.user-nav .quick-menu .dropdown-menu {
  width: 200px;
  padding: 0 0 15px; }
  .user-nav .quick-menu .dropdown-menu:after {
    border-bottom-color: #fff; }

.user-nav .quick-menu .user-profile {
  position: relative;
  padding: 20px 25px;
  background-color: #fff;
  margin-bottom: 15px;
  border-radius: 0.25rem 0.25rem 0 0; }

.module-box-header-right {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center; }

.app-top-header {
  position: relative;
  z-index: 9999; }

/*Navbar Styles*/
.app-main-menu .navbar-nav {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; }

.navbar-nav {
  position: relative; }
  .navbar-nav li {
    position: relative; }
    .navbar-nav li:hover > ul.sub-menu, .navbar-nav li:focus > ul.sub-menu {
      opacity: 1;
      visibility: visible;
      top: 100%; }
    .navbar-nav li:hover > a, .navbar-nav li:focus > a {
      color: #3f51b5; }
    .navbar-nav li a {
      display: block;
      color: #868e96;
      padding: 10px 0;
      font-size: 14px; }
    .navbar-nav li a:hover,
    .navbar-nav li a:focus {
      text-decoration: none;
      color: #3f51b5; }
    .navbar-nav li.mega-menu {
      position: static; }
    .navbar-nav li.mega-menu ul.sub-menu {
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      -webkit-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      width: 85%;
      margin: 0 auto;
      left: 0;
      right: 0; }
      .navbar-nav li.mega-menu ul.sub-menu li {
        width: 25%;
        padding: 0 15px; }
  .navbar-nav > li:last-child ul.sub-menu {
    left: auto;
    right: 0; }
  .navbar-nav > li:last-child ul.sub-menu ul.sub-menu {
    left: auto;
    right: 100%;
    top: 50px; }
  .navbar-nav > li:last-child ul.sub-menu li:hover > ul.sub-menu,
  .navbar-nav > li:last-child ul.sub-menu li:focus > ul.sub-menu {
    top: 0; }
  .navbar-nav li.nav-item {
    padding: 0 10px; }
    .navbar-nav li.nav-item > a {
      padding: 23px 0; }
    .navbar-nav li.nav-item.active > a {
      color: #3f51b5; }
  .navbar-nav li.nav-item:hover > a,
  .navbar-nav li.nav-item:focus > a,
  .navbar-nav li.nav-item > a:hover,
  .navbar-nav li.nav-item > a:focus {
    color: #3f51b5; }
  .navbar-nav ul.sub-menu {
    list-style: none;
    border: solid 1px #ced4da;
    position: absolute;
    left: 0;
    top: 100px;
    opacity: 0;
    padding: 10px 0;
    background-color: #fff;
    visibility: hidden;
    border-radius: 4px;
    -webkit-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out; }
    .navbar-nav ul.sub-menu li a {
      padding: 5px 15px;
      width: 200px;
      font-size: 14px; }
      .navbar-nav ul.sub-menu li a.active {
        color: #3f51b5; }
    .navbar-nav ul.sub-menu li > ul.sub-menu {
      left: 100%;
      right: auto;
      top: 50px; }
    .navbar-nav ul.sub-menu li:hover > ul.sub-menu,
    .navbar-nav ul.sub-menu li:focus > ul.sub-menu {
      top: 0; }
    .navbar-nav ul.sub-menu li a i {
      margin-right: 10px; }
    .navbar-nav ul.sub-menu li.active > a {
      color: #3f51b5; }
  .navbar-nav .nav-arrow > a {
    position: relative; }
    .navbar-nav .nav-arrow > a:before {
      color: #868e96;
      content: "\\f2fb";
      display: inline-block;
      float: right;
      font-family: 'Material-Design-Iconic-Font';
      font-size: 15px;
      margin-left: 10px;
      position: relative;
      -webkit-transition: all 300ms ease-in-out;
      -o-transition: all 300ms ease-in-out;
      transition: all 300ms ease-in-out;
      font-weight: normal; }
  .navbar-nav .nav-arrow a:hover:before,
  .navbar-nav .nav-arrow a:focus:before {
    color: #3f51b5; }
  .navbar-nav .nav-arrow:hover > a:before, .navbar-nav .nav-arrow:focus > a:before, .navbar-nav .nav-arrow.active > a:before {
    color: #3f51b5; }
  .navbar-nav ul.sub-menu-half {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 300px; }
    .navbar-nav ul.sub-menu-half li {
      width: 50%; }
      .navbar-nav ul.sub-menu-half li a {
        width: 100%; }
        @media screen and (max-width: 1099px) {
          .navbar-nav ul.sub-menu-half li a {
            font-size: 13px; } }
    @media screen and (max-width: 1099px) {
      .navbar-nav ul.sub-menu-half {
        width: 262px; } }

.navbar-nav-mega {
  position: static !important; }

.app-top-nav {
  background-color: #3f51b5; }
  .app-top-nav .navbar-nav li.nav-item {
    padding: 0 30px; }
  .app-top-nav .navbar-nav li.nav-item > a {
    color: #fff;
    padding: 13px 0; }
  .app-top-nav .navbar-nav li.nav-item:hover > a,
  .app-top-nav .navbar-nav li.nav-item:focus > a,
  .app-top-nav .navbar-nav li.nav-item > a:hover,
  .app-top-nav .navbar-nav li.nav-item > a:focus,
  .app-top-nav .navbar-nav li.nav-item.active > a {
    color: #E91E63; }
  .app-top-nav .navbar-nav ul.sub-menu {
    margin-top: 0; }

/*Main Content Styles*/
.app-main-content {
  flex: 1;
  width: 100%; }
  @media screen and (max-width: 575px) {
    .app-main-content {
      padding: 0; } }

.app-wrapper {
  padding: 36px 40px 0 40px;
  width: 100%; }
  @media screen and (max-width: 575px) {
    .app-wrapper {
      padding: 20px; } }

/*Footer Styles*/
.app-footer {
  padding: 0 40px;
  border-top: solid 1px #e6e6e6;
  background-color: #fff;
  color: #868e96;
  line-height: 50px;
  min-height: 50px; }
  .app-footer a {
    color: #868e96; }
    .app-footer a:hover {
      color: #3f51b5; }
  @media screen and (max-width: 575px) {
    .app-footer {
      padding: 20px; } }
  @media screen and (max-width: 400px) {
    .app-footer {
      font-size: 12px; } }

/*Right Sidebar Styles*/
.color-theme {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: 300px;
  height: 100%; }
  @media screen and (max-width: 499px) {
    .color-theme {
      max-width: 250px; } }

.color-theme-header {
  background-color: #3f51b5;
  color: #fff;
  padding: 19px 25px 20px;
  text-transform: uppercase;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between; }
  .color-theme-header .color-theme-title {
    margin-bottom: 0; }

.color-theme-body {
  padding: 28px 25px; }
  .color-theme-body h3 {
    margin-bottom: 20px; }
  @media screen and (max-width: 499px) {
    .color-theme-body {
      padding: 25px 15px; } }

.color-option {
  list-style: none;
  padding-left: 0;
  margin: 0 -7px 10px; }
  .color-option li {
    position: relative;
    display: inline-block;
    padding: 0 7px;
    margin-bottom: 10px; }
  .color-option li a {
    height: 45px;
    width: 45px;
    line-height: 45px;
    display: inline-block;
    color: transparent !important;
    position: relative; }
    .color-option li a:before {
      content: "\\f26b";
      font-family: "Material-Design-Iconic-Font";
      font-size: 20px;
      height: 45px;
      width: 45px;
      line-height: 45px;
      position: absolute;
      top: 0;
      left: 0;
      color: #fff;
      text-align: center;
      display: none;
      z-index: 2; }
  .color-option li a.active:before {
    display: block; }

.cr-op-dark-sidebar li a:after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  background-color: #5c5c5c;
  width: 8px; }

.theme-option {
  position: fixed;
  top: 10%;
  right: 0;
  z-index: 1500;
  background-color: #0070cd;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -o-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  color: #fff; }
  .theme-option span.icon-btn {
    position: relative;
    z-index: 1505; }

.app-sidebar-content.right-sidebar .rmc-drawer-sidebar {
  z-index: 1506;
  color: #5c5c5c;
  background-color: #fff; }

.material-switch {
  margin-bottom: 24px; }
  .material-switch > input[type="checkbox"] {
    display: none; }
  .material-switch > label {
    cursor: pointer;
    height: 0;
    position: relative;
    width: 40px; }
    .material-switch > label:before {
      background: black;
      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
      border-radius: 8px;
      content: '';
      height: 16px;
      margin-top: -8px;
      position: absolute;
      opacity: 0.3;
      transition: all 0.4s ease-in-out;
      width: 40px; }
    .material-switch > label:after {
      background: white;
      border-radius: 16px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
      content: '';
      height: 24px;
      left: -4px;
      margin-top: -8px;
      position: absolute;
      top: -4px;
      transition: all 0.3s ease-in-out;
      width: 24px; }
  .material-switch > input[type="checkbox"]:checked + label::before {
    background: #000;
    opacity: 0.5; }
  .material-switch > input[type="checkbox"]:checked + label::after {
    background: #495057;
    left: 20px; }

@media screen and (max-width: 499px) {
  .color-theme .jr-btn {
    padding: 10px 15px !important; } }

/* UI Components
   ========================================================================== */
/*Alert Styles*/
.alert {
  border: 0 none;
  padding: 20px 24px;
  border-radius: 8px;
  position: relative; }
  .alert .close {
    line-height: inherit;
    font-weight: 300; }
  .alert .alert-addon {
    width: 60px;
    background-color: rgba(0, 0, 0, 0.2);
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 1; }

.alert-dismissible {
  padding-right: 60px; }

.alert-addon-card {
  padding-left: 80px; }

/*Avatar Styles*/
.user-avatar {
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  position: relative;
  overflow: hidden;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  border-radius: 50%;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  border: 1px solid #ced4da; }
  .user-avatar.avatar-shadow {
    border: 0 none; }

.user-profile {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: flex-start;
  align-items: flex-start; }
  .user-profile .user-detail {
    -webkit-flex: 1;
    flex: 1;
    -ms-flex-align: center;
    -webkit-align-self: center;
    align-self: center; }

.user-detail .user-name {
  margin-bottom: 2px;
  font-weight: 400;
  text-transform: capitalize; }

.user-detail .user-description {
  font-size: 12px;
  margin-bottom: 0;
  color: #adb5bd; }

.user-thumb {
  position: relative; }
  .messages-list .user-thumb {
    margin-right: 8px; }

/*Badges Styles*/
.badge {
  font-weight: 400;
  padding: 3px 8px;
  line-height: inherit;
  margin-bottom: 6px;
  border-radius: 2px; }
  .badge:not(:last-child) {
    margin-right: 15px; }
  table .badge {
    margin-bottom: 0; }

.badge-pill {
  border-radius: 20px; }

.badge-border {
  border: 2px solid !important; }

.badge-outline {
  background-color: transparent;
  border: 1px solid #ced4da; }

/*Blockquotes Styles*/
blockquote {
  padding: 10px 0 10px 20px;
  font-size: 13px !important; }
  blockquote .blockquote-footer {
    font-size: 13px !important; }

.blockquote {
  border-left: 5px solid #e9ecef; }

.blockquote-reverse {
  border-left: 0 none;
  border-right: 5px solid #e9ecef;
  text-align: right;
  padding-left: 0;
  padding-right: 20px; }

/*Bottom Navigation Styles*/
.bottom-navigation button {
  min-width: 10px !important; }

/*Breadcrumb Styles*/
.breadcrumb {
  border-radius: 2px; }

.breadcrumb-item + .breadcrumb-item::before {
  content: '\\F2FB';
  font-family: 'Material-Design-Iconic-Font';
  font-size: 16px;
  line-height: 1;
  vertical-align: middle; }

/*Button Styles*/
button {
  outline: 0 none !important;
  cursor: pointer;
  border: 1px solid transparent; }

.jr-btn {
  position: relative;
  display: inline-block;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.2;
  border-radius: 4px;
  vertical-align: top;
  cursor: pointer;
  text-align: center; }
  .jr-btn:hover, .jr-btn:focus, .jr-btn:active {
    outline: 0 none;
    text-decoration: none;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    -o-box-shadow: none !important;
    box-shadow: none !important; }
  .login-content .jr-btn {
    padding: 10px 35px; }

.btn:hover, .btn:focus, .btn:active {
  outline: 0 none;
  text-decoration: none;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important; }

.login-content .btn {
  padding: 10px 35px; }

.btn,
.btn-info,
.btn-success,
.btn-warning,
.btn-danger,
.btn-light,
.btn-dark,
.btn-primary,
.btn-secondary {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important; }

.show > .btn.dropdown-toggle:focus,
.show > .btn-info.dropdown-toggle:focus,
.show > .btn-success.dropdown-toggle:focus,
.show > .btn-warning.dropdown-toggle:focus,
.show > .btn-danger.dropdown-toggle:focus,
.show > .btn-light.dropdown-toggle:focus,
.show > .btn-dark.dropdown-toggle:focus,
.show > .btn-primary.dropdown-toggle:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important; }

.jr-btn,
.jr-fab-btn,
.jr-flat-btn,
.btn {
  margin-bottom: 6px; }
  .jr-btn:not(:last-child),
  .jr-fab-btn:not(:last-child),
  .jr-flat-btn:not(:last-child),
  .btn:not(:last-child) {
    margin-right: 15px; }
  .form-inline .jr-btn, .form-inline
  .jr-fab-btn, .form-inline
  .jr-flat-btn, .form-inline
  .btn {
    margin-bottom: 0;
    min-height: 35px; }
  .navbar .jr-btn, .navbar
  .jr-fab-btn, .navbar
  .jr-flat-btn, .navbar
  .btn {
    margin-bottom: 0; }

.btn-primary:focus, .btn-primary.focus {
  box-shadow: none !important; }

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-append > .btn {
  margin-right: 0;
  margin-bottom: 0;
  line-height: inherit; }

.jr-fab-btn {
  position: relative;
  display: inline-flex;
  border-radius: 50%;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  background-color: #eeeeee;
  overflow: hidden; }
  .jr-fab-btn:hover, .jr-fab-btn:focus {
    outline: 0 none;
    text-decoration: none; }

.jr-btn,
.jr-flat-btn {
  padding: 12px 20px; }
  .jr-btn i + span,
  .jr-btn span + i,
  .jr-flat-btn i + span,
  .jr-flat-btn span + i {
    margin-left: 6px; }

.jr-flat-btn {
  background-color: transparent;
  color: #5c5c5c; }
  .jr-flat-btn:hover, .jr-flat-btn:focus, .jr-flat-btn:active {
    background-color: #f5f5f5;
    color: #5c5c5c; }

.jr-btn-group {
  margin: 0 -8px; }
  .jr-btn-group:not(:last-child) {
    margin-bottom: 16px; }
  .jr-btn-group .jr-btn,
  .jr-btn-group .jr-fab-btn {
    margin: 0 8px 18px; }

.jr-btn-rounded {
  border-radius: 50px !important; }

.jr-btn-lg, .btn-group-lg > .jr-btn {
  padding: 16px 24px; }

.jr-btn-sm, .btn-group-sm > .jr-btn {
  padding: 8px 15px; }

.jr-btn-xs {
  padding: 6px 10px; }

.jr-btn-fab-lg, .jr-btn-lg, .btn-group-lg > .jr-btn {
  font-size: 17px; }
  .jr-btn-fab-lg i,
  .jr-btn-lg i,
  .btn-group-lg > .jr-btn i {
    font-size: 19px; }

.jr-btn-fab-sm, .jr-btn-sm, .btn-group-sm > .jr-btn {
  font-size: 11px; }
  .jr-btn-fab-sm i,
  .jr-btn-sm i,
  .btn-group-sm > .jr-btn i {
    font-size: 11px; }

.jr-btn-fab-xs,
.jr-btn-xs {
  font-size: 10px; }
  .jr-btn-fab-xs i,
  .jr-btn-xs i {
    font-size: 10px; }

.complex-btn-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-width: 200px;
  width: 100%; }

.complex-btn {
  position: relative;
  height: 200px;
  overflow: hidden;
  width: 33.333%;
  border: 0 none; }
  @media screen and (max-width: 767px) {
    .complex-btn {
      width: 100%;
      height: 100px; } }
  .complex-btn:hover {
    z-index: 1; }
    .complex-btn:hover .img-btn-overlay {
      opacity: 0.15; }
    .complex-btn:hover .img-marked {
      opacity: 0; }
    .complex-btn:hover .img-title {
      border: 4px solid currentColor; }
  .complex-btn .img-btn {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    color: #fff; }
  .complex-btn .img-src {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-size: cover;
    background-position: center 40%; }
  .complex-btn .img-btn-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #000;
    opacity: 0.4;
    -webkit-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    -o-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1); }
  .complex-btn .img-title {
    position: relative;
    padding: 16px 32px 14px; }
  .complex-btn .img-marked {
    height: 3px;
    width: 18px;
    background: #fff;
    position: absolute;
    bottom: -2px;
    left: calc(50% - 9px);
    -webkit-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    -o-transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1); }

.btn-group-mins {
  margin: 0 -5px; }
  .btn-group-mins .btn,
  .btn-group-mins .jr-btn {
    margin: 0 5px 5px; }

.jr-btn.jr-btn-label i {
  background-color: rgba(255, 255, 255, 0.2);
  width: 40px;
  height: 100%;
  line-height: 42px;
  text-align: center; }

.jr-btn.jr-btn-label.left i {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1; }

.jr-btn.jr-btn-label.right i {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1; }

.jr-btn.jr-btn-label.left i + span {
  margin-left: 30px; }

.jr-btn.jr-btn-label.right i + span {
  margin-right: 30px;
  margin-left: 0; }

.jr-btn.jr-btn-label.jr-btn-lg i, .btn-group-lg > .jr-btn.jr-btn-label i {
  line-height: 54px; }

.jr-btn.jr-btn-label.jr-btn-sm i, .btn-group-sm > .jr-btn.jr-btn-label i {
  line-height: 32px; }

.jr-btn.jr-btn-label.jr-btn-xs i {
  line-height: 24px;
  width: 30px; }

.btn-primary {
  background-color: #3f51b5;
  color: #fff; }
  .btn-primary:hover, .btn-primary:focus {
    background-color: #3849a2;
    color: #fff; }

.btn-red {
  background-color: #F44336;
  color: #fff; }
  .btn-red:hover, .btn-red:focus {
    background-color: #f32c1e;
    color: #fff; }

.btn-pink {
  background-color: #e91e63;
  color: #fff; }
  .btn-pink:hover, .btn-pink:focus {
    background-color: #d81558;
    color: #fff; }

.btn-purple {
  background-color: #9C27B0;
  color: #fff; }
  .btn-purple:hover, .btn-purple:focus {
    background-color: #89229b;
    color: #fff; }

.btn-deep-purple {
  background-color: #673ab7;
  color: #fff; }
  .btn-deep-purple:hover, .btn-deep-purple:focus {
    background-color: #5c34a4;
    color: #fff; }

.btn-indigo {
  background-color: #3f51b5;
  color: #fff; }
  .btn-indigo:hover, .btn-indigo:focus {
    background-color: #3849a2;
    color: #fff; }

.btn-blue {
  background-color: #2196F3;
  color: #fff; }
  .btn-blue:hover, .btn-blue:focus {
    background-color: #0d8aee;
    color: #fff; }

.btn-light-blue {
  background-color: #03a9f4;
  color: #fff; }
  .btn-light-blue:hover, .btn-light-blue:focus {
    background-color: #0398db;
    color: #fff; }

.btn-cyan {
  background-color: #00bcd4;
  color: #fff; }
  .btn-cyan:hover, .btn-cyan:focus {
    background-color: #00a5bb;
    color: #fff; }

.btn-teal {
  background-color: #009688;
  color: #fff; }
  .btn-teal:hover, .btn-teal:focus {
    background-color: #007d71;
    color: #fff; }

.btn-green {
  background-color: #4CAF50;
  color: #fff; }
  .btn-green:hover, .btn-green:focus {
    background-color: #449d48;
    color: #fff; }

.btn-light-green {
  background-color: #8bc34a;
  color: #fff; }
  .btn-light-green:hover, .btn-light-green:focus {
    background-color: #7eb73d;
    color: #fff; }

.btn-lime {
  background-color: #cddc39;
  color: #fff; }
  .btn-lime:hover, .btn-lime:focus {
    background-color: #c6d626;
    color: #fff; }

.btn-yellow {
  background-color: #ffeb3b;
  color: #fff; }
  .btn-yellow:hover, .btn-yellow:focus {
    background-color: #ffe822;
    color: #fff; }

.btn-amber {
  background-color: #ffc107;
  color: #fff; }
  .btn-amber:hover, .btn-amber:focus {
    background-color: #edb100;
    color: #fff; }

.btn-orange {
  background-color: #ff9800;
  color: #fff; }
  .btn-orange:hover, .btn-orange:focus {
    background-color: #e68900;
    color: #fff; }

.btn-deep-orange {
  background-color: #ff5722;
  color: #fff; }
  .btn-deep-orange:hover, .btn-deep-orange:focus {
    background-color: #ff4409;
    color: #fff; }

.btn-brown {
  background-color: #795548;
  color: #fff; }
  .btn-brown:hover, .btn-brown:focus {
    background-color: #694a3e;
    color: #fff; }

.btn-blue-grey {
  background-color: #607d8b;
  color: #fff; }
  .btn-blue-grey:hover, .btn-blue-grey:focus {
    background-color: #566f7c;
    color: #fff; }

.btn-grey {
  background-color: #9e9e9e;
  color: #fff; }
  .btn-grey:hover, .btn-grey:focus {
    background-color: #919191;
    color: #fff; }

.jr-btn-shadow {
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -moz-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  -o-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important; }
  .jr-btn-shadow:hover, .jr-btn-shadow:focus {
    -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
    -moz-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
    -o-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important; }
  .jr-btn-shadow:active {
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    -o-box-shadow: none !important;
    box-shadow: none !important; }

.jr-btn.disabled,
.jr-btn.disabled {
  pointer-events: none;
  opacity: 0.65; }

.jr-btn-default {
  background-color: #fff;
  color: #5c5c5c;
  border: 1px solid #dee2e6; }
  .jr-btn-default:hover, .jr-btn-default:focus {
    background-color: #f2f2f2;
    color: #5c5c5c; }

.jr-btn-secondary {
  background-color: #E91E63;
  color: #fff; }
  .jr-btn-secondary:hover, .jr-btn-secondary:focus {
    background-color: #d81558;
    color: #fff; }

.jr-flat-btn.jr-btn-primary {
  background-color: transparent;
  color: #3f51b5; }
  .jr-flat-btn.jr-btn-primary:hover, .jr-flat-btn.jr-btn-primary:focus {
    background-color: rgba(63, 81, 181, 0.12);
    color: #3f51b5; }

.bg-primary .jr-flat-btn.jr-btn-primary {
  background-color: transparent;
  color: #fff; }
  .bg-primary .jr-flat-btn.jr-btn-primary:hover, .bg-primary .jr-flat-btn.jr-btn-primary:focus {
    background-color: rgba(255, 255, 255, 0.12);
    color: #fff; }

.jr-flat-btn.jr-btn-secondary {
  background-color: transparent;
  color: #E91E63; }
  .jr-flat-btn.jr-btn-secondary:hover, .jr-flat-btn.jr-btn-secondary:focus {
    background-color: rgba(233, 30, 99, 0.12);
    color: #E91E63; }

.bg-secondary .jr-flat-btn.jr-btn-secondary {
  background-color: transparent;
  color: #fff; }
  .bg-secondary .jr-flat-btn.jr-btn-secondary:hover, .bg-secondary .jr-flat-btn.jr-btn-secondary:focus {
    background-color: rgba(255, 255, 255, 0.12);
    color: #fff; }

.jr-btn-hover:hover:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.06); }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }

.action-btn {
  height: 40px;
  width: 40px;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  vertical-align: middle;
  color: rgba(0, 0, 0, 0.54); }
  .action-btn:hover, .action-btn:focus, .action-btn:active {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.64); }
  .circle-check .action-btn {
    height: 24px;
    width: 24px;
    font-size: 16px; }
  .chat-main-header .action-btn {
    color: #fff; }

.action-replay .jr-btn-default {
  font-size: 14px;
  padding: 5px 10px;
  border-color: #6c757d !important; }

.btn-outline-primary:focus,
.btn-outline-secondary:focus {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -o-box-shadow: none !important;
  box-shadow: none !important; }

/*Button Group Styles*/
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .jr-btn,
  .btn-group-vertical > .jr-btn {
    position: relative;
    flex: 0 1 auto;
    border-color: #dee2e6; }
    .btn-group > .jr-btn:hover,
    .btn-group-vertical > .jr-btn:hover {
      z-index: 2; }
    .btn-group > .jr-btn:focus, .btn-group > .jr-btn:active, .btn-group > .jr-btn.active,
    .btn-group-vertical > .jr-btn:focus,
    .btn-group-vertical > .jr-btn:active,
    .btn-group-vertical > .jr-btn.active {
      z-index: 2; }
    .btn-group > .jr-btn.active,
    .btn-group-vertical > .jr-btn.active {
      background-color: #3f51b5;
      color: #fff;
      border-color: #3f51b5; }
    .btn-group > .jr-btn.jr-flat-btn,
    .btn-group-vertical > .jr-btn.jr-flat-btn {
      border-color: transparent; }
      .btn-group > .jr-btn.jr-flat-btn.active,
      .btn-group-vertical > .jr-btn.jr-flat-btn.active {
        background-color: transparent;
        color: #3f51b5; }
        .btn-group > .jr-btn.jr-flat-btn.active:hover, .btn-group > .jr-btn.jr-flat-btn.active:focus,
        .btn-group-vertical > .jr-btn.jr-flat-btn.active:hover,
        .btn-group-vertical > .jr-btn.jr-flat-btn.active:focus {
          background-color: rgba(63, 81, 181, 0.12);
          color: #3f51b5; }
  .btn-group .jr-btn + .jr-btn,
  .btn-group .jr-btn + .btn-group,
  .btn-group .btn-group + .jr-btn,
  .btn-group .btn-group + .btn-group,
  .btn-group-vertical .jr-btn + .jr-btn,
  .btn-group-vertical .jr-btn + .btn-group,
  .btn-group-vertical .btn-group + .jr-btn,
  .btn-group-vertical .btn-group + .btn-group {
    margin-left: -1px; }

.btn-group.no-border > .btn-group > .jr-btn,
.btn-group.no-border > .btn-group-vertical > .jr-btn,
.btn-group.no-border > .jr-btn,
.btn-group-vertical.no-border > .btn-group > .jr-btn,
.btn-group-vertical.no-border > .btn-group-vertical > .jr-btn,
.btn-group-vertical.no-border > .jr-btn {
  border-color: transparent; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group > .jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0; }

.btn-group > .jr-btn:first-child {
  margin-left: 0; }
  .btn-group > .jr-btn:first-child:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }

.btn-group > .jr-btn:last-child:not(:first-child),
.btn-group > .dropdown-toggle:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.btn-group > .btn-group {
  float: left; }

.btn-group > .btn-group:not(:first-child):not(:last-child) > .jr-btn {
  border-radius: 0; }

.btn-group > .btn-group:first-child:not(:last-child) > .jr-btn:last-child,
.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.btn-group > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.jr-btn + .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  .jr-btn + .dropdown-toggle-split::after {
    margin-left: 0; }

.jr-btn-sm + .dropdown-toggle-split, .btn-group-sm > .jr-btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.jr-btn-lg + .dropdown-toggle-split, .btn-group-lg > .jr-btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group.show .dropdown-toggle {
  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -moz-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  -o-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }
  .btn-group.show .dropdown-toggle.btn-link {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    -o-box-shadow: none;
    box-shadow: none; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical .jr-btn,
  .btn-group-vertical .btn-group {
    width: 100%; }
  .btn-group-vertical > .jr-btn + .jr-btn,
  .btn-group-vertical > .jr-btn + .btn-group,
  .btn-group-vertical > .btn-group + .jr-btn,
  .btn-group-vertical > .btn-group + .btn-group {
    margin-top: -1px;
    margin-left: 0; }
  .btn-group-vertical > .jr-btn:not(:first-child):not(:last-child) {
    border-radius: 0; }
  .btn-group-vertical > .jr-btn:first-child:not(:last-child) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .jr-btn:last-child:not(:first-child) {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }
  .btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .jr-btn {
    border-radius: 0; }
  .btn-group-vertical > .btn-group:first-child:not(:last-child) > .jr-btn:last-child,
  .btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

[data-toggle="buttons"] > .jr-btn input[type="radio"],
[data-toggle="buttons"] > .jr-btn input[type="checkbox"],
[data-toggle="buttons"] > .btn-group > .jr-btn input[type="radio"],
[data-toggle="buttons"] > .btn-group > .jr-btn input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0); }

.btn-group > .jr-btn,
.btn-group > .btn,
.btn-group-vertical > .jr-btn,
.btn-group-vertical > .btn {
  margin-right: 0;
  margin-bottom: 0; }

/*Callout Styles*/
.card-image .grid-thumb-equal {
  padding-bottom: 82%; }

/*Product listing page style*/
.product-row {
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  text-align: right; }
  .product-row.even {
    text-align: left; }

.product-col {
  order: 1;
  width: 50%; }

.odd .product-thumb {
  order: 2; }

.product-content {
  padding: 20px 55px; }

.product-row .grid-thumb-equal {
  padding-bottom: 69%; }

.product-thumb img {
  width: 100%; }

.product-content h4 {
  margin-bottom: 25px; }

@media screen and (max-width: 1230px) {
  .product-row .grid-thumb-equal {
    padding-bottom: 71%; } }

@media screen and (max-width: 1199px) {
  .product-content h4 {
    margin-bottom: 10px; }
  .product-content {
    padding: 20px 35px; }
  .product-row .grid-thumb-equal {
    padding-bottom: 85%; } }

@media screen and (max-width: 991px) {
  .card-image .grid-thumb-equal {
    padding-bottom: 120%; } }

@media screen and (max-width: 767px) {
  .product-row {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center; }
    .product-row.even {
      text-align: center; }
  .product-content {
    padding: 20px 0; }
  .product-col,
  .odd .product-thumb {
    order: 1;
    width: 100%; }
  .product-row .grid-thumb-equal {
    padding-bottom: 44%; }
  .card-image .grid-thumb-equal {
    padding-bottom: 44%; } }

/*Cards Styles*/
.profile-intro {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden; }
  .profile-intro img.avatar-circle {
    display: inline-block;
    border-radius: 50%;
    -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
    -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
    position: relative;
    margin: 0 auto;
    -webkit-transform: translateY(50px);
    -ms-transform: translateY(50px);
    transform: translateY(50px);
    -webkit-transition: all 0.4s ease-in-out;
    -o-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    z-index: 1; }
  .profile-intro:hover .avatar-circle {
    -webkit-transition: border-radius 0.4s ease 0.1s;
    -o-transition: border-radius 0.4s ease 0.1s;
    transition: border-radius 0.4s ease 0.1s;
    border-radius: 25%; }

.profile-intro .card-image {
  position: relative;
  width: 100%;
  min-height: 100%;
  background-image: url("http://via.placeholder.com/1920x1072");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover; }

.profile-intro .pi-content {
  padding: 70px 40px 24px; }

.profile-intro .pi-footer {
  padding: 0 40px 24px; }

.profile-intro .icon {
  display: inline-block;
  -webkit-transition: all 0.2s ease 0s;
  -o-transition: all 0.2s ease 0s;
  transition: all 0.2s ease 0s;
  color: #3f51b5; }
  .profile-intro .icon:hover, .profile-intro .icon:focus, .profile-intro .icon:active {
    -webkit-transform: scale(1.2);
    -ms-transform: scale(1.2);
    transform: scale(1.2); }

.profile-intro .icon:not(:last-child) {
  margin-right: 10px; }

.layer:before {
  display: block;
  content: "";
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  z-index: 0; }

.card.jr-card-full-height,
.jr-card.jr-card-full-height {
  height: calc(100% - 34px); }
  @media screen and (max-width: 575px) {
    .card.jr-card-full-height,
    .jr-card.jr-card-full-height {
      height: auto; } }

.jr-card > .jr-card-body:first-child {
  margin-top: 6px; }

.jr-card.p-0 > .jr-card-body:first-child {
  margin-top: 0; }

.jr-card .jr-card-thumb {
  margin: -24px -30px 0; }
  .jr-card .jr-card-thumb .card-img {
    border-radius: 8px 8px 0 0; }

@media screen and (max-width: 575px) {
  .jr-card {
    margin-bottom: 18px; } }

.jr-card-header {
  margin-bottom: 24px; }
  .jr-card-header .card-heading {
    margin-bottom: 4px; }
  .jr-card-header .badge {
    margin-bottom: 0; }
    .jr-card-header .badge:last-child {
      margin-left: 10px; }
  @media screen and (max-width: 575px) {
    .jr-card-header {
      margin-bottom: 18px; } }

.jr-entry-header {
  margin-bottom: 24px; }
  .jr-entry-header .entry-heading {
    margin-bottom: 4px; }
  .jr-entry-header .entry-description {
    margin-bottom: 0;
    font-size: 13px;
    color: #6c757d; }
  @media screen and (max-width: 575px) {
    .jr-entry-header {
      margin-bottom: 18px; } }

.card {
  margin-bottom: 34px; }
  @media screen and (max-width: 575px) {
    .card {
      margin-bottom: 18px; } }

.card-header {
  font-size: 16px; }
  .card-header .badge {
    margin-bottom: 0; }
    .card-header .badge:last-child {
      margin-left: 10px; }

.card-title {
  font-size: 16px;
  text-transform: capitalize; }

.card-subtitle {
  font-size: 14px;
  color: #495057; }
  .card-subtitle:not(:last-child) {
    margin-bottom: 16px; }

.card-mt-footer {
  padding: 0 15px 20px;
  margin-top: -10px; }

.jr-card-social {
  font-size: 22px;
  padding-top: 26px; }

.social-link {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin: 0 -5px 10px; }
  .social-link li {
    padding: 0 5px;
    margin-bottom: 5px; }
  .social-link li a {
    color: #5c5c5c; }
  .social-link li.active a,
  .social-link li a:hover,
  .social-link li a:focus {
    color: #E91E63; }
  .jr-card-social .social-link {
    margin-bottom: 0;
    -webkit-justify-content: space-around;
    justify-content: space-around; }

.jr-cart-ab {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  color: #fff;
  font-size: 16px; }
  .jr-cart-ab i {
    vertical-align: middle;
    font-size: 25px; }

.img-overlay-card {
  border-radius: 8px;
  margin-bottom: 34px; }
  @media screen and (max-width: 1199px) {
    .img-overlay-card .center-crop-img {
      min-height: 135px; } }
  @media screen and (max-width: 767px) {
    .img-overlay-card .center-crop-img {
      min-height: 160px; } }
  @media screen and (max-width: 575px) {
    .img-overlay-card {
      margin-bottom: 18px; } }

/*Charts Styles*/
.chart-header {
  padding: 15px 18px; }
  .chart-header .card-title h4 {
    color: #fff;
    margin-bottom: 4px; }
  .chart-header .title h4 {
    margin-bottom: 4px; }
  .chart-header p {
    margin-bottom: 4px; }

/*Chips Styles*/
.chip-outline {
  background-color: transparent !important;
  border: 1px solid #adb5bd !important; }

/*Carousel Styles*/
.carousel-caption h3 {
  font-size: 18px; }

/*Color Picker Styles*/
.cp-color {
  width: 36px;
  height: 14px;
  border-radius: 2px; }

.cp-swatch {
  padding: 5px;
  background: #fff;
  border-radius: 1px;
  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  cursor: pointer; }

.cp-popover {
  position: absolute;
  z-index: 2; }

.cp-cover {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0; }

.photoshop-picker,
.swatches-picker,
.alpha-picker,
.hue-picker {
  width: 100% !important; }

.material-picker {
  width: 100% !important;
  height: 100% !important; }

.rc-time-picker-input {
  height: 31px !important; }

.date-btn {
  display: inline-block;
  vertical-align: top; }

.dateInputCreateUser .DateInput,
.dateInputCreateUser .SingleDatePickerInput {
  background: transparent !important; }

.dateInputCreateUser .DateInput_input {
  font-size: 15px !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  border: none !important;
  padding: 10px 0 5px 0px !important;
  font-weight: 400 !important;
  display: block !important;
  width: 100% !important;
  height: calc(2.25rem + 2px) !important;
  outline: none !important;
  background-color: transparent !important;
  transition: .2s all ease-in-out; }

.dateInputCreateUserDark .DateInput_input {
  color: white !important; }

.dateInputCreateUserWarn .DateInput_input {
  color: red !important; }

.dateInputCreateUserWarn .DateInput_input::placeholder {
  color: red !important; }

.dateInputCreateUser .DateInput_input::placeholder {
  font-size: 15px !important;
  transition: .2s all ease-in-out; }

.dateInputCreateUser .DateInput,
.dateInputCreateUser .SingleDatePickerInput {
  background: transparent !important; }

.dateInputEditUser .DateInput_input {
  font-size: 12px !important;
  font-family: 'roboto';
  box-shadow: none !important;
  border-radius: 0 !important;
  border: none !important;
  padding: 5px 0px !important;
  font-weight: 400 !important;
  display: block !important;
  width: 100% !important;
  height: 28px !important;
  outline: none !important;
  background-color: transparent !important;
  background: transparent !important;
  transition: .2s all ease-in-out; }

.dateInputEditUserDark .DateInput_input {
  color: white !important;
  background-color: #1c2938 !important;
  background: #1c2938 !important; }

.dateInputEditUserDark1 .DateInput_input {
  color: #d5d5d5 !important;
  background-color: #1C1C1C !important;
  background: #1C1C1C !important; }

.dateInputEditUserDark2 .DateInput_input {
  color: #ebebed !important;
  background-color: #333333 !important;
  background: #333333 !important; }

.dateInputEditUserDark3 .DateInput_input {
  color: #e7e7e7 !important;
  background-color: #262335 !important;
  background: #262335 !important; }

.dateInputEditUserLight1 .DateInput_input {
  color: #949494 !important;
  background-color: #ffffff !important;
  background: #ffffff !important; }

.dateInputEditUserLight2 .DateInput_input {
  color: #333333 !important;
  background-color: #fafafa !important;
  background: #fafafa !important; }

.dateInputEditUserContrast .DateInput_input {
  color: #000000 !important;
  background-color: transparent !important;
  background: transparent !important; }

.dateInputEditUser .DateInput_input::placeholder {
  font-size: 12px !important;
  transition: .2s all ease-in-out; }

/*Drawer Styles*/
.drawer {
  width: 250px; }

.full-drawer {
  width: 100%; }

/*E-commerce Styles*/
.product-item, .product-item-vertical {
  overflow: hidden; }

.product-item-vertical .card-image .grid-thumb-equal {
  padding-bottom: 110%; }
  @media screen and (max-width: 1199px) {
    .product-item-vertical .card-image .grid-thumb-equal {
      padding-bottom: 74%; } }
  @media screen and (max-width: 991px) {
    .product-item-vertical .card-image .grid-thumb-equal {
      padding-bottom: 110%; } }
  @media screen and (max-width: 829px) {
    .product-item-vertical .card-image .grid-thumb-equal {
      padding-bottom: 120%; } }
  @media screen and (max-width: 767px) {
    .product-item-vertical .card-image .grid-thumb-equal {
      padding-bottom: 44%; } }

/*Grids List Styles*/
.gl-image,
.gl-list,
.gl-advanced,
.gl-single-line {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  overflow: hidden; }

.gl {
  max-width: 100%;
  max-height: 360px;
  transform: translateZ(0); }
  .gl.row.no-gutters {
    margin: 0 -2px; }
    .gl.row.no-gutters .col,
    .gl.row.no-gutters > [class*="col-"] {
      padding-right: 2px;
      padding-left: 2px;
      margin-bottom: 4px; }

.gl-single-line .slg {
  -ms-flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: 100%; }

.title-gradient {
  background: -webkit-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important; }

.title-gradient-bottom {
  background: -webkit-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: -o-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 70%, rgba(0, 0, 0, 0) 100%) !important; }

.g-title {
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif; }

.grid {
  height: 100%;
  display: block;
  position: relative;
  overflow: hidden; }
  .grid > img {
    top: 50%;
    left: 50%;
    position: relative;
    transform: translate(-50%, -50%);
    display: flex;
    padding: 0;
    flex-wrap: wrap; }

.g-ul {
  display: flex;
  padding: 0;
  flex-wrap: wrap;
  overflow-y: auto;
  list-style: none;
  -webkit-overflow-scrolling: touch; }

.gradient-text {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 20px;
  color: white; }

.title-gradient-bottom {
  padding: 20px;
  bottom: 0;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
  background: -o-linear-gradient(to top, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent 100%) !important;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important; }

.title-gradient-top {
  padding: 10px;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important;
  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent 100%) !important;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0, rgba(0, 0, 0, 0.3) 70%, transparent) !important; }

.grid-thumb img {
  max-height: 185px; }

.gl-advanced-grid {
  position: relative; }

/*Icons Styles*/
.icon {
  display: inline-block;
  text-align: center; }

.icons-wrapper {
  display: inline-block; }
  .icons-wrapper + .icons-wrapper {
    margin-left: 25px; }

/*Label Styles*/
label {
  margin-bottom: 0; }

/*List Styles*/
.pinned-list {
  position: relative;
  height: 370px;
  overflow: auto;
  width: auto; }

.user-list {
  width: 100%;
  padding: 20px 15px 10px; }
  .user-list.card {
    padding-left: 30px; }
    @media screen and (max-width: 575px) {
      .user-list.card {
        padding-left: 15px; } }
  .user-list .user-avatar {
    margin-right: 20px;
    margin-bottom: 10px; }
  .user-list h3 {
    font-weight: 700;
    margin-bottom: 8px; }
  .user-list a[class*="meta-"] i {
    margin-right: 6px; }
  .user-list a[class*="meta-"]:hover {
    text-decoration: none; }
  .user-list a[class*="meta-"] {
    display: inline-block;
    color: #5c5c5c;
    font-size: 13px;
    font-weight: 700; }

.user-list .img-section {
  width: 230px; }
  @media screen and (max-width: 649px) {
    .user-list .img-section {
      width: 100%; } }

.user-list .description {
  width: calc(100% - 300px); }
  @media screen and (max-width: 649px) {
    .user-list .description {
      width: 100%; } }

.user-list .jr-btn-list li:not(:last-child) {
  margin-right: 10px; }

.user-list .jr-btn-list .btn-light {
  background-color: lightgray;
  border-color: lightgray;
  color: #5c5c5c;
  font-weight: 600; }
  .user-list .jr-btn-list .btn-light:hover, .user-list .jr-btn-list .btn-light:focus, .user-list .jr-btn-list .btn-light:active {
    background-color: #c7c7c7;
    border-color: #c7c7c7; }

.user-list .jr-btn-list.badge-list li:not(:last-child) {
  margin-right: 0; }

.list-inline {
  margin-left: -5px;
  margin-right: -5px; }
  .list-inline li {
    padding: 0 5px;
    display: inline-block; }
    .list-inline li.media {
      display: flex; }

.card-strip {
  border-bottom: solid 1px #dee2e6;
  margin-bottom: 10px; }

.jr-mbtn-list {
  margin-left: -20px; }

.img-res {
  max-width: 100%;
  height: auto; }

.nav-link {
  cursor: pointer;
  padding: 0.5rem; }

.card-header.bg-primary .nav-link {
  color: #fff; }
  .card-header.bg-primary .nav-link.active, .card-header.bg-primary .nav-link:hover, .card-header.bg-primary .nav-link:focus {
    color: #000;
    background-color: #fff; }
  .card-header.bg-primary .nav-link.disabled {
    color: #f8f9fa; }
  .card-header.bg-primary .nav-link.disabled:hover {
    color: #212529; }

/*Pricing Styles*/
.pt-classic .package,
.pt-default .package,
.pt-dark .package,
.pt-circle .package {
  position: relative;
  padding: 0;
  overflow: hidden;
  border-radius: 10px;
  -webkit-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out; }
  .pt-classic .package:hover, .pt-classic .package:focus, .pt-classic .package:active,
  .pt-default .package:hover,
  .pt-default .package:focus,
  .pt-default .package:active,
  .pt-dark .package:hover,
  .pt-dark .package:focus,
  .pt-dark .package:active,
  .pt-circle .package:hover,
  .pt-circle .package:focus,
  .pt-circle .package:active {
    -webkit-transform: scale(1.05);
    -ms-transform: scale(1.05);
    transform: scale(1.05); }
  .pt-classic .package.highlight,
  .pt-default .package.highlight,
  .pt-dark .package.highlight,
  .pt-circle .package.highlight {
    -webkit-transform: scale(1.05);
    -ms-transform: scale(1.05);
    -o-transform: scale(1.05);
    transform: scale(1.05);
    z-index: 2; }

.pt-classic .package-header,
.pt-default .package-header,
.pt-dark .package-header,
.pt-circle .package-header {
  padding: 35px;
  text-align: center; }
  .pt-classic .package-header > .price,
  .pt-default .package-header > .price,
  .pt-dark .package-header > .price,
  .pt-circle .package-header > .price {
    display: inline-block;
    font-size: 36px;
    font-weight: 700;
    margin-left: 0;
    margin-bottom: 12px; }
    .pt-classic .package-header > .price > i,
    .pt-default .package-header > .price > i,
    .pt-dark .package-header > .price > i,
    .pt-circle .package-header > .price > i {
      display: inline-block;
      margin-right: 6px;
      font-weight: bold; }
  .pt-classic .package-header h5,
  .pt-default .package-header h5,
  .pt-dark .package-header h5,
  .pt-circle .package-header h5 {
    color: inherit; }

.pt-classic .package-items,
.pt-default .package-items,
.pt-dark .package-items,
.pt-circle .package-items {
  list-style: none;
  font-size: 14px;
  margin: 0;
  padding: 50px 50px 120px; }
  .pt-classic .package-items li,
  .pt-default .package-items li,
  .pt-dark .package-items li,
  .pt-circle .package-items li {
    margin-bottom: 16px;
    line-height: inherit; }
    .pt-classic .package-items li:before, .pt-classic .package-items li:after,
    .pt-default .package-items li:before,
    .pt-default .package-items li:after,
    .pt-dark .package-items li:before,
    .pt-dark .package-items li:after,
    .pt-circle .package-items li:before,
    .pt-circle .package-items li:after {
      content: " ";
      display: table; }
    .pt-classic .package-items li:after,
    .pt-default .package-items li:after,
    .pt-dark .package-items li:after,
    .pt-circle .package-items li:after {
      clear: both; }
    .pt-classic .package-items li i,
    .pt-default .package-items li i,
    .pt-dark .package-items li i,
    .pt-circle .package-items li i {
      float: left;
      min-width: 20px;
      margin-right: 16px;
      line-height: inherit; }
    .pt-classic .package-items li span,
    .pt-default .package-items li span,
    .pt-dark .package-items li span,
    .pt-circle .package-items li span {
      display: block;
      overflow: hidden; }

.pt-classic .package-footer,
.pt-default .package-footer,
.pt-dark .package-footer,
.pt-circle .package-footer {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  padding: 40px 50px;
  text-align: center; }
  .pt-classic .package-footer .btn,
  .pt-default .package-footer .btn,
  .pt-dark .package-footer .btn,
  .pt-circle .package-footer .btn {
    color: inherit;
    padding: 10px 30px;
    border: 0 none; }

.pt-classic .package {
  border: 0 none;
  border-radius: 0; }

.pt-dark .package:hover {
  border-radius: 20px; }

.pt-circle .package-header {
  border-radius: 50%;
  height: 224px;
  width: 224px;
  margin: 40px auto 0;
  -webkit-align-items: center;
  align-items: center; }
  .pt-circle .package-header .price {
    margin-top: 30px; }

@media only screen and (max-width: 991px) {
  .pt-classic .package-header,
  .pt-default .package-header,
  .pt-dark .package-header,
  .pt-circle .package-header {
    padding: 30px 20px; }
  .pt-classic .package-items,
  .pt-default .package-items,
  .pt-dark .package-items,
  .pt-circle .package-items {
    padding: 30px 20px 120px; }
  .pt-circle .package-header {
    height: 204px;
    width: 204px; } }

@media only screen and (max-width: 767px) {
  .pt-classic .package:hover, .pt-classic .package:focus, .pt-classic .package:active, .pt-classic .package.highlight,
  .pt-default .package:hover,
  .pt-default .package:focus,
  .pt-default .package:active,
  .pt-default .package.highlight,
  .pt-dark .package:hover,
  .pt-dark .package:focus,
  .pt-dark .package:active,
  .pt-dark .package.highlight,
  .pt-circle .package:hover,
  .pt-circle .package:focus,
  .pt-circle .package:active,
  .pt-circle .package.highlight {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1); } }

/*Progressbar Styles*/
.pb-wrapper {
  display: flex;
  align-items: center; }

.pb-btn-wrapper {
  margin: 8px;
  position: relative; }
  .pb-btn-wrapper .btn-success {
    background-color: #4CAF50; }
    .pb-btn-wrapper .btn-success:hover {
      background-color: #388E3C; }

.fab-progress {
  color: #4CAF50;
  position: absolute;
  top: -6px;
  left: -6px;
  z-index: 1; }

.btn-progress {
  color: #4CAF50;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px; }

/*Popover Styles*/
.popover {
  z-index: 1510;
  max-height: 400px; }

.popover-inner {
  max-height: 400px; }

.popover-header {
  background-color: transparent;
  border-bottom: 0 none;
  color: #000;
  font-size: 18px;
  padding: 15px 20px 0; }

.popover-body {
  padding: 15px 20px;
  max-height: 355px;
  overflow: auto; }

/*Tables Styles*/
.table-header {
  padding-right: 2px !important;
  min-height: 64px;
  padding-left: 24px;
  align-items: center; }
  .table-header.highlight-light {
    color: #616161;
    background-color: #e0e0e0; }
  .table-header.highlight-dark {
    color: #fff;
    background-color: #616161; }

.spacer {
  -webkit-flex: 1 1 100%;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%; }

.actions {
  color: #F44336; }

.title {
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto; }

.table-hover tbody tr:hover {
  background-color: rgba(63, 81, 181, 0.075); }

.table-material {
  width: 100% !important;
  max-width: 100% !important;
  background-color: transparent !important; }
  .table-material th,
  .table-material td {
    padding: 0.75rem !important;
    vertical-align: top !important;
    border-top: 1px solid #dee2e6 !important; }
  .table-material thead th {
    vertical-align: bottom !important;
    border-bottom: 2px solid #dee2e6 !important; }
  .table-material tbody + tbody {
    border-top: 2px solid #dee2e6 !important; }
  .table-material .table-material {
    background-color: #fff !important; }

.d-flex-stretch {
  -webkit-align-items: stretch;
  align-items: stretch;
  display: -webkit-flex;
  display: -webkit-box;
  display: -moz-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; }

.default-table {
  margin-bottom: 0; }
  .default-table thead th {
    font-weight: 400;
    font-size: 16px; }
  .default-table td {
    vertical-align: middle; }

.table-unbordered th,
.table-unbordered td {
  border: 0 none !important; }

.table-unbordered .th-border-b th {
  border-bottom: 2px solid #ced4da !important; }

.table-responsive-material {
  min-height: .01%;
  overflow-x: auto; }

@media screen and (max-width: 767px) {
  .table-responsive-material {
    width: 100%;
    margin-bottom: 15px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd; }
  .table-responsive-material > .table {
    margin-bottom: 0; }
  .table-responsive-material > .table > thead > tr > th,
  .table-responsive-material > .table > tbody > tr > th,
  .table-responsive-material > .table > tfoot > tr > th,
  .table-responsive-material > .table > thead > tr > td,
  .table-responsive-material > .table > tbody > tr > td,
  .table-responsive-material > .table > tfoot > tr > td {
    white-space: nowrap; }
  .table-responsive-material > .table-bordered {
    border: 0; }
  .table-responsive-material > .table-bordered > thead > tr > th:first-child,
  .table-responsive-material > .table-bordered > tbody > tr > th:first-child,
  .table-responsive-material > .table-bordered > tfoot > tr > th:first-child,
  .table-responsive-material > .table-bordered > thead > tr > td:first-child,
  .table-responsive-material > .table-bordered > tbody > tr > td:first-child,
  .table-responsive-material > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0; }
  .table-responsive-material > .table-bordered > thead > tr > th:last-child,
  .table-responsive-material > .table-bordered > tbody > tr > th:last-child,
  .table-responsive-material > .table-bordered > tfoot > tr > th:last-child,
  .table-responsive-material > .table-bordered > thead > tr > td:last-child,
  .table-responsive-material > .table-bordered > tbody > tr > td:last-child,
  .table-responsive-material > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0; }
  .table-responsive-material > .table-bordered > tbody > tr:last-child > th,
  .table-responsive-material > .table-bordered > tfoot > tr:last-child > th,
  .table-responsive-material > .table-bordered > tbody > tr:last-child > td,
  .table-responsive-material > .table-bordered > tfoot > tr:last-child > td {
    border-bottom: 0; } }

.fst-td-br-tp-0 tr:first-child td {
  border-top: 0 none; }

/*Tabs Styles*/
.tab {
  min-width: 10px !important; }

.tab-icon > span {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; }

/*Testimonial Styles*/
.testimonial-in-bg {
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: 5px 5px 6px rgba(0, 0, 0, 0.06);
  padding: 30px 30px 30px 150px;
  overflow: hidden;
  position: relative; }
  @media screen and (max-width: 450px) {
    .testimonial-in-bg {
      padding-left: 100px; } }
  .testimonial-in-bg .pic {
    display: inline-block;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    position: absolute;
    top: 30px;
    left: 20px;
    border: 4px solid #ffa000; }
    @media screen and (max-width: 450px) {
      .testimonial-in-bg .pic {
        width: 50px;
        height: 50px; } }
  .testimonial-in-bg .pic img {
    width: 100%;
    height: auto; }
  .testimonial-in-bg .description {
    color: #bdbdbd;
    font-style: italic;
    font-weight: 400;
    line-height: 25px;
    margin-bottom: 15px;
    position: relative; }
    .testimonial-in-bg .description:before {
      content: "\\f1b2";
      font-family: 'Material-Design-Iconic-Font';
      font-size: 24px;
      -moz-transform: scaleX(-1);
      -webkit-transform: scaleX(-1);
      -o-transform: scaleX(-1);
      transform: scaleX(-1);
      position: absolute;
      left: -24px; }
  .testimonial-in-bg .title {
    color: #ffa000;
    margin-bottom: 2px; }

.classic-testimonial {
  text-align: center; }
  .classic-testimonial .pic {
    margin: 0 auto;
    margin-bottom: 30px;
    width: 120px;
    height: 120px; }
    @media screen and (max-width: 500px) {
      .classic-testimonial .pic {
        width: 80px;
        height: 80px; } }
  .classic-testimonial .pic img {
    width: 100%;
    height: 100%; }

/*Time Lines Style*/
.timeline-left {
  float: left;
  margin-right: 20px; }

.timeline-right {
  float: right;
  margin-left: 20px; }

.timeline-circle {
  border-radius: 50%; }

.timeline-section {
  margin-bottom: 25px; }

.timeline-item {
  padding-bottom: 25px;
  padding-left: 80px;
  position: relative; }
  .timeline-item:before {
    border-left: solid 2px #dee2e6;
    content: "";
    left: 25px;
    position: absolute;
    top: 25px;
    bottom: -20px;
    width: 2px;
    z-index: 1; }
  .timeline-item:first-child:before {
    border-left-style: dashed; }
  .timeline-item:last-child:before {
    border-left-style: dashed;
    bottom: 25px; }

.timeline-badge {
  position: absolute;
  left: 0;
  top: 16px;
  z-index: 2;
  font-size: 16px;
  color: #fff;
  text-align: center;
  border-radius: 50%; }
  .timeline-badge.timeline-img {
    background-color: transparent; }
  .timeline-badge svg {
    vertical-align: calc(100% - 56px); }

.timeline-badge.timeline-img:after {
  display: none; }

.timeline-badge:after {
  position: absolute;
  content: "";
  width: 42px;
  height: 42px;
  background-color: transparent;
  border: 4px solid #fff;
  border-radius: 50%;
  left: 4px;
  top: 4px;
  z-index: 1; }

.timeline-img > img,
.timeline-header-img > img {
  display: inline-block;
  max-width: 100%;
  height: auto; }

.timeline-panel {
  padding: 20px 30px;
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #e9ecef; }
  .timeline-panel:after, .timeline-panel:before {
    content: "";
    position: absolute;
    border-style: solid;
    display: inline-block; }
  .timeline-panel:before {
    border-color: transparent #dee2e6;
    border-width: 10px 17px 10px 0;
    left: -17px;
    top: 30px; }
  .timeline-panel:after {
    border-color: transparent #fff;
    border-width: 10px 16px 10px 0;
    left: -16px;
    top: 30px; }

.timeline-no-padding {
  padding: 0; }

.timeline-no-shadow {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none; }
  .timeline-no-shadow:before, .timeline-no-shadow:after {
    display: none; }

.timeline-panel-header, .timeline-header-img {
  margin-bottom: 10px; }

.timeline-inverted .timeline-left {
  float: right;
  margin-right: 0;
  margin-left: 20px; }

.timeline-heading {
  overflow: hidden;
  margin-bottom: 10px; }

.timeline-body {
  clear: both; }

/*Gxtl Center Style*/
.timeline-center .timeline-item {
  clear: both;
  float: right;
  width: 50%;
  padding-left: 55px; }
  .timeline-center .timeline-item:before {
    left: 0; }

.timeline-center .timeline-badge {
  left: -25px;
  right: auto; }

.timeline-center .timeline-time {
  position: absolute;
  top: 32px;
  left: -150px;
  right: auto;
  z-index: 2; }

.timeline-center .timeline-inverted {
  float: left;
  text-align: right;
  padding-left: 0;
  padding-right: 55px; }
  .timeline-center .timeline-inverted:before {
    border-left: 0 none;
    border-right: solid 2px #dee2e6;
    left: auto;
    right: -2px; }
  .timeline-center .timeline-inverted .timeline-badge {
    left: auto;
    right: -25px; }
  .timeline-center .timeline-inverted .timeline-panel:before {
    border-width: 10px 0 10px 17px;
    left: auto;
    right: -17px; }
  .timeline-center .timeline-inverted .timeline-panel:after {
    border-width: 10px 0 10px 16px;
    left: auto;
    right: -16px; }
  .timeline-center .timeline-inverted .timeline-time {
    position: absolute;
    top: 32px;
    right: -150px;
    left: auto;
    z-index: 2; }

/*Gxtl Zigzag Style*/
.timeline-zigzag .timeline-item {
  padding-left: 150px; }
  .timeline-zigzag .timeline-item + .timeline-item {
    margin-top: -80px; }

.timeline-zigzag .timeline-img {
  width: 90px;
  height: 90px;
  left: 5px; }
  .timeline-zigzag .timeline-img > img {
    width: 100%; }

.timeline-zigzag .timeline-inverted .timeline-img {
  right: 5px !important; }

.timeline-zigzag .timeline-item:before {
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  -o-transform: rotate(35deg);
  transform: rotate(35deg);
  top: 20px;
  bottom: 20px; }

.timeline-zigzag .timeline-inverted {
  padding-left: 0;
  padding-right: 150px; }
  .timeline-zigzag .timeline-inverted:before {
    -webkit-transform: rotate(-35deg);
    -ms-transform: rotate(-35deg);
    -o-transform: rotate(-35deg);
    transform: rotate(-35deg); }

.timeline-zigzag .timeline-item:first-child:before {
  border-left-style: solid; }

.timeline-zigzag .timeline-item:last-child:before {
  display: none; }

.timeline-item:last-child:before {
  bottom: 25px; }

@media screen and (max-width: 991px) {
  .timeline-zigzag .timeline-item + .timeline-item {
    margin-top: -60px; }
  .timeline-zigzag .timeline-item:before {
    bottom: 0; }
  .timeline-zigzag .timeline-item {
    padding-left: 120px; }
  .timeline-zigzag .timeline-inverted {
    padding-right: 120px;
    padding-left: 0; } }

@media screen and (max-width: 767px) {
  .timeline-center .timeline-item {
    float: none;
    padding-left: 80px;
    width: auto; }
    .timeline-center .timeline-item:before {
      left: 25px; }
  .timeline-center .timeline-badge {
    left: 0; }
  .timeline-center .timeline-inverted {
    float: none;
    text-align: left;
    padding-right: 0; }
    .timeline-center .timeline-inverted:before {
      border-left: solid 2px #dee2e6;
      border-right: 0 none;
      left: 24px;
      right: auto; }
    .timeline-center .timeline-inverted .timeline-badge {
      right: auto;
      left: 0; }
    .timeline-center .timeline-inverted .timeline-panel:before {
      border-width: 10px 17px 10px 0;
      left: -17px;
      right: auto; }
    .timeline-center .timeline-inverted .timeline-panel:after {
      border-width: 10px 16px 10px 0;
      left: -16px;
      right: auto; }
  .timeline-inverted .timeline-panel-header {
    float: none; }
  .timeline-inverted .timeline-left {
    float: left;
    margin-left: 0;
    margin-right: 20px; }
  .timeline-zigzag .timeline-panel {
    max-height: none;
    min-height: 10px;
    overflow-y: visible; }
  .timeline-zigzag .timeline-item {
    padding-left: 100px; }
    .timeline-zigzag .timeline-item + .timeline-item {
      margin-top: 0; }
    .timeline-zigzag .timeline-item:before {
      transform: none;
      top: 25px;
      bottom: -25px;
      left: 45px; }
    .timeline-zigzag .timeline-item:last-child:before {
      bottom: 0; }
  .timeline-zigzag .timeline-inverted:before {
    transform: none; }
  .timeline-center .timeline-time,
  .timeline-center .timeline-inverted .timeline-time {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    margin-bottom: 6px; }
  .timeline-center .timeline-time-item .timeline-panel::before {
    top: 10px; }
  .timeline-center .timeline-time-item .timeline-panel::after {
    top: 11px; } }

@media screen and (max-width: 399px) {
  .timeline-left {
    float: none;
    margin-right: 0; }
  .timeline-right {
    float: none;
    margin-left: 0; }
  .timeline-inverted .timeline-left {
    float: none;
    margin-right: 0; } }

/*Form Styles*/
@media screen and (max-width: 575px) {
  .horizontal-stepper p,
  .horizontal-stepper span {
    opacity: 0;
    visibility: hidden;
    font-size: 12px; }
  .horizontal-stepper.active p,
  .horizontal-stepper.active span {
    opacity: 1;
    visibility: visible; }
  .horizontal-stepper > *,
  .horizontal-stepper > button > * {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap; }
  .horizontal-stepper .stepperlabel,
  .horizontal-stepper .stepperbutton,
  .horizontal-stepper .stepperlabel span:first-child,
  .horizontal-stepper .stepperbutton span:first-child {
    opacity: 1;
    visibility: visible; }
  .horizontal-stepper-linear {
    padding-left: 0 !important;
    padding-right: 0 !important; } }

.form-checkbox {
  position: relative;
  z-index: 1; }

.form-checkbox > input {
  height: 18px;
  opacity: 0;
  position: absolute;
  padding: 10px;
  top: 0;
  width: 18px;
  z-index: 2;
  cursor: pointer; }

.form-control-checkbox .form-checkbox > input {
  height: 48px;
  width: 48px; }

.form-control-checkbox .form-checkbox {
  height: 48px;
  display: flex;
  align-items: center;
  width: 48px;
  justify-content: center; }

.form-checkbox > input + .check {
  border: 1px solid #868e96;
  border-radius: 2px;
  color: #3f51b5;
  cursor: pointer;
  display: inline-block;
  height: 18px;
  position: relative;
  width: 18px;
  z-index: -1; }

.form-checkbox > input.sm + .check {
  border: 1px solid #868e96;
  border-radius: 2px;
  color: #3f51b5;
  cursor: pointer;
  display: inline-block;
  height: 14px;
  position: relative;
  top: 3px;
  width: 14px;
  z-index: -1; }

.form-checkbox > input + .check i {
  display: none;
  left: 1px;
  opacity: 0;
  position: absolute;
  top: 2px; }

.form-checkbox > input.sm + .check i {
  display: none;
  left: 1px;
  opacity: 0;
  position: absolute;
  top: 2px; }

.form-checkbox > input:checked + span i {
  display: block;
  opacity: 1; }

/*Radio and Checkbox styles*/
.checkbox-replace {
  padding-left: 20px; }

.checkbox-replace input[type="checkbox"],
.radio-replace input[type="radio"] {
  margin-left: -20px;
  position: absolute; }

.form-inline .checkbox-replace label {
  padding-left: 5px; }

.form-inline .checkbox-replace,
.form-inline .radio-replace {
  margin-right: 20px; }

.form-inline .checkbox-replace:last-child {
  margin-right: 0; }

.checkbox-replace label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 5px; }

.checkbox-replace label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 18px;
  height: 18px;
  left: 0;
  top: 0;
  margin-left: -20px;
  margin-top: 2px;
  border: 1px solid #868e96;
  border-radius: 3px;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out; }

.checkbox-replace label::after {
  display: inline-block;
  position: absolute;
  width: 12px;
  height: 12px;
  left: 3px;
  top: 5px;
  margin-left: -20px;
  font-size: 11px;
  color: #495057; }

.checkbox-replace input[type="checkbox"] {
  opacity: 0;
  z-index: 1;
  cursor: pointer; }

.checkbox-replace input[type="checkbox"]:focus + label::before {
  outline: 0 none; }

.checkbox-replace input[type="checkbox"]:checked + label::after {
  background-color: #ced4da;
  content: ""; }

.checkbox-replace input[type="checkbox"]:disabled + label {
  opacity: 0.65; }

.checkbox-replace input[type="checkbox"]:disabled + label::before {
  background-color: #fff;
  cursor: not-allowed; }

.checkbox-replace.checkbox-inline {
  margin-top: 0; }

.checkbox-primary label::before {
  border-color: #3f51b5; }

.checkbox-primary input[type="checkbox"]:checked + label::after {
  background-color: #3f51b5; }

.checkbox-danger label::before {
  border-color: #E91E63; }

.checkbox-danger input[type="checkbox"]:checked + label::after {
  border-color: #E91E63; }

.checkbox-info label::before {
  border-color: #00bcd4; }

.checkbox-info input[type="checkbox"]:checked + label::after {
  border-color: #00bcd4; }

.checkbox-warning label::before {
  border-color: #ff9800; }

.checkbox-warning input[type="checkbox"]:checked + label::after {
  border-color: #ff9800; }

.checkbox-success label::before {
  border-color: #4caf50; }

.checkbox-success input[type="checkbox"]:checked + label::after {
  border-color: #4caf50; }

.radio-replace {
  padding-left: 20px; }

.radio-replace label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 5px; }

.radio-replace label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 18px;
  height: 18px;
  left: 0;
  top: 0;
  margin-left: -20px;
  margin-top: 2px;
  border: 1px solid #ced4da;
  border-radius: 50%;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out;
  transition: border 0.15s ease-in-out; }

.radio-replace label::after {
  display: inline-block;
  position: absolute;
  content: " ";
  width: 12px;
  height: 12px;
  left: 3px;
  top: 5px;
  margin-left: -20px;
  border-radius: 50%;
  background-color: #ced4da;
  -webkit-transform: rotate(scale(0, 0));
  -ms-transform: rotate(scale(0, 0));
  -o-transform: rotate(scale(0, 0));
  transform: rotate(scale(0, 0));
  -webkit-transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  -o-transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33); }

.radio-replace input[type="radio"] {
  opacity: 0;
  z-index: 1;
  cursor: pointer; }

.radio-replace input[type="radio"]:focus + label::before {
  outline: 0 none; }

.radio-replace input[type="radio"]:checked + label::after {
  -webkit-transform: rotate(scale(1, 1));
  -ms-transform: rotate(scale(1, 1));
  -o-transform: rotate(scale(1, 1));
  transform: rotate(scale(1, 1)); }

.radio-replace input[type="radio"]:disabled + label {
  opacity: 0.65; }

.radio-replace input[type="radio"]:disabled + label::before {
  cursor: not-allowed; }

.radio-replace.radio-inline {
  margin-top: 0; }

.radio-primary input[type="radio"] + label::after {
  background-color: #3f51b5; }

.radio-primary input[type="radio"]:checked + label::before {
  border-color: #3f51b5; }

.radio-primary input[type="radio"]:checked + label::after {
  background-color: #3f51b5; }

.radio-danger input[type="radio"] + label::after {
  background-color: #E91E63; }

.radio-danger input[type="radio"]:checked + label::before {
  border-color: #E91E63; }

.radio-danger input[type="radio"]:checked + label::after {
  background-color: #E91E63; }

.radio-info input[type="radio"] + label::after {
  background-color: #00bcd4; }

.radio-info input[type="radio"]:checked + label::before {
  border-color: #00bcd4; }

.radio-info input[type="radio"]:checked + label::after {
  background-color: #00bcd4; }

.radio-warning input[type="radio"] + label::after {
  background-color: #ff9800; }

.radio-warning input[type="radio"]:checked + label::before {
  border-color: #ff9800; }

.radio-warning input[type="radio"]:checked + label::after {
  background-color: #ff9800; }

.radio-success input[type="radio"] + label::after {
  background-color: #4caf50; }

.radio-success input[type="radio"]:checked + label::before {
  border-color: #4caf50; }

.radio-success input[type="radio"]:checked + label::after {
  background-color: #4caf50; }

.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {
  padding-top: 7px;
  margin-top: 0;
  margin-bottom: 0; }

.form-horizontal .form-inline .checkbox,
.form-horizontal .form-inline .checkbox-inline,
.form-horizontal .form-inline .radio,
.form-horizontal .form-inline .radio-inline {
  padding-top: 0; }

.form-horizontal .checkbox, .form-horizontal .radio {
  min-height: 27px; }

.form-wizard .tab-content .pager.wizard .first a {
  margin-right: 8px; }

.form-wizard .tab-content .pager.wizard .last a {
  margin-left: 8px; }

.wizard-navbar {
  margin: 60px auto 20px; }

.wizard-navbar > ul {
  display: table;
  width: 100%;
  text-align: center;
  margin: 0;
  font-weight: 600;
  padding: 0;
  list-style: none outside none;
  table-layout: fixed; }

.wizard-navbar > ul li {
  display: table-cell;
  width: 1%;
  position: relative; }

.wizard-navbar > ul li a {
  color: #868e96;
  position: relative;
  padding: 0 10px;
  display: block;
  text-decoration: none; }

.wizard-navbar > ul li a span.wz-number {
  background-color: #e9ecef;
  border-radius: 50%;
  color: #adb5bd;
  display: block;
  height: 40px;
  left: 50%;
  line-height: 40px;
  margin-left: -20px;
  margin-top: -50px;
  position: absolute;
  text-align: center;
  -webkit-transition: all 300ms ease-in-out 0s;
  -o-transition: all 300ms ease-in-out 0s;
  transition: all 300ms ease-in-out 0s;
  width: 40px;
  z-index: 5; }

.wizard-navbar > ul li.completed a span.wz-number {
  background-color: #3f51b5;
  color: #fff; }

.wizard-navbar > ul li a.active span.wz-number {
  background-color: #E91E63;
  color: #fff; }

.wizard-navbar > ul li a.active,
.wizard-navbar > ul li.completed a {
  color: #6c757d; }

.wizard-navbar > ul li a:before,
.wizard-navbar > ul li a:after {
  content: '';
  position: absolute;
  height: 4px;
  width: 50%;
  background-color: #e9ecef;
  top: -32px;
  left: 0; }

.wizard-navbar > ul li a:after {
  left: auto;
  right: 0; }

.wizard-navbar > ul li a.active:before,
.wizard-navbar > ul li a.active:after {
  background-color: #E91E63; }

.wizard-navbar > ul li.completed a:before,
.wizard-navbar > ul li.completed a:after {
  background-color: #3f51b5; }

label.error {
  display: block;
  color: #f44336;
  font-weight: 400;
  margin: 5px 0; }

@media screen and (max-width: 479px) {
  .wizard-navbar > ul li a span.wz-label {
    visibility: hidden; }
  .wizard-navbar > ul li a.active span.wz-label {
    visibility: visible; } }

.form-checkbox-custom {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 12px; }

.form-checkbox-custom .check {
  margin-right: 10px; }

.react-switch {
  vertical-align: middle;
  margin-left: 4px; }

/*Input Styles*/
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-size: 12px;
  color: gainsboro; }

::-moz-placeholder {
  /* Firefox 19+ */
  font-size: 12px;
  color: gainsboro; }

:-ms-input-placeholder {
  /* IE 10+ */
  font-size: 12px;
  color: gainsboro; }

:-moz-placeholder {
  /* Firefox 18- */
  font-size: 12px;
  color: gainsboro; }

.module-box-header ::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-size: 14px; }

.module-box-header ::-moz-placeholder {
  /* Firefox 19+ */
  font-size: 14px; }

.module-box-header :-ms-input-placeholder {
  /* IE 10+ */
  font-size: 14px; }

.module-box-header :-moz-placeholder {
  /* Firefox 18- */
  font-size: 14px; }

.search-bar {
  background-color: #fff;
  position: relative; }
  .search-bar .form-group {
    width: 100%;
    height: 100%;
    margin-bottom: 0; }
  .search-bar input[type="search"] {
    padding-right: 50px; }
  .search-bar .search-icon {
    background-color: transparent;
    border: 0 none;
    color: #868e96;
    height: 36px;
    width: 30px; }
  .search-bar .form-control {
    box-shadow: none; }
    .search-bar .form-control.form-control-lg + .search-icon {
      position: absolute;
      right: 14px;
      top: 6px; }
  .search-bar .search-icon {
    position: absolute;
    right: 14px;
    top: 3px; }
  .search-bar.right-side-icon input[type="search"] {
    padding-right: 16px;
    padding-left: 50px; }
  .search-bar.right-side-icon .search-icon {
    position: absolute;
    left: 14px;
    top: 2px; }
  .search-bar.right-side-icon .form-control {
    box-shadow: none; }
    .search-bar.right-side-icon .form-control.form-control-lg + .search-icon {
      position: absolute;
      left: 14px;
      top: 6px; }

.nav-searchbox .search-bar input + .search-icon i {
  color: rgba(92, 92, 92, 0.8); }

/* Removing arrows for input type number in Chrome, Safari, Edge, Opera */
.inputClassComponent::-webkit-outer-spin-button,
.inputClassComponent::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0; }

/* Removing arrows for input type number in Firefox */
.inputClassComponent[type=number] {
  -moz-appearance: textfield; }

@media screen and (max-width: 767px) {
  .jr-card .app-main-header .search-bar {
    width: 150px; } }

/* Pages
   ========================================================================== */
/*Login Styles*/
/*Login Styles*/
.indexPage {
  background-color: #f4f6f8;
  height: 100vh;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0;
  margin: 0; }
  @media screen and (max-width: 575px) {
    .indexPage {
      height: 100%; } }

.landingPage {
  background-color: #fff;
  height: 680px;
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: cover; }
  @media screen and (max-width: 575px) {
    .landingPage {
      height: 100%; } }

.login-container {
  position: relative;
  height: 100%; }

.login-content {
  width: 420px;
  margin: auto;
  padding: 35px 35px 20px;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #ced4da;
  font-size: 14px;
  max-width: 94%; }

.login-header {
  margin-bottom: 30px; }

.login-content .form-control {
  background-color: #f5f5f5; }
  .login-content .form-control:focus {
    box-shadow: none;
    border-color: #3f51b5; }

.login-content .btn, .login-content .jr-btn {
  padding: 10px 35px !important; }

.app-login-container {
  position: relative;
  max-width: 680px;
  width: 94%;
  margin: 0 auto; }
  .app-login-container .loader-view {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    top: 0;
    bottom: 0;
    z-index: 2; }

.app-login-main-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background-color: #fff;
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  font-size: 14px;
  overflow: hidden; }

.app-login-content {
  padding: 35px 35px 20px;
  width: 60%;
  order: 1; }
  @media screen and (max-width: 575px) {
    .app-login-content {
      width: 100%;
      order: 2; } }

.app-login-header {
  margin-bottom: 30px; }

.app-login-content .form-control {
  background-color: #f5f5f5; }
  .app-login-content .form-control:focus {
    box-shadow: none;
    border-color: #3f51b5; }

.app-login-content .btn, .login-content .jr-btn {
  padding: 10px 35px !important; }

.app-logo-content {
  background-color: #3f51b5;
  padding: 35px 35px 20px;
  width: 40%;
  order: 2; }
  @media screen and (max-width: 575px) {
    .app-logo-content {
      width: 100%;
      order: 1; } }

.app-social-block {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between; }
  .app-social-block .social-link,
  .app-social-block .social-link li {
    margin: 0; }
  .app-social-block .social-link span {
    border: solid 1px #3f51b5;
    border-radius: 50%;
    color: #3f51b5; }
    .app-social-block .social-link span:hover, .app-social-block .social-link span:focus {
      color: #fff;
      background-color: #3f51b5; }
  .app-social-block p {
    margin-bottom: 0; }

/*Error Styles*/
.page-error-container {
  padding: 30px 0;
  position: relative; }
  @media screen and (max-width: 575px) {
    .page-error-container {
      padding: 15px 0; } }

.page-error-content {
  margin: 0 auto;
  padding: 40px 0;
  width: 380px;
  max-width: 94%; }
  @media screen and (max-width: 767px) {
    .page-error-content {
      padding: 15px 0; } }
  @media screen and (max-width: 575px) {
    .page-error-content {
      padding: 0; } }

.error-code {
  color: #212529;
  font-size: 160px;
  text-align: center;
  line-height: 1;
  font-weight: 600;
  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8); }
  @media screen and (max-width: 991px) {
    .error-code {
      font-size: 130px; } }
  @media screen and (max-width: 767px) {
    .error-code {
      font-size: 100px; } }
  @media screen and (max-width: 575px) {
    .error-code {
      font-size: 80px; } }

.page-error-content h2 {
  margin-bottom: 50px; }
  @media screen and (max-width: 767px) {
    .page-error-content h2 {
      margin-bottom: 20px; } }

/*Editor Styles*/
.rdw-inline-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; }

.rdw-option-wrapper {
  margin-bottom: 6px; }

/*Contact Page Styles*/
.contact-form {
  padding: 60px; }

.contact-block .contact-info {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-align-content: stretch;
  -ms-flex-align: stretch;
  align-content: stretch; }
  .contact-block .contact-info li {
    -webkit-flex: 1 1 0;
    -ms-flex: 1 1 0;
    flex: 1 1 0;
    overflow: hidden;
    padding: 10px 40px;
    border-right: 2px solid #5c5c5c;
    word-wrap: break-word; }
    .contact-block .contact-info li:last-child {
      border: 0 none; }
    .contact-block .contact-info li > i {
      float: left;
      font-size: 16px;
      margin-right: 5px; }
    .contact-block .contact-info li .contact-body {
      overflow: hidden; }
      .contact-block .contact-info li .contact-body .icons-wrapper {
        margin-top: 15px;
        margin-left: 0; }
      .contact-block .contact-info li .contact-body .icon {
        background-color: #5c6bc0;
        color: #fff;
        border-radius: 50%;
        margin-right: 6px;
        margin-bottom: 6px; }
        .contact-block .contact-info li .contact-body .icon:last-child {
          margin-right: 0; }
      .contact-block .contact-info li .contact-body .twitter-icon {
        background-color: #40c4ff; }
      .contact-block .contact-info li .contact-body .google-icon {
        background-color: #EF5350; }
      .contact-block .contact-info li .contact-body .linkedin-icon {
        background-color: #0277bd; }
  .contact-block .contact-info.vertical {
    display: block;
    margin-bottom: 0; }
    .contact-block .contact-info.vertical li {
      padding: 0 0 24px;
      border-right: 0 none;
      border-bottom: 2px solid #5c5c5c;
      margin-bottom: 24px; }
      .contact-block .contact-info.vertical li:last-child {
        border: 0 none;
        margin-bottom: 0;
        padding-bottom: 0; }

@media screen and (max-width: 767px) {
  .contact-form {
    padding: 30px; }
  .contact-block .contact-info {
    display: block;
    margin-bottom: 0; }
    .contact-block .contact-info li {
      padding: 0 0 24px;
      border-right: 0 none;
      border-bottom: 2px solid #5c5c5c;
      margin-bottom: 24px; }
      .contact-block .contact-info li:last-child {
        border: 0 none;
        margin-bottom: 0;
        padding-bottom: 0; }
  .content-section {
    padding: 20px 10px 0;
    text-align: center; }
    .content-section h2 {
      font-size: 28px; }
    .content-section p {
      font-size: 18px; } }

/*Portfolio Styles*/
.portfolio-section .card-image {
  margin-bottom: 20px; }
  .portfolio-section .card-image img {
    width: 100%;
    -webkit-transition: all 1200ms ease;
    -o-transition: all 1200ms ease;
    transition: all 1200ms ease; }
  .portfolio-section .card-image:hover img {
    -webkit-transform: scale(1.08);
    -ms-transform: scale(1.08);
    transform: scale(1.08); }

.filter-with-bg-color ul {
  padding-left: 0;
  margin: 0 -10px 45px; }
  .filter-with-bg-color ul li {
    display: inline-block;
    margin-bottom: 10px;
    padding: 0 10px; }
  .filter-with-bg-color ul li a {
    text-transform: uppercase;
    font-size: 12px;
    padding: 10px 24px;
    border: 1px solid #3f51b5;
    display: block;
    text-decoration: none; }
  .filter-with-bg-color ul li a:hover,
  .filter-with-bg-color ul li a:focus,
  .filter-with-bg-color ul li a.active {
    cursor: pointer;
    background-color: #3f51b5;
    border-color: #3f51b5;
    color: #fff; }
  @media screen and (max-width: 575px) {
    .filter-with-bg-color ul {
      margin-bottom: 15px; } }

/*Faqs Styles*/
.Collapsible {
  margin-bottom: 15px; }

.Collapsible__contentInner {
  padding: 20px;
  border: 1px solid #e9ecef;
  background-color: #fff;
  border-top: 0; }
  .Collapsible__contentInner p {
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 20px; }
    .Collapsible__contentInner p:last-child {
      margin-bottom: 0; }

.Collapsible__trigger {
  display: block;
  cursor: pointer;
  font-weight: 400;
  text-decoration: none;
  position: relative;
  padding: 18px 20px;
  border-radius: 8px;
  background: #3f51b5;
  color: #fff; }
  .Collapsible__trigger:after {
    content: '\\f2f9';
    font-family: 'Material-Design-Iconic-Font';
    font-size: 20px;
    position: absolute;
    right: 24px;
    top: 16px;
    display: block;
    transition: transform 300ms; }
  .Collapsible__trigger.is-open {
    border-radius: 8px 8px 0 0; }
    .Collapsible__trigger.is-open:after {
      transform: rotateZ(180deg); }

.categories-list {
  margin-bottom: 0; }
  .categories-list li {
    margin-bottom: 10px; }
    .categories-list li:last-child {
      margin-bottom: 0; }
  .categories-list li.active a {
    color: #3f51b5; }
  .categories-list .badge {
    font-size: 9px; }

.articles-section .articles {
  margin-bottom: 26px; }
  .articles-section .articles:last-child {
    margin-bottom: 0; }

.article-image {
  display: block;
  margin-bottom: 12px; }
  .article-image > img {
    border-radius: 8px;
    width: 100%; }

.article-description p {
  font-weight: 500;
  margin-bottom: 2px; }

.meta-wrapper {
  margin-bottom: 10px; }

.meta-date,
.meta-comment {
  font-size: 14px;
  color: #adb5bd;
  display: inline-block; }
  .meta-date i,
  .meta-comment i {
    display: inline-block;
    margin-right: 6px; }

.meta-date + .meta-comment {
  margin-left: 10px; }

/*Dashboard Styles*/
.box {
  position: relative; }
  .box .box-top,
  .box .box-bottom {
    height: 100px;
    padding: 32px 15px;
    font-size: 40px;
    line-height: 40px;
    text-align: center;
    font-weight: 300; }
    .box .box-top .size-h5,
    .box .box-bottom .size-h5 {
      font-size: 24px;
      margin-left: 2px; }
    .box .box-top .material-icons,
    .box .box-bottom .material-icons {
      font-size: 40px;
      line-height: 40px; }
  .box .box-bottom {
    border-top: 1px solid rgba(0, 0, 0, 0.15); }
  .box .box-info {
    position: absolute;
    width: 100%;
    top: 50%;
    margin-top: -12px;
    text-align: center; }
    .box .box-info span {
      height: 24px;
      display: inline-block;
      padding: 4px 10px;
      text-transform: uppercase;
      line-height: 14px;
      background-color: #fff;
      border: 1px solid rgba(0, 0, 0, 0.15);
      font-size: 12px;
      color: #6c757d;
      border-radius: 1em; }
      .box .box-info span .material-icons {
        line-height: 14px;
        font-size: 11px; }

.contact-list {
  margin-bottom: 14px; }
  .contact-list i {
    margin-right: 14px;
    color: #3f51b5; }
  .contact-list .media {
    margin-bottom: 10px; }

.temp-section .temp-point,
.temp-section .detail-icon {
  font-size: 54px; }

.assignment-table tbody tr:nth-child(odd) {
  background-color: #dee2e6 !important; }

.assignment-table td {
  padding-top: 10px;
  padding-bottom: 10px; }

.status-cell {
  min-width: 100px;
  max-width: 120px;
  padding-right: 24px !important; }
  .status-cell .badge {
    min-width: 70px; }

.thumbnail-list {
  margin-bottom: 0; }
  .thumbnail-list .thumbnail-item {
    padding: 0 2.5px;
    display: inline-block;
    width: 33.333%;
    margin-bottom: 5px; }
    @media screen and (max-width: 767px) {
      .thumbnail-list .thumbnail-item {
        width: 50%; } }
    @media screen and (max-width: 575px) {
      .thumbnail-list .thumbnail-item {
        width: 33.333%; } }

.post-list .post-image .grid-thumb-equal {
  padding-bottom: 100%; }

/*Ecommerce Dashboard Styles*/
.chart-f30 {
  font-size: 30px; }
  @media screen and (max-width: 1099px) {
    .chart-f30 {
      font-size: 20px; } }

.chart-f20 {
  font-size: 20px; }
  @media screen and (max-width: 1099px) {
    .chart-f20 {
      font-size: 16px; } }

.chart-order .col-5 {
  order: 2;
  text-align: center; }
  @media screen and (max-width: 575px) {
    .chart-order .col-5 {
      order: 1; } }

.chart-order .col-7 {
  order: 1; }
  @media screen and (max-width: 575px) {
    .chart-order .col-7 {
      order: 2; } }

.tab-notifications {
  margin-left: -30px;
  margin-right: -30px;
  border-bottom: 1px solid #adb5bd; }
  @media screen and (max-width: 567px) {
    .tab-notifications button,
    .tab-notifications button * {
      font-size: 12px !important; } }

.chart-title h2 {
  font-size: 22px;
  margin-bottom: 5px; }

.img-fluid {
  width: 100%; }

.comment-footer button {
  margin-bottom: 6px; }

/*Intranet Dashboard Styles*/
.net-chart {
  padding-left: 80px;
  padding-right: 15px;
  min-height: 100px;
  position: relative;
  overflow: hidden;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center; }
  .net-chart .jr-card-thumb {
    margin: 0;
    width: 50px;
    height: 50px;
    color: #fff;
    font-size: 20px;
    border-radius: 50%;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-transition: all 100ms ease;
    -o-transition: all 100ms ease;
    transition: all 100ms ease;
    position: absolute;
    left: 15px; }
  .net-chart:hover .jr-card-thumb {
    width: 70px;
    height: 100%;
    font-size: 30px;
    border-radius: 0;
    position: absolute;
    left: 0; }

.net-chart-hr {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  min-height: 120px;
  padding-right: 8px;
  overflow: hidden; }
  .net-chart-hr .jr-card-thumb {
    margin: -30px 12px -30px -30px;
    min-width: 105px; }
  .net-chart-hr .grid-thumb-equal {
    padding-bottom: 130%; }
  .net-chart-hr .jr-card-body {
    width: calc(100% - 100px); }

.user-profile {
  padding: 10px 0; }

.mh-120 {
  min-height: 120px; }

.jr-card-header-top {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-right: -16px; }

.jr-card-header-color {
  padding: 10px 20px 20px;
  margin: -24px -30px 25px; }

.todo-cell-group .todo-cell:not(:last-child) {
  margin-bottom: 8px; }

.social-list-line {
  position: relative; }
  .social-list-line:not(:last-child):before {
    border-left: solid 1px #adb5bd;
    content: "";
    left: 20px;
    position: absolute;
    top: 5px;
    bottom: 0;
    width: 1px;
    z-index: 1; }

.list-line-item {
  position: relative;
  padding-left: 40px; }
  .list-line-item:not(:last-child):before {
    border-left: solid 1px #adb5bd;
    content: "";
    left: 20px;
    position: absolute;
    top: -25px;
    bottom: -25px;
    width: 1px;
    z-index: 1; }

.list-line-badge {
  position: absolute;
  left: 16px;
  top: 15px;
  z-index: 2;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  background-color: #adb5bd; }

.circle-shape {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%; }

.project-list {
  line-height: 1; }
  .project-list:not(:last-child) {
    margin-bottom: 20px; }
  .project-list .circle-shape {
    margin-top: 4px;
    margin-right: 16px; }
  .project-list .project-name {
    display: block;
    margin-bottom: 4px;
    color: #5c5c5c; }
    .project-list .project-name:hover, .project-list .project-name:focus {
      color: #3f51b5;
      text-decoration: none; }

.nav-pill-sales li + li {
  margin-right: -1px; }

.nav-pill-sales .nav-link {
  background-color: #e9ecef;
  border-radius: 0;
  padding: 6px 15px;
  color: #6c757d;
  font-size: 13px;
  border: 1px solid #ced4da; }
  .nav-pill-sales .nav-link.active {
    background-color: #3f51b5;
    color: #fff;
    border-color: #3f51b5; }
    .nav-pill-sales .nav-link.active:hover, .nav-pill-sales .nav-link.active:focus {
      color: #fff; }

.nav-pill-sales li:first-child .nav-link {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px; }

.nav-pill-sales li:last-child .nav-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px; }

.temp-week-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  color: #808992; }
  .temp-week-list li:not(:last-child) {
    margin-bottom: 10px; }
    @media screen and (max-width: 340px) {
      .temp-week-list li:not(:last-child) {
        margin-bottom: 20px; } }
  .temp-week-list img {
    width: 24px;
    height: 24px; }
  .temp-week-list span {
    display: inline-block; }
    .temp-week-list span.temp-point {
      margin: 0 20px; }
      @media screen and (max-width: 1199px) {
        .temp-week-list span.temp-point {
          margin: 0 10px; } }
      @media screen and (max-width: 1050px) {
        .temp-week-list span.temp-point {
          margin: 0 5px; } }
      @media screen and (max-width: 340px) {
        .temp-week-list span.temp-point {
          margin: 0 20px; } }

.temp-section .temp-point {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 0; }
  .temp-section .temp-point sub,
  .temp-section .temp-point sup {
    font-size: 70%; }

/*Dropzone Styles*/
.dropzone-card {
  position: relative; }

.dropzone {
  margin-bottom: 20px; }
  .dropzone > div {
    margin: 0 auto;
    padding: 15px;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-justify-content: center;
    justify-content: center; }
    .dropzone > div :last-child {
      margin-bottom: 0; }
  .dropzone .btn {
    margin-top: 20px; }

.upload-file-list {
  list-style: none;
  padding-left: 0; }
  .upload-file-list li {
    margin-bottom: 5px; }

.form-group-dropzone label {
  margin-bottom: 6px; }

.form-group-dropzone .form-control {
  max-width: 200px;
  margin: 0 auto; }

/* Slider
   ========================================================================== */
.brand-logo {
  border: 1px solid #dee2e6;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  padding-bottom: 75%; }
  .brand-logo .brand-logo-inner {
    text-align: center; }
    .brand-logo .brand-logo-inner:before {
      content: "";
      display: inline-block;
      height: 100%;
      vertical-align: middle; }
    .brand-logo .brand-logo-inner img {
      height: auto;
      max-height: 100%;
      max-width: 100%;
      display: inline-block;
      vertical-align: middle;
      width: auto !important; }
  .brand-logo:hover {
    -webkit-transition: all 0.4s ease-in-out 0.1s;
    -o-transition: all 0.4s ease-in-out 0.1s;
    transition: all 0.4s ease-in-out 0.1s;
    background-color: #f2f2f2; }
  @media screen and (max-width: 575px) {
    .brand-logo {
      margin-bottom: 15px; } }

.owl-app-frame.owl-carousel .owl-item img {
  display: inline-block;
  width: auto; }

.carousel-item img {
  max-width: 100%; }

/* Modules
   ========================================================================== */
/* App Module Style */
.app-wrapper-module {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: stretch;
  align-items: stretch;
  height: 100%; }

.app-module {
  position: relative;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin: -36px -40px 0 -40px; }
  @media screen and (max-width: 575px) {
    .app-module {
      margin: -20px; } }

.module-side {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 230px;
  -ms-flex: 0 1 230px;
  flex: 0 1 230px;
  max-width: 230px;
  min-width: 230px; }

.module-side-header {
  border-bottom: solid 1px #e9ecef;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap; }
  .module-side-header .user-detail {
    padding: 15px 10px;
    text-align: center; }

.module-logo {
  padding: 10px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  min-height: 78px;
  font-size: 20px;
  background-color: #f9fafb;
  color: #2f353a; }
  .module-logo .zmdi {
    font-size: 28px; }

.module-user-info, .module-side-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap; }

.module-user-detail {
  font-size: 12px; }

.module-add-task {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 24px; }

.module-nav {
  list-style: none;
  padding-left: 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center; }
  .module-nav li {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap; }
  .module-nav li a {
    padding: 12px 29px;
    color: #8f8f8f;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-items: center;
    align-items: center;
    text-decoration: none; }
    .module-nav li a:hover, .module-nav li a:focus {
      color: #5c5c5c; }
    .module-nav li a.active {
      color: #3f51b5; }
  .module-nav li i {
    margin-right: 16px;
    font-size: 16px; }
  .module-nav li span {
    display: inline-block;
    vertical-align: middle; }
  .module-nav li.module-nav-label {
    padding: 12px 29px; }

.module-box {
  position: relative;
  z-index: 2;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: calc(100% - 231px); }

.module-box-header {
  padding: 10px 26px;
  min-height: 79px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  background-color: #fff;
  border-bottom: solid 1px #e9ecef; }
  .module-box-header .search-bar.right-side-icon {
    min-width: 350px; }
    .module-box-header .search-bar.right-side-icon .form-control {
      border-radius: 0;
      height: 46px;
      padding: 10px 18px 10px 40px; }
      .module-box-header .search-bar.right-side-icon .form-control:focus {
        background-color: #f8f9fa; }
    .module-box-header .search-bar.right-side-icon .search-icon {
      width: 25px;
      height: 46px;
      font-size: 16px;
      left: 10px;
      top: 0;
      padding: 0; }

.module-box-header-inner {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between; }

.module-box-content {
  background-color: #fff;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap; }

.module-box-topbar {
  padding: 8px 12px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: solid 1px #e9ecef; }
  .module-box-topbar button + button {
    border-radius: 0; }

.module-box-topbar-todo {
  padding-left: 64px; }
  @media screen and (max-width: 575px) {
    .module-box-topbar-todo {
      padding-left: 27px; } }

.module-list-icon {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  padding-right: 10px; }

.bar-icon {
  margin-right: 15px; }

.toolbar-separator {
  border-left: solid 1px #ced4da;
  height: 100%;
  width: 1px;
  margin: 0 12px; }

.toolbar-left {
  margin-left: auto; }

.module-list {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center; }

.module-list-item {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  padding: 15px 28px;
  border-bottom: solid 1px #e9ecef;
  z-index: 5;
  position: relative;
  cursor: pointer; }
  .module-list-item > .check-label {
    margin-left: 0;
    margin-bottom: 0; }
  .module-list-item.mail-cell {
    padding-left: 12px;
    -webkit-align-items: start;
    align-items: start; }

.module-detail-header {
  margin-bottom: 10px; }
  .module-detail-header > .check-label {
    margin-right: auto; }

.module-list-info {
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: calc(100% - 169px); }

.module-todo-content {
  position: relative; }
  .module-todo-content .subject {
    margin-bottom: 5px; }

.module-list-actions {
  text-align: right; }

.app-module-sidenav {
  background-color: #fff;
  border-right: solid 1px #e9ecef;
  position: relative;
  z-index: 9; }
  .app-module-sidenav .chat-sidenav-main {
    max-width: 300px;
    min-width: 300px;
    width: 90%; }

.module-date {
  max-width: 160px; }
  .module-date > div:before {
    display: none; }

.module-detail-item {
  padding: 10px 28px; }

.task-title {
  font-size: 18px; }

.chat-todo-avatar {
  margin-right: 15px; }

.modal-title {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
  width: 100%;
  font-size: 18px; }

.loader-view-block, .loader-view {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center; }

.module-date > div {
  -webkit-align-items: center;
  align-items: center; }

@media screen and (max-width: 1199px) {
  .module-side {
    display: -webkit-block;
    display: -moz-block;
    display: -ms-block;
    display: -o-block;
    display: block;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 200px;
    min-width: 200px;
    background-color: #fff; }
  .module-box-header {
    position: relative;
    min-height: 58px;
    padding: 5px 26px 5px 75px; }
    .module-box-header .drawer-btn {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      border-right: solid 1px #e9ecef;
      height: 58px;
      width: 56px;
      border-radius: 0;
      font-size: 22px; }
    .module-box-header .search-bar.right-side-icon .form-control {
      height: 38px;
      padding: 5px 18px 5px 40px; }
    .module-box-header .search-bar.right-side-icon .search-icon {
      height: 38px; }
  .chat-loader-view {
    height: calc(100vh - 120px); }
  .module-box {
    max-width: 100%; } }

@media screen and (min-width: 991px) {
  .modal-dialog {
    max-width: 750px; } }

@media screen and (max-width: 991px) {
  .app-module {
    padding-top: 0; } }

@media screen and (max-width: 599px) {
  .module-box-header .search-bar {
    margin-left: 0;
    max-width: none; }
    .module-box-header .search-bar.right-side-icon {
      min-width: 250px; } }

@media screen and (max-width: 575px) {
  .module-list-item {
    padding: 10px 12px; }
  .module-list-info {
    max-width: 100%; }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu {
    right: auto !important;
    left: 0 !important; }
  .module-box-header .search-bar.right-side-icon {
    min-width: 200px; }
    .module-box-header .search-bar.right-side-icon .form-control {
      border-radius: 0.25rem; }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu:after {
    right: auto;
    left: 9px; }
  .module-box-header .nav-searchbox.quick-menu .dropdown-menu:before {
    right: auto;
    left: 9px; }
  .module-box-header .search-bar {
    padding-right: 2px; } }

@media screen and (max-width: 399px) {
  .module-box-header .search-bar.right-side-icon {
    min-width: 100px; } }

@media screen and (min-width: 399px) {
  .d-xs-flex {
    display: flex !important; } }

/*Chat Module Styles*/
.chat-module {
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto; }
  .chat-module:before {
    left: -29px; }

.chat-module-box {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  background-color: #f8f9fa;
  position: relative;
  width: 100%; }

.chat-sidenav {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 0 1 315px;
  -ms-flex: 0 1 315px;
  flex: 0 1 315px;
  min-width: 315px;
  border-right: solid 1px #e9ecef; }

.chat-box {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
  position: relative;
  z-index: 2; }

.chat-sidenav-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 25px 20px 12px;
  background-color: #f9fafb; }

.chat-user-hd {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 25px; }

.chat-sidenav-header .search-wrapper {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  margin-bottom: 0; }
  .chat-sidenav-header .search-wrapper .search-bar.right-side-icon {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto; }
    .chat-sidenav-header .search-wrapper .search-bar.right-side-icon .form-control {
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      -o-box-shadow: none;
      box-shadow: none;
      border-radius: 0;
      padding-left: 42px;
      height: 42px; }
    .chat-sidenav-header .search-wrapper .search-bar.right-side-icon .search-icon {
      left: 10px;
      top: 0;
      height: 42px;
      padding: 0; }

.chat-avatar {
  min-width: 50px; }
  .chat-user-item .chat-avatar {
    padding: 0 5px;
    min-width: 10px; }
  .chat-user-hd .chat-avatar {
    cursor: pointer; }

.chat-avatar-mode {
  position: relative;
  max-width: 50px; }
  .chat-avatar-mode .chat-mode {
    display: block;
    position: absolute;
    left: 0;
    top: 2px;
    z-index: 1;
    width: 12px;
    height: 12px;
    border-radius: 50%; }
    .chat-avatar-mode .chat-mode.small {
      width: 8px;
      height: 8px; }
    .chat-avatar-mode .chat-mode.online {
      background-color: #4CAF50; }
    .chat-avatar-mode .chat-mode.offline {
      background-color: #fff;
      border: solid 1px #4CAF50; }
    .chat-avatar-mode .chat-mode.away {
      background-color: #fdd835; }
  .chat-main-header-info .chat-avatar-mode {
    max-width: 60px; }

.chat-sidenav-content {
  background-color: #fff; }

.chat-sidenav-title {
  padding: 10px 16px;
  font-size: 13px;
  color: #00bcd4;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center; }

.chat-tabs-header {
  background-color: #f9fafb !important; }

.chat-user {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap; }
  .chat-user.chat-user-center {
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center; }
    .chat-user.chat-user-center .chat-avatar {
      margin-left: auto; }

.chat-user-item {
  border-bottom: solid 1px #e9ecef;
  padding: 16px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  cursor: pointer;
  max-height: 96px; }
  .chat-user-item.active, .chat-user-item:hover {
    background-color: #e4e7f6; }

.chat-user-row {
  margin: 0 -5px;
  -webkit-align-items: center;
  align-items: center; }

.chat-info, .chat-contact-col {
  padding: 0 5px; }
  .chat-info p, .chat-contact-col p {
    margin-bottom: 0; }
  .chat-info .h4, .chat-contact-col .h4 {
    display: block;
    margin-bottom: 3px; }

.chat-info-des {
  color: #6c757d;
  font-size: 13px; }

.chat-date {
  padding: 0 5px;
  text-align: right; }

.chat-box-main {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%; }

.module-default {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  height: 100%;
  padding: 15px; }

.s-128 {
  font-size: 128px !important;
  width: 128px !important;
  height: 128px !important;
  line-height: 128px !important;
  margin-bottom: 12px; }

.chat-main {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap; }

.chat-main-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  border-bottom: solid 1px #e9ecef;
  padding: 16px;
  background-color: #fff;
  width: 100%; }

.chat-main-header-info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center;
  margin-right: auto; }

.chat-contact-name {
  font-size: 20px;
  font-weight: 500; }

.chat-main-footer {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  border-top: solid 1px #e9ecef;
  padding: 16px;
  background-color: #fff;
  width: 100%; }
  .chat-main-footer .form-group {
    margin-bottom: 0; }

.todo-main-footer {
  padding: 6px 16px; }

.chat-item {
  padding: 16px; }
  .chat-item .bubble {
    padding: 8px 12px;
    background-color: #fff;
    border-radius: 20px 20px 20px 0px;
    position: relative;
    margin-left: 16px;
    max-width: 600px;
    border: solid 1px #ced4da; }
  .chat-item.flex-row-reverse .bubble {
    margin-right: 16px;
    margin-left: 0;
    background-color: #e4e7f6;
    border-radius: 20px 20px 0 20px; }

.chat-btn {
  font-size: 38px !important;
  margin: 0 10px 0 -8px; }

.chat-textarea {
  height: 40px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  border-radius: 0; }

.last-message-time {
  font-size: 11px;
  color: #adb5bd; }

@media screen and (max-width: 1399px) {
  .s-128 {
    font-size: 100px !important;
    width: 100px !important;
    height: 100px !important;
    line-height: 100px !important; } }

@media screen and (max-width: 1199px) {
  .chat-module {
    margin: -24px -29px -23px;
    padding-top: 0; }
  .chat-main-header {
    padding: 8px 24px; }
    .chat-main-header .size-60 {
      height: 50px !important;
      width: 50px !important;
      line-height: 50px; }
    .chat-main-header button {
      margin-bottom: 0; }
  .chat-main-header-info .chat-avatar-mode {
    max-width: 50px; }
  .chat-contact-name,
  .chat-sidenav-title {
    font-size: 16px; }
  .chat-main-footer {
    padding: 8px 16px; }
  .s-128 {
    font-size: 128px !important;
    width: 128px !important;
    height: 128px !important;
    line-height: 128px !important; } }

@media screen and (max-width: 991px) {
  .s-128 {
    font-size: 100px !important;
    width: 100px !important;
    height: 100px !important;
    line-height: 100px !important;
    margin-bottom: 10px; } }

@media screen and (max-width: 767px) {
  .chat-sidenav-title,
  .chat-contact-name {
    font-size: 15px; }
  .s-128 {
    font-size: 80px !important;
    width: 80px !important;
    height: 80px !important;
    line-height: 80px !important; } }

@media screen and (max-width: 575px) {
  .module-default h1 {
    font-size: 17px; }
  .s-128 {
    font-size: 40px !important;
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important; } }

/*Mails Module Styles*/
.module-box-row {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%; }

.module-box-column {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  width: 100%; }

.mail-user-info {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center; }
  .mail-user-info .avatar {
    margin-right: 10px; }
  .mail-user-info .time,
  .mail-user-info button {
    margin-left: auto; }
  .mail-user-info .badge {
    margin-bottom: 0; }

.module-list-item.mail-cell {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; }

.mail-detail {
  padding: 24px !important; }

.mail-header {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-align-items: center;
  align-items: center; }

.mail-header-content {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap; }
  .mail-header-content .subject {
    margin-bottom: 5px; }

.show-detail {
  cursor: pointer; }

.text-truncate, .module-list-content .subject, .module-list-content .message p {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.module-list-content .message {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  color: #919ca6;
  font-size: 13px; }
  .module-list-content .message p {
    margin-bottom: 8px; }

.size {
  margin: 5px 0; }

.sender-name {
  margin-right: 0;
  font-weight: 500;
  font-size: 15px; }

.mail-header-actions {
  text-align: right;
  min-width: 100px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap; }
  .mail-header-actions .icon-btn:not(:last-child) {
    margin-right: 3px; }

@media screen and (max-width: 991px) {
  .module-list-item.mail-cell {
    padding-right: 20px; } }

@media screen and (max-width: 576px) {
  .mail-list {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%;
    border-right: 0 none; }
  .mail-detail {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    max-width: 100%; }
    .mail-detail .module-list-scroll {
      padding: 24px; } }

@media screen and (max-width: 499px) {
  .mail-header {
    display: block;
    -webkit-align-items: flex-start;
    align-items: flex-start;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap; }
  .mail-header-actions {
    text-align: left;
    min-width: 10px; }
  .MuiDialog-paperWidthSm-99 {
    max-width: 250px !important; } }

/*Contact Module Styles*/
.contact-item {
  -webkit-align-items: center;
  align-items: center;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border-bottom: solid 1px #e9ecef;
  padding: 8px 12px; }

.contact-name {
  font-size: 15px; }

.modal-box {
  position: relative; }

.modal-w {
  max-width: 400px;
  min-width: 350px; }
  .modal-box-mail .modal-w {
    min-width: 600px; }

.modal-box-header {
  color: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px; }

.modal-box-header h2 {
  color: #fff;
  position: relative; }
  .modal-box-header h2 button {
    position: absolute;
    right: 0;
    top: -10px;
    z-index: 1;
    color: #fff; }

.modal-box-content {
  padding: 24px; }
  .modal-box-content .avatar {
    margin: 0 auto; }

.modal-box-footer {
  padding: 0 24px 24px; }
  .modal-box-footer .attach-file {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-items: center;
    align-items: center;
    margin-bottom: 15px; }

.btn-fixed {
  position: fixed !important;
  right: 40px;
  bottom: 60px;
  z-index: 100; }

.draggable-icon {
  cursor: all-scroll;
  color: #6c757d; }
  .draggable-icon:hover, .draggable-icon:focus, .draggable-icon:active {
    cursor: all-scroll;
    color: #212529; }

.module-side-nav {
  padding: 20px 0; }

@media screen and (max-width: 767px) {
  .modal-box-mail .modal-w {
    min-width: 500px; }
  .modal-box-header h2 {
    font-size: 18px; } }

@media screen and (max-width: 575px) {
  .modal-w {
    min-width: 300px; }
    .modal-box-mail .modal-w {
      min-width: 400px; }
  .modal-box-header h2 {
    font-size: 16px; } }

@media screen and (max-width: 419px) {
  .modal-w {
    min-width: 250px; }
    .modal-box-mail .modal-w {
      min-width: 250px; } }

@media screen and (max-width: 399px) {
  .con-inf-mw-100 {
    min-width: 100% !important; } }

/* Calendar Module Style */
.app-calendar .rbc-calendar {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: calc(100vh - 160px); }

.app-cul-calendar .rbc-calendar {
  min-height: calc(100vh - 200px); }

.rbc-event {
  background-color: #3f51b5; }

.rbc-event.rbc-selected {
  background-color: #32408f; }

.rbc-slot-selection {
  background-color: rgba(63, 81, 181, 0.7); }

.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
  color: #fff;
  background-image: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5; }

.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button.rbc-active:focus {
  color: #fff;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5; }

.rbc-toolbar button:focus {
  color: #fff;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5; }

.rbc-toolbar button:hover {
  color: #fff;
  background-color: rgba(63, 81, 181, 0.9);
  border-color: #3f51b5; }

.rbc-month-row {
  min-height: 100px; }

.rbc-event {
  min-height: 50px; }

@media screen and (max-width: 867px) {
  .rbc-toolbar {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-align-items: flex-start;
    align-items: flex-start; }
  .rbc-toolbar .rbc-toolbar-label {
    margin: 8px 0; } }

@media screen and (max-height: 600px) {
  .app-calendar .rbc-calendar {
    min-height: 400px; }
  .app-cul-calendar .rbc-calendar {
    min-height: 400px; } }

@media screen and (max-width: 467px) {
  .rbc-toolbar {
    font-size: 12px; }
  .rbc-toolbar button {
    padding: 5px 10px; } }
`, "",{"version":3,"sources":["webpack://./styles/app.scss","webpack://./styles/global/__global-dir.scss","webpack://./styles/global/_place-holder.scss","webpack://./styles/global/_variables.scss","webpack://./styles/global/_mixin.scss","webpack://./styles/bootstrap/_variables.scss","webpack://./styles/global/_sizes.scss","webpack://./styles/global/_color.scss","webpack://./styles/global/_custom-animation.scss","webpack://./styles/base/__base-dir.scss","webpack://./styles/base/_base.scss","webpack://./styles/base/_typography.scss","webpack://./styles/layout/__layout-dir.scss","webpack://./styles/layout/_app-layout.scss","webpack://./styles/layout/_sidebar.scss","webpack://./styles/layout/_header.scss","webpack://./styles/layout/_navbar.scss","webpack://./styles/layout/_main-content.scss","webpack://./styles/layout/_footer.scss","webpack://./styles/layout/_right-sidebar.scss","webpack://./styles/ui/__ui-dir.scss","webpack://./styles/ui/_alert.scss","webpack://./styles/ui/_avatar.scss","webpack://./styles/ui/_badges.scss","webpack://./styles/ui/_blockquotes.scss","webpack://./styles/ui/_bottom-navigation.scss","webpack://./styles/ui/_breadcrumb.scss","webpack://./styles/ui/_button.scss","webpack://./styles/ui/_button-group.scss","webpack://./styles/ui/_callout.scss","webpack://./styles/ui/_card.scss","webpack://./styles/ui/_charts.scss","webpack://./styles/ui/_chip.scss","webpack://./styles/ui/_carousel.scss","webpack://./styles/ui/_color-picker.scss","webpack://./styles/ui/_date-input.scss","webpack://./styles/ui/_drawer.scss","webpack://./styles/ui/_e-commerce.scss","webpack://./styles/ui/_grid-list.scss","webpack://./styles/ui/_icons.scss","webpack://./styles/ui/_label.scss","webpack://./styles/ui/_list.scss","webpack://./styles/ui/_nav.scss","webpack://./styles/ui/_pricing-tables.scss","webpack://./styles/ui/_progressbar.scss","webpack://./styles/ui/_popover.scss","webpack://./styles/ui/_tables.scss","webpack://./styles/ui/_tabs.scss","webpack://./styles/ui/_testimonial.scss","webpack://./styles/ui/_timeline.scss","webpack://./styles/ui/_form.scss","webpack://./styles/ui/_ad-form.scss","webpack://./styles/ui/_input.scss","webpack://./styles/pages/__pages-dir.scss","webpack://./styles/pages/_login.scss","webpack://./styles/pages/_error.scss","webpack://./styles/pages/_editor.scss","webpack://./styles/pages/_contact.scss","webpack://./styles/pages/_portfolio.scss","webpack://./styles/pages/_faq.scss","webpack://./styles/pages/_dashboard.scss","webpack://./styles/pages/_dropzone.scss","webpack://./styles/slider/_owl-carousel.scss","webpack://./styles/module/__module-dir.scss","webpack://./styles/module/_app-module.scss","webpack://./styles/module/_chat.scss","webpack://./styles/module/_mail.scss","webpack://./styles/module/_contact.scss","webpack://./styles/module/_calendar.scss"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;gEA8DgE;ACnEhE;+EDqE+E;AEnE7E;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,cAAc;EACd,yBCqDkB;EDpDlB,cAAc;EE4BhB,iCF3BmC;EE4BnC,4BF5BmC;EE6BnC,yBF7BmC;EACjC,aAAa;EACb,eAAe,EAAA;EAEf;IAEE,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,OAAO;IACP,WAAW;IACX,eAAe;IACf,WAAW;IEcf,iCFbqC;IEcrC,4BFdqC;IEerC,yBFfqC,EAAA;EAGnC;IACE,WAAW;IACX,YAAY,EAAA;EAGd;IACE,WAAW;IACX,SAAS,EAAA;;AAIX;EACE,WAAW,EAAA;EACX;IAEE,WAAW,EAAA;;AAMnB;EACE,uBAA2B;EAC3B,sBAA0B;EAC1B,iBCyGY,EAAA;;ADtGd;EACE,uBAA2B;EAC3B,sBAA0B;EAC1B,iBCoGY,EAAA;;ADjGd;EACE,uBAA2B;EAC3B,sBAA0B;EAC1B,iBC+FY,EAAA;;AD5Fd;EACE,wBAA4B;EAC5B,uBAA2B;EAC3B,kBC0Fc,EAAA;;ADvFhB;EACE,uBAA2B;EAC3B,sBAA0B;EAC1B,iBC8EY,EAAA;;AD1Ed;EACE,uBAA2B;EAC3B,sBAA0B;EAC1B,iBCwEY,EAAA;;ADrEd;EACE,uBAA2B;EAC3B,sBAA0B;EAC1B,iBCmEY,EAAA;;ADhEd;EACE,wBAA4B;EAC5B,uBAA2B;EAC3B,kBCkEc,EAAA;;AD/DhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB,EAAA;;AAG3B;EACE,kBCxByB;EDyBzB,mBC1BmB;ED2BnB,sBGhGU;EDsFR,kBDxDkB;EDoEpB,yBG9FgB;EH+FhB,kBAAkB,EAAA;;AAGpB,iBAAA;AACA;EACE,kBAAkB;EAClB,gBAAgB,EAAA;EAChB;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,oCGjHQ;IHkHR,UAAU;IE5BV,mBF6B2B;IAC3B,sCAAsC;IACtC,yBAAyB,EAAA;EAG3B;IACE,6BAA6B,EAAA;;AAIjC;EACE;IACE,sBAAsB;IACtB,YAAY,EAAA;EAEd;IACE,wBAAwB;IACxB,YAAY,EAAA;EAEd;IACE,UAAU;IACV,0BAA0B,EAAA,EAAA;;AAI9B;EACE;IACE,sBAAsB;IACtB,YAAY,EAAA;EAEd;IACE,wBAAwB;IACxB,YAAY,EAAA;EAEd;IACE,UAAU;IACV,0BAA0B,EAAA,EAAA;;AAK9B;EACE,cAAc;EErKd,gDDyFc;ECxFd,6CDwFc;ECvFd,2CDuFc;ECtFd,wCDsFc;ED8Ed,4BAA4B,EAAA;;AAG9B;EACE;IACE,kDCnFY,EAAA;EDqFd;IACE,mDCtFY,EAAA;EDwFd;IACE,gDCzFY,EAAA,EAAA;;AD6FhB;EACE;IACE,+CC/FY;IDgGZ,0CChGY,EAAA;EDkGd;IACE,gDCnGY;IDoGZ,2CCpGY,EAAA;EDsGd;IACE,6CCvGY;IDwGZ,wCCxGY,EAAA,EAAA;;AD6GhB;EACE,cAAc;EEvMd,gDCwCa;EDvCb,6CCuCa;EDtCb,2CCsCa;EDrCb,wCCqCa;EHiKb,6BAA6B,EAAA;;AAG/B;EACE;IACE,kDGtKW,EAAA;EHwKb;IACE,mDGzKW,EAAA;EH2Kb;IACE,gDG5KW,EAAA,EAAA;;AHgLf;EACE;IACE,+CGlLW;IHmLX,0CGnLW,EAAA;EHqLb;IACE,gDGtLW;IHuLX,2CGvLW,EAAA;EHyLb;IACE,6CG1LW;IH2LX,wCG3LW,EAAA,EAAA;;AHgMf;EACE,cAAc;EEzOd,gDCuCc;EDtCd,6CCsCc;EDrCd,2CCqCc;EDpCd,wCCoCc;EHoMd,2BAA2B,EAAA;;AAG7B;EACE;IACE,kDGzMY,EAAA;EH2Md;IACE,mDG5MY,EAAA;EH8Md;IACE,gDG/MY,EAAA,EAAA;;AHmNhB;EACE;IACE,+CGrNY;IHsNZ,0CGtNY,EAAA;EHwNd;IACE,gDGzNY;IH0NZ,2CG1NY,EAAA;EH4Nd;IACE,6CG7NY;IH8NZ,wCG9NY,EAAA,EAAA;;AHkOhB,4DAAA;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW,EAAA;;AAIb;EACE,sBAAwB,EAAA;EAExB;IAEE,sBAAwB,EAAA;;AAK5B;EACE,eAAe,EAAA;;AAMf;;;;;;;;;;;;;;;;;EAEE,sBAAsB;EErTxB,wBFsT0B;EErT1B,qBFqT0B;EEpT1B,mBFoT0B;EEnT1B,gBFmT0B,EAAA;EAExB;;;;;;;;;;;;;;;;;IExTF,wBFyT4B;IExT5B,qBFwT4B;IEvT5B,mBFuT4B;IEtT5B,gBFsT4B,EAAA;;AIvT1B;EACE,qBAA4B,EAAA;;AAD9B;EACE,qBAA4B,EAAA;;AAD9B;EACE,qBAA4B,EAAA;;AAD9B;EACE,sBAA4B,EAAA;;AAD9B;EACE,sBAA4B,EAAA;;AAD9B;EACE,sBAA4B,EAAA;;AAD9B;EACE,sBAA4B,EAAA;;AAD9B;EACE,uBAA4B,EAAA;;AAD9B;EACE,yBAA4B,EAAA;;AAD9B;EACE,yBAA4B,EAAA;;AAD9B;EACE,yBAA4B,EAAA;;AAD9B;EACE,0BAA4B,EAAA;;AAD9B;EACE,0BAA4B,EAAA;;AAD9B;EACE,0BAA4B,EAAA;;AAD9B;EACE,0BAA4B,EAAA;;AAD9B;EACE,2BAA4B,EAAA;;AC8W5B;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAhBzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAIzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AAS7C;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,oCAAyC,EAAA;;AAE3C;EACE,yBAA8B,EAAA;EADhC;IAGI,gCAAqC,EAAA;;AANzC;EACE,wCAAyC,EAAA;;AAE3C;EACE,6BAA8B,EAAA;EADhC;IAGI,oCAAqC,EAAA;;AClZ3C,mBAAA;AAEA;EACE;IACE,kCAAkC;IAClC,UAAU;IACV,yDAAyD,EAAA;EAE3D;IACE,kCAAkC;IAClC,wDAAwD,EAAA;EAE1D;IACE,UAAU;IACV,wDAAwD,EAAA;EAE1D;IACE,wDAAwD,EAAA;EAE1D;IACE,gCAAgC,EAAA,EAAA;;AAIpC;EACE;IACE,kCAAkC;IAClC,UAAU;IACV,yDAAyD,EAAA;EAE3D;IACE,kCAAkC;IAClC,wDAAwD,EAAA;EAE1D;IACE,UAAU;IACV,wDAAwD,EAAA;EAE1D;IACE,wDAAwD,EAAA;EAE1D;IACE,gCAAgC,EAAA,EAAA;;AAIpC;EACE,0BAA0B;EAC1B,4BAA4B,EAAA;;AAG9B;EACE;IACE,oBAAoB;IACpB,8BAA8B,EAAA;EAEhC;IACE,UAAU;IACV,oBAAoB;IACpB,8BAA8B,EAAA,EAAA;;AAIlC;EACE;IACE,oBAAoB;IACpB,8BAA8B,EAAA;EAEhC;IACE,UAAU;IACV,oBAAoB;IACpB,8BAA8B,EAAA,EAAA;;AAIlC;EACE,2BAA2B;EAC3B,4BAA4B,EAAA;;AAG9B;EACE;IACE,UAAU;IACV,qCAAqC,EAAA;EAEvC;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAInB;EACE;IACE,UAAU;IACV,qCAAqC,EAAA;EAEvC;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAInB;EACE,+BAA+B,EAAA;;AAGjC;EACE;IACE,UAAU;IACV,sCAAsC,EAAA;EAExC;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAInB;EACE;IACE,UAAU;IACV,sCAAsC,EAAA;EAExC;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAInB;EACE,8BAA8B,EAAA;;AAGhC;EACE;IACE,qCAAqC,EAAA;EAEvC;IACE,eAAe,EAAA,EAAA;;AAInB;EACE;IACE,qCAAqC,EAAA;EAEvC;IACE,eAAe,EAAA,EAAA;;AAInB;EACE,gCAAgC,EAAA;;AAGlC;EACE;IACE,sCAAsC,EAAA;EAExC;IACE,eAAe,EAAA,EAAA;;AAInB;EACE;IACE,sCAAsC,EAAA;EAExC;IACE,eAAe,EAAA,EAAA;;AAInB;EACE,+BAA+B,EAAA;;AAGjC;EACE;IACE,oCAAoC,EAAA;EAEtC;IACE,eAAe,EAAA,EAAA;;AAInB;EACE;IACE,oCAAoC,EAAA;EAEtC;IACE,eAAe,EAAA,EAAA;;AAInB;EACE,6BAA6B,EAAA;;AAG/B,sBAAA;AACA;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,sBAAsB,EAAA;;AAGxB;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,sBAAsB,EAAA;;AAGxB;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,sBAAsB,EAAA;;AAGxB;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,sBAAsB,EAAA;;AAKxB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,mBAAmB,EAAA;;AAGrB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,mBAAmB,EAAA;;AAGrB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,mBAAmB,EAAA;;AAGrB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,mBAAmB,EAAA;;AAGrB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,mBAAmB,EAAA;;AC9iBrB;+ET46F+E;AU56F/E,cAAA;AAEA;EACE,YAAY,EAAA;;AAGd;EAEI,iCPQyC;EOPzC,ePWiB;EOVjB,gBL8NoB;EK5NtB,cPmFkB;EOlFlB,sBPiFY;EOhFZ,YAAY;EACZ,gBAAgB,EAAA;;AAGlB;EACE,uBAAuB;EACvB,4BAA4B,EAAA;;AAG9B;EACE,wBAAwB;EACxB,8BAAmC,EAAA;;AAGrC;EN1BE,gEM2B0E;EN1B1E,6DM0B0E;ENzB1E,2DMyB0E;ENxB1E,wDMwB0E,EAAA;;AAG5E;EACE,wBAAwB,EAAA;;AAG1B;EACE,oCAAyC;EACzC,qCAA0C,EAAA;;AAO5C;EACE,oBAAoB,EAAA;;AAGtB;EACE,gCAAgC,EAAA;;AAGlC;EACE,2BAA2B,EAAA;;AAG7B;EACE,WAAW,EAAA;;AAmCb;EACE,gCLjFgB,EAAA;;AKoFlB;EACE,8BLrFgB,EAAA;EKoFlB;IAGI,cAAc,EAAA;;AAIlB;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,wBAAwB,EAAA;;AAG1B;EACE,2BAA2B,EAAA;;AAG7B;EACE,4BAA4B,EAAA;;AAG9B;EACE,qBAAqB;EACrB,cPxEmB;EOyEnB,0BAA0B,EAAA;EAH5B;IAKI,gBAAgB;IAChB,0CAA0C;IAC1C,cP7EiB;IO8EjB,gBAAgB;IAChB,eAAe;IACf,sBAAsB,EAAA;EAV1B;IAeI,qBAAqB,EAAA;;AAIzB;EACE,mBPlBuB,EAAA;;AOqBzB;EACE,mBPrBqB,EAAA;;AOwBvB;EACE,mBPxBqB,EAAA;;AO2BvB;EACE,mBAAoC,EAAA;EADtC;IAII,0BAA0B;IAC1B,gBAAgB,EAAA;EALpB;IASI,UAAU;IACV,6BAA6B;IAC7B,gBAAgB,EAAA;EAGlB;IAdF;MAeI,mBAAmB,EAAA,EAEtB;;AAED;EACE,eP/JmB;EOgKnB,cLrKgB;EKsKhB,gBAAgB,EAAA;EAHlB;IAKI,8BAA8B,EAAA;;AAIlC;EACE,gBAAgB,EAAA;EADlB;IAGI,kBAAkB,EAAA;IAHtB;MAKM,kBAAkB,EAAA;;AAMxB;ENpME,mCMqMmC;ENpMnC,gCMoMmC;ENnMnC,8BMmMmC;ENlMnC,2BMkMmC,EAAA;;AAGrC;ENxME,mDDqEyC;ECpEzC,gDDoEyC;ECnEzC,8CDmEyC;EClEzC,2CDkEyC,EAAA;;AOuI3C;EN5ME,mDDsEsC;ECrEtC,gDDqEsC;ECpEtC,8CDoEsC;ECnEtC,2CDmEsC,EAAA;;AO0IxC;ENhNE,qDDuE4C;ECtE5C,kDDsE4C;ECrE5C,gDDqE4C;ECpE5C,6CDoE4C,EAAA;;AO6I9C;ENpNE,mDDwE0C;ECvE1C,gDDuE0C;ECtE1C,8CDsE0C;ECrE1C,2CDqE0C,EAAA;;AOgJ5C;ENxNE,kDDyE6C;ECxE7C,+CDwE6C;ECvE7C,6CDuE6C;ECtE7C,0CDsE6C,EAAA;;AOmJ/C;EAEI,cAAc,EAAA;;AAKlB;EACE,mBAAmB,EAAA;EADrB;IAGI,gCL5Nc;IK6Nd,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB,EAAA;;AAItB;EACE,oCAAsC,EAAA;;AAGxC;EACE,iBAAiB,EAAA;;AAQb;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AADvC;EACE,gCAAqC,EAAA;;AAQ7C;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB,EAAA;EAJlB;IAOI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,wCAAwC;IACxC,oCAAoC;IACpC,gCAAgC,EAAA;EAdpC;IAkBI,WAAW;IACX,YAAY,EAAA;;AAiDhB;EACE,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cLrUgB,EAAA;EKuUhB;IACE,cAAc,EAAA;;AAIlB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc,EAAA;;AAEhB;EACE,4CAA4C;EAC5C,oCACF,EAAA;;AAEA;EACE,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,iBAAiB;EN7Rf,kBDzDe;EOwVjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,gCAAgC,EAAA;;AAGlC;EACE,iBAAiB;EACjB,kBAAkB,EAAA;EAFpB;IAKI,iBAAiB;IACjB,kBAAkB,EAAA;;AAItB;EACE,0BAA0B,EAAA;;AAG5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,oEAAoE;EACpE,yBAAyB,EAAA;;AAG3B;EACE,yBAAwB;EACxB,WAAW,EAAA;;AAGb;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB,EAAA;;AAG3B;EACE,aAAa,EAAA;;AAIf;EACE,aAAa,EAAA;;AAOf;EACE,wDAAuD;EACvD,SAAQ;EACR,eAAc;EACd,qBAAoB;EACpB,gBAAe;EACf,iBAAgB;EAChB,kBAAiB;EACjB,kBAAiB;EACjB,2BAA0B;EAC1B,yBAAwB;EACxB,qBAAoB;EACpB,WAAU;EACV,kBAAiB;EACjB,mBAAkB;EAClB,iBAAgB;EAChB,eAAc;EACd,kBACF,EAAA;;AACA;EACE,yBAAwB;EACxB,qBACF,EAAA;;AACA;EACE,yBAAwB;EACxB,qBACF,EAAA;;AACA;EACE,eAAc;EACd,YAAW;EACX,iBAAgB;EAChB,cAAa;EACb,cAAa;EACb,WAAU;EACV,WAAU;EACV,gBAAe;EACf,gBAAe;EACf,iBAAgB;EAChB,cAAa;EACb,kBAAiB;EACjB,wDACF,EAAA;;AACA;EACE,sBACF,EAAA;;AACA;EACE,sBAAqB;EACrB,UAAS;EACT,YAAW;EACX,kBAAiB;EACjB,iBAAgB;EAChB,0BAAyB;EACzB,uBAAsB;EACtB,sBAAqB;EACrB,kBACF,EAAA;;AACA;EACE,UACF,EAAA;;AACA;EACE,eACF,EAAA;;AACA;EACE,sBACF,EAAA;;AACA;EACE,4BAA2B;EAC3B,6BACF,EAAA;;AACA;EACE,WAAU;EACV,cAAa;EACb,aAAY;EACZ,WACF,EAAA;;AAAC;EACC,kBACF,EAAA;;AACA;EACE,kBAAiB;EACjB,oBAAmB;EACnB,OAAM;EACN,SAAQ;EACR,aAAY;EACZ,WAAU;EACV,+EAA8E,EAAA;;AAEhF;EACE,cACF,EAAA;;AACA;EACE,qBAAoB;EACpB,UAAS;EACT,gBAAe;EACf,YAAW;EACX,iBAAgB;EAChB,wDAAuD;EACvD,eAAc;EACd,mBAAkB;EAClB,iBAAgB;EAChB,cAAa;EACb,yBAAwB;EACxB,sBAAqB;EACrB,0BAAyB;EACzB,uBAAsB;EACtB,sBAAqB;EACrB,kBACF,EAAA;;AACA;EACE,yBACF,EAAA;;AACA;EACE,eAAc;EACd,WAAU;EACV,YAAW;EACX,UAAS;EACT,uBAAsB;EACtB,mBAAkB;EAClB,YACF,EAAA;;AACA;EACE,gBAAe;EACf,eAAc;EACd,oBAAmB;EACnB,gBACF,EAAA;;AACA;EACE,cACF,EAAA;;AACA;EACE,cACF,EAAA;;AACA;EACE,cACF,EAAA;;AACA;EACE,cACF,EAAA;;AACA;EACE,cACF,EAAA;;AACA;EACE,6BACF,EAAA;;AACA;EACE,aAAY;EACZ,qCAAgC,EAAA;;AAElC;EAAkB,YAAW,EAAA;;AAAC;EAC5B,eACF,EAAA;;AACA;EACE,gCAA+B,EAAA;;AAEjC;EACE,gCAA+B,EAAA;;AAEjC;EACE,gBAAe;EACf,mBAAkB;EAClB,iBACF,EAAA;;AACA;EACE,eAAc;EACd,WAAU;EACV,iBACF,EAAA;;AACA;EACE,cAAa;EACb,UAAS;EACT,WAAU;EACV,cACF,EAAA;;AACA;EACE,cAAa;EACb,WAAU;EACV,WAAU;EACV,UAAS;EACT,iBAAgB;EAChB,gBAAe;EACf,mBAAkB;EAClB,mBACF,EAAA;;AACA;EACE,gBACF,EAAA;;AACA;EACE,gBACF,EAAA;;AACA;EACE,gBACF,EAAA;;AACA;EACE,mBACF,EAAA;;AACA;EACE,cAAa;EACb,mBAAkB;EAClB,eAAc;EACd,wDACF,EAAA;;AACA;EACE,UACF,EAAA;;AACA;EACE,kBAAiB;EACjB,wDAAuD;EACvD,iBAAgB;EAChB,eAAc;EACd,cACF,EAAA;;AACA;EACE,gBAAe;EACf,cAAa;EACb,UACF,EAAA;;AACA;EACE,gBAAe;EACf,eAAc;EACd,wDACF,EAAA;;AACA;EACE,eACF,EAAA;;AACA;EACE;IACE,WAAU;IAAC,WACb,EAAA;EACA;IACE,UACF,EAAA;EACA;IACE,WACF,EAAA,EAAC;;AAEH;EACE,wBAAuB;EACvB,qBACF,EAAA;;AACA;EACE,wDACF,EAAA;;AACA;EACE,oBAAmB;EACnB,6CAA4C,EAAA;;AAG9C;EACE,6BAA4B,EAAA;;AAE9B;EACE,2BAA0B,EAAA;;AAjK5B;EAoKE,2BAA0B;EAC1B,6CAA4C,EAAA;;AAE9C;EACE,sBAAqB,EAAA;;AAEvB;EACE,sBAAqB,EAAA;;AAEvB;EACE,oBAAmB,EAAA;;AAErB;EACE,oBAAmB,EAAA;;AAErB;EACE,oBAAmB,EAAA;;AAErB;EACE,0BAAyB,EAAA;;AAE3B;EACE,yBAAwB;EACxB,2BAA0B;EAC1B,0BAAyB,EAAA;;AAE3B;EACE,sBAAqB;EACrB,oBAAmB,EAAA;;AAErB;EACE,sBAAqB;EACrB,yBAAyB;EACzB,6BAA4B,EAAA;;AAE9B;EACE,0BAAyB,EAAA;;AA/F3B;EAkGE,2BAA0B,EAAA;;AAE5B;EACE,sBAAqB;EACrB,oBAAmB,EAAA;;AAErB;EACE,oBAAmB;EACnB,2BAA0B,EAAA;;AAuI5B,wCAAA;AACA,kCAAA;AAEA,gFAAA;AACA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,uBAAuB,EAAA;;AAGzB,iEAAA;AACA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,uBAAuB,EAAA;;AAGzB,oEAAA;AACA;EACE,uBAAuB,EAAA;;AAGzB,kEAAA;AACA,0EAAA;AACA;;EAEE,8BAA8B,EAAA;;AAIhC;EACE,2CAA2C;EAC3C,sCAAsC,EAAA;;AAGxC;EACE,uBAAuB,EAAA;;AAGzB;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB;EACzB,sBAAsB,EAAA;;AAGxB;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,gCAAgC;EAChC,mCAAmC;EACnC,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC,EAAA;;AAGxC;EACE,oCAAoC;EACpC,gCAAgC,EAAA;;AAGlC;EACE,yBAAyB,EAAA;;AAG3B;EACI,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC,EAAA;;AAG7C;EACE,0BAA0B,EAAA;;AAG5B;EACE,6BACF,EAAA;;AA7PA;EAoQI,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,WAAW,EAAA;;AAvSf;EA2SI,wBAAwB,EAAA;;AAG5B;EACI,UAAU,EAAA;;AAGd;EACI,UAAU,EAAA;;AAGd;EACI,UAAU,EAAA;;AA5Td;EAiUI,qBAAqB;EACrB,cAAc,EAAA;;AAElB;EACI,cAAc;EACd,qBAAqB;EACrB,cAAc,EAAA;;AAGlB;EACI,cAAc;EACd,qBAAqB;EACrB,aAAa,EAAA;;AAxTjB;EA4TI,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,qBAAqB,EAAA;;AAGzB;EACI,aAAa,EAAA;;AAGjB;EACI,aAAa,EAAA;;AAKjB;EACI,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,eAAe,EAAA;;AA9UnB;EAkVI,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,WAAW,EAAA;;AAGf;EACI,aAAa,EAAA;;AAGjB;;;EAGI,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAElB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,+BAA+B;EAC/B,qBAAqB,EAAA;;AAGzB;;;EAGI,eAAe;EACf,WACJ,EAAA;;AAEA;EACI,qBAAqB;EACrB,qBAAqB,EAAA;;AAGzB;EACI,cAAc;EACd,eAAe;EACf,mBAAmB,EAAA;;AAjsBvB;EAqsBE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AChmCnB,oBAAA;AACA;;EAEE,gBR8BwB;EQ7BxB,gBR2B0C;EQ1B1C,cR8BsB,EAAA;;AQ3BxB;EACE,eReiB;EQdjB,kCAAkC,EAAA;;AAGpC;EACE,eRWiB;EQVjB,kCAAkC,EAAA;;AAGpC;EACE,eROiB,EAAA;;AQJnB;EACE,eRIiB,EAAA;;AQDnB;EACE,eRCiB,EAAA;;AQEnB;EACE,eRFiB,EAAA;;AQKnB;EACE,wCAAwC,EAAA;;AAG1C;EA9BA;IAgCI,eRfe;IQgBf,kCAAkC,EAAA;EA5BtC;IAgCI,eRnBe;IQoBf,kCAAkC,EAAA;EA5BtC;IAgCI,eRvBe,EAAA,EQwBhB;;AAGH;EACE,gBAAgB,EAAA;EADlB;IAGI,kBRuBuB;IQtBvB,gCN5Cc;IM6Cd,kBAAmC;IACnC,mBAAoC,EAAA;IANxC;MASM,qBAAqB,EAAA;IAT3B;MAaM,kBAAkB,EAAA;EAbxB;IAoBM,qBAAqB,EAAA;IApB3B;MAuBQ,yBNhEU,EAAA;;AOblB;+EZkzH+E;AalzH/E,oBAAA;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,YAAY,EAAA;;AAGd;EToDE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aSvD0B;ETwD1B,2BSxD+B;ETyD/B,uBSzD+B;ET0D/B,mBS1D+B;ET2D/B,yBS3DuC;ET4DvC,qBS5DuC;ET6DvC,iBS7DuC;EACvC,WAAW,EAAA;;AAGb;ET+CE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aSlD0B;ETmD1B,8BSnDkC;EToDlC,0BSpDkC;ETqDlC,sBSrDkC;ETsDlC,yBStD0C;ETuD1C,qBSvD0C;ETwD1C,iBSxD0C;EAC1C,YVwGoB;EUvGpB,gBVuGoB;EUtGpB,gBVsGoB,EAAA;;AUnGtB;ETwCE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aS3C0B;ET4C1B,8BS5CkC;ET6ClC,0BS7CkC;ET8ClC,sBS9CkC;ET+ClC,yBS/C0C;ETgD1C,qBShD0C;ETiD1C,iBSjD0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,gBV+FmB;EU9FnB,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,OAAO;ET0BP,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aS7B0B;ET8B1B,8BS9BkC;ET+BlC,0BS/BkC;ETgClC,sBShCkC;ETiClC,yBSjC0C;ETkC1C,qBSlC0C;ETmC1C,iBSnC0C;EAC1C,WAAW;EACX,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EAGM,sBAAsB;ETR1B,kESSgE;ETRhE,6DSQgE;ETPhE,0DSOgE,EAAA;;AAJlE;EAUM,sBAAsB;ETf1B,kESgBgE;ETfhE,6DSegE;ETdhE,0DScgE,EAAA;;AAXlE;EAeM,kBAAkB,EAAA;;AAfxB;EAqBM,sBAAsB;ET1B1B,kES2BgE;ET1BhE,6DS0BgE;ETzBhE,0DSyBgE,EAAA;;AAtBlE;EA0BM,WVqDkB;EUpDlB,eVoDkB;EUnDlB,eVmDkB,EAAA;;AWzHxB,iBAAA;AAEA;EACE,YXqHoB;EWpHpB,oCAAwC;EACxC,yBAAqC;EACrC,0CAA4C;EAC5C,wBAAwB;EACxB,YAAY,EAAA;EANd;IASI,yBXsDuC;IWrDvC,6BAA6B,EAAA;EAVjC;IAcI,6BAA6B;IAC7B,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB,EAAA;EAjBrB;IAsBM,cXkCe;IWjCf,eAAe;IACf,eXNe;IWOf,gBAAgB;IAChB,mBAAmB,EAAA;;AAKzB;EAEI,eAAe,EAAA;;AAInB,gBAAA;AACA;EACE,kBAAkB;EAClB,eXtBmB;EWuBnB,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EAEI,gBAAgB,EAAA;;AAFpB;EAKI,aAAa,EAAA;;AALjB;EAQI,cAAc,EAAA;;AARlB;EAaM,cAAc,EAAA;;AAKpB;EACE,cXV0B;EWW1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAEhB,qBAAqB;EViBnB,gBUhBsB,EAAA;EAP1B;IAUI,gBAAgB;IAChB,oBAAoB,EAAA;;AAIxB;EAEI,cX1BwB;EW2BxB,iBAAiB;EACjB,eAAe;EACf,yBAAyB,EAAA;EAL7B;IAQM,gBAAgB,EAAA;;AAKtB;;;;EAIE,cX/CmB,EAAA;;AWkDrB;EACE,kBAAkB;EAClB,kCAAkC,EAAA;;AAGpC;EACE,yBAAyB,EAAA;;AAG3B;;EAEE,cX7DmB,EAAA;;AWgErB;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB,EAAA;;AAGlB;EACE,0BAA0B,EAAA;;AAG5B;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,cXxF0B;EWyF1B,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EAEV,0CAAqC;EACrC,eAAU;EAEZ,iBAAiB;EACjB,kBAAkB;EV5HlB,yCU6HyC;EV5HzC,oCU4HyC;EV3HzC,iCU2HyC;EACzC,mBAAmB,EAAA;;AAErB;EACE,aAAa,EAAA;;AAGf;;;;EAIE,6BAA6B;EAC7B,cXpHmB,EAAA;;AWuHrB;;EVtIE,gCAAmC;EACnC,4BAA+B;EAC/B,2BAA8B;EAC9B,wBAA2B,EAAA;;AUwI7B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBX/HmB;EWgInB,WThLU;EDsFR,kBDzDe;EWqJjB,qBAAqB,EAAA;;AAGvB;;;;;EAKE,cX1ImB,EAAA;;AW6IrB;EVlKE,wCCgLmC;ED/KnC,mCC+KmC;ED9KnC,gCC8KmC;ESXjC,WXjFoB,EAAA;EW8ExB;;IAOM,aAAa,EAAA;EAPnB;IAWM,wBAAwB,EAAA;EAX9B;IAeM,wBAAwB,EAAA;EAf9B;IAmBM,kBAAkB,EAAA;IAnBxB;MAqBQ,eAAe,EAAA;IArBvB;MAyBQ,gBAAgB,EAAA;EAzBxB;IA+BQ,kBAAkB,EAAA;EA/B1B;IAkCQ,kBAAkB,EAAA;EAlC1B;IAwCQ,aAAa,EAAA;EAxCrB;IA6CM,aAAa,EAAA;;AAKnB;EAEI,YXnIkB,EAAA;EWiItB;IAKM,gCAAgC,EAAA;EALtC;IASM,wBAAwB,EAAA;EAT9B;IAaM,yBAAyB,EAAA;EAb/B;IAiBM,wBAAwB,EAAA;EAjB9B;IAsBQ,gBAAgB,EAAA;IAtBxB;MAwBU,kBAAkB,EAAA;IAxB5B;MA4BU,kBAAkB,EAAA;IA5B5B;MAgCU,iBAAiB,EAAA;EAhC3B;IAqCQ,0BAA0B,EAAA;EArClC;IAyCQ,kBAAkB,EAAA;EAzC1B;IA6CQ,kBAAkB,EAAA;EA7C1B;IAiDQ,mBAAmB,EAAA;EAjD3B;IAuDQ,cAAc,EAAA;EAvDtB;IA4DM,aAAa,EAAA;EA5DnB;IAgEM,cAAc,EAAA;;AAKpB;EACE,kBAAkB,EAAA;EADpB;IAGI,YAAY;IACZ,eAAe,EAAA;;AAInB;EAGM,eAAe,EAAA;;AAMnB;;EAEE,YAAY,EAAA;;AAIhB;EACE,eAAe;EACf,2CAA2C;EAC3C,mCAAmC;EACnC,gBAAgB,EAAA;EAEhB;IACE,OAAO;IACP,oCAAoC;IACpC,4BAA4B;IAC5B,YAAY,EAAA;EAGd;IACE,QAAQ;IACR,mCAAmC;IACnC,2BAA2B;IAC3B,YAAY,EAAA;EAGd;IACE,YAAY,EAAA;EAGd;IACE,YAAY,EAAA;;AAKd;EADF;IAEI,6BAA6B,EAAA,EAEhC;;AAED;EACE,kBAAkB,EAAA;EADpB;IAGI,kBAAkB;IAClB,aAAa;IACb,sBAAsB,EAAA;;AAI1B;EACE,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;EACpC,YAAY;EACZ,0BAA0B,EAAA;;AAG5B;EAEI,kBAAkB,EAAA;;AClZtB,gBAAA;AACA;EACE,wBAAwB;EX+ExB,8CW9E8C;EX+E9C,sCW/E8C;EAE9C,yBAAyB;EAEzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB,EAAA;;AAGrB;EACE,sBVJU;EUKV,cZ8CoB;EY7CpB,gBAAgB;EAChB,kBAAkB,EAAA;EAJpB;IXwBE,wCCgLmC;ID/KnC,mCC+KmC;ID9KnC,gCC8KmC;IUhMjC,6BAA6B;IAC7B,cZuCkB;IYrClB,gBAAgB,EAAA;IAXpB;MAaM,MAAM,EAAA;MAbZ;QAeQ,+BZiCc;QYhCd,eAAe,EAAA;IAhBvB;MAoBM,WAAW,EAAA;IApBjB;MAyBM,sBZwDQ;MYvDR,cZsBgB,EAAA;MYhDtB;QA6BU,+BZmBY,EAAA;EYRpB;IACE,yBVxCc;IDkFd,kBDxDkB,EAAA;;AYmBtB;EACE,kBAAkB,EAAA;EADpB;IAII,YAAY,EAAA;IAEZ;MANJ;QAOM,YAAY,EAAA,EAEf;EAED;IACE,kBAAkB,EAAA;IAElB;MAHF;QAII,kBAAkB,EAAA,EAErB;;AAIH;EACE,wBAAwB,EAAA;;AAG1B;EACE;IACE,wBAAwB,EAAA,EACzB;;AAGH;EACE,gBAAgB;EAChB,kBAAkB,EAAA;;AAIpB;EACE,gBZ2BmB;EY1BnB,mBAAmB,EAAA;EAFrB;IAKI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY,EAAA;IAEZ;MATJ;QAUM,YAAY,EAAA,EAWf;IARC;MAbJ;QAcM,YAAY,EAAA,EAOf;IAJC;MAjBJ;QAkBM,iBAAiB;QACjB,YAAY,EAAA,EAEf;EAED;IAvBF;MAwBI,eAAe,EAAA,EAUlB;EAPC;IA3BF;MA4BI,eAAe,EAAA,EAMlB;EAHC;IACE,gBAAgB,EAAA;;AAMhB;EAFJ;IAGM,kBAAkB,EAAA,EAErB;;AAGH;EAEI,YAAY,EAAA;EAEZ;IAJJ;MAKM,YAAY,EAAA,EAMf;EAHC;IARJ;MASM,YAAY,EAAA,EAEf;;AAGH;EAGM,cAAc;EACd,WAAW,EAAA;;AAJjB;EXrHE,wCCgLmC;ED/KnC,mCC+KmC;ED9KnC,gCC8KmC;EUlD/B,sBVzJM;EU0JN,cZrEc,EAAA;EY2DpB;IAaU,4BZxEU,EAAA;EY2DpB;IAkBQ,6BAA6B;IAC7B,cZ9EY,EAAA;IY2DpB;MAsBY,4BZjFQ,EAAA;;AYyFpB;EACE,gBAAgB,EAAA;EADlB;IAII,sBAAsB,EAAA;EAItB;IARJ;MASM,eAAe,EAAA,EAElB;;AAGH;EXpME,wBWqMwB;EXpMxB,qBWoMwB;EXnMxB,mBWmMwB;EXlMxB,gBWkMwB,EAAA;;AAG1B;EAGI,iBAAiB;EACjB,YAAY,EAAA;EAJhB;IAOM,sBAAsB;IACtB,4BAA4B;IAC5B,gCVtMY;IUuMZ,WAAW,EAAA;EAVjB;IAcM,kCAAkC;IAClC,mCAAmC;IACnC,6BVhNM;IUiNN,SAAS;IACT,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW,EAAA;EAtBjB;IA0BM,kCAAkC;IAClC,mCAAmC;IACnC,6BVlNM;IUmNN,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW,EAAA;EAGb;IArCJ;MAsCM,YAAY,EAAA,EAMf;EAHC;IAzCJ;MA0CM,YAAY,EAAA,EAEf;;AA5CH;EA+CI,kBAAkB,EAAA;;AA/CtB;EAmDI,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU,EAAA;;AAId;EAEI,YAAY;EACZ,kBAAkB;EAClB,sBAAsB,EAAA;;AAJ1B;EAQI,WAAW;EACX,SAAS,EAAA;;AATb;EAaI,WAAW;EACX,SAAS,EAAA;;AAGX;EAjBF;IAkBI,aAAa,EAAA,EAEhB;;AAED;EAtBA;IAwBI,YAAY,EAAA,EACb;;AAGH;EA5BA;IA8BI,YAAY,EAAA,EACb;;AAGH;EACE,yBAAyB,EAAA;;AAG3B;EACE,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gCVxSgB,EAAA;EUqSlB;IAMI,cZ9PiB,EAAA;EYwPrB;IAUI,eAAe;IACf,6BAA6B,EAAA;IAXjC;MAcM,2BAA2B,EAAA;EAdjC;IAmBI,qBAAqB,EAAA;EAnBzB;IAuBI,0BAA0B,EAAA;EAvB9B;IA2BI,0BAA0B;IAC1B,uBAAuB,EAAA;;AAI3B;EAEI,cZvRkB,EAAA;;AYqRtB;EAMI,kBAAkB,EAAA;EANtB;IASM,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,MAAM;IACN,WAAW;IACX,UAAU;IACV,WAAW;IACX,yBZxQU;ICKZ,kBWoQ4B,EAAA;;AAlBhC;EAwBI,kCAAkC;EAClC,qCAAqC;EACrC,gCAAgC;EAChC,6BAA6B,EAAA;;AAnKjC;EAyKI,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,kDAAkD;EXnVpD,wCWoV0C;EXnV1C,mCWmV0C;EXlV1C,gCWkV0C,EAAA;;AAR5C;EAYI,UAAU;EACV,iDAAiD;EACjD,mBAAmB,EAAA;;AAIvB;EAEI,YAAY;EACZ,iBAAiB,EAAA;EAHrB;IAMM,yBZ3SQ,EAAA;;AYqSd;EAWI,kBAAkB;EAClB,kBAAkB;EAClB,sBZlTU;EYmTV,mBAAmB;EXjTnB,kCWkT0C,EAAA;;AAI9C;EXzVE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2BWkU2B;EXjU3B,mBWiU2B,EAAA;;AAG7B;EACE,kBAAkB;EAClB,aAAa,EAAA;;AC7Zf,gBAAA;AACA;EZ4DE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE,EAAA;;AYrDvE;EACE,kBAAkB,EAAA;EADpB;IAII,kBAAkB,EAAA;IAJtB;MASQ,UAAU;MACV,mBAAmB;MACnB,SAAS,EAAA;IAXjB;MAeQ,cboCa,EAAA;IanDrB;MAoBM,cAAc;MACd,cboCsB;ManCtB,eAAe;MACf,eAAe,EAAA;IAvBrB;;MA4BM,qBAAqB;MACrB,cbsBe,EAAA;IanDrB;MAiCM,gBAAgB,EAAA;IAjCtB;MZsDE,qBAA+B;MAC/B,kBAA4B;MAC5B,iBAA2B;MAC3B,gBAA0B;MAC1B,aAL6B;MAM7B,2BANmD;MAOnD,uBAPmD;MAQnD,mBARmD;MASnD,uBATqE;MAUrE,mBAVqE;MAWrE,eAXqE;MYfjE,UAAU;MACV,cAAc;MACd,OAAO;MACP,QAAQ,EAAA;MAzCd;QA4CQ,UAAU;QACV,eAAe,EAAA;EA7CvB;IAqDQ,UAAU;IACV,QAAQ,EAAA;EAtDhB;IA0DQ,UAAU;IACV,WAAW;IACX,SAAS,EAAA;EA5DjB;;IAiEQ,MAAM,EAAA;EAjEd;IAuEI,eAAe,EAAA;IAvEnB;MA0EM,eAAe,EAAA;IA1ErB;MA8EM,cb3Be,EAAA;EanDrB;;;;IAsFI,cbnCiB,EAAA;EanDrB;IA0FI,gBAAgB;IAChB,yBXpFc;IWqFd,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV,eAAe;IACf,sBX9FQ;IW+FR,kBAAkB;IZTlB,kBYU0B;IZrE5B,wCYsE0C;IZrE1C,mCYqE0C;IZpE1C,gCYoE0C,EAAA;IApG5C;MAwGQ,iBAAiB;MACjB,YAAY;MACZ,eAAe,EAAA;MA1GvB;QA6GU,cb1DW,EAAA;IanDrB;MAkHQ,UAAU;MACV,WAAW;MACX,SAAS,EAAA;IApHjB;;MAyHQ,MAAM,EAAA;IAzHd;MA6HQ,kBAAkB,EAAA;IA7H1B;MAiIQ,cb9Ea,EAAA;EanDrB;IAwIM,kBAAkB,EAAA;IAxIxB;MA2IQ,cblFoB;MamFpB,gBAAgB;MAChB,qBAAqB;MACrB,YAAY;MAEV,0CAAqC;MACrC,eAAU;MAEZ,iBAAiB;MACjB,kBAAkB;MZtHxB,yCYuH+C;MZtH/C,oCYsH+C;MZrH/C,iCYqH+C;MACzC,mBAAmB,EAAA;EAtJ3B;;IA6JQ,cb1Ga,EAAA;EanDrB;IAqKQ,cblHa,EAAA;EanDrB;IZsDE,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,aAL6B;IAM7B,2BANmD;IAOnD,uBAPmD;IAQnD,mBARmD;IASnD,uBATqE;IAUrE,mBAVqE;IAWrE,eAXqE;IYuHnE,YAAY,EAAA;IA5KhB;MA+KM,UAAU,EAAA;MA/KhB;QAkLQ,WAAW,EAAA;QAEX;UApLR;YAqLU,eAAe,EAAA,EAElB;IAGH;MA1LJ;QA2LM,YAAY,EAAA,EAEf;;AAGH;EACE,2BAA2B,EAAA;;AAG7B;EACE,yBblJmB,EAAA;EaiJrB;IAKM,eAAe,EAAA;EALrB;IASM,WX1MM;IW2MN,eAAe,EAAA;EAVrB;;;;;IAkBM,cbjKa,EAAA;Ea+InB;IAsBM,aAAa,EAAA;;ACjOnB,sBAAA;AACA;EACE,OAAO;EACP,WAAW,EAAA;EAEX;IAJF;MAKI,UAAU,EAAA,EAEb;;AAED;EACE,yBAAyB;EACzB,WAAW,EAAA;EAEX;IAJF;MAKI,aAAa,EAAA,EAEhB;;ACjBD,gBAAA;AAEA;EACE,eAAe;EACf,6BAA2C;EAC3C,sBfyFY;EexFZ,cf0D0B;EezD1B,iBfwHkB;EevHlB,gBfuHkB,EAAA;Ee7HpB;IASI,cfqDwB,EAAA;Ie9D5B;MAWM,cf6Ce,EAAA;EezCnB;IAfF;MAgBI,aAAa,EAAA,EAMhB;EAHC;IAnBF;MAoBI,eAAe,EAAA,EAElB;;ACxBD,uBAAA;AACA;Ef4DE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,ae/D0B;EfgE1B,8BehEkC;EfiElC,0BejEkC;EfkElC,sBelEkC;EfmElC,yBenE0C;EfoE1C,qBepE0C;EfqE1C,iBerE0C;EAC1C,gBAAgB;EAChB,YAAY,EAAA;EAEZ;IALF;MAMI,gBAAgB,EAAA,EAEnB;;AAED;EACE,yBhB8CmB;EgB7CnB,WdHU;EcIV,uBAAuB;EACvB,yBAAyB;Ef8CzB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2BerE2B;EfsE3B,mBetE2B;EfgE3B,sCe/DsC;EfgEtC,8BehEsC,EAAA;EAPxC;IAUI,gBAAgB,EAAA;;AAIpB;EACE,kBAAkB,EAAA;EADpB;IAII,mBAAmB,EAAA;EAGrB;IAPF;MAQI,kBAAkB,EAAA,EAErB;;AAED;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB,EAAA;EAHrB;IAMI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,mBAAmB,EAAA;EATvB;IAaI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,kBAAkB,EAAA;IAlBtB;MAqBM,gBAAgB;MAChB,0CAA0C;MAC1C,eAAe;MACf,YAAY;MACZ,WAAW;MACX,iBAAiB;MACjB,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,WdzDM;Mc0DN,kBAAkB;MAClB,aAAa;MACb,UAAU,EAAA;EAjChB;IAuCM,cAAc,EAAA;;AAKpB;EAGM,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBhBKc;EgBJd,UAAU,EAAA;;AAMhB;EACE,eAAe;EACf,QAAQ;EACR,QAAQ;EACR,aAAa;EACb,yBAAyB;EfqBvB,2BDpFe;ECqFf,8BDrFe;ECrCjB,kDCkBU;EDjBV,+CCiBU;EDhBV,6CCgBU;EDfV,0CCeU;EcqFV,Wd/FU,EAAA;EcuFZ;IAWI,kBAAkB;IAClB,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,chBpBkB;EgBqBlB,sBd1GU,EAAA;;Ac8GZ;EACE,mBAAmB,EAAA;EADrB;IAII,aAAa,EAAA;EAJjB;IAQI,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,WAAW,EAAA;IAXf;MAcM,iBAAwB;MACxB,6CAA6C;MAC7C,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,YAAY;MACZ,gCAAgC;MAChC,WAAW,EAAA;IAvBjB;MA2BM,iBAA8B;MAC9B,mBAAmB;MACnB,sCAAsC;MACtC,WAAW;MACX,YAAY;MACZ,UAAU;MACV,gBAAgB;MAChB,kBAAkB;MAClB,SAAS;MACT,gCAAgC;MAChC,WAAW,EAAA;EArCjB;IA0CI,gBd9IQ;Ic+IR,YAAY,EAAA;EA3ChB;IA+CI,mBdtJc;IcuJd,UAAU,EAAA;;AAId;EACE;IACE,6BAA6B,EAAA,EAC9B;;AC/KH;+EpBu0J+E;AqBv0J/E,eAAA;AACA;EACE,cAAc;EACd,kBAAkB;EjB6FhB,kBDxDkB;EkBnCpB,kBAAkB,EAAA;EAJpB;IAOI,oBAAoB;IACpB,gBhB8NmB,EAAA;EgBtOvB;IAYI,WlBgJU;IkB/IV,oChBMQ;IDyCV,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,aiBlD4B;IjBmD5B,8BiBnDoC;IjBoDpC,0BiBpDoC;IjBqDpC,sBiBrDoC;IjBsDpC,yBiBtD4C;IjBuD5C,qBiBvD4C;IjBwD5C,iBiBxD4C;IjBkE5C,+BiBjEiC;IjBkEjC,uBiBlEiC;IjBsEjC,2BiBrE6B;IjBsE7B,mBiBtE6B;IAC3B,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,UAAU,EAAA;;AAId;EACE,mBlBkIY,EAAA;;AkB/Hd;EACE,kBlB+HY,EAAA;;AmB9Jd,gBAAA;AACA;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;ElBoEhB,+BkBnE+B;ElBoE/B,uBkBpE+B;ElBwE/B,2BkBvE2B;ElBwE3B,mBkBxE2B;EAC3B,sBAAsB;EACtB,cAAc;ElB+EZ,kBkB9EwB;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,yBjBRgB,EAAA;EiBblB;IAwBI,cAAc,EAAA;;AAIlB;ElBgCE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,+BkBvD+B;ElBwD/B,uBkBxD+B,EAAA;EAFjC;IAKI,eAAe;IACf,OAAO;IACP,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB,EAAA;;ARLtB;EQWI,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B,EAAA;;AAJ9B;EAOI,eAAe;EACf,gBAAgB;EAChB,cjBpCc,EAAA;;AiBwClB;EACE,kBAAkB,EAAA;EAElB;IACE,iBAAiB,EAAA;;AC3DrB,gBAAA;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EnB2FhB,kBD1DkB,EAAA;EoBrCtB;IAQI,kBAAkB,EAAA;EAGpB;IACE,gBAAgB,EAAA;;AAIpB;EnB+EI,mBmB9EyB,EAAA;;AAG7B;EACE,4BAA4B,EAAA;;AAG9B;EACE,6BAA6B;EAC7B,yBlBbgB,EAAA;;AmBdlB,qBAAA;AACA;EACE,yBAAyB;EACzB,0BAAqC,EAAA;EAFvC;IAKI,0BAAqC,EAAA;;AAIzC;EACE,8BnBCgB,EAAA;;AmBElB;EACE,mBAAmB;EACnB,+BnBJgB;EmBKhB,iBAAiB;EACjB,eAAe;EACf,mBAAmB,EAAA;;ACnBrB,2BAAA;AACA;EAEI,0BAA0B,EAAA;;ACH9B,oBAAA;AACA;EtB+FI,kBD1DkB,EAAA;;AuBjCtB;EACE,gBAAgB;EAEd,0CAAqC;EACrC,eAAU;EAEZ,cAAc;EACd,sBAAsB,EAAA;;ACZxB,gBAAA;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,6BAA6B,EAAA;;AAG/B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,exBUmB;EwBTnB,gBtB6NsB;EsB3NtB,gBxBwImB;ECrDjB,kBDzDe;EwBxBjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB,EAAA;EAVpB;IAeI,eAAe;IACf,qBAAqB;IvBrBvB,mCuBsBqC;IvBrBrC,gCuBqBqC;IvBpBrC,8BuBoBqC;IvBnBrC,2BuBmBqC,EAAA;EAGrC;IACE,kBAAkB,EAAA;;AAItB;EAII,eAAe;EACf,qBAAqB;EvBnCvB,mCuBoCqC;EvBnCrC,gCuBmCqC;EvBlCrC,8BuBkCqC;EvBjCrC,2BuBiCqC,EAAA;;AAGrC;EACE,kBAAkB,EAAA;;AAItB;;;;;;;;;EvB5CE,mCuBsDmC;EvBrDnC,gCuBqDmC;EvBpDnC,8BuBoDmC;EvBnDnC,2BuBmDmC,EAAA;;AAGrC;;;;;;;;;EvBzDE,mCuBoEuC;EvBnEvC,gCuBmEuC;EvBlEvC,8BuBkEuC;EvBjEvC,2BuBiEuC,EAAA;;AAKzC;;;;EAIE,kBAAkB,EAAA;EAJpB;;;;IAQI,kBAAkB,EAAA;EAGpB;;;;IACE,gBAAgB;IAChB,gBAAgB,EAAA;EAGlB;;;;IACE,gBAAgB,EAAA;;AAIpB;EACE,2BAA2B,EAAA;;AAG7B;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,oBAAoB;EvBblB,kBDtDsB;ECuCxB,+BuB+B+B;EvB9B/B,uBuB8B+B;EvB1B/B,2BuB2B2B;EvB1B3B,mBuB0B2B;EAC3B,yBpBqN0B;EoBpN1B,gBAAgB,EAAA;EARlB;IAYI,eAAe;IACf,qBAAqB,EAAA;;AAIzB;;EAEE,kBxBeqB,EAAA;EwBjBvB;;;;IAMI,gBAAgB,EAAA;;AAIpB;EACE,6BAA6B;EAC7B,cxBzCkB,EAAA;EwBuCpB;IAMI,yBpB0LwB;IoBzLxB,cxB9CgB,EAAA;;AwBkDpB;EACE,cAAc,EAAA;EADhB;IAII,mBAAmB,EAAA;EAJvB;;IASI,kBAAkB,EAAA;;AAItB;EvB9DI,8BuB+DoC,EAAA;;AAGxC;EACE,kBxBvBwB,EAAA;;AwB0B1B;EACE,iBxBzBuB,EAAA;;AwB4BzB;EACE,iBxB5BuB,EAAA;;AwB4CzB;EAEE,exBxKkC,EAAA;EwBsKpC;;;IAII,eAAoC,EAAA;;AAIxC;EAEE,eAAoC,EAAA;EAFtC;;;IAII,eAAoC,EAAA;;AAIxC;;EAEE,exBnEqB,EAAA;EwBiEvB;;IAII,exBrEmB,EAAA;;AwByEvB;EvBtJE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,auBmJ0B;EvBlJ1B,2BuBkJ+B;EvBjJ/B,uBuBiJ+B;EvBhJ/B,mBuBgJ+B;EvB/I/B,uBuB+IqC;EvB9IrC,mBuB8IqC;EvB7IrC,euB6IqC;EACrC,gBAAgB;EAChB,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,cAAc,EAAA;EAEd;IAPF;MAQI,WAAW;MACX,aAAa,EAAA,EA8DhB;EAvED;IAYI,UAAU,EAAA;IAZd;MAcM,aAAa,EAAA;IAdnB;MAkBM,UAAU,EAAA;IAlBhB;MAsBM,8BAA8B,EAAA;EAtBpC;IA2BI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IvBnKf,2BuBoK6B;IvBnK7B,mBuBmK6B;IvBzK7B,+BuB0KiC;IvBzKjC,uBuByKiC;IAC/B,WtBlPQ,EAAA;EsB+MZ;IAsCI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,sBAAsB;IACtB,+BAA+B,EAAA;EA5CnC;IAgDI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,gBtB1PQ;IsB2PR,YAAY;IvB1Od,yDD8E8C;IC7E9C,oDD6E8C;IC5E9C,iDD4E8C,EAAA;EwBsGhD;IA2DI,kBAAkB;IAClB,uBAAuB,EAAA;EA5D3B;IA+DI,WAAW;IACX,WAAW;IACX,gBtBhRQ;IsBiRR,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IvBxPvB,yDD8E8C;IC7E9C,oDD6E8C;IC5E9C,iDD4E8C,EAAA;;AwB+KhD;EACE,cAAc,EAAA;EADhB;;IAKI,iBAAiB,EAAA;;AAMrB;EACE,0CtBpSU;EsBqSV,WxBpJY;EwBqJZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,iBxB5KY,EAAA;;AwB+Kd;EACE,kBxBhLY;EwBiLZ,cAAc,EAAA;;AAGhB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB;EACjB,WxB9LY,EAAA;;AwBqMR;EACE,yBpBvVe;EoBwVf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBtUe;EoBuUf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBrTe;EoBsTf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBpSe;EoBqSf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBnRe;EoBoRf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBlQe;EoBmQf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBjPe;EoBkPf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBhOe;EoBiOf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpB/Me;EoBgNf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpB9Le;EoB+Lf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpB7Ke;EoB8Kf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpB5Je;EoB6Jf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpB3Ie;EoB4If,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpB1He;EoB2Hf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBzGe;EoB0Gf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBxFe;EoByFf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBvEe;EoBwEf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBtDe;EoBuDf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpBzCe;EoB0Cf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBqVN;EACE,yBpB5Be;EoB6Bf,WtBvVI,EAAA;EsBqVN;IAKI,yBAA0C;IAC1C,WtB3VE,EAAA;;AsBkWZ;EvB1WE,kIuB2W+H;EvB1W/H,+HuB0W+H;EvBzW/H,6HuByW+H;EvBxW/H,0HuBwW+H,EAAA;EADjI;IvB1WE,kIuB8WiI;IvB7WjI,+HuB6WiI;IvB5WjI,6HuB4WiI;IvB3WjI,0HuB2WiI,EAAA;EAJnI;IvB1WE,mCuBkXqC;IvBjXrC,gCuBiXqC;IvBhXrC,8BuBgXqC;IvB/WrC,2BuB+WqC,EAAA;;AAIvC;;EAEE,oBAAoB;EACpB,aAAa,EAAA;;AAGf;EACE,sBtBrXU;EsBsXV,cxBjSkB;EwBkSlB,yBtBpXgB,EAAA;EsBiXlB;IAMI,yBAAoC;IACpC,cxBtSgB,EAAA;;AwB0SpB;EACE,yBxB9UiB;EwB+UjB,WtBjYU,EAAA;EsB+XZ;IAKI,yBAAwC;IACxC,WtBrYQ,EAAA;;AsByYZ;EACE,6BAA6B;EAC7B,cxB3VmB,EAAA;EwByVrB;IAMI,yCxB/ViB;IwBgWjB,cxBhWiB,EAAA;;AwBoWrB;EAEI,6BAA6B;EAC7B,WtBvZQ,EAAA;EsBoZZ;IAOM,2CtB3ZM;IsB4ZN,WtB5ZM,EAAA;;AsBiaZ;EACE,6BAA6B;EAC7B,cxBjXiB,EAAA;EwB+WnB;IAMI,yCxBrXe;IwBsXf,cxBtXe,EAAA;;AwB0XnB;EAEI,6BAA6B;EAC7B,WtB/aQ,EAAA;EsB4aZ;IAOM,2CtBnbM;IsBobN,WtBpbM,EAAA;;AsBybZ;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,qCtBxbU,EAAA;;AsB2bZ;EACE,wBAAwB;EACxB,uBAAuB,EAAA;;AAGzB;EACE,YxB1TY;EwB2TZ,WxB3TY;EwB4TZ,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;EvBnYpB,2BuBoY2B;EvBnY3B,mBuBmY2B;EvBzY3B,+BuB0Y+B;EvBzY/B,uBuByY+B;EAC/B,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,0BtB3cU,EAAA;EsBgcZ;IAgBI,qBAAqB;IACrB,0BtBjdQ,EAAA;EsBodV;IACE,YAAY;IACZ,WAAW;IACX,eAAe,EAAA;EAGjB;IACE,WtBreQ,EAAA;;AsByeZ;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAkC,EAAA;;AAGpC;;EvBvfE,mCuB0fqC;EvBzfrC,gCuByfqC;EvBxfrC,8BuBwfqC;EvBvfrC,2BuBufqC,EAAA;;AC5fvC,sBAAA;AAKA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc;IACd,qBvBDc,EAAA;IDgIhB;;MwB1HI,UAAU,EAAA;IAdhB;;;;MAmBM,UAAU,EAAA;IAnBhB;;MAuBM,yBzB8Be;MyB7Bf,WvBnBM;MuBoBN,qBzB4Be,EAAA;IyBrDrB;;MA6BM,yBAAyB,EAAA;MA7B/B;;QA+BQ,6BAA6B;QAC7B,czBqBa,EAAA;QyBrDrB;;;UAoCU,yCzBiBW;UyBhBX,czBgBW,EAAA;EyBrDrB;;;;;;;;IAiDI,iBvBmJc,EAAA;;AuB/IlB;;;;;;EAMI,yBAAyB,EAAA;;AAK7B;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AAIf;EACE,gBAAgB,EAAA;;AAKlB;EACE,cAAc,EAAA;EADhB;IxBwBI,0BwBpB8B;IxBqB9B,6BwBrB8B,EAAA;;AAMlC;;ExB4BI,yBwB1B2B;ExB2B3B,4BwB3B2B,EAAA;;AAK/B;EACE,WAAW,EAAA;;AAGb;EACE,gBAAgB,EAAA;;AAGlB;;ExBDI,0BwBI8B;ExBH9B,6BwBG8B,EAAA;;AAIlC;ExBMI,yBwBL2B;ExBM3B,4BwBN2B,EAAA;;AAgB/B;EACE,wBAAyC;EACzC,uBAAwC,EAAA;EAF1C;IAKI,cAAc,EAAA;;AAIlB;EACE,uBAA4C;EAC5C,sBAA2C,EAAA;;AAG7C;EACE,sBAA4C;EAC5C,qBAA2C,EAAA;;AAK7C;ExBzJE,wDCkBU;EDjBV,qDCiBU;EDhBV,mDCgBU;EDfV,gDCeU,EAAA;EuBuIZ;IxBzJE,wBwB8J0B;IxB7J1B,qBwB6J0B;IxB5J1B,mBwB4J0B;IxB3J1B,gBwB2J0B,EAAA;;AAS5B;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;;;IAcI,gBvBkBc;IuBjBd,cAAc,EAAA;EAflB;IAoBM,gBAAgB,EAAA;EApBtB;IxBrDI,6BwB6EiC;IxB5EjC,4BwB4EiC,EAAA;EAxBrC;IxBnEI,yBwB+F8B;IxB9F9B,0BwB8F8B,EAAA;EA5BlC;IAiCI,gBAAgB,EAAA;EAjCpB;;IxBrDI,6BwB4FiC;IxB3FjC,4BwB2FiC,EAAA;EAvCrC;IxBnEI,yBwB+G4B;IxB9G5B,0BwB8G4B,EAAA;;A5Bi8KhC;;;;E4Bt7KM,kBAAkB;EAClB,sBAAmB,EAAA;;AAOzB;;;;EAMI,eAAe;EACf,gBAAgB,EAAA;;AC/OpB,iBAAA;AAKE;EACE,mBAAmB,EAAA;;AAYvB,6BAAA;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EzBuChB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2ByB9D2B;EzB+D3B,mByB/D2B;EzByD3B,+ByBxD+B;EzByD/B,uByBzD+B;EAC/B,iBAAiB,EAAA;EANnB;IASI,gBAAgB,EAAA;;AAIpB;EACE,QAAQ;EACR,UAAU,EAAA;;AAGZ;EACE,QAAQ,EAAA;;AAGV;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,WAAW,EAAA;;AAGb;EACE,mBAAmB,EAAA;;AAGrB;EAZA;IAcI,mBAAmB,EAAA,EACpB;;AAGH;EAVA;IAYI,mBAAmB,EAAA;EAxBvB;IA2BI,kBAAkB,EAAA;EAvBtB;IA0BI,mBAAmB,EAAA,EACpB;;AAGH;EAvEE;IA0EI,oBAAoB,EAAA,EACrB;;AAIL;EAhEA;IzByCE,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,ayBqB4B;IzBpB5B,8ByBoBoC;IzBnBpC,0ByBmBoC;IzBlBpC,sByBkBoC;IzBjBpC,uBATqE;IAUrE,mBAVqE;IAWrE,eAXqE;IyB2BnE,kBAAkB,EAAA;IAnEtB;MAsEM,kBAAkB,EAAA;EAhDxB;IAqDI,eAAe,EAAA;EAGjB;;IAEE,QAAQ;IACR,WAAW,EAAA;EAvDf;IA0DI,mBAAmB,EAAA;EAnGrB;IAwGI,mBAAmB,EAAA,EACpB;;AC9GL,eAAA;AACA;EACE,sBzBQU;EDsFR,kBDxDkB;E2BpCpB,gBAAgB,EAAA;EAHlB;IAMI,qBAAqB;I1ByFrB,kB0BvF0B;I1BP5B,mDDsEsC;ICrEtC,gDDqEsC;ICpEtC,8CDoEsC;ICnEtC,2CDmEsC;I2B7DpC,kBAAkB;IAClB,cAAc;IACd,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;I1BsB7B,wC0BrB0C;I1BsB1C,mC0BtB0C;I1BuB1C,gC0BvB0C;IACxC,UAAU,EAAA;EAhBd;I1BoCE,gD0BfoD;I1BgBpD,2C0BhBoD;I1BiBpD,wC0BjBoD;I1B0ElD,kB0BzE4B,EAAA;;AAKhC;EAEI,kBAAkB;EAClB,WAAW;EACX,gBAAgB;E1BoBhB,6DAAoB;EACpB,kC0BpByE;E1BqBzE,4BAJuD;EAKvD,sBALoE,EAAA;;A0BtBxE;EAQI,uBAAuB,EAAA;;AAR3B;EAYI,oBAAoB,EAAA;;AAZxB;EAeI,qBAAqB;E1BNvB,oC0BOsC;E1BNtC,+B0BMsC;E1BLtC,4B0BKsC;EACpC,c3BaiB,EAAA;E2B9BrB;IAsBM,6BAA6B;IAC7B,yBAAyB;IACzB,qBAAqB,EAAA;;AAxB3B;EA6BI,kBAAkB,EAAA;;AAItB;EAEI,cAAc;EACd,WAAW;EACX,oCzB7CQ;EyB8CR,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,UAAU,EAAA;;AAId;;EAEE,yBAAuC,EAAA;EAEvC;IAJF;;MAKI,YAAY,EAAA,EAEf;;AAED;EAII,eAAe,EAAA;;AAJnB;EAQI,aAAa,EAAA;;AARjB;EAYI,qBAAqB,EAAA;EAZzB;I1BUI,0B0BKgE,EAAA;;AAIlE;EAnBF;IAoBI,mBAAmB,EAAA,EAEtB;;AAED;EACE,mBAAmB,EAAA;EADrB;IAII,kBAAyB,EAAA;EAJ7B;IAQI,gBAAgB,EAAA;IARpB;MAWM,iBAAiB,EAAA;EAIrB;IAfF;MAgBI,mBAAmB,EAAA,EAEtB;;AAED;EACE,mBAAmB,EAAA;EADrB;IAII,kBAAyB,EAAA;EAJ7B;IAQI,gBAAgB;IAChB,eAAe;IACf,czB5Hc,EAAA;EyB+HhB;IAbF;MAcI,mBAAmB,EAAA,EAEtB;;AAED;EACE,mB3BtEmB,EAAA;E2BwEnB;IAHF;MAII,mBAAmB,EAAA,EAEtB;;AAED;EACE,eAAe,EAAA;EADjB;IAII,gBAAgB,EAAA;IAJpB;MAOM,iBAAiB,EAAA;;AAKvB;EACE,e3B/IiB;E2BgJjB,0BAA0B,EAAA;;AAG5B;EACE,eAAe;EACf,czB9JgB,EAAA;EyB4JlB;IAKI,mB3BxJe,EAAA;;A2B4JnB;EACE,oBAAoB;EACpB,iBAAiB,EAAA;;AAGnB;EACE,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB;EAChB,eAAe;E1BrIf,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B0B8G2B;E1B7G3B,mB0B6G2B;EAC3B,mBAAmB,EAAA;EALrB;IAQI,cAAc;IACd,kBAAkB,EAAA;EATtB;IAaI,c3B9GgB,EAAA;E2BiGpB;;;IAmBI,c3BvJe,EAAA;E2B0JjB;IACE,gBAAgB;I1BtIlB,qC0BuIuC;I1BtIvC,6B0BsIuC,EAAA;;AAIzC;E1B/JE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B0BwI2B;E1BvI3B,mB0BuI2B;E1B7I3B,qC0B8IqC;E1B7IrC,6B0B6IqC;EACrC,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WzB5NU;EyB6NV,e3B7MiB,EAAA;E2BkMnB;IAcI,sBAAsB;IACtB,eAAe,EAAA;;AAInB;E1B/II,kBDxDkB;E2ByMpB,mB3BlKmB,EAAA;E2BoKnB;IAJF;MAMM,iBAAiB,EAAA,EAClB;EAGH;IAVF;MAYM,iBAAiB,EAAA,EAClB;EAGH;IAhBF;MAiBI,mBAAmB,EAAA,EAEtB;;AClQD,gBAAA;AAEA;EACE,kBAAkB,EAAA;EADpB;IAIM,W1BIM;I0BHN,kBAAkB,EAAA;EALxB;IAUI,kBAAkB,EAAA;EAVtB;IAaI,kBAAkB,EAAA;;ACftB,eAAA;AACA;EACE,wCAAwC;EACxC,oCAAsC,EAAA;;ACHxC,kBAAA;AAEA;EAEI,e9BqBe,EAAA;;A+BzBnB,sBAAA;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAA;;AAGpB;EACE,YAAY;EACZ,gB7BAU;E6BCV,kBAAkB;E9BTlB,gDCkBU;EDjBV,6CCiBU;EDhBV,2CCgBU;EDfV,wCCeU;E6BPV,qBAAqB;EACrB,eAAe,EAAA;;AAGjB;EACE,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO,EAAA;;AAGT;;;;EAIE,sBAAsB,EAAA;;AAGxB;EACE,sBAAsB;EACtB,uBAAuB,EAAA;;AAGzB;EACE,uBAAuB,EAAA;;AAGzB;EACE,qBAAqB;EACrB,mBAAmB,EAAA;;AC9CrB;;EAEE,kCAAkC,EAAA;;AAIpC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;EACtC,wBAAwB;EACxB,wCAAwC;EACxC,+BAA+B,EAAA;;AAGjC;EACE,uBAAuB,EAAA;;AAGzB;EACE,qBAAqB,EAAA;;AAEvB;EACE,qBAAqB,EAAA;;AAGvB;EACE,0BAA0B;EAC1B,+BAA+B,EAAA;;AAlCjC;;EAwCE,kCAAkC,EAAA;;AAIpC;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;EACxC,kCAAkC;EAClC,+BAA+B,EAAA;;AAGjC;EACE,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B,EAAA;;AAGhC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B,EAAA;;AAGhC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B,EAAA;;AAGhC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B,EAAA;;AAGhC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B,EAAA;;AAGhC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B,EAAA;;AAGhC;EACE,yBAAyB;EACzB,wCAAwC;EACxC,kCAAkC,EAAA;;AAGpC;EACE,0BAA0B;EAC1B,+BAA+B,EAAA;;AC3GjC,gBAAA;AAEA;EACE,YAAY,EAAA;;AAGd;EACE,WAAW,EAAA;;ACPb,oBAAA;AAEA;EACE,gBAAgB,EAAA;;AAGlB;EAII,oBAAoB,EAAA;EAEpB;IANJ;MAOM,mBAAmB,EAAA,EActB;EAXC;IAVJ;MAWM,oBAAoB,EAAA,EAUvB;EAPC;IAdJ;MAeM,oBAAoB,EAAA,EAMvB;EAHC;IAlBJ;MAmBM,mBAAmB,EAAA,EAEtB;;AC3BH,oBAAA;AAEA;;;;ElC2DE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EAqBrE,qCkC1EqC;ElC2ErC,6BkC3EqC;EACrC,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,iBAAiB;EAEjB,wBAAwB,EAAA;EAJ1B;IAOI,cAAc,EAAA;IAPlB;;MAWM,kBAAkB;MAClB,iBAAiB;MACjB,kBAAkB,EAAA;;AAKxB;EAEI,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe,EAAA;;AAInB;EACE,+HAA4H;EAC5H,0HAAuH;EACvH,uHAAoH,EAAA;;AAGtH;EACE,4HAAyH;EACzH,uHAAoH;EACpH,oHAAiH,EAAA;;AAGnH;EACE,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,uDAAuD,EAAA;;AAGzD;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB,EAAA;EAJlB;IAOI,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,UAAU;IACV,eAAe,EAAA;;AAInB;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC,EAAA;;AAGnC;EACE,uDAAuD;EACvD,eAAe;EACf,YAAY,EAAA;;AA9Cd;EAkDE,aAAa;EACb,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,uDAAuD;EACvD,+GAA6G;EAC7G,iHAA+G;EAC/G,uGAAqG,EAAA;;AAGvG;EACE,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,uDAAuD;EAEvD,iHAA+G;EAC/G,oHAAkH;EAClH,yGAAuG,EAAA;;AAGzG;EACE,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB,EAAA;;ACnIpB,eAAA;AAEA;EACE,qBAAqB;EAErB,kBAAkB,EAAA;;AAGpB;EACE,qBAAqB,EAAA;EADvB;IAGI,iBAAiB,EAAA;;ACXrB,eAAA;A9BweA;E8BteE,gBAAgB,EAAA;;ACFlB,cAAA;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW,EAAA;;AAGb;EACE,WAAW;EACX,uBAAuB,EAAA;EAFzB;IAKI,kBAAkB,EAAA;IAElB;MAPJ;QAQM,kBAAkB,EAAA,EAErB;EAVH;IAaI,kBAAkB;IAClB,mBAAmB,EAAA;EAdvB;IAmBI,gBAAgB;IAChB,kBAAkB,EAAA;EApBtB;IAwBI,iBAAiB,EAAA;EAxBrB;IA4BI,qBAAqB,EAAA;EA5BzB;IAgCI,qBAAqB;IACrB,ctCqDgB;IsCpDhB,etCvBiB;IsCwBjB,gBAAgB,EAAA;;AAIpB;EAEI,YAAY,EAAA;EACZ;IAHJ;MAIM,WAAW,EAAA,EAEd;;AANH;EASI,yBAAyB,EAAA;EACzB;IAVJ;MAWM,WAAW,EAAA,EAEd;;AAbH;EAiBM,kBAAkB,EAAA;;AAjBxB;EAqBM,2BAAuD;EACvD,uBAAmD;EACnD,ctCwBc;EsCvBd,gBAAgB,EAAA;EAxBtB;IA6BQ,yBAAwD;IACxD,qBAAoD,EAAA;;AA9B5D;EAoCQ,eAAe,EAAA;;AAMvB;EACE,iBAAiB;EACjB,kBAAkB,EAAA;EAFpB;IAII,cAAc;IACd,qBAAqB,EAAA;IALzB;MAQM,aAAa,EAAA;;AAKnB;EACE,gCpC3FgB;EoC4FhB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB,EAAA;;AAGpB;EAEI,eAAe;EACf,YAAY,EAAA;;AClHhB;EACE,eAAe;EACf,eAAe,EAAA;;AAGjB;EAEI,WrCEQ,EAAA;EqCJZ;IAOM,WrCOM;IqCNN,sBrCJM,EAAA;EqCJZ;IAYM,crCPY,EAAA;EqCLlB;IAgBM,crCHY,EAAA;;AsCnBlB,iBAAA;AACA;;;;EAMI,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EvCuFhB,mBuCtF2B;EvC2B7B,wCuC1B0C;EvC2B1C,mCuC3B0C;EvC4B1C,gCuC5B0C,EAAA;EAV5C;;;;;;;;;;IAeM,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB,EAAA;EAjB5B;;;;IAoBM,8BAA8B;IAC9B,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;IACtB,UAAU,EAAA;;AAxBhB;;;;EA4BI,aAAa;EACb,kBAAkB,EAAA;EA7BtB;;;;IAgCM,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB,EAAA;IApCzB;;;;MAsCQ,qBAAqB;MACrB,iBAAiB;MACjB,iBAAiB,EAAA;EAxCzB;;;;IA6CM,cAAc,EAAA;;AA7CpB;;;;EAkDI,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,wBAAwB,EAAA;EArD5B;;;;IAwDM,mBAAmB;IAEnB,oBAAoB,EAAA;IvClCxB;;;;;;;MAEE,YAAY;MACZ,cAAc,EAAA;IAEhB;;;;MACE,WAAW,EAAA;IuC9Bf;;;;MA4DQ,WAAW;MACX,eAAe;MACf,kBAAkB;MAClB,oBAAoB,EAAA;IA/D5B;;;;MAmEQ,cAAc;MACd,gBAAgB,EAAA;;AApExB;;;;EA0EI,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB,EAAA;EA/EtB;;;;IAkFM,cAAc;IACd,kBAAkB;IAClB,cAAc,EAAA;;AAKpB;EACE,cAAc;EvCKZ,gBuCJsB,EAAA;;AAG1B;EvCCI,mBuCE6B,EAAA;;AAKjC;EvCPI,kBuCS0B;EAC1B,aAAa;EACb,YAAY;EACZ,mBAAmB;EvCtBrB,2BuCuB6B;EvCtB7B,mBuCsB6B,EAAA;EAN/B;IASM,gBAAgB,EAAA;;AAKtB;EApHA;;;;IA0HM,kBAAkB,EAAA;EA1HxB;;;;IA6HM,wBAAwB,EAAA;EAvB9B;IA6BM,aAAa;IACb,YAAY,EAAA,EACb;;AAIL;EACE;;;;;;;;;;;;;IASM,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB,EAAA,EACpB;;ACvJP,qBAAA;AAEA;EACE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,kBAAkB,EAAA;EAFpB;IAII,yBrCwKmB,EAAA;IqC5KvB;MAMM,yBrC6KqB,EAAA;;AqCxK3B;EACE,crCgKqB;EqC/JrB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU,EAAA;;AAGZ;EACE,crCwJqB;EqCvJrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,kBAAkB,EAAA;;AChCpB,iBAAA;AACA;EACE,aAAa;EACb,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,WxCOU;EwCNV,e1CWiB;E0CVjB,oBAAoB,EAAA;;AAGtB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc,EAAA;;ACrBhB,gBAAA;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB,EAAA;EAJrB;IAOI,cvCkUuB;IuCjUvB,yBvC8TwB,EAAA;EuCtU5B;IAWI,WzCHQ;IyCIR,yBvC6TuB,EAAA;;AuCzT3B;E1CyDE,sB0CxDwB;E1CyDxB,kB0CzDwB;E1C0DxB,c0C1DwB,EAAA;;ApCslB1B;EoCllBE,cvCGqB,EAAA;;AuCAvB;E1CiDE,sB0ChDwB;E1CiDxB,kB0CjDwB;E1CkDxB,c0ClDwB,EAAA;;AAG1B;EACE,0C3C2BmB,EAAA;;A2CxBrB;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAsC,EAAA;EAHxC;;IAOI,2BAAuC;IACvC,8BAA8B;IAC9B,wCAAoE,EAAA;EATxE;IAaI,iCAAiC;IACjC,2CAA6E,EAAA;EAdjF;IAkBI,wCAA0E,EAAA;EAlB9E;IAsBI,iCAAqC,EAAA;;AAIzC;E1C0BE,4B0CzB4B;E1C0B5B,oB0C1B4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe,EAAA;;AAGjB;EACE,gBAAgB,EAAA;EADlB;IAGI,gBAAgB;IAChB,eAAe,EAAA;EAJnB;IAOI,sBAAsB,EAAA;;AAI1B;;EAGI,yBAAyB,EAAA;;AAH7B;EAOI,2CAA6C,EAAA;;AAIjD;EACE,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EALA;IAOI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,sBAAsB,EAAA;EAExB;IACE,gBAAgB,EAAA;EAElB;;;;;;IAME,mBAAmB,EAAA;EAErB;IACE,SAAS,EAAA;EAEX;;;;;;IAME,cAAc,EAAA;EAEhB;;;;;;IAME,eAAe,EAAA;EAEjB;;;;IAIE,gBAAgB,EAAA,EACjB;;AAGH;EAEI,kBAAkB,EAAA;;ACpJtB,cAAA;AAEA;EACE,0BAA0B,EAAA;;AAG5B;E3CuDE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE,EAAA;;A4C5DvE,qBAAA;AAEA;EACE,oC3CiBU;E2ChBV,2C3CgBU;E2CfV,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB,EAAA;EAElB;IAPF;MAQI,mBAAmB,EAAA,EAiDtB;EAzDD;IAYI,qBAAqB;IACrB,W7C+IU;I6C9IV,Y7C8IU;IC9DV,kB4C/E0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,yBzCwOuB,EAAA;IyCtOvB;MAtBJ;QAuBM,W7CmIQ;Q6ClIR,Y7CkIQ,EAAA,E6ChIX;EA1BH;IA4BI,WAAW;IACX,YAAY,EAAA;EA7BhB;IAgCI,czCuSwB;IyCtSxB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB,EAAA;IArCtB;MAwCM,gBAAgB;MAEd,0CAAqC;MACrC,eAAU;MAEZ,0BAA0B;MAC1B,6BAA6B;MAC7B,wBAAwB;MACxB,qBAAqB;MACrB,kBAAkB;MAClB,WAAW,EAAA;EAlDjB;IAsDI,czCsMuB;IyCrMvB,kBAAkB,EAAA;;AAKtB;EACE,kBAAkB,EAAA;EADpB;IAII,cAAc;IACd,mBAAmB;IACnB,Y7C4FY;I6C3FZ,a7C2FY,EAAA;I6CzFZ;MATJ;QAUM,W7CsFQ;Q6CrFR,Y7CqFQ,EAAA,E6CnFX;EAbH;IAeI,WAAW;IACX,YAAY,EAAA;;AC9EhB,mBAAA;AAEA;EACE,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,YAAY;EACZ,iBAAiB,EAAA;;AAGnB;E7CoFI,kB6CnFwB,EAAA;;AAG5B;EACE,mBAAmB,EAAA;;AAGrB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB,EAAA;EAHpB;IAMI,8B5Cbc;I4Ccd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV,UAAU,EAAA;EAbd;IAgBI,yBAAyB,EAAA;EAhB7B;IAmBI,yBAAyB;IACzB,YAAY,EAAA;;AAIhB;EAGE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,eAAe;EACf,W5C1CU;E4C2CV,kBAAkB;E7C2ChB,kBDtDsB,EAAA;E8CE1B;IAaI,6BAA6B,EAAA;EAbjC;IAgBI,iCAAiC,EAAA;;AAIrC;EAEI,aAAa,EAAA;;AAFjB;EAMI,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,sB9CmBU;ECEV,kBDtDsB;E8CmCtB,SAAS;EACT,QAAQ;EACR,UAAU,EAAA;;AAId;;EAEE,qBAAqB;EACrB,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sB5CnFU;EDsFR,kBDxDkB;E8CuDpB,yB5CnFgB,EAAA;E4C8ElB;IASI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB,EAAA;EAZzB;IAgBI,iC5C7Fc;I4C8Fd,8BAA8B;IAC9B,WAAW;IACX,SAAS,EAAA;EAnBb;IAuBI,8B5CvGQ;I4CwGR,8BAA8B;IAC9B,WAAW;IACX,SAAS,EAAA;;AAIb;EACE,UAAU,EAAA;;AAGZ;E7C1HE,wB6C2HwB;E7C1HxB,qB6C0HwB;E7CzHxB,mB6CyHwB;E7CxHxB,gB6CwHwB,EAAA;EAD1B;IAII,aAAa,EAAA;;AAIjB;EACE,mBAAmB,EAAA;;AAGrB;EAEI,YAAY;EACZ,eAAe;EACf,iBAAiB,EAAA;;AAIrB;EACE,gBAAgB;EAChB,mBAAmB,EAAA;;AAGrB;EACE,WAAW,EAAA;;AAGb,oBAAA;AACA;EAEI,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB,EAAA;EALtB;IAQM,OAAO,EAAA;;AAKb;EAEI,WAAW;EACX,WAAW,EAAA;;AAHf;EAOI,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,UAAU,EAAA;;AAXd;EAeI,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB,EAAA;EAlBvB;IAqBM,mBAAmB;IACnB,+B5ChLY;I4CiLZ,UAAU;IACV,WAAW,EAAA;EAxBjB;IA2BM,UAAU;IACV,YAAY,EAAA;EA5BlB;IAiCQ,8BAA8B;IAC9B,UAAU;IACV,YAAY,EAAA;EAnCpB;IAuCQ,8BAA8B;IAC9B,UAAU;IACV,YAAY,EAAA;EAzCpB;IA8CM,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV,UAAU,EAAA;;AAKhB,oBAAA;AACA;EAEI,mBAAmB,EAAA;EAFvB;IAKM,iBAAiB,EAAA;;AALvB;EAUI,WAAW;EACX,YAAY;EACZ,SAAS,EAAA;EAZb;IAcM,WAAW,EAAA;;AAdjB;EAmBI,qBAAqB,EAAA;;AAnBzB;E7CpLE,gCAAmC;EACnC,4BAA+B;EAC/B,2BAA8B;EAC9B,wBAA2B;E6CyMzB,SAAS;EACT,YAAY,EAAA;;AAzBhB;EA6BI,eAAe;EACf,oBAAoB,EAAA;EA9BxB;I7CpLE,iCAAmC;IACnC,6BAA+B;IAC/B,4BAA8B;IAC9B,yBAA2B,EAAA;;A6CiL7B;EAqCI,wBAAwB,EAAA;;AArC5B;EAyCI,aAAa,EAAA;;AApPjB;EAyPE,YAAY,EAAA;;AAGd;EAjDA;IAmDI,iBAAiB,EAAA;EAnDrB;IAuDI,SAAS,EAAA;EAvDb;IA4DM,mBAAmB,EAAA;EA5DzB;IAgEM,oBAAoB;IACpB,eAAe,EAAA,EAChB;;AAIL;EA3IA;IA8IM,WAAW;IACX,kBAAkB;IAClB,WAAW,EAAA;IAhJjB;MAkJQ,UAAU,EAAA;EArIlB;IA0IM,OAAO,EAAA;EA1Ib;IA8IM,WAAW;IACX,gBAAgB;IAChB,gBAAgB,EAAA;IAhJtB;MAmJQ,8B5C7SU;M4C8SV,oBAAoB;MACpB,UAAU;MACV,WAAW,EAAA;IAtJnB;MAyJQ,WAAW;MACX,OAAO,EAAA;IA1Jf;MA+JU,8BAA8B;MAC9B,WAAW;MACX,WAAW,EAAA;IAjKrB;MAoKU,8BAA8B;MAC9B,WAAW;MACX,WAAW,EAAA;EAMnB;IAEI,WAAW,EAAA;EA7MjB;IAiNM,WAAW;IACX,cAAc;IACd,kBAAkB,EAAA;EAItB;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB,EAAA;EApIzB;IAwIM,mBAAmB,EAAA;IAxIzB;MA0IQ,aAAa,EAAA;IA1IrB;MA8IQ,eAAe;MACf,SAAS;MACT,aAAa;MACb,UAAU,EAAA;IAjJlB;MAqJQ,SAAS,EAAA;EArJjB;IAyJM,eAAe,EAAA;EAInB;;IAGI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB,EAAA;EAPtB;IAWI,SAAS,EAAA;EAXb;IAeI,SAAS,EAAA,EACV;;AAIL;EA9YA;IAgZI,WAAW;IACX,eAAe,EAAA;EA5YnB;IAgZI,WAAW;IACX,cAAc,EAAA;EAhRlB;IAqRM,WAAW;IACX,eAAe,EAAA,EAChB;;AC/ZL,cAAA;AACA;EACE;;IAGI,UAAU;IACV,kBAAkB;IAClB,eAAe,EAAA;EALnB;;IAWM,UAAU;IACV,mBAAmB,EAAA;EAZzB;;I9C2DA,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,a8C7C8B;I9C8C9B,8B8C9CsC;I9C+CtC,0B8C/CsC;I9CgDtC,sB8ChDsC;I9CiDtC,yB8CjD8C;I9CkD9C,qB8ClD8C;I9CmD9C,iB8CnD8C,EAAA;EAlB9C;;;;IAyBI,UAAU;IACV,mBAAmB,EAAA;EAIvB;IACE,0BAA0B;IAC1B,2BAA2B,EAAA,EAC5B;;ACnCH;EACE,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,WAAW;EACX,UAAU;EACV,eAAe,EAAA;;AAGjB;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB,EAAA;;AAGzB;EACE,yBhDkC0B;EgDjC1B,kBAAkB;EAClB,chD0BmB;EgDzBnB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW,EAAA;;AAGb;EACE,yBhDsB0B;EgDrB1B,kBAAkB;EAClB,chDcmB;EgDbnB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ,EAAA;;AAGV;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ,EAAA;;AAGV;EACE,cAAc;EACd,UAAU,EAAA;;AAGZ,4BAAA;AAEA;EACE,kBAAkB,EAAA;;AAGpB;;EAEE,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,iBAAiB,EAAA;;AAGnB;;EAEE,kBAAkB,EAAA;;AAGpB;EACE,eAAe,EAAA;;AAGjB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,eAAe;EACf,yBhDrD0B;EgDsD1B,kBAAkB;EAClB,sB9C7GU;ED2BV,qE+CmFsE;E/ClFtE,gE+CkFsE;E/CjFtE,6D+CiFsE,EAAA;;AAGxE;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,c9CnHgB,EAAA;;A8CsHlB;EACE,UAAU;EACV,UAAU;EACV,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,yB9CpIgB;E8CqIhB,WAAW,EAAA;;AAGb;EACE,aAAa,EAAA;;AAGf;EACE,sB9CjJU;E8CkJV,mBAAmB,EAAA;;AAGrB;EACE,aAAa,EAAA;;AAGf;EACE,qBhD1GmB,EAAA;;AgD6GrB;EACE,yBhD9GmB,EAAA;;AgDiHrB;EACE,qBhDhHiB,EAAA;;AgDmHnB;EACE,qBhDpHiB,EAAA;;AgDuHnB;EACE,qBhD3FY,EAAA;;AgD8Fd;EACE,qBhD/FY,EAAA;;AgDkGd;EACE,qBhDlGe,EAAA;;AgDqGjB;EACE,qBhDtGe,EAAA;;AgDyGjB;EACE,qBhD5Ge,EAAA;;AgD+GjB;EACE,qBhDhHe,EAAA;;AgDmHjB;EACE,kBAAkB,EAAA;;AAGpB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,eAAe;EACf,yB9ClNgB;E8CmNhB,kBAAkB;EAClB,sB9CxNU;ED2BV,4C+C8L4C;E/C7L5C,uC+C6L4C;E/C5L5C,oC+C4L4C,EAAA;;AAG9C;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yB9ClOgB;ED6BhB,sCAAmC;EACnC,kCAA+B;EAC/B,iCAA8B;EAC9B,8BAA2B;EAT3B,sE+C6MuE;E/C5MvE,iE+C4MuE;E/C3MvE,8D+C2MuE,EAAA;;AAGzE;EACE,UAAU;EACV,UAAU;EACV,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;E/CpNE,sCAAmC;EACnC,kCAA+B;EAC/B,iCAA8B;EAC9B,8BAA2B,EAAA;;A+CsN7B;EACE,aAAa,EAAA;;AAGf;EACE,mBAAmB,EAAA;;AAGrB;EACE,aAAa,EAAA;;AAGf;EACE,yBhDvNmB,EAAA;;AgD0NrB;EACE,qBhD3NmB,EAAA;;AgD8NrB;EACE,yBhD/NmB,EAAA;;AgDkOrB;EACE,yBhDjOiB,EAAA;;AgDoOnB;EACE,qBhDrOiB,EAAA;;AgDwOnB;EACE,yBhDzOiB,EAAA;;AgD4OnB;EACE,yBhDhNY,EAAA;;AgDmNd;EACE,qBhDpNY,EAAA;;AgDuNd;EACE,yBhDxNY,EAAA;;AgD2Nd;EACE,yBhD3Ne,EAAA;;AgD8NjB;EACE,qBhD/Ne,EAAA;;AgDkOjB;EACE,yBhDnOe,EAAA;;AgDsOjB;EACE,yBhDzOe,EAAA;;AgD4OjB;EACE,qBhD7Oe,EAAA;;AgDgPjB;EACE,yBhDjPe,EAAA;;AgDoPjB;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB,EAAA;;AAGlB;;;;EAIE,cAAc,EAAA;;AAGhB;EACE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB,EAAA;;AAGlB;EACE,sBAAsB,EAAA;;AAGxB;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB,EAAA;;AAGpB;EACE,chD3T0B;EgD4T1B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB,EAAA;;AAGvB;EACE,yB9CvXgB;E8CwXhB,kBAAkB;EAElB,c9CvXgB;E8CwXhB,cAAc;EACd,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;E/CzWlB,4C+C0W4C;E/CzW5C,uC+CyW4C;E/CxW5C,oC+CwW4C;EAC5C,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,yBhD3VmB;EgD4VnB,W9C5YU,EAAA;;A8C+YZ;EACE,yBhD9ViB;EgD+VjB,W9CjZU,EAAA;;A8CoZZ;;EAEE,c9ChZgB,EAAA;;A8CmZlB;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,yB9C7ZgB;E8C8ZhB,UAAU;EACV,OAAO,EAAA;;AAGT;EACE,UAAU;EACV,QAAQ,EAAA;;AAGV;;EAEE,yBhDzXiB,EAAA;;AgD4XnB;;EAEE,yBhDhYmB,EAAA;;AgDmYrB;EACE,cAAc;EACd,chDpWc;EgDqWd,gBAAgB;EAChB,aAAa,EAAA;;AAGf;EACE;IACE,kBAAkB,EAAA;EAGpB;IACE,mBAAmB,EAAA,EACpB;;AAGH;E/CjZE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B+C0X2B;E/CzX3B,mB+CyX2B;EAC3B,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB,EAAA;;AAGpB;EACE,sBAAsB;EACtB,gBAAgB,EAAA;;AC1dlB,eAAA;AACA;EAA8B,wBAAA;EAC5B,eAAe;EACf,gBAAgC,EAAA;;AAGlC;EAAqB,gBAAA;EACnB,eAAe;EACf,gBAAgC,EAAA;;AAGlC;EAAyB,WAAA;EACvB,eAAe;EACf,gBAAgC,EAAA;;AAGlC;EAAoB,gBAAA;EAClB,eAAe;EACf,gBAAgC,EAAA;;AAGlC;EAAiD,wBAAA;EAC/C,eAAe,EAAA;;AAGjB;EAAwC,gBAAA;EACtC,eAAe,EAAA;;AAGjB;EAA4C,WAAA;EAC1C,eAAe,EAAA;;AAGjB;EAAuC,gBAAA;EACrC,eAAe,EAAA;;AAIjB;EACE,sB/C7BU;E+C8BV,kBAAkB,EAAA;EAFpB;IAII,WAAW;IACX,YAAY;IACZ,gBAAgB,EAAA;EANpB;IASI,mBAAmB,EAAA;EATvB;IAaI,6BAA6B;IAC7B,cAAc;IACd,cAA8B;IAC9B,YAAY;IACZ,WAAW,EAAA;EAjBf;IAqBI,gBAAgB,EAAA;IArBpB;MAuBM,kBAAkB;MAClB,WAAW;MACX,QAAQ,EAAA;EAzBd;IA8BI,kBAAkB;IAClB,WAAW;IACX,QAAQ,EAAA;EAhCZ;IAqCM,mBAAmB;IACnB,kBAAkB,EAAA;EAtCxB;IA0CM,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAA;EA5Cd;IAgDM,gBAAgB,EAAA;IAhDtB;MAkDQ,kBAAkB;MAClB,UAAU;MACV,QAAQ,EAAA;;AAMhB;EAGM,4BjDJc,EAAA;;AiDSpB,yEAAA;AACA;;EAEE,wBAAwB;EACxB,SAAS,EAAA;;AAGX,qDAAA;AACA;EACE,0BAA0B,EAAA;;AAG5B;EACE;IAEI,YAAY,EAAA,EACb;;ACxHL;+ErD0lP+E;AsD1lP/E,eAAA;AACA,eAAA;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;EACtB,UAAU;EACV,SAAS,EAAA;EACT;IARF;MASI,YAAY,EAAA,EAEf;;AAED;EACE,sBAAsB;EACtB,aAAa;EACb,iCAAiC;EACjC,4BAA4B;EAC5B,sBAAsB,EAAA;EACtB;IANF;MAOI,YAAY,EAAA,EAEf;;AAED;EACE,kBAAkB;EAClB,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sBjD1BU;EDsFR,kBDxDkB;EmDFpB,yBjDxBgB;EiDyBhB,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,mBAAmB,EAAA;;AAGrB;EACE,yB/CsR0B,EAAA;E+CvR5B;IAII,gBAAgB;IAChB,qBnDMiB,EAAA;;AmDFrB;EACE,6BAA6B,EAAA;;AAG/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,cAAc,EAAA;EAJhB;IAOI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU,EAAA;;AAId;ElDhBE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EkDmBrE,sBjDrEU;EDRV,mDDsEsC;ECrEtC,gDDqEsC;ECpEtC,8CDoEsC;ECnEtC,2CDmEsC;ECwBpC,mBkDfyB;EAC3B,eAAe;EACf,gBAAgB,EAAA;;AAGlB;EACE,uBAAuB;EACvB,UAAU;EACV,QAAQ,EAAA;EAER;IALF;MAMI,WAAW;MACX,QAAQ,EAAA,EAEX;;AAED;EACE,mBAAmB,EAAA;;AAGrB;EACE,yB/CgO0B,EAAA;E+CjO5B;IAII,gBAAgB;IAChB,qBnDhDiB,EAAA;;AmDoDrB;EACE,6BAA6B,EAAA;;AAG/B;EACE,yBnDzDmB;EmD0DnB,uBAAuB;EACvB,UAAU;EACV,QAAQ,EAAA;EAER;IANF;MAOI,WAAW;MACX,QAAQ,EAAA,EAEX;;AAED;ElDjEE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2BkD0C2B;ElDzC3B,mBkDyC2B;ElD/C3B,sCkDgDsC;ElD/CtC,8BkD+CsC,EAAA;EAHxC;;IAOI,SAAS,EAAA;EAPb;IAWI,yBnD/EiB;ICsCjB,kBkD0C0B;IAC1B,cnDjFiB,EAAA;ImDoErB;MAiBM,WjDrIM;MiDsIN,yBnDtFe,EAAA;EmDoErB;IAuBI,gBAAgB,EAAA;;ACrJpB,eAAA;AAEA;EACE,eAAe;EACf,kBAAkB,EAAA;EAElB;IAJF;MAKI,eAAe,EAAA,EAElB;;AAED;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc,EAAA;EAEd;IANF;MAOI,eAAe,EAAA,EAMlB;EAHC;IAVF;MAWI,UAAU,EAAA,EAEb;;AAED;EACE,clDRgB;EkDShB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kDAAkD,EAAA;EAElD;IARF;MASI,gBAAgB,EAAA,EAUnB;EAPC;IAZF;MAaI,gBAAgB,EAAA,EAMnB;EAHC;IAhBF;MAiBI,eAAe,EAAA,EAElB;;AAED;EACE,mBpD4GY,EAAA;EoD1GZ;IAHF;MAII,mBAAmB,EAAA,EAEtB;;ACrDD,gBAAA;AACA;EpD4DE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE,EAAA;;AoDvDvE;EACE,kBAAkB,EAAA;;ACNpB,sBAAA;AAEA;EACE,aAAa,EAAA;;AAGf;EAEI,gBAAgB;EAChB,eAAe;EACf,gBAAgB;ErDmDlB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2BqD1E6B;ErD2E7B,mBqD3E6B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB,EAAA;EAT1B;IrDqEE,mBqDzDyB;IrD0DzB,eqD1DyB;IrD2DzB,WqD3DyB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,+BtD0Ec;IsDzEd,qBAAqB,EAAA;IAhB3B;MAmBQ,cAAc,EAAA;IAnBtB;MAuBQ,WAAW;MACX,eAAe;MACf,iBAAiB,EAAA;IAzBzB;MA6BQ,gBAAgB,EAAA;MA7BxB;QA+BU,gBAAgB;QAChB,cAAc,EAAA;MAhCxB;QAoCU,yBlDyDkB;QkDxDlB,WpDjCE;QDsFR,kBqDpDgC;QAC1B,iBAAiB;QACjB,kBAAkB,EAAA;QAxC5B;UA0CY,eAAe,EAAA;MA1C3B;QA+CU,yBlDsFiB,EAAA;MkDrI3B;QAmDU,yBlD1BkB,EAAA;MkDzB5B;QAuDU,yBlD2EiB,EAAA;EkDlI3B;IA6DM,cAAc;IACd,gBAAgB,EAAA;IA9DtB;MAgEQ,iBAAiB;MACjB,oBAAoB;MACpB,gCtDuBY;MsDtBZ,mBAAmB,EAAA;MAnE3B;QAsEU,cAAc;QACd,gBAAgB;QAChB,iBAAiB,EAAA;;AAQ3B;EApFA;IAsFI,aAAa,EAAA;EAlFjB;IAuFM,cAAc;IACd,gBAAgB,EAAA;IAxFtB;MA0FQ,iBAAiB;MACjB,oBAAoB;MACpB,gCtDHY;MsDIZ,mBAAmB,EAAA;MA7F3B;QAgGU,cAAc;QACd,gBAAgB;QAChB,iBAAiB,EAAA;EAMzB;IACE,oBAAoB;IACpB,kBAAkB,EAAA;IAFpB;MAII,eAAe,EAAA;IAJnB;MAOI,eAAe,EAAA,EAChB;;ACtHL,mBAAA;AAEA;EAEI,mBAAmB,EAAA;EAFvB;IAIM,WAAW;ItD+Bf,mCsD9BuC;ItD+BvC,8BsD/BuC;ItDgCvC,2BsDhCuC,EAAA;EALzC;IASQ,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB,EAAA;;AAM9B;EAEI,eAAe;EACf,oBAAoB,EAAA;EAHxB;IAKM,qBAAqB;IACrB,mBAAmB;IACnB,eAAe,EAAA;EAPrB;IAWM,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,yBvDyBe;IuDxBf,cAAc;IACd,qBAAqB,EAAA;EAhB3B;;;IAsBM,eAAe;IACf,yBvDgBe;IuDff,qBvDee;IuDdf,WrDlCM,EAAA;EqDqCR;IA5BJ;MA6BM,mBAAmB,EAAA,EAEtB;;AClDH,cAAA;AAEA;EACE,mBAAmB,EAAA;;AAIrB;EACE,aAAa;EACb,yBtDGgB;EsDFhB,sBtDAU;EsDCV,aAAa,EAAA;EAJf;IAOI,mBAAmB;IACnB,eAAe;IACf,iBAAiB,EAAA;IATrB;MAYM,gBAAgB,EAAA;;AAMtB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EvDiEhB,kBuDhEwB;EAC1B,mBxDyBmB;EwDxBnB,WtDxBU,EAAA;EsDeZ;IAYI,gBAAgB;IAEd,0CAAqC;IACrC,eAAU;IAEZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;IACd,2BAA2B,EAAA;EArB/B;IvDuEI,0BuD9CkC,EAAA;IAzBtC;MA2BM,0BAA0B,EAAA;;AAMhC;EACE,gBAAgB,EAAA;EADlB;IAGI,mBAAmB,EAAA;IAHvB;MAKM,gBAAgB,EAAA;EALtB;IASI,cxDTiB,EAAA;EwDArB;IAYI,cAAc,EAAA;;AAIlB;EAEI,mBAAmB,EAAA;EAFvB;IAIM,gBAAgB,EAAA;;AAKtB;EACE,cAAc;EACd,mBAAmB,EAAA;EAFrB;IvDaI,kBuDT0B;IAC1B,WAAW,EAAA;;AAIf;EAEI,gBAAgB;EAChB,kBAAkB,EAAA;;AAItB;EACE,mBAAmB,EAAA;;AAGrB;;EAEE,eAAe;EACf,ctD3FgB;EsD4FhB,qBAAqB,EAAA;EAJvB;;IAMI,qBAAqB;IACrB,iBAAiB,EAAA;;AAIrB;EAEI,iBAAiB,EAAA;;ACpHrB,mBAAA;AACA;EACE,kBAAkB,EAAA;EADpB;;IAKI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBvDqPiB,EAAA;IuD/PrB;;MAYM,eAAe;MACf,gBAAgB,EAAA;IAbtB;;MAgBM,eAAe;MACf,iBAAiB,EAAA;EAjBvB;IAsBI,yCvDHQ,EAAA;EuDnBZ;IA0BI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,iBAAiB;IACjB,kBAAkB,EAAA;IA9BtB;MAiCM,YAAY;MACZ,qBAAqB;MACrB,iBAAiB;MACjB,yBAAyB;MACzB,iBAAiB;MACjB,sBvD7BM;MuD8BN,qCvDpBM;MuDqBN,eAAe;MACf,cvD1BY;MuD2BZ,kBAAkB,EAAA;MA1CxB;QA4CQ,iBAAiB;QACjB,eAAe,EAAA;;AAMvB;EACE,mBAAmB,EAAA;EADrB;IAII,kBAAkB;IAClB,czDCiB,EAAA;EyDNrB;IASI,mBAAmB,EAAA;;AAIvB;;EAII,eAAe,EAAA;;AAInB;EAEI,oCAAsC,EAAA;;AAF1C;EAKI,iBAAiB;EACjB,oBAAoB,EAAA;;AAIxB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B,EAAA;EAHhC;IAKI,eAAe,EAAA;;AAInB;EACE,gBAAgB,EAAA;EADlB;IAGI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,kBAAkB,EAAA;IAElB;MARJ;QASM,UAAU,EAAA,EAMb;IAHC;MAZJ;QAaM,cAAc,EAAA,EAEjB;;AAGH;EAEI,oBAAoB,EAAA;;AAIxB,6BAAA;AACA;EACE,eAAe,EAAA;EAEf;IAHF;MAII,eAAe,EAAA,EAElB;;AAED;EACE,eAAe,EAAA;EAEf;IAHF;MAII,eAAe,EAAA,EAElB;;AAED;EAEI,QAAQ;EACR,kBAAkB,EAAA;EAElB;IALJ;MAMM,QAAQ,EAAA,EAEX;;AARH;EAWI,QAAQ,EAAA;EAER;IAbJ;MAcM,QAAQ,EAAA,EAEX;;AAGH;EACE,kBAAmC;EACnC,mBAAoC;EACpC,gCvD5IgB,EAAA;EuD8IhB;IALF;;MAQM,0BAA0B,EAAA,EAC3B;;AAIL;EAEI,eAAe;EACf,kBAAkB,EAAA;;AAItB;EACE,WAAW,EAAA;;AAGb;EAEI,kBAAkB,EAAA;;AAItB,4BAAA;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;ExD/HhB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2BwDwG2B;ExDvG3B,mBwDuG2B,EAAA;EAP7B;IAUI,SAAS;IACT,WzDtCU;IyDuCV,YzDvCU;IyDwCV,WvD1LQ;IuD2LR,eAAe;IxDrGf,kBDtDsB;ICmBxB,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,awDsI4B;IxDrI5B,8BwDqIoC;IxDpIpC,0BwDoIoC;IxDnIpC,sBwDmIoC;IxDlIpC,yBwDkI4C;IxDjI5C,qBwDiI4C;IxDhI5C,iBwDgI4C;IxDtH5C,+BwDuHiC;IxDtHjC,uBwDsHiC;IxDlHjC,2BwDmH6B;IxDlH7B,mBwDkH6B;IxDpK7B,kCwDqKoC;IxDpKpC,6BwDoKoC;IxDnKpC,0BwDmKoC;IAClC,kBAAkB;IAClB,UAAU,EAAA;EArBd;IAyBI,WAAW;IACX,YAAY;IACZ,eAAe;IxDlHf,gBwDmHwB;IACxB,kBAAkB;IAClB,OAAO,EAAA;;AAIX;ExD5JE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2BwDqI2B;ExDpI3B,mBwDoI2B;EAC3B,iBzD5Dc;EyD6Dd,kBAAkB;EAClB,gBAAgB,EAAA;EALlB;IAQI,8BAA8B;IAC9B,gBAA0B,EAAA;EAT9B;IAaI,oBAAoB,EAAA;EAbxB;IAiBI,yBAAgC,EAAA;;AtC7MpC;EsCkNE,eAAe,EAAA;;AAGjB;EACE,iBzDnFc,EAAA;;AyDsFhB;ExDzLE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2BwDkK2B;ExDjK3B,mBwDiK2B;EAC3B,mBAAmB,EAAA;;AAGrB;EACE,uBAAuB;EACvB,wBAAwB,EAAA;;AAG1B;EAGM,kBAAkB,EAAA;;AAKxB;EACE,kBAAkB,EAAA;EADpB;IAII,8BvD9Pc;IuD+Pd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,UAAU,EAAA;;AAKd;EACE,kBAAkB;EAClB,kBAAkB,EAAA;EAFpB;IAKI,8BvD/Qc;IuDgRd,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,UAAU;IACV,UAAU,EAAA;;AAId;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;ExD7MR,kBwD8MwB;EAC1B,YAAY;EACZ,WAAW;EACX,yBvDlSgB,EAAA;;AuDqSlB;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;ExDvNT,kBDtDsB,EAAA;;AyDiR1B;EACE,cAAc,EAAA;EADhB;IAII,mBAAmB,EAAA;EAJvB;IAQI,eAAe;IACf,kBAAkB,EAAA;EATtB;IAaI,cAAc;IACd,kBAAkB;IAClB,czD3OgB,EAAA;IyD4NpB;MAmBM,czDpRe;MyDqRf,qBAAqB,EAAA;;AAK3B;EAEI,kBAAkB,EAAA;;AAFtB;EAKI,yBvD7Uc;EuD8Ud,gBAAgB;EAChB,iBAAiB;EACjB,cvD5Uc;EuD6Ud,eAAe;EACf,yBvDhVc,EAAA;EuDsUlB;IAaM,yBzDvSe;IyDwSf,WvDxVM;IuDyVN,qBzDzSe,EAAA;IyD0RrB;MAmBQ,WvD7VI,EAAA;;AuD0UZ;ExDzNI,2BDpFe;ECqFf,8BDrFe,EAAA;;AyD6SnB;ExDvOI,4BDtEe;ECuEf,+BDvEe,EAAA;;AyD8UnB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAA6B,EAAA;EAJ/B;IAOI,mBAAmB,EAAA;IACnB;MARJ;QASM,mBAAmB,EAAA,EAEtB;EAXH;IAcI,WAAW;IACX,YAAY,EAAA;EAfhB;IAmBI,qBAAqB,EAAA;IAnBzB;MAsBM,cAAc,EAAA;MAEd;QAxBN;UAyBQ,cAAc,EAAA,EAUjB;MAPC;QA5BN;UA6BQ,aAAa,EAAA,EAMhB;MAHC;QAhCN;UAiCQ,cAAc,EAAA,EAEjB;;AAIL;EAGI,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EALpB;;IASM,cAAc,EAAA;;ACrapB,kBAAA;AACA;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;EADrB;IAII,cAAc;IACd,aAAa;IzDmDf,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,ayDtD4B;IzDuD5B,8ByDvDoC;IzDwDpC,0ByDxDoC;IzDyDpC,sByDzDoC;IzD0DpC,yByD1D4C;IzD2D5C,qByD3D4C;IzD4D5C,iByD5D4C;IzDsE5C,+ByDrEiC;IzDsEjC,uByDtEiC,EAAA;IAPnC;MAUM,gBAAgB,EAAA;EAVtB;IAeI,gBAAgB,EAAA;;AAIpB;EACE,gBAAgB;EAChB,eAAe,EAAA;EAFjB;IAKI,kBAAkB,EAAA;;AAItB;EAEI,kBAAkB,EAAA;;AAFtB;EAMI,gBAAgB;EAChB,cAAc,EAAA;;ACxClB;+E9D04Q+E;A8Dx4Q/E;EAEE,yBzDSgB;EyDRhB,sBzDKU;EDsFR,kBDxDkB;E2DjCpB,mBAAmB;EACnB,mBAAmB,EAAA;EANrB;IAUI,kBAAkB,EAAA;IAVtB;MAaM,WAAW;MACX,qBAAqB;MACrB,YAAY;MACZ,sBAAsB,EAAA;IAhB5B;MAoBM,YAAY;MACZ,gBAAgB;MAChB,eAAe;MACf,qBAAqB;MACrB,sBAAsB;MACtB,sBAAsB,EAAA;EAzB5B;I1DmCE,6C0DL+C;I1DM/C,wC0DN+C;I1DO/C,qC0DP+C;IAC7C,yBAAoC,EAAA;EAGtC;IAlCF;MAmCI,mBAAmB,EAAA,EAEtB;;AAED;EAEI,qBAAqB;EACrB,WAAW,EAAA;;AAIf;EAEI,eAAe,EAAA;;AClDnB;+E/Dg7Q+E;AgEh7Q/E,qBAAA;AAEA;E5D2DE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4D9D0B;E5D+D1B,8B4D/DkC;E5DgElC,0B4DhEkC;E5DiElC,sB4DjEkC;E5DkElC,yB4DlE0C;E5DmE1C,qB4DnE0C;E5DoE1C,iB4DpE0C;E5DmF1C,4B4DlF4B;E5DmF5B,oB4DnF4B;EAC5B,YAAY,EAAA;;AAGd;EACE,kBAAkB;E5DoDlB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4DvD0B;E5DwD1B,2B4DxD+B;E5DyD/B,uB4DzD+B;E5D0D/B,mB4D1D+B;E5D2D/B,yB4D3DuC;E5D4DvC,qB4D5DuC;E5D6DvC,iB4D7DuC;EACvC,2BAA2B,EAAA;EAE3B;IALF;MAMI,aAAa,EAAA,EAEhB;;AAED;EACE,kBAAkB;EAClB,UAAU;E5DyCV,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4D5C0B;E5D6C1B,8B4D7CkC;E5D8ClC,0B4D9CkC;E5D+ClC,sB4D/CkC;E5DgDlC,yB4DhD0C;E5DiD1C,qB4DjD0C;E5DkD1C,iB4DlD0C;E5DsD1C,uB4DrDyB;E5DsDzB,mB4DtDyB;E5DuDzB,e4DvDyB;EACzB,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,gC3DhBgB;EDiDhB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4DpC0B;E5DqC1B,8B4DrCkC;E5DsClC,0B4DtCkC;E5DuClC,sB4DvCkC;E5DwClC,yB4DxC0C;E5DyC1C,qB4DzC0C;E5D0C1C,iB4D1C0C,EAAA;EAF5C;IAKI,kBAAkB;IAClB,kBAAkB,EAAA;;AAItB;EACE,aAAa;E5DuBb,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B4D9C2B;E5D+C3B,mB4D/C2B;E5DyC3B,+B4DxC+B;E5DyC/B,uB4DzC+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAA0C;EAC1C,cAA4B,EAAA;EAR9B;IAUI,eAAe,EAAA;;AAInB;E5DUE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4Db0B;E5Dc1B,8B4DdkC;E5DelC,0B4DfkC;E5DgBlC,sB4DhBkC;E5DiBlC,yB4DjB0C;E5DkB1C,qB4DlB0C;E5DmB1C,iB4DnB0C,EAAA;;AAG5C;EACE,eAAe,EAAA;;AAOjB;E5DFE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;E4DKrE,aAAa,EAAA;;AAGf;EACE,gBAAgB;EAChB,eAAe;E5DTf,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4DM0B;E5DL1B,8B4DKkC;E5DJlC,0B4DIkC;E5DHlC,sB4DGkC;E5DFlC,yB4DE0C;E5DD1C,qB4DC0C;E5DA1C,iB4DA0C;E5DU1C,+B4DT+B;E5DU/B,uB4DV+B,EAAA;EAJjC;I5DPE,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,a4DU4B;I5DT5B,8B4DSoC;I5DRpC,0B4DQoC;I5DPpC,sB4DOoC;I5DNpC,yB4DM4C;I5DL5C,qB4DK4C;I5DJ5C,iB4DI4C,EAAA;EAP9C;IAWI,kBAAkB;IAClB,cAAgC;I5DnBlC,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,aAL6B;IAM7B,2BANmD;IAOnD,uBAPmD;IAQnD,mBARmD;IASnD,uBATqE;IAUrE,mBAVqE;IAWrE,eAXqE;IA0BrE,2B4DJ6B;I5DK7B,mB4DL6B;IAC3B,qBAAqB,EAAA;IAfzB;MAmBM,c7DQc,EAAA;I6D3BpB;MAuBM,c7DjCe,EAAA;E6DUrB;IA4BI,kBAAkB;IAClB,eAAe,EAAA;EA7BnB;IAiCI,qBAAqB;IACrB,sBAAsB,EAAA;EAlC1B;IAsCI,kBAAkB,EAAA;;AAItB;EACE,kBAAkB;EAClB,UAAU;E5DnDV,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4DgD0B;E5D/C1B,8B4D+CkC;E5D9ClC,0B4D8CkC;E5D7ClC,sB4D6CkC;E5D5ClC,yB4D4C0C;E5D3C1C,qB4D2C0C;E5D1C1C,iB4D0C0C;E5DtC1C,sB4DuCwB;E5DtCxB,kB4DsCwB;E5DrCxB,c4DqCwB;EACxB,6BAA6B,EAAA;;AAG/B;EACE,kBAAkB;EAClB,gBAAgB;E5D3DhB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4DwD0B;E5DvD1B,8B4DuDkC;E5DtDlC,0B4DsDkC;E5DrDlC,sB4DqDkC;E5DpDlC,yB4DoD0C;E5DnD1C,qB4DmD0C;E5DlD1C,iB4DkD0C;E5DxC1C,+B4DyC+B;E5DxC/B,uB4DwC+B;EAC/B,sB3DjHU;E2DkHV,gC3DhHgB,EAAA;E2D0GlB;IASI,gBAAgB,EAAA;IATpB;M5DtBI,gB4DkC0B;MACxB,YAAY;MACZ,4BAA4B,EAAA;MAdlC;QAiBQ,yB3D5HU,EAAA;I2D2GlB;MAsBM,WAAW;MACX,YAAY;MACZ,eAAe;MACf,UAAU;MACV,MAAM;MACN,UAAU,EAAA;;AAKhB;E5DzFE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B4DkE2B;E5DjE3B,mB4DiE2B;E5DvE3B,sC4DwEsC;E5DvEtC,8B4DuEsC,EAAA;;AAGxC;EACE,sB3DnJU;EDmDV,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4D6F0B;E5D5F1B,8B4D4FkC;E5D3FlC,0B4D2FkC;E5D1FlC,sB4D0FkC;E5DzFlC,yB4DyF0C;E5DxF1C,qB4DwF0C;E5DvF1C,iB4DuF0C,EAAA;;AAG5C;EACE,iBAAiB;E5DrGjB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;E4DwGrE,gC3DxJgB,EAAA;E2DqJlB;I5DjEI,gB4DuEwB,EAAA;;AAI5B;EACE,kBAAkB,EAAA;EAElB;IAHF;MAII,kBAAkB,EAAA,EAErB;;AAED;E5DtHE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B4D+F2B;E5D9F3B,mB4D8F2B;EAC3B,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB,EAAA;;AAGpB;EACE,8B3DhLgB;E2DiLhB,YAAY;EACZ,UAAU;EACV,cAAc,EAAA;;AAGhB;EACE,iBAAiB,EAAA;;AAGnB;E5D3IE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4DwI0B;E5DvI1B,8B4DuIkC;E5DtIlC,0B4DsIkC;E5DrIlC,sB4DqIkC;E5DpIlC,yB4DoI0C;E5DnI1C,qB4DmI0C;E5DlI1C,iB4DkI0C;E5DxH1C,+B4DyH+B;E5DxH/B,uB4DwH+B,EAAA;;AAGjC;E5DhJE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B4DyH2B;E5DxH3B,mB4DwH2B;EAC3B,kBAAkB;EAClB,gC3DrMgB;E2DsMhB,UAAU;EACV,kBAAkB;EAClB,eAAe,EAAA;EAPjB;IAUI,cAAc;IACd,gBAAgB,EAAA;EAXpB;IAeI,kBAAkB;I5DtIpB,0B4DuI4B;I5DtI5B,kB4DsI4B,EAAA;;AAI9B;EACE,mBAAmB,EAAA;EADrB;IAII,kBAAkB,EAAA;;AAItB;E5D9JE,mB4D+JqB;E5D9JrB,e4D8JqB;E5D7JrB,W4D6JqB;E5D7KrB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4D0K0B;E5DzK1B,8B4DyKkC;E5DxKlC,0B4DwKkC;E5DvKlC,sB4DuKkC;E5DtKlC,yB4DsK0C;E5DrK1C,qB4DqK0C;E5DpK1C,iB4DoK0C;EAC1C,6BAA6B,EAAA;;AAG/B;EACE,kBAAkB,EAAA;EADpB;IAII,kBAAkB,EAAA;;AAItB;EACE,iBAAiB,EAAA;;AAGnB;EACE,sB3DlPU;E2DmPV,+B3DjPgB;E2DkPhB,kBAAkB;EAClB,UAAU,EAAA;EAJZ;IAOI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU,EAAA;;AAId;EACE,gBAAgB,EAAA;EADlB;IAII,aAAa,EAAA;;AAIjB;EACE,kBAAkB,EAAA;;AAGpB;EACE,eAAe,EAAA;;AAGjB;EACE,kBAAkB,EAAA;;AAGpB;E5D/NE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EAqBrE,sC4D6MsC;E5D5MtC,8B4D4MsC;E5DxMtC,2B4DyM2B;E5DxM3B,mB4DwM2B;EAC3B,WAAW;EACX,eAAe,EAAA;;AAGjB;E5DvOE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a4DoO0B;E5DnO1B,8B4DmOkC;E5DlOlC,0B4DkOkC;E5DjOlC,sB4DiOkC;E5DhOlC,yB4DgO0C;E5D/N1C,qB4D+N0C;E5D9N1C,iB4D8N0C;E5DpN1C,+B4DqN+B;E5DpN/B,uB4DoN+B;E5DhN/B,2B4DiN2B;E5DhN3B,mB4DgN2B,EAAA;;AAQ7B;E5DzNE,2B4D0N2B;E5DzN3B,mB4DyN2B,EAAA;;AAG7B;EAjSA;I5D2CE,sBAA+B;IAC/B,mBAA4B;IAC5B,kBAA2B;IAC3B,iBAA0B;IAC1B,c4DoP6B;I5DnP7B,2B4DmPkC;I5DlPlC,uB4DkPkC;I5DjPlC,mB4DiPkC;I5DhPlC,yB4DgP0C;I5D/O1C,qB4D+O0C;I5D9O1C,iB4D8O0C;I5D1O1C,sBAD2D;IAE3D,kBAF2D;IAG3D,cAH2D;I4D6OzD,gB7D/LkB;I6DgMlB,gB7DhMkB;I6DiMlB,sB3D/SQ,EAAA;E2D4GZ;IAuMI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B,EAAA;IAH5B;MAMI,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,UAAU;MACV,+B3D1TY;M2D2TZ,YAAY;MACZ,WAAW;M5DxOb,gB4DyO0B;MACxB,eAAe,EAAA;IApNrB;MAwNM,YAAY;MACZ,0BAA0B,EAAA;IAzNhC;MA6NM,YAAY,EAAA;EAIhB;IACE,2BAA2B,EAAA;EA1O/B;IA8OI,eAAe,EAAA,EAChB;;AAGH;EACE;IACE,gBAAgB,EAAA,EACjB;;AAGH;EA9VA;IAgWI,cAAc,EAAA,EACf;;AAGH;EACE;IACE,cAAc;IACd,eAAe,EAAA;IAzPnB;MA4PM,gBAAgB,EAAA,EACjB;;AAIL;EA1KA;IA4KI,kBAAkB,EAAA;EAhJtB;IAoJI,eAAe,EAAA;EAGjB;IAEI,sBAAsB;IACtB,kBAAkB,EAAA;EA7QxB;IAiRM,gBAAgB,EAAA;IAjRtB;M5DtBI,sB4D0SkC,EAAA;EAVpC;IAgBM,WAAW;IACX,SAAS,EAAA;EAjBf;IAqBM,WAAW;IACX,SAAS,EAAA;EAzCf;IA8CI,kBAAkB,EAAA,EACnB;;AAIL;EA1SA;IA6SM,gBAAgB,EAAA,EACjB;;AAIL;EACE;IACE,wBAAwB,EAAA,EACzB;;AC3aH,qBAAA;AAEA;E7DyEE,sBAD2D;EAE3D,kBAF2D;EAG3D,cAH2D,EAAA;E6DxE7D;IAII,WAAW,EAAA;;AAIf;E7DmDE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6DtD0B;E7DuD1B,2B6DvD+B;E7DwD/B,uB6DxD+B;E7DyD/B,mB6DzD+B;E7D0D/B,yB6D1DuC;E7D2DvC,qB6D3DuC;E7D4DvC,iB6D5DuC;E7DgEvC,sBAD2D;EAE3D,kBAF2D;EAG3D,cAH2D;E6D7D3D,yB5DFgB;E4DGhB,kBAAkB;EAClB,WAAW,EAAA;;AAGb;E7D2CE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6D9C0B;E7D+C1B,8B6D/CkC;E7DgDlC,0B6DhDkC;E7DiDlC,sB6DjDkC;E7DkDlC,yB6DlD0C;E7DmD1C,qB6DnD0C;E7DoD1C,iB6DpD0C;E7DwD1C,uB6DvDyB;E7DwDzB,mB6DxDyB;E7DyDzB,e6DzDyB;EACzB,gBAAgB;EAChB,+B5DVgB,EAAA;;A4DalB;E7DoCE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6DvC0B;E7DwC1B,8B6DxCkC;E7DyClC,0B6DzCkC;E7D0ClC,sB6D1CkC;E7D2ClC,yB6D3C0C;E7D4C1C,qB6D5C0C;E7D6C1C,iB6D7C0C;E7DiD1C,sBAD2D;EAE3D,kBAF2D;EAG3D,cAH2D;E6D9C3D,eAAe;EACf,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;E7D4BE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6D/B0B;E7DgC1B,8B6DhCkC;E7DiClC,0B6DjCkC;E7DkClC,sB6DlCkC;E7DmClC,yB6DnC0C;E7DoC1C,qB6DpC0C;E7DqC1C,iB6DrC0C;EAC1C,uBAAuB;EACvB,yBAA0C,EAAA;;AAG5C;E7DsBE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;E6DnBrE,mBAAmB,EAAA;;AAGrB;E7DiBE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6DpB0B;E7DqB1B,8B6DrBkC;E7DsBlC,0B6DtBkC;E7DuBlC,sB6DvBkC;E7DwBlC,yB6DxB0C;E7DyB1C,qB6DzB0C;E7D0B1C,iB6D1B0C;EAC1C,gBAAgB,EAAA;EAFlB;I7D+BE,sBAD2D;IAE3D,kBAF2D;IAG3D,cAH2D,EAAA;I6D9B7D;M7D1CE,wB6DkD4B;M7DjD5B,qB6DiD4B;M7DhD5B,mB6DgD4B;M7D/C5B,gB6D+C4B;M7D4C1B,gB6D3C0B;MACxB,kBAAkB;MAClB,YAAY,EAAA;IAXlB;MAeM,UAAU;MACV,MAAM;MACN,YAAY;MACZ,UAAU,EAAA;;AAKhB;EACE,e9DwFY,EAAA;E8DtFZ;IACE,cAAc;IACd,eAAe,EAAA;EAGjB;IACE,eAAe,EAAA;;AAInB;EACE,kBAAkB;EAClB,e9D0EY,EAAA;E8D5Ed;IAKI,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAA;IAZtB;MAeM,UAAU;MACV,WAAW,EAAA;IAhBjB;MAoBM,yB1D+EiB,EAAA;I0DnGvB;MAyBM,sB5D/FM;M4DgGN,yB1DyEiB,EAAA;I0DnGvB;MA+BM,yB1D6HqB,EAAA;E0DxHzB;IACE,e9DwCU,EAAA;;A8DpCd;EACE,sB5DhHU,EAAA;;A4DmHZ;EACE,kBAAkB;EAClB,e9D3GmB;E8D4GnB,c9DvCY;EC5BZ,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6DgE0B;E7D/D1B,8B6D+DkC;E7D9DlC,0B6D8DkC;E7D7DlC,sB6D6DkC;E7D5DlC,yB6D4D0C;E7D3D1C,qB6D2D0C;E7D1D1C,iB6D0D0C;E7DhD1C,+B6DiD+B;E7DhD/B,uB6DgD+B,EAAA;;AAGjC;EACE,oCAAqD,EAAA;;AAGvD;E7D5EE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6DyE0B;E7DxE1B,8B6DwEkC;E7DvElC,0B6DuEkC;E7DtElC,sB6DsEkC;E7DrElC,yB6DqE0C;E7DpE1C,qB6DoE0C;E7DnE1C,iB6DmE0C,EAAA;EAD5C;I7DxDE,+B6D4DiC;I7D3DjC,uB6D2DiC;I7DvDjC,2B6DwD6B;I7DvD7B,mB6DuD6B,EAAA;IAL/B;MAQM,iBAAiB,EAAA;;AAKvB;EACE,gC5D3IgB;E4D4IhB,aAAa;E7D3Fb,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6DwF0B;E7DvF1B,8B6DuFkC;E7DtFlC,0B6DsFkC;E7DrFlC,sB6DqFkC;E7DpFlC,yB6DoF0C;E7DnF1C,qB6DmF0C;E7DlF1C,iB6DkF0C;E7DxE1C,+B6DyE+B;E7DxE/B,uB6DwE+B;EAC/B,eAAe;EACf,gBAAgB,EAAA;EANlB;IAUI,yBAA4C,EAAA;;AAIhD;EACE,cAAc;E7D/Ed,2B6DgF2B;E7D/E3B,mB6D+E2B,EAAA;;AAG7B;EACE,cAAc,EAAA;EADhB;IAII,gBAAgB,EAAA;EAJpB;IAQI,cAAc;IACd,kBAAkB,EAAA;;AAItB;EACE,c5DvKgB;E4DwKhB,eAAe,EAAA;;AAGjB;EACE,cAAc;EACd,iBAAiB,EAAA;;AAOnB;E7DvIE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6DoI0B;E7DnI1B,8B6DmIkC;E7DlIlC,0B6DkIkC;E7DjIlC,sB6DiIkC;E7DhIlC,yB6DgI0C;E7D/H1C,qB6D+H0C;E7D9H1C,iB6D8H0C;E7DpH1C,+B6DqH+B;E7DpH/B,uB6DoH+B;EAC/B,YAAY,EAAA;;AAGd;E7D7IE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6D0I0B;E7DzI1B,8B6DyIkC;E7DxIlC,0B6DwIkC;E7DvIlC,sB6DuIkC;E7DtIlC,yB6DsI0C;E7DrI1C,qB6DqI0C;E7DpI1C,iB6DoI0C;E7D1H1C,+B6D2H+B;E7D1H/B,uB6D0H+B;E7DtH/B,2B6DuH2B;E7DtH3B,mB6DsH2B;EAC3B,YAAY;EACZ,aAAa,EAAA;;AAGf;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB,EAAA;;AAGrB;E7D7JE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6D0J0B;E7DzJ1B,8B6DyJkC;E7DxJlC,0B6DwJkC;E7DvJlC,sB6DuJkC;E7DtJlC,yB6DsJ0C;E7DrJ1C,qB6DqJ0C;E7DpJ1C,iB6DoJ0C,EAAA;;AAG5C;E7DjKE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B6D0I2B;E7DzI3B,mB6DyI2B;EAC3B,gC5DrNgB;E4DsNhB,aAAa;EACb,sB5DzNU;E4D0NV,WAAW,EAAA;;AAGb;E7D1KE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B6DmJ2B;E7DlJ3B,mB6DkJ2B;EAC3B,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,gBAAgB,EAAA;;AAGlB;E7DrLE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a6DkL0B;E7DjL1B,8B6DiLkC;E7DhLlC,0B6DgLkC;E7D/KlC,sB6D+KkC;E7D9KlC,yB6D8K0C;E7D7K1C,qB6D6K0C;E7D5K1C,iB6D4K0C;EAC1C,6B5DxOgB;E4DyOhB,aAAa;EACb,sB5D5OU;E4D6OV,WAAW,EAAA;EALb;IAQI,gBAAgB,EAAA;;AAIpB;EACE,iBAAiB,EAAA;;AAGnB;EACE,aAAa,EAAA;EADf;IAII,iBAAiB;IACjB,sB5D7PQ;IDsFR,iC6DwKyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yB5D9Pc,EAAA;E4DoPlB;IAeM,kBAAkB;IAClB,cAAc;IACd,yBAA4C;I7DnL9C,+B6DoLyC,EAAA;;AAK7C;EACE,0BAA0B;EAC1B,qBAAqB,EAAA;;AAGvB;EACE,YAAY;E7D7RZ,wB6D8RwB;E7D7RxB,qB6D6RwB;E7D5RxB,mB6D4RwB;E7D3RxB,gB6D2RwB;E7DhMtB,gB6DiMsB,EAAA;;AAG1B;EACE,eAAe;EACf,c5DvRgB,EAAA;;A4D0RlB;EAvFA;IAyFI,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B,EAAA,EAC9B;;AAGH;EAhTA;IAkTI,yBAAyB;IACzB,cAAc,EAAA;EAvFlB;IA2FI,iBAAiB,EAAA;IADnB;MAII,uBAAuB;MACvB,sBAAsB;MACtB,iBAAiB,EAAA;IANrB;MAUI,gBAAgB,EAAA;EA9MpB;IAoNI,eAAe,EAAA;EAInB;;IAEE,eAAe,EAAA;EA5FnB;IAgGI,iBAAiB,EAAA;EAhIrB;IAoII,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B,EAAA,EAC9B;;AAGH;EA3IA;IA6II,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB,EAAA,EACpB;;AAGH;EACE;;IAEE,eAAe,EAAA;EAxJnB;IA4JI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B,EAAA,EAC7B;;AAGH;EACE;IAEI,eAAe,EAAA;EAtKrB;IA0KI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B,EAAA,EAC7B;;AChYH,sBAAA;AAEA;E9D2DE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;E8DxDrE,WAAW,EAAA;;AAGb;E9DsDE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a8DzD0B;E9D0D1B,8B8D1DkC;E9D2DlC,0B8D3DkC;E9D4DlC,sB8D5DkC;E9D6DlC,yB8D7D0C;E9D8D1C,qB8D9D0C;E9D+D1C,iB8D/D0C;EAC1C,WAAW,EAAA;;AAGb;E9DiDE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B8DxE2B;E9DyE3B,mB8DzE2B,EAAA;EAF7B;IAKI,kBAAkB,EAAA;EALtB;;IAUI,iBAAiB,EAAA;EAVrB;IAcI,gBAAgB,EAAA;;AFmLpB;E5DhJE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE,EAAA;;A8D1BvE;EACE,wBAAwB,EAAA;;AAG1B;E9DuBE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;EA0BrE,2B8D9C2B;E9D+C3B,mB8D/C2B,EAAA;;AAG7B;E9DkBE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a8DrB0B;E9DsB1B,8B8DtBkC;E9DuBlC,0B8DvBkC;E9DwBlC,sB8DxBkC;E9DyBlC,yB8DzB0C;E9D0B1C,qB8D1B0C;E9D2B1C,iB8D3B0C,EAAA;EAD5C;IAII,kBAAkB,EAAA;;AAItB;EACE,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;E9DDE,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,a8DG4B;E9DF5B,8B8DEoC;E9DDpC,0B8DCoC;E9DApC,sB8DAoC;E9DCpC,yB8DD4C;E9DE5C,qB8DF4C;E9DG5C,iB8DH4C;EAC1C,cAA6B;EAC7B,eAAe,EAAA;EARnB;IAYM,kBAAkB,EAAA;;AAKxB;EACE,aAAa,EAAA;;AAGf;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,iBAAiB;EACjB,gBAAgB;E9D9BhB,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE,EAAA;E8D6BvE;IAMI,iBAAiB,EAAA;;AAIrB;EF0GA;IExGI,mBAAmB,EAAA,EACpB;;AAGH;EACE;I9D/BA,sB8DgC0B;I9D/B1B,kB8D+B0B;I9D9B1B,c8D8B0B;IACxB,eAAe;IACf,oBAAoB,EAAA;EA3ExB;I9DyCE,sB8DsC0B;I9DrC1B,kB8DqC0B;I9DpC1B,c8DoC0B;IACxB,eAAe,EAAA;IAFjB;MAKI,aAAa,EAAA,EACd;;AAIL;EApFA;IAsFI,cAAc;I9DtChB,+B8DuCiC;I9DtCjC,uB8DsCiC;IAC/B,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB,EAAA;EA1CrB;IA8CI,gBAAgB;IAChB,eAAe,EAAA;EAGjB;IACE,2BAA2B,EAAA,EAC5B;;AC7IH,wBAAA;AAEA;E/DoFE,2B+DnF2B;E/DoF3B,mB+DpF2B;E/D0D3B,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,aAL6B;EAM7B,2BANmD;EAOnD,uBAPmD;EAQnD,mBARmD;EASnD,uBATqE;EAUrE,mBAVqE;EAWrE,eAXqE;E+DvDrE,gC9DOgB;E8DNhB,iBAAiB,EAAA;;AAGnB;EACE,eAAe,EAAA;;AAGjB;EACE,kBAAkB,EAAA;;AAGpB;EACE,gBAAgB;EAChB,gBAAgB,EAAA;EAEhB;IACE,gBAAgB,EAAA;;AAIpB;EACE,W9DjBU;ED4FR,2B+D1E4B;E/D2E5B,4B+D3E4B,EAAA;;AAGhC;EACE,W9DtBU;E8DuBV,kBAAkB,EAAA;EAFpB;IAKI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,W9D9BQ,EAAA;;A8DkCZ;EACE,aAAa,EAAA;EADf;IAII,cAAc,EAAA;;AAIlB;EACE,oBAAoB,EAAA;EADtB;I/DSE,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,aAL6B;IAM7B,2BANmD;IAOnD,uBAPmD;IAQnD,mBARmD;IASnD,uBATqE;IAUrE,mBAVqE;IAWrE,eAXqE;IA0BrE,2B+D7B6B;I/D8B7B,mB+D9B6B;IAC3B,mBAAmB,EAAA;;AAIvB;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,c9DvDgB,EAAA;E8DqDlB;IAOI,kBAAkB;IAClB,c9D1Dc,EAAA;;A8D8DlB;EACE,eAAe,EAAA;;AAGjB;EAhEE;IAmEI,gBAAgB,EAAA;EAzDtB;IA8DI,eAAe,EAAA,EAChB;;AAGH;EAhFA;IAkFI,gBAAgB,EAAA;IA9ElB;MAiFI,gBAAgB,EAAA;EAvEtB;IA4EI,eAAe,EAAA,EAChB;;AAGH;EA9FA;IAgGI,gBAAgB,EAAA;IA5FlB;MA+FI,gBAAgB,EAAA,EACjB;;AAIL;EACE;IACE,0BAA0B,EAAA,EAC3B;;AC5HH,0BAAA;AAGE;EhE0DA,qBAA+B;EAC/B,kBAA4B;EAC5B,iBAA2B;EAC3B,gBAA0B;EAC1B,agE7D4B;EhE8D5B,8BgE9DoC;EhE+DpC,0BgE/DoC;EhEgEpC,sBgEhEoC;EhEiEpC,yBgEjE4C;EhEkE5C,qBgElE4C;EhEmE5C,iBgEnE4C;EhEuE5C,sBAD2D;EAE3D,kBAF2D;EAG3D,cAH2D;EgEpEzD,+BAA+B,EAAA;;AAGjC;EACE,+BAA+B,EAAA;;AAInC;EACE,yBjE2CmB,EAAA;;AiExCrB;EACE,yBAA2C,EAAA;;AAG7C;EACE,wCjEmCmB,EAAA;;AiEhCrB;;EAEE,W/DlBU;E+DmBV,sBAAsB;EhE3BtB,wBgE4BwB;EhE3BxB,qBgE2BwB;EhE1BxB,mBgE0BwB;EhEzBxB,gBgEyBwB;EACxB,wCjE2BmB;EiE1BnB,qBjE0BmB,EAAA;;AiEvBrB;;;;EAIE,W/D7BU;E+D8BV,wCjEkBmB;EiEjBnB,qBjEiBmB,EAAA;;AiEdrB;EACE,W/DnCU;E+DoCV,wCjEYmB;EiEXnB,qBjEWmB,EAAA;;AiERrB;EACE,W/DzCU;E+D0CV,wCjEMmB;EiELnB,qBjEKmB,EAAA;;AiEFrB;EACE,iBAAiB,EAAA;;AA3CnB;EA+CE,gBAAgB,EAAA;;AAGlB;EACE;IhEJA,qBAA+B;IAC/B,kBAA4B;IAC5B,iBAA2B;IAC3B,gBAA0B;IAC1B,agEC4B;IhEA5B,8BgEAoC;IhECpC,0BgEDoC;IhEEpC,sBgEFoC;IhEGpC,yBgEH4C;IhEI5C,qBgEJ4C;IhEK5C,iBgEL4C;IhEoB5C,+BgEnBiC;IhEoBjC,uBgEpBiC,EAAA;EAGjC;IACE,aAAa,EAAA,EACd;;AAGH;EAxEE;IA2EI,iBAAiB,EAAA;EArErB;IAyEI,iBAAiB,EAAA,EAClB;;AAIL;EAtBE;IAwBE,eAAe,EAAA;EAGjB;IACE,iBAAiB,EAAA,EAClB","sourcesContent":["/*\r\nAuthor         : G-axon\r\nTemplate Name  : Jumbo React - Admin Template\r\nVersion        : 1.0\r\n*/\r\n/*=============================================================\r\n    Table of Contents:\r\n    =============================\r\n    A. Globals\r\n        01. Custom Animation\r\n    B. Base\r\n        01. Base Styles\r\n        02. Typography Styles\r\n    C. Layouts\r\n        01. App Layout Styles\r\n        02. Sidebar Styles\r\n        03. Header Styles\r\n        04. Main Content Styles\r\n        05. Footer Styles\r\n        06. Right Sidebar Styles\r\n    D. UI Components\r\n        01. Alert Styles\r\n        02. Avatar Styles\r\n        03. Badges Styles\r\n        04. Blockquotes Styles\r\n        05. Bottom Navigation Styles\r\n        06. Breadcrumb Styles\r\n        07. Button Styles\r\n        08. Button Group Styles\r\n        09. Callout Styles\r\n        10. Cards Styles\r\n        11. Charts Styles\r\n        12. Chips Styles\r\n        13. Carousel Styles\r\n        14. Color Picker Styles\r\n        15. Drawer Styles\r\n        16. E-commerce Styles\r\n        17. Grids List Styles\r\n        18. Icons Styles\r\n        19. Label Styles\r\n        20. List Styles\r\n        21. Nav Style\r\n        22. Pricing Styles\r\n        23. Progressbar Styles\r\n        24. Popover Styles\r\n        25. React Joyride Styles\r\n        26. Tables Styles\r\n        27. Tabs Styles\r\n        28. Testimonial Styles\r\n        29. Time Lines Style\r\n        30. Joyride Tour Styles\r\n        31. Form Styles\r\n    E. Pages\r\n        01. Login Styles\r\n        02. Error Styles\r\n        03. Editor Styles\r\n        04. Contact Page Styles\r\n        05. Portfolio Styles\r\n        06. Faqs Styles\r\n        07. Dashboard Styles\r\n    F. Slider\r\n    G. Modules\r\n        01. App Module Style\r\n        02. Chat Module Styles\r\n        03. Mails Module Styles\r\n        04. Contact Module Styles\r\n        05. Calendar Module Style\r\n  =============================================================*/\r\n//Custom Variables\r\n@import \"global/_global-dir\";\r\n//Custom Files\r\n@import \"base/_base-dir\";\r\n@import \"layout/_layout-dir\";\r\n@import \"ui/_ui-dir\";\r\n@import \"pages/_pages-dir\";\r\n@import \"slider/owl-carousel\";\r\n@import \"module/_module-dir\";","/* Globals\r\n   ========================================================================== */\r\n@import \"variables\";\r\n@import \"mixin\";\r\n@import \"place-holder\";\r\n@import \"sizes\";\r\n@import \"color\";\r\n@import \"custom-animation\";\r\n","//Place Holders\r\n%jr-menu-icon {\r\n  .menu-icon {\r\n    position: relative;\r\n    width: 70%;\r\n    height: 1px;\r\n    min-height: 1px;\r\n    color: inherit;\r\n    background-color: $gray-default;\r\n    display: block;\r\n    @include transition(all 0.4s ease);\r\n    margin: 6px 0;\r\n    cursor: pointer;\r\n\r\n    &:after,\r\n    &:before {\r\n      position: absolute;\r\n      display: block;\r\n      color: inherit;\r\n      background-color: inherit;\r\n      left: 0;\r\n      height: 1px;\r\n      min-height: 1px;\r\n      content: \"\";\r\n      @include transition(all 0.4s ease);\r\n    }\r\n\r\n    &:after {\r\n      width: 120%;\r\n      bottom: -6px;\r\n    }\r\n\r\n    &:before {\r\n      width: 130%;\r\n      top: -6px;\r\n    }\r\n  }\r\n  &:hover {\r\n    & .menu-icon {\r\n      width: 100%;\r\n      &:after,\r\n      &:before {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n%size-50 {\r\n  height: $size-50 !important;\r\n  width: $size-50 !important;\r\n  line-height: $size-50;\r\n}\r\n\r\n%size-60 {\r\n  height: $size-60 !important;\r\n  width: $size-60 !important;\r\n  line-height: $size-60;\r\n}\r\n\r\n%size-80 {\r\n  height: $size-80 !important;\r\n  width: $size-80 !important;\r\n  line-height: $size-80;\r\n}\r\n\r\n%size-100 {\r\n  height: $size-100 !important;\r\n  width: $size-100 !important;\r\n  line-height: $size-100;\r\n}\r\n\r\n%size-20 {\r\n  height: $size-20 !important;\r\n  width: $size-20 !important;\r\n  line-height: $size-20;\r\n}\r\n\r\n\r\n%size-30 {\r\n  height: $size-30 !important;\r\n  width: $size-30 !important;\r\n  line-height: $size-30;\r\n}\r\n\r\n%size-40 {\r\n  height: $size-40 !important;\r\n  width: $size-40 !important;\r\n  line-height: $size-40;\r\n}\r\n\r\n%size-120 {\r\n  height: $size-120 !important;\r\n  width: $size-120 !important;\r\n  line-height: $size-120;\r\n}\r\n\r\n%icon-addon {\r\n  display: inline-block;\r\n  text-align: center;\r\n  background-color: inherit;\r\n}\r\n\r\n%jr-card-style {\r\n  padding: $jr-card-padding;\r\n  margin-bottom: $jr-card-margin;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  border: $jr-border;\r\n  position: relative;\r\n}\r\n\r\n/* Ripple magic */\r\n%ripple-effect {\r\n  position: relative;\r\n  overflow: hidden;\r\n  &:after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 5px;\r\n    height: 5px;\r\n    background: rgba($white, 0.5);\r\n    opacity: 0;\r\n    @include border-radius(100%);\r\n    transform: scale(1, 1) translate(-50%);\r\n    transform-origin: 50% 50%;\r\n  }\r\n\r\n  &:hover:after {\r\n    animation: ripple 1s ease-out;\r\n  }\r\n}\r\n\r\n@keyframes ripple {\r\n  0% {\r\n    transform: scale(0, 0);\r\n    opacity: 0.5;\r\n  }\r\n  20% {\r\n    transform: scale(60, 60);\r\n    opacity: 0.3;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(100, 100);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes ripple {\r\n  0% {\r\n    transform: scale(0, 0);\r\n    opacity: 0.5;\r\n  }\r\n  20% {\r\n    transform: scale(60, 60);\r\n    opacity: 0.3;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(100, 100);\r\n  }\r\n}\r\n\r\n//Pulse Effect\r\n%pulse-effect {\r\n  display: block;\r\n  @include box-shadow (0 0 0 rgba($danger, 0.4));\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@-webkit-keyframes pulse {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($danger, 0.4);\r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 10px rgba($danger, 0);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($danger, 0);\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($danger, 0.4);\r\n    box-shadow: 0 0 0 0 rgba($danger, 0.4);\r\n  }\r\n  70% {\r\n    -moz-box-shadow: 0 0 0 10px rgba($danger, 0);\r\n    box-shadow: 0 0 0 10px rgba($danger, 0);\r\n  }\r\n  100% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($danger, 0);\r\n    box-shadow: 0 0 0 0 rgba($danger, 0);\r\n  }\r\n}\r\n\r\n//Online Effect\r\n%online-effect {\r\n  display: block;\r\n  @include box-shadow (0 0 0 rgba($green, 0.4));\r\n  animation: online 2s infinite;\r\n}\r\n\r\n@-webkit-keyframes online {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($green, 0.4);\r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 10px rgba($green, 0);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($green, 0);\r\n  }\r\n}\r\n\r\n@keyframes online {\r\n  0% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($green, 0.4);\r\n    box-shadow: 0 0 0 0 rgba($green, 0.4);\r\n  }\r\n  70% {\r\n    -moz-box-shadow: 0 0 0 10px rgba($green, 0);\r\n    box-shadow: 0 0 0 10px rgba($green, 0);\r\n  }\r\n  100% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($green, 0);\r\n    box-shadow: 0 0 0 0 rgba($green, 0);\r\n  }\r\n}\r\n\r\n//Away Effect\r\n%away-effect {\r\n  display: block;\r\n  @include box-shadow (0 0 0 rgba($yellow, 0.4));\r\n  animation: away 2s infinite;\r\n}\r\n\r\n@-webkit-keyframes away {\r\n  0% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($yellow, 0.4);\r\n  }\r\n  70% {\r\n    -webkit-box-shadow: 0 0 0 10px rgba($yellow, 0);\r\n  }\r\n  100% {\r\n    -webkit-box-shadow: 0 0 0 0 rgba($yellow, 0);\r\n  }\r\n}\r\n\r\n@keyframes away {\r\n  0% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($yellow, 0.4);\r\n    box-shadow: 0 0 0 0 rgba($yellow, 0.4);\r\n  }\r\n  70% {\r\n    -moz-box-shadow: 0 0 0 10px rgba($yellow, 0);\r\n    box-shadow: 0 0 0 10px rgba($yellow, 0);\r\n  }\r\n  100% {\r\n    -moz-box-shadow: 0 0 0 0 rgba($yellow, 0);\r\n    box-shadow: 0 0 0 0 rgba($yellow, 0);\r\n  }\r\n}\r\n\r\n/*Different size images set in Equal block height and width*/\r\n%thumb-equal {\r\n  position: relative;\r\n  padding-bottom: 68%;\r\n  height: 0;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n%thumb-cover {\r\n  display: block;\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n%thumb-cover-img {\r\n  height: auto;\r\n  max-width: 100%;\r\n  min-height: 100%;\r\n  object-fit: cover;\r\n  width: 100%;\r\n}\r\n\r\n// Hover Effect On Bootstrap Components\r\n%link-hover {\r\n  color: $white !important;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    color: $white !important;\r\n  }\r\n}\r\n\r\n// Pointer\r\n%pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n//Remove Botton Shadow\r\n\r\n%btn-no-shadow {\r\n  &:not([disabled]):not(.disabled):active,\r\n  &:not([disabled]):not(.disabled).active {\r\n    background-image: none;\r\n    @include box-shadow(none);\r\n\r\n    &:focus {\r\n      @include box-shadow(none);\r\n    }\r\n  }\r\n}","@import \"../bootstrap/functions\";\r\n@import \"../bootstrap/variables\";\r\n@import \"../bootstrap/mixins\";\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n// @import url('https://fonts.googleapis.com/css?family=Nunito+Sans:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i');\r\n@import url(\"https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n\r\n//# sourceMappingURL=roboto.css.map\r\n\r\n// import material icons\r\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: 'Roboto', sans-serif;\r\n$font-family-base: $font-family-sans-serif;\r\n\r\n// stylelint-enable value-keyword-case\r\n$font-size-base: 13px; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base + 4);\r\n$font-size-sm: $font-size-base;\r\n\r\n$h1-font-size: 24px;\r\n$h2-font-size: 18px;\r\n$h3-font-size: 16px;\r\n$h4-font-size: 15px;\r\n$h5-font-size: 13px;\r\n$h6-font-size: 12px;\r\n\r\n$headings-margin-bottom: ($h1-font-size / 2);\r\n$headings-font-family: inherit;\r\n$headings-font-weight: 400;\r\n$headings-line-height: 1.2;\r\n$headings-color: inherit;\r\n\r\n//Border Radius\r\n$border-radius-sm: 2px;\r\n$border-radius: 4px;\r\n$border-radius-lg: 8px;\r\n$border-radius-xl: 10px !default;\r\n$border-radius-circle: 50% !default;\r\n\r\n//Bootstrap Card Variables\r\n$card-spacer-y: 24px;\r\n$card-spacer-x: 30px;\r\n$card-border-color: $border-color;\r\n$card-border-radius: $border-radius-lg;\r\n$card-inner-border-radius: $border-radius-lg;\r\n$list-group-border-radius: $border-radius-lg;\r\n\r\n//Grid Gutter Space Between\r\n$grid-gutter-width: 34px;\r\n\r\n//Mixin Values True and False\r\n$enable-shadows: true;\r\n\r\n$app-primary: #3f51b5 !default;\r\n$primary: $app-primary;\r\n$secondary: #E91E63;\r\n$gray-default: #808080 !default;\r\n\r\n$sidebar-bg: #f5f7f9 !default;\r\n$sidebar-text-color: #868e96 !default;\r\n$sidebar-bg-darken: darken($sidebar-bg, 3%);\r\n$sidebar-hover-color: $app-primary;\r\n\r\n$top-nav-bg: $app-primary !default;\r\n\r\n//Default shadow\r\n$shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\r\n$shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);\r\n$shadow-lg: 0 1px 8px -1px rgba(0, 0, 0, 0.20);\r\n$shadow-xl: 0 0 16px 0px rgba(0, 0, 0, 0.20);\r\n$avatar-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.50);\r\n\r\n//Custom Card Variables\r\n$jr-card-shadow: $shadow !default;\r\n$jr-card-margin: 34px !default;\r\n$jr-card-padding: 24px 30px !default;\r\n$jr-border: 1px solid $gray-400 !default;\r\n\r\n// Links\r\n$link-color: $app-primary;\r\n$link-hover-color: darken($app-primary, 10%);\r\n\r\n//Color Variables\r\n$success: #4caf50;\r\n$info: #00bcd4;\r\n$warning: #ff9800;\r\n$danger: #f44336;\r\n$light: #e8eaf6;\r\n$dark: $gray-800;\r\n$body-bg: #fff;\r\n$body-color: #5c5c5c;\r\n\r\n$theme-colors: (\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n);\r\n\r\n//Default Image Location\r\n$image_path: \"../assets/images\" !default;\r\n\r\n// Motion\r\n// https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves\r\n$transition-bezier: .05, .74, .27, .99 !default; // for nav, quickview\r\n\r\n$transition-ease: cubic-bezier(0.4, 0.0, 0.2, 1) !default;\r\n$transition-ease-out: cubic-bezier(0.0, 0.0, 0.2, 1) !default;\r\n$transition-ease-in: cubic-bezier(0.4, 0.0, 1, 1) !default;\r\n\r\n//Side Nav Width\r\n$side-nav-width: 200px !default;\r\n$mini-drawer-width: 80px !default;\r\n\r\n//App Bar Height\r\n$app-bar-height: 60px !default;\r\n\r\n//Footer Height\r\n$footer-height: 50px !default;\r\n\r\n//latter Spacing variables\r\n$letter-spacing-base: 3px !default;\r\n$letter-spacing-lg: 6px !default;\r\n$letter-spacing-xl: 8px !default;\r\n\r\n//Button Variables\r\n$btn-font-size-lg: $font-size-lg !default;\r\n$btn-font-size: $font-size-base !default;\r\n$btn-font-size-sm: $font-size-sm !default;\r\n$btn-font-size-xs: 10px !default;\r\n\r\n$btn-padding-lg: 16px 24px !default;\r\n$btn-padding: 12px 20px !default;\r\n$btn-padding-sm: 8px 15px !default;\r\n$btn-padding-xs: 6px 10px !default;\r\n\r\n$btn-fab-size-lg: 70px !default;\r\n$btn-fab-size-sm: 46px !default;\r\n$btn-fab-size-xs: 40px !default;\r\n\r\n$btn-line-height: 1.2;\r\n\r\n//Sizes Variables\r\n\r\n$size-20: 20px !default;\r\n$size-30: 30px !default;\r\n$size-40: 40px !default;\r\n$size-50: 50px !default;\r\n$size-60: 60px !default;\r\n$size-80: 80px !default;\r\n$size-100: 100px !default;\r\n$size-120: 120px !default;","// Box Shadow\r\n@mixin box-shadow($shadow...) {\r\n  -webkit-box-shadow: $shadow;\r\n  -moz-box-shadow: $shadow;\r\n  -o-box-shadow: $shadow;\r\n  box-shadow: $shadow;\r\n}\r\n\r\n// Single side border-radius\r\n@mixin border-radius($radius...) {\r\n  -webkit-border-radius: $radius;\r\n  -moz-border-radius: $radius;\r\n  border-radius: $radius;\r\n}\r\n\r\n// Single side box-sizing\r\n@mixin box-sizing($box-sizing) {\r\n  -webkit-box-sizing: $box-sizing;\r\n  -moz-box-sizing: $box-sizing;\r\n  box-sizing: $box-sizing;\r\n}\r\n\r\n// Clearfix\r\n\r\n@mixin clearfix() {\r\n  &:before,\r\n  &:after {\r\n    content: \" \"; // 1\r\n    display: table; // 2\r\n  }\r\n  &:after {\r\n    clear: both;\r\n  }\r\n}\r\n\r\n// Transitions\r\n@mixin transition($transition...) {\r\n  -webkit-transition: $transition;\r\n  -o-transition: $transition;\r\n  transition: $transition;\r\n}\r\n\r\n@mixin rotate($degrees) {\r\n  -webkit-transform: rotate($degrees);\r\n  -ms-transform: rotate($degrees); // IE9 only\r\n  -o-transform: rotate($degrees);\r\n  transform: rotate($degrees);\r\n}\r\n\r\n//Background Image\r\n@mixin background($imgpath,$position:0 0,$repeat: no-repeat,$size: cover) {\r\n  background: {\r\n    image: url($imgpath);\r\n    position: $position;\r\n    repeat: $repeat;\r\n    size: $size;\r\n  }\r\n}\r\n\r\n// Flex\r\n@mixin display-flex($flex: flex, $flex-direction: row, $flex-wrap: wrap) {\r\n  display: #{'-webkit'}-#{$flex};\r\n  display: #{'-moz'}-#{$flex};\r\n  display: #{'-ms'}-#{$flex};\r\n  display: #{'-o'}-#{$flex};\r\n  display: $flex;\r\n  -webkit-flex-direction: $flex-direction;\r\n  -ms-flex-direction: $flex-direction;\r\n  flex-direction: $flex-direction;\r\n  -webkit-flex-wrap: $flex-wrap;\r\n  -ms-flex-wrap: $flex-wrap;\r\n  flex-wrap: $flex-wrap;\r\n}\r\n\r\n@mixin flex($flex-grow: 1, $flex-shrink: 1, $flex-basis: auto) {\r\n  -webkit-flex: $flex-grow $flex-shrink $flex-basis;\r\n  -ms-flex: $flex-grow $flex-shrink $flex-basis;\r\n  flex: $flex-grow $flex-shrink $flex-basis;\r\n}\r\n\r\n@mixin justify-content($justify-content) {\r\n  -webkit-justify-content: $justify-content;\r\n  justify-content: $justify-content;\r\n}\r\n\r\n@mixin align-items($align-items) {\r\n  -webkit-align-items: $align-items;\r\n  align-items: $align-items;\r\n}\r\n\r\n//Border Radius\r\n\r\n// Single side border-radius\r\n\r\n@mixin border-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-top-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-top-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-right-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-right-radius: $radius;\r\n    border-bottom-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-bottom-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-bottom-right-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-left-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n\r\n//Mixin Hover\r\n\r\n// stylelint-disable indentation\r\n@mixin hover {\r\n  // TODO: re-enable along with mq4-hover-shim\r\n  //  @if $enable-hover-media-query {\r\n  //    // See Media Queries Level 4: https://drafts.csswg.org/mediaqueries/#hover\r\n  //    // Currently shimmed by https://github.com/twbs/mq4-hover-shim\r\n  //    @media (hover: hover) {\r\n  //      &:hover { @content }\r\n  //    }\r\n  //  }\r\n  //  @else {\r\n  &:hover {\r\n    @content;\r\n  }\r\n  //  }\r\n}\r\n\r\n@mixin hover-focus {\r\n  @if $enable-hover-media-query {\r\n    &:focus {\r\n      @content;\r\n    }\r\n    @include hover {\r\n      @content;\r\n    }\r\n  } @else {\r\n    &:focus,\r\n    &:hover {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin plain-hover-focus {\r\n  @if $enable-hover-media-query {\r\n    &,\r\n    &:focus {\r\n      @content;\r\n    }\r\n    @include hover {\r\n      @content;\r\n    }\r\n  } @else {\r\n    &,\r\n    &:focus,\r\n    &:hover {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin hover-focus-active {\r\n  @if $enable-hover-media-query {\r\n    &:focus,\r\n    &:active {\r\n      @content;\r\n    }\r\n    @include hover {\r\n      @content;\r\n    }\r\n  } @else {\r\n    &:focus,\r\n    &:active,\r\n    &:hover {\r\n      @content;\r\n    }\r\n  }\r\n}","// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n//\r\n// Color system\r\n//\r\n\r\n// stylelint-disable\r\n$white: #fff !default;\r\n$gray-100: #f8f9fa !default;\r\n$gray-200: #e9ecef !default;\r\n$gray-300: #dee2e6 !default;\r\n$gray-400: #ced4da !default;\r\n$gray-500: #adb5bd !default;\r\n$gray-600: #6c757d !default;\r\n$gray-700: #495057 !default;\r\n$gray-800: #343a40 !default;\r\n$gray-900: #212529 !default;\r\n$black: #000 !default;\r\n\r\n$grays: () !default;\r\n$grays: map-merge((\r\n        \"100\": $gray-100,\r\n        \"200\": $gray-200,\r\n        \"300\": $gray-300,\r\n        \"400\": $gray-400,\r\n        \"500\": $gray-500,\r\n        \"600\": $gray-600,\r\n        \"700\": $gray-700,\r\n        \"800\": $gray-800,\r\n        \"900\": $gray-900\r\n), $grays);\r\n\r\n$blue: #007bff !default;\r\n$indigo: #6610f2 !default;\r\n$purple: #6f42c1 !default;\r\n$pink: #e83e8c !default;\r\n$red: #dc3545 !default;\r\n$orange: #fd7e14 !default;\r\n$yellow: #ffc107 !default;\r\n$green: #28a745 !default;\r\n$teal: #20c997 !default;\r\n$cyan: #17a2b8 !default;\r\n\r\n$colors: () !default;\r\n$colors: map-merge((\r\n        \"blue\": $blue,\r\n        \"indigo\": $indigo,\r\n        \"purple\": $purple,\r\n        \"pink\": $pink,\r\n        \"red\": $red,\r\n        \"orange\": $orange,\r\n        \"yellow\": $yellow,\r\n        \"green\": $green,\r\n        \"teal\": $teal,\r\n        \"cyan\": $cyan,\r\n        \"white\": $white,\r\n        \"gray\": $gray-600,\r\n        \"gray-dark\": $gray-800\r\n), $colors);\r\n\r\n$primary: $blue !default;\r\n$secondary: $gray-600 !default;\r\n$success: $green !default;\r\n$info: $cyan !default;\r\n$warning: $yellow !default;\r\n$danger: $red !default;\r\n$light: $gray-100 !default;\r\n$dark: $gray-800 !default;\r\n\r\n$theme-colors: () !default;\r\n$theme-colors: map-merge((\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n), $theme-colors);\r\n// stylelint-enable\r\n\r\n// Set a specific jump point for requesting color jumps\r\n$theme-color-interval: 8% !default;\r\n\r\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\r\n$yiq-contrasted-threshold: 150 !default;\r\n\r\n// Customize the light and dark text colors for use in our YIQ color contrast function.\r\n$yiq-text-dark: $gray-900 !default;\r\n$yiq-text-light: $white !default;\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret: true !default;\r\n$enable-rounded: true !default;\r\n$enable-shadows: false !default;\r\n$enable-gradients: false !default;\r\n$enable-transitions: true !default;\r\n$enable-hover-media-query: false !default; // Deprecated, no longer affects any compiled CSS\r\n$enable-grid-classes: true !default;\r\n$enable-print-styles: true !default;\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n// stylelint-disable\r\n$spacer: 1rem !default;\r\n$spacers: () !default;\r\n$spacers: map-merge((\r\n        0: 0,\r\n        1: ($spacer * .25),\r\n        2: ($spacer * .5),\r\n        3: $spacer,\r\n        4: ($spacer * 1.5),\r\n        5: ($spacer * 3)\r\n), $spacers);\r\n\r\n// This variable affects the `.h-*` and `.w-*` classes.\r\n$sizes: () !default;\r\n$sizes: map-merge((\r\n        25: 25%,\r\n        50: 50%,\r\n        75: 75%,\r\n        100: 100%\r\n), $sizes);\r\n// stylelint-enable\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg: $white !default;\r\n$body-color: $gray-900 !default;\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color: theme-color(\"primary\") !default;\r\n$link-decoration: none !default;\r\n$link-hover-color: darken($link-color, 15%) !default;\r\n$link-hover-decoration: underline !default;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom: 1rem !default;\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n$grid-breakpoints: (\r\n        xs: 0,\r\n        sm: 576px,\r\n        md: 768px,\r\n        lg: 992px,\r\n        xl: 1200px\r\n) !default;\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints);\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n$container-max-widths: (\r\n        sm: 540px,\r\n        md: 720px,\r\n        lg: 960px,\r\n        xl: 1140px\r\n) !default;\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns: 12 !default;\r\n$grid-gutter-width: 30px !default;\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n$line-height-lg: 1.5 !default;\r\n$line-height-sm: 1.5 !default;\r\n\r\n$border-width: 1px !default;\r\n$border-color: $gray-300 !default;\r\n\r\n$border-radius: .25rem !default;\r\n$border-radius-lg: .3rem !default;\r\n$border-radius-sm: .2rem !default;\r\n\r\n$component-active-color: $white !default;\r\n$component-active-bg: theme-color(\"primary\") !default;\r\n\r\n$caret-width: .3em !default;\r\n\r\n$transition-base: all .2s ease-in-out !default;\r\n$transition-fade: opacity .15s linear !default;\r\n$transition-collapse: height .35s ease !default;\r\n\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !default;\r\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\r\n$font-family-base: $font-family-sans-serif !default;\r\n// stylelint-enable value-keyword-case\r\n\r\n$font-size-base: 1rem !default; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base * 1.25) !default;\r\n$font-size-sm: ($font-size-base * .875) !default;\r\n\r\n$font-weight-light: 300 !default;\r\n$font-weight-normal: 400 !default;\r\n$font-weight-bold: 700 !default;\r\n\r\n$font-weight-base: $font-weight-normal !default;\r\n$line-height-base: 1.5 !default;\r\n\r\n$h1-font-size: $font-size-base * 2.5 !default;\r\n$h2-font-size: $font-size-base * 2 !default;\r\n$h3-font-size: $font-size-base * 1.75 !default;\r\n$h4-font-size: $font-size-base * 1.5 !default;\r\n$h5-font-size: $font-size-base * 1.25 !default;\r\n$h6-font-size: $font-size-base !default;\r\n\r\n$headings-margin-bottom: ($spacer / 2) !default;\r\n$headings-font-family: inherit !default;\r\n$headings-font-weight: 500 !default;\r\n$headings-line-height: 1.2 !default;\r\n$headings-color: inherit !default;\r\n\r\n$display1-size: 6rem !default;\r\n$display2-size: 5.5rem !default;\r\n$display3-size: 4.5rem !default;\r\n$display4-size: 3.5rem !default;\r\n\r\n$display1-weight: 300 !default;\r\n$display2-weight: 300 !default;\r\n$display3-weight: 300 !default;\r\n$display4-weight: 300 !default;\r\n$display-line-height: $headings-line-height !default;\r\n\r\n$lead-font-size: ($font-size-base * 1.25) !default;\r\n$lead-font-weight: 300 !default;\r\n\r\n$small-font-size: 80% !default;\r\n\r\n$text-muted: $gray-600 !default;\r\n\r\n$blockquote-small-color: $gray-600 !default;\r\n$blockquote-font-size: ($font-size-base * 1.25) !default;\r\n\r\n$hr-border-color: rgba($black, .1) !default;\r\n$hr-border-width: $border-width !default;\r\n\r\n$mark-padding: .2em !default;\r\n\r\n$dt-font-weight: $font-weight-bold !default;\r\n\r\n$kbd-box-shadow: inset 0 -.1rem 0 rgba($black, .25) !default;\r\n$nested-kbd-font-weight: $font-weight-bold !default;\r\n\r\n$list-inline-padding: .5rem !default;\r\n\r\n$mark-bg: #fcf8e3 !default;\r\n\r\n$hr-margin-y: $spacer !default;\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n$table-cell-padding: .75rem !default;\r\n$table-cell-padding-sm: .3rem !default;\r\n\r\n$table-bg: transparent !default;\r\n$table-accent-bg: rgba($black, .05) !default;\r\n$table-hover-bg: rgba($black, .075) !default;\r\n$table-active-bg: $table-hover-bg !default;\r\n\r\n$table-border-width: $border-width !default;\r\n$table-border-color: $gray-300 !default;\r\n\r\n$table-head-bg: $gray-200 !default;\r\n$table-head-color: $gray-700 !default;\r\n\r\n$table-dark-bg: $gray-900 !default;\r\n$table-dark-accent-bg: rgba($white, .05) !default;\r\n$table-dark-hover-bg: rgba($white, .075) !default;\r\n$table-dark-border-color: lighten($gray-900, 7.5%) !default;\r\n$table-dark-color: $body-bg !default;\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n$input-btn-padding-y: .375rem !default;\r\n$input-btn-padding-x: .75rem !default;\r\n$input-btn-line-height: $line-height-base !default;\r\n\r\n$input-btn-focus-width: .2rem !default;\r\n$input-btn-focus-color: rgba($component-active-bg, .25) !default;\r\n$input-btn-focus-box-shadow: 0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\r\n\r\n$input-btn-padding-y-sm: .25rem !default;\r\n$input-btn-padding-x-sm: .5rem !default;\r\n$input-btn-line-height-sm: $line-height-sm !default;\r\n\r\n$input-btn-padding-y-lg: .5rem !default;\r\n$input-btn-padding-x-lg: 1rem !default;\r\n$input-btn-line-height-lg: $line-height-lg !default;\r\n\r\n$input-btn-border-width: $border-width !default;\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n$btn-padding-y: $input-btn-padding-y !default;\r\n$btn-padding-x: $input-btn-padding-x !default;\r\n$btn-line-height: $input-btn-line-height !default;\r\n\r\n$btn-padding-y-sm: $input-btn-padding-y-sm !default;\r\n$btn-padding-x-sm: $input-btn-padding-x-sm !default;\r\n$btn-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$btn-padding-y-lg: $input-btn-padding-y-lg !default;\r\n$btn-padding-x-lg: $input-btn-padding-x-lg !default;\r\n$btn-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$btn-border-width: $input-btn-border-width !default;\r\n\r\n$btn-font-weight: $font-weight-normal !default;\r\n$btn-box-shadow: inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\r\n$btn-focus-width: $input-btn-focus-width !default;\r\n$btn-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n$btn-disabled-opacity: .65 !default;\r\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, .125) !default;\r\n\r\n$btn-link-disabled-color: $gray-600 !default;\r\n\r\n$btn-block-spacing-y: .5rem !default;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius: $border-radius !default;\r\n$btn-border-radius-lg: $border-radius-lg !default;\r\n$btn-border-radius-sm: $border-radius-sm !default;\r\n\r\n$btn-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n// Forms\r\n\r\n$input-padding-y: $input-btn-padding-y !default;\r\n$input-padding-x: $input-btn-padding-x !default;\r\n$input-line-height: $input-btn-line-height !default;\r\n\r\n$input-padding-y-sm: $input-btn-padding-y-sm !default;\r\n$input-padding-x-sm: $input-btn-padding-x-sm !default;\r\n$input-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$input-padding-y-lg: $input-btn-padding-y-lg !default;\r\n$input-padding-x-lg: $input-btn-padding-x-lg !default;\r\n$input-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$input-bg: $white !default;\r\n$input-disabled-bg: $gray-200 !default;\r\n\r\n$input-color: $gray-700 !default;\r\n$input-border-color: $gray-400 !default;\r\n$input-border-width: $input-btn-border-width !default;\r\n$input-box-shadow: inset 0 1px 1px rgba($black, .075) !default;\r\n\r\n$input-border-radius: $border-radius !default;\r\n$input-border-radius-lg: $border-radius-lg !default;\r\n$input-border-radius-sm: $border-radius-sm !default;\r\n\r\n$input-focus-bg: $input-bg !default;\r\n$input-focus-border-color: lighten($component-active-bg, 25%) !default;\r\n$input-focus-color: $input-color !default;\r\n$input-focus-width: $input-btn-focus-width !default;\r\n$input-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$input-placeholder-color: $gray-600 !default;\r\n\r\n$input-height-border: $input-border-width * 2 !default;\r\n\r\n$input-height-inner: ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\r\n$input-height: calc(#{$input-height-inner} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-sm: ($font-size-sm * $input-btn-line-height-sm) + ($input-btn-padding-y-sm * 2) !default;\r\n$input-height-sm: calc(#{$input-height-inner-sm} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-lg: ($font-size-lg * $input-btn-line-height-lg) + ($input-btn-padding-y-lg * 2) !default;\r\n$input-height-lg: calc(#{$input-height-inner-lg} + #{$input-height-border}) !default;\r\n\r\n$input-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n$form-text-margin-top: .25rem !default;\r\n\r\n$form-check-input-gutter: 1.25rem !default;\r\n$form-check-input-margin-y: .3rem !default;\r\n$form-check-input-margin-x: .25rem !default;\r\n\r\n$form-check-inline-margin-x: .75rem !default;\r\n$form-check-inline-input-margin-x: .3125rem !default;\r\n\r\n$form-group-margin-bottom: 1rem !default;\r\n\r\n$input-group-addon-color: $input-color !default;\r\n$input-group-addon-bg: $gray-200 !default;\r\n$input-group-addon-border-color: $input-border-color !default;\r\n\r\n$custom-control-gutter: 1.5rem !default;\r\n$custom-control-spacer-x: 1rem !default;\r\n\r\n$custom-control-indicator-size: 1rem !default;\r\n$custom-control-indicator-bg: $gray-300 !default;\r\n$custom-control-indicator-bg-size: 50% 50% !default;\r\n$custom-control-indicator-box-shadow: inset 0 .25rem .25rem rgba($black, .1) !default;\r\n\r\n$custom-control-indicator-disabled-bg: $gray-200 !default;\r\n$custom-control-label-disabled-color: $gray-600 !default;\r\n\r\n$custom-control-indicator-checked-color: $component-active-color !default;\r\n$custom-control-indicator-checked-bg: $component-active-bg !default;\r\n$custom-control-indicator-checked-disabled-bg: rgba(theme-color(\"primary\"), .5) !default;\r\n$custom-control-indicator-checked-box-shadow: none !default;\r\n\r\n$custom-control-indicator-focus-box-shadow: 0 0 0 1px $body-bg, $input-btn-focus-box-shadow !default;\r\n\r\n$custom-control-indicator-active-color: $component-active-color !default;\r\n$custom-control-indicator-active-bg: lighten($component-active-bg, 35%) !default;\r\n$custom-control-indicator-active-box-shadow: none !default;\r\n\r\n$custom-checkbox-indicator-border-radius: $border-radius !default;\r\n$custom-checkbox-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-checkbox-indicator-indeterminate-bg: $component-active-bg !default;\r\n$custom-checkbox-indicator-indeterminate-color: $custom-control-indicator-checked-color !default;\r\n$custom-checkbox-indicator-icon-indeterminate: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-checkbox-indicator-indeterminate-box-shadow: none !default;\r\n\r\n$custom-radio-indicator-border-radius: 50% !default;\r\n$custom-radio-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='#{$custom-control-indicator-checked-color}'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-select-padding-y: .375rem !default;\r\n$custom-select-padding-x: .75rem !default;\r\n$custom-select-height: $input-height !default;\r\n$custom-select-indicator-padding: 1rem !default; // Extra padding to account for the presence of the background-image based indicator\r\n$custom-select-line-height: $input-btn-line-height !default;\r\n$custom-select-color: $input-color !default;\r\n$custom-select-disabled-color: $gray-600 !default;\r\n$custom-select-bg: $white !default;\r\n$custom-select-disabled-bg: $gray-200 !default;\r\n$custom-select-bg-size: 8px 10px !default; // In pixels because image dimensions\r\n$custom-select-indicator-color: $gray-800 !default;\r\n$custom-select-indicator: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-select-border-width: $input-btn-border-width !default;\r\n$custom-select-border-color: $input-border-color !default;\r\n$custom-select-border-radius: $border-radius !default;\r\n\r\n$custom-select-focus-border-color: $input-focus-border-color !default;\r\n$custom-select-focus-box-shadow: inset 0 1px 2px rgba($black, .075), 0 0 5px rgba($custom-select-focus-border-color, .5) !default;\r\n\r\n$custom-select-font-size-sm: 75% !default;\r\n$custom-select-height-sm: $input-height-sm !default;\r\n\r\n$custom-select-font-size-lg: 125% !default;\r\n$custom-select-height-lg: $input-height-lg !default;\r\n\r\n$custom-file-height: $input-height !default;\r\n$custom-file-focus-border-color: $input-focus-border-color !default;\r\n$custom-file-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$custom-file-padding-y: $input-btn-padding-y !default;\r\n$custom-file-padding-x: $input-btn-padding-x !default;\r\n$custom-file-line-height: $input-btn-line-height !default;\r\n$custom-file-color: $input-color !default;\r\n$custom-file-bg: $input-bg !default;\r\n$custom-file-border-width: $input-btn-border-width !default;\r\n$custom-file-border-color: $input-border-color !default;\r\n$custom-file-border-radius: $input-border-radius !default;\r\n$custom-file-box-shadow: $input-box-shadow !default;\r\n$custom-file-button-color: $custom-file-color !default;\r\n$custom-file-button-bg: $input-group-addon-bg !default;\r\n$custom-file-text: (\r\n        en: \"Browse\"\r\n) !default;\r\n\r\n// Form validation\r\n$form-feedback-margin-top: $form-text-margin-top !default;\r\n$form-feedback-font-size: $small-font-size !default;\r\n$form-feedback-valid-color: theme-color(\"success\") !default;\r\n$form-feedback-invalid-color: theme-color(\"danger\") !default;\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n$dropdown-min-width: 10rem !default;\r\n$dropdown-padding-y: .5rem !default;\r\n$dropdown-spacer: .125rem !default;\r\n$dropdown-bg: $white !default;\r\n$dropdown-border-color: rgba($black, .15) !default;\r\n$dropdown-border-radius: $border-radius !default;\r\n$dropdown-border-width: $border-width !default;\r\n$dropdown-divider-bg: $gray-200 !default;\r\n$dropdown-box-shadow: 0 .5rem 1rem rgba($black, .175) !default;\r\n\r\n$dropdown-link-color: $gray-900 !default;\r\n$dropdown-link-hover-color: darken($gray-900, 5%) !default;\r\n$dropdown-link-hover-bg: $gray-100 !default;\r\n\r\n$dropdown-link-active-color: $component-active-color !default;\r\n$dropdown-link-active-bg: $component-active-bg !default;\r\n\r\n$dropdown-link-disabled-color: $gray-600 !default;\r\n\r\n$dropdown-item-padding-y: .25rem !default;\r\n$dropdown-item-padding-x: 1.5rem !default;\r\n\r\n$dropdown-header-color: $gray-600 !default;\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n$zindex-dropdown: 1000 !default;\r\n$zindex-sticky: 1020 !default;\r\n$zindex-fixed: 1030 !default;\r\n$zindex-modal-backdrop: 1040 !default;\r\n$zindex-modal: 1050 !default;\r\n$zindex-popover: 1060 !default;\r\n$zindex-tooltip: 1070 !default;\r\n\r\n// Navs\r\n\r\n$nav-link-padding-y: .5rem !default;\r\n$nav-link-padding-x: 1rem !default;\r\n$nav-link-disabled-color: $gray-600 !default;\r\n\r\n$nav-tabs-border-color: $gray-300 !default;\r\n$nav-tabs-border-width: $border-width !default;\r\n$nav-tabs-border-radius: $border-radius !default;\r\n$nav-tabs-link-hover-border-color: $gray-200 $gray-200 $nav-tabs-border-color !default;\r\n$nav-tabs-link-active-color: $gray-700 !default;\r\n$nav-tabs-link-active-bg: $body-bg !default;\r\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\r\n\r\n$nav-pills-border-radius: $border-radius !default;\r\n$nav-pills-link-active-color: $component-active-color !default;\r\n$nav-pills-link-active-bg: $component-active-bg !default;\r\n\r\n// Navbar\r\n\r\n$navbar-padding-y: ($spacer / 2) !default;\r\n$navbar-padding-x: $spacer !default;\r\n\r\n$navbar-nav-link-padding-x: .5rem !default;\r\n\r\n$navbar-brand-font-size: $font-size-lg !default;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height: ($font-size-base * $line-height-base + $nav-link-padding-y * 2) !default;\r\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base !default;\r\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) / 2 !default;\r\n\r\n$navbar-toggler-padding-y: .25rem !default;\r\n$navbar-toggler-padding-x: .75rem !default;\r\n$navbar-toggler-font-size: $font-size-lg !default;\r\n$navbar-toggler-border-radius: $btn-border-radius !default;\r\n\r\n$navbar-dark-color: rgba($white, .5) !default;\r\n$navbar-dark-hover-color: rgba($white, .75) !default;\r\n$navbar-dark-active-color: $white !default;\r\n$navbar-dark-disabled-color: rgba($white, .25) !default;\r\n$navbar-dark-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-dark-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-dark-toggler-border-color: rgba($white, .1) !default;\r\n\r\n$navbar-light-color: rgba($black, .5) !default;\r\n$navbar-light-hover-color: rgba($black, .7) !default;\r\n$navbar-light-active-color: rgba($black, .9) !default;\r\n$navbar-light-disabled-color: rgba($black, .3) !default;\r\n$navbar-light-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\r\n\r\n// Pagination\r\n\r\n$pagination-padding-y: .5rem !default;\r\n$pagination-padding-x: .75rem !default;\r\n$pagination-padding-y-sm: .25rem !default;\r\n$pagination-padding-x-sm: .5rem !default;\r\n$pagination-padding-y-lg: .75rem !default;\r\n$pagination-padding-x-lg: 1.5rem !default;\r\n$pagination-line-height: 1.25 !default;\r\n\r\n$pagination-color: $link-color !default;\r\n$pagination-bg: $white !default;\r\n$pagination-border-width: $border-width !default;\r\n$pagination-border-color: $gray-300 !default;\r\n\r\n$pagination-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$pagination-hover-color: $link-hover-color !default;\r\n$pagination-hover-bg: $gray-200 !default;\r\n$pagination-hover-border-color: $gray-300 !default;\r\n\r\n$pagination-active-color: $component-active-color !default;\r\n$pagination-active-bg: $component-active-bg !default;\r\n$pagination-active-border-color: $pagination-active-bg !default;\r\n\r\n$pagination-disabled-color: $gray-600 !default;\r\n$pagination-disabled-bg: $white !default;\r\n$pagination-disabled-border-color: $gray-300 !default;\r\n\r\n// Jumbotron\r\n\r\n$jumbotron-padding: 2rem !default;\r\n$jumbotron-bg: $gray-200 !default;\r\n\r\n// Cards\r\n\r\n$card-spacer-y: .75rem !default;\r\n$card-spacer-x: 1.25rem !default;\r\n$card-border-width: $border-width !default;\r\n$card-border-radius: $border-radius !default;\r\n$card-border-color: rgba($black, .125) !default;\r\n$card-inner-border-radius: calc(#{$card-border-radius} - #{$card-border-width}) !default;\r\n$card-cap-bg: rgba($black, .03) !default;\r\n$card-bg: $white !default;\r\n\r\n$card-img-overlay-padding: 1.25rem !default;\r\n\r\n$card-group-margin: ($grid-gutter-width / 2) !default;\r\n$card-deck-margin: $card-group-margin !default;\r\n\r\n$card-columns-count: 3 !default;\r\n$card-columns-gap: 1.25rem !default;\r\n$card-columns-margin: $card-spacer-y !default;\r\n\r\n// Tooltips\r\n\r\n$tooltip-font-size: $font-size-sm !default;\r\n$tooltip-max-width: 200px !default;\r\n$tooltip-color: $white !default;\r\n$tooltip-bg: $black !default;\r\n$tooltip-border-radius: $border-radius !default;\r\n$tooltip-opacity: .9 !default;\r\n$tooltip-padding-y: .25rem !default;\r\n$tooltip-padding-x: .5rem !default;\r\n$tooltip-margin: 0 !default;\r\n\r\n$tooltip-arrow-width: .8rem !default;\r\n$tooltip-arrow-height: .4rem !default;\r\n$tooltip-arrow-color: $tooltip-bg !default;\r\n\r\n// Popovers\r\n\r\n$popover-font-size: $font-size-sm !default;\r\n$popover-bg: $white !default;\r\n$popover-max-width: 276px !default;\r\n$popover-border-width: $border-width !default;\r\n$popover-border-color: rgba($black, .2) !default;\r\n$popover-border-radius: $border-radius-lg !default;\r\n$popover-box-shadow: 0 .25rem .5rem rgba($black, .2) !default;\r\n\r\n$popover-header-bg: darken($popover-bg, 3%) !default;\r\n$popover-header-color: $headings-color !default;\r\n$popover-header-padding-y: .5rem !default;\r\n$popover-header-padding-x: .75rem !default;\r\n\r\n$popover-body-color: $body-color !default;\r\n$popover-body-padding-y: $popover-header-padding-y !default;\r\n$popover-body-padding-x: $popover-header-padding-x !default;\r\n\r\n$popover-arrow-width: 1rem !default;\r\n$popover-arrow-height: .5rem !default;\r\n$popover-arrow-color: $popover-bg !default;\r\n\r\n$popover-arrow-outer-color: fade-in($popover-border-color, .05) !default;\r\n\r\n// Badges\r\n\r\n$badge-font-size: 75% !default;\r\n$badge-font-weight: $font-weight-bold !default;\r\n$badge-padding-y: .25em !default;\r\n$badge-padding-x: .4em !default;\r\n$badge-border-radius: $border-radius !default;\r\n\r\n$badge-pill-padding-x: .6em !default;\r\n// Use a higher than normal value to ensure completely rounded edges when\r\n// customizing padding or font-size on labels.\r\n$badge-pill-border-radius: 10rem !default;\r\n\r\n// Modals\r\n\r\n// Padding applied to the modal body\r\n$modal-inner-padding: 1rem !default;\r\n\r\n$modal-dialog-margin: .5rem !default;\r\n$modal-dialog-margin-y-sm-up: 1.75rem !default;\r\n\r\n$modal-title-line-height: $line-height-base !default;\r\n\r\n$modal-content-bg: $white !default;\r\n$modal-content-border-color: rgba($black, .2) !default;\r\n$modal-content-border-width: $border-width !default;\r\n$modal-content-box-shadow-xs: 0 .25rem .5rem rgba($black, .5) !default;\r\n$modal-content-box-shadow-sm-up: 0 .5rem 1rem rgba($black, .5) !default;\r\n\r\n$modal-backdrop-bg: $black !default;\r\n$modal-backdrop-opacity: .5 !default;\r\n$modal-header-border-color: $gray-200 !default;\r\n$modal-footer-border-color: $modal-header-border-color !default;\r\n$modal-header-border-width: $modal-content-border-width !default;\r\n$modal-footer-border-width: $modal-header-border-width !default;\r\n$modal-header-padding: 1rem !default;\r\n\r\n$modal-lg: 800px !default;\r\n$modal-md: 500px !default;\r\n$modal-sm: 300px !default;\r\n\r\n$modal-transition: transform .3s ease-out !default;\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n$alert-padding-y: .75rem !default;\r\n$alert-padding-x: 1.25rem !default;\r\n$alert-margin-bottom: 1rem !default;\r\n$alert-border-radius: $border-radius !default;\r\n$alert-link-font-weight: $font-weight-bold !default;\r\n$alert-border-width: $border-width !default;\r\n\r\n$alert-bg-level: -10 !default;\r\n$alert-border-level: -9 !default;\r\n$alert-color-level: 6 !default;\r\n\r\n// Progress bars\r\n\r\n$progress-height: 1rem !default;\r\n$progress-font-size: ($font-size-base * .75) !default;\r\n$progress-bg: $gray-200 !default;\r\n$progress-border-radius: $border-radius !default;\r\n$progress-box-shadow: inset 0 .1rem .1rem rgba($black, .1) !default;\r\n$progress-bar-color: $white !default;\r\n$progress-bar-bg: theme-color(\"primary\") !default;\r\n$progress-bar-animation-timing: 1s linear infinite !default;\r\n$progress-bar-transition: width .6s ease !default;\r\n\r\n// List group\r\n\r\n$list-group-bg: $white !default;\r\n$list-group-border-color: rgba($black, .125) !default;\r\n$list-group-border-width: $border-width !default;\r\n$list-group-border-radius: $border-radius !default;\r\n\r\n$list-group-item-padding-y: .75rem !default;\r\n$list-group-item-padding-x: 1.25rem !default;\r\n\r\n$list-group-hover-bg: $gray-100 !default;\r\n$list-group-active-color: $component-active-color !default;\r\n$list-group-active-bg: $component-active-bg !default;\r\n$list-group-active-border-color: $list-group-active-bg !default;\r\n\r\n$list-group-disabled-color: $gray-600 !default;\r\n$list-group-disabled-bg: $list-group-bg !default;\r\n\r\n$list-group-action-color: $gray-700 !default;\r\n$list-group-action-hover-color: $list-group-action-color !default;\r\n\r\n$list-group-action-active-color: $body-color !default;\r\n$list-group-action-active-bg: $gray-200 !default;\r\n\r\n// Image thumbnails\r\n\r\n$thumbnail-padding: .25rem !default;\r\n$thumbnail-bg: $body-bg !default;\r\n$thumbnail-border-width: $border-width !default;\r\n$thumbnail-border-color: $gray-300 !default;\r\n$thumbnail-border-radius: $border-radius !default;\r\n$thumbnail-box-shadow: 0 1px 2px rgba($black, .075) !default;\r\n\r\n// Figures\r\n\r\n$figure-caption-font-size: 90% !default;\r\n$figure-caption-color: $gray-600 !default;\r\n\r\n// Breadcrumbs\r\n\r\n$breadcrumb-padding-y: .75rem !default;\r\n$breadcrumb-padding-x: 1rem !default;\r\n$breadcrumb-item-padding: .5rem !default;\r\n\r\n$breadcrumb-margin-bottom: 1rem !default;\r\n\r\n$breadcrumb-bg: $gray-200 !default;\r\n$breadcrumb-divider-color: $gray-600 !default;\r\n$breadcrumb-active-color: $gray-600 !default;\r\n$breadcrumb-divider: \"/\" !default;\r\n\r\n// Carousel\r\n\r\n$carousel-control-color: $white !default;\r\n$carousel-control-width: 15% !default;\r\n$carousel-control-opacity: .5 !default;\r\n\r\n$carousel-indicator-width: 30px !default;\r\n$carousel-indicator-height: 3px !default;\r\n$carousel-indicator-spacer: 3px !default;\r\n$carousel-indicator-active-bg: $white !default;\r\n\r\n$carousel-caption-width: 70% !default;\r\n$carousel-caption-color: $white !default;\r\n\r\n$carousel-control-icon-width: 20px !default;\r\n\r\n$carousel-control-prev-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$carousel-control-next-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$carousel-transition: transform .6s ease !default;\r\n\r\n// Close\r\n\r\n$close-font-size: $font-size-base * 1.5 !default;\r\n$close-font-weight: $font-weight-bold !default;\r\n//$close-color: $black !default;\r\n//$close-text-shadow: 0 1px 0 $white !default;\r\n\r\n// Code\r\n\r\n$code-font-size: 87.5% !default;\r\n$code-color: $pink !default;\r\n\r\n$kbd-padding-y: .2rem !default;\r\n$kbd-padding-x: .4rem !default;\r\n$kbd-font-size: $code-font-size !default;\r\n$kbd-color: $white !default;\r\n$kbd-bg: $gray-900 !default;\r\n\r\n$pre-color: $gray-900 !default;\r\n$pre-scrollable-max-height: 340px !default;\r\n\r\n// Printing\r\n$print-page-size: a3 !default;\r\n$print-body-min-width: map-get($grid-breakpoints, \"lg\") !default;\r\n","// Width and height Styles\r\n\r\n@each $prop, $abbrev in (width: w, height: h, max-width: mw, max-height: mh) {\r\n  @each $size, $length in $sizes {\r\n    .#{$abbrev}-#{$size} {\r\n      #{$prop}: $length !important;\r\n    }\r\n  }\r\n}\r\n","// Utility Color Classes\r\n\r\n//.success {\r\n//\r\n//}\r\n\r\n// Google Color Palette defined: http://www.google.com/design/spec/style/color.html\r\n\r\n$primary: (\r\n        \"base\": #3f51b5,\r\n        \"lighten-5\": #e8eaf6,\r\n        \"lighten-4\": #c5cae9,\r\n        \"lighten-3\": #9fa8da,\r\n        \"lighten-2\": #7986cb,\r\n        \"lighten-1\": #5c6bc0,\r\n        \"darken-1\": #3949ab,\r\n        \"darken-2\": #303f9f,\r\n        \"darken-3\": #283593,\r\n        \"darken-4\": #1a237e,\r\n        \"accent-1\": #8c9eff,\r\n        \"accent-2\": #536dfe,\r\n        \"accent-3\": #3d5afe,\r\n        \"accent-4\": #304ffe\r\n);\r\n\r\n$red: (\r\n        \"base\": #F44336,\r\n        \"lighten-5\": #FFEBEE,\r\n        \"lighten-4\": #FFCDD2,\r\n        \"lighten-3\": #EF9A9A,\r\n        \"lighten-2\": #E57373,\r\n        \"lighten-1\": #EF5350,\r\n        \"darken-1\": #E53935,\r\n        \"darken-2\": #D32F2F,\r\n        \"darken-3\": #C62828,\r\n        \"darken-4\": #B71C1C,\r\n        \"accent-1\": #FF8A80,\r\n        \"accent-2\": #FF5252,\r\n        \"accent-3\": #FF1744,\r\n        \"accent-4\": #D50000\r\n);\r\n\r\n$pink: (\r\n        \"base\": #e91e63,\r\n        \"lighten-5\": #fce4ec,\r\n        \"lighten-4\": #f8bbd0,\r\n        \"lighten-3\": #f48fb1,\r\n        \"lighten-2\": #f06292,\r\n        \"lighten-1\": #ec407a,\r\n        \"darken-1\": #d81b60,\r\n        \"darken-2\": #c2185b,\r\n        \"darken-3\": #ad1457,\r\n        \"darken-4\": #880e4f,\r\n        \"accent-1\": #ff80ab,\r\n        \"accent-2\": #ff4081,\r\n        \"accent-3\": #f50057,\r\n        \"accent-4\": #c51162\r\n);\r\n\r\n$purple: (\r\n        \"base\": #9C27B0,\r\n        \"lighten-5\": #f3e5f5,\r\n        \"lighten-4\": #e1bee7,\r\n        \"lighten-3\": #ce93d8,\r\n        \"lighten-2\": #ba68c8,\r\n        \"lighten-1\": #ab47bc,\r\n        \"darken-1\": #8e24aa,\r\n        \"darken-2\": #7b1fa2,\r\n        \"darken-3\": #6a1b9a,\r\n        \"darken-4\": #4a148c,\r\n        \"accent-1\": #ea80fc,\r\n        \"accent-2\": #e040fb,\r\n        \"accent-3\": #d500f9,\r\n        \"accent-4\": #aa00ff\r\n);\r\n\r\n$deep-purple: (\r\n        \"base\": #673ab7,\r\n        \"lighten-5\": #ede7f6,\r\n        \"lighten-4\": #d1c4e9,\r\n        \"lighten-3\": #b39ddb,\r\n        \"lighten-2\": #9575cd,\r\n        \"lighten-1\": #7e57c2,\r\n        \"darken-1\": #5e35b1,\r\n        \"darken-2\": #512da8,\r\n        \"darken-3\": #4527a0,\r\n        \"darken-4\": #311b92,\r\n        \"accent-1\": #b388ff,\r\n        \"accent-2\": #7c4dff,\r\n        \"accent-3\": #651fff,\r\n        \"accent-4\": #6200ea\r\n);\r\n\r\n$indigo: (\r\n        \"base\": #3f51b5,\r\n        \"lighten-5\": #e8eaf6,\r\n        \"lighten-4\": #c5cae9,\r\n        \"lighten-3\": #9fa8da,\r\n        \"lighten-2\": #7986cb,\r\n        \"lighten-1\": #5c6bc0,\r\n        \"darken-1\": #3949ab,\r\n        \"darken-2\": #303f9f,\r\n        \"darken-3\": #283593,\r\n        \"darken-4\": #1a237e,\r\n        \"accent-1\": #8c9eff,\r\n        \"accent-2\": #536dfe,\r\n        \"accent-3\": #3d5afe,\r\n        \"accent-4\": #304ffe\r\n);\r\n\r\n$blue: (\r\n        \"base\": #2196F3,\r\n        \"lighten-5\": #E3F2FD,\r\n        \"lighten-4\": #BBDEFB,\r\n        \"lighten-3\": #90CAF9,\r\n        \"lighten-2\": #64B5F6,\r\n        \"lighten-1\": #42A5F5,\r\n        \"darken-1\": #1E88E5,\r\n        \"darken-2\": #1976D2,\r\n        \"darken-3\": #1565C0,\r\n        \"darken-4\": #0D47A1,\r\n        \"accent-1\": #82B1FF,\r\n        \"accent-2\": #448AFF,\r\n        \"accent-3\": #2979FF,\r\n        \"accent-4\": #2962FF\r\n);\r\n\r\n$light-blue: (\r\n        \"base\": #03a9f4,\r\n        \"lighten-5\": #e1f5fe,\r\n        \"lighten-4\": #b3e5fc,\r\n        \"lighten-3\": #81d4fa,\r\n        \"lighten-2\": #4fc3f7,\r\n        \"lighten-1\": #29b6f6,\r\n        \"darken-1\": #039be5,\r\n        \"darken-2\": #0288d1,\r\n        \"darken-3\": #0277bd,\r\n        \"darken-4\": #01579b,\r\n        \"accent-1\": #80d8ff,\r\n        \"accent-2\": #40c4ff,\r\n        \"accent-3\": #00b0ff,\r\n        \"accent-4\": #0091ea\r\n);\r\n\r\n$cyan: (\r\n        \"base\": #00bcd4,\r\n        \"lighten-5\": #e0f7fa,\r\n        \"lighten-4\": #b2ebf2,\r\n        \"lighten-3\": #80deea,\r\n        \"lighten-2\": #4dd0e1,\r\n        \"lighten-1\": #26c6da,\r\n        \"darken-1\": #00acc1,\r\n        \"darken-2\": #0097a7,\r\n        \"darken-3\": #00838f,\r\n        \"darken-4\": #006064,\r\n        \"accent-1\": #84ffff,\r\n        \"accent-2\": #18ffff,\r\n        \"accent-3\": #00e5ff,\r\n        \"accent-4\": #00b8d4\r\n);\r\n\r\n$teal: (\r\n        \"base\": #009688,\r\n        \"lighten-5\": #e0f2f1,\r\n        \"lighten-4\": #b2dfdb,\r\n        \"lighten-3\": #80cbc4,\r\n        \"lighten-2\": #4db6ac,\r\n        \"lighten-1\": #26a69a,\r\n        \"darken-1\": #00897b,\r\n        \"darken-2\": #00796b,\r\n        \"darken-3\": #00695c,\r\n        \"darken-4\": #004d40,\r\n        \"accent-1\": #a7ffeb,\r\n        \"accent-2\": #64ffda,\r\n        \"accent-3\": #1de9b6,\r\n        \"accent-4\": #00bfa5\r\n);\r\n\r\n$green: (\r\n        \"base\": #4CAF50,\r\n        \"lighten-5\": #E8F5E9,\r\n        \"lighten-4\": #C8E6C9,\r\n        \"lighten-3\": #A5D6A7,\r\n        \"lighten-2\": #81C784,\r\n        \"lighten-1\": #66BB6A,\r\n        \"darken-1\": #43A047,\r\n        \"darken-2\": #388E3C,\r\n        \"darken-3\": #2E7D32,\r\n        \"darken-4\": #1B5E20,\r\n        \"accent-1\": #B9F6CA,\r\n        \"accent-2\": #69F0AE,\r\n        \"accent-3\": #00E676,\r\n        \"accent-4\": #00C853\r\n);\r\n\r\n$light-green: (\r\n        \"base\": #8bc34a,\r\n        \"lighten-5\": #f1f8e9,\r\n        \"lighten-4\": #dcedc8,\r\n        \"lighten-3\": #c5e1a5,\r\n        \"lighten-2\": #aed581,\r\n        \"lighten-1\": #9ccc65,\r\n        \"darken-1\": #7cb342,\r\n        \"darken-2\": #689f38,\r\n        \"darken-3\": #558b2f,\r\n        \"darken-4\": #33691e,\r\n        \"accent-1\": #ccff90,\r\n        \"accent-2\": #b2ff59,\r\n        \"accent-3\": #76ff03,\r\n        \"accent-4\": #64dd17\r\n);\r\n\r\n$lime: (\r\n        \"base\": #cddc39,\r\n        \"lighten-5\": #f9fbe7,\r\n        \"lighten-4\": #f0f4c3,\r\n        \"lighten-3\": #e6ee9c,\r\n        \"lighten-2\": #dce775,\r\n        \"lighten-1\": #d4e157,\r\n        \"darken-1\": #c0ca33,\r\n        \"darken-2\": #afb42b,\r\n        \"darken-3\": #9e9d24,\r\n        \"darken-4\": #827717,\r\n        \"accent-1\": #f4ff81,\r\n        \"accent-2\": #eeff41,\r\n        \"accent-3\": #c6ff00,\r\n        \"accent-4\": #aeea00\r\n);\r\n\r\n$yellow: (\r\n        \"base\": #ffeb3b,\r\n        \"lighten-5\": #fffde7,\r\n        \"lighten-4\": #fff9c4,\r\n        \"lighten-3\": #fff59d,\r\n        \"lighten-2\": #fff176,\r\n        \"lighten-1\": #ffee58,\r\n        \"darken-1\": #fdd835,\r\n        \"darken-2\": #fbc02d,\r\n        \"darken-3\": #f9a825,\r\n        \"darken-4\": #f57f17,\r\n        \"accent-1\": #ffff8d,\r\n        \"accent-2\": #ffff00,\r\n        \"accent-3\": #ffea00,\r\n        \"accent-4\": #ffd600\r\n);\r\n\r\n$amber: (\r\n        \"base\": #ffc107,\r\n        \"lighten-5\": #fff8e1,\r\n        \"lighten-4\": #ffecb3,\r\n        \"lighten-3\": #ffe082,\r\n        \"lighten-2\": #ffd54f,\r\n        \"lighten-1\": #ffca28,\r\n        \"darken-1\": #ffb300,\r\n        \"darken-2\": #ffa000,\r\n        \"darken-3\": #ff8f00,\r\n        \"darken-4\": #ff6f00,\r\n        \"accent-1\": #ffe57f,\r\n        \"accent-2\": #ffd740,\r\n        \"accent-3\": #ffc400,\r\n        \"accent-4\": #ffab00\r\n);\r\n\r\n$orange: (\r\n        \"base\": #ff9800,\r\n        \"lighten-5\": #fff3e0,\r\n        \"lighten-4\": #ffe0b2,\r\n        \"lighten-3\": #ffcc80,\r\n        \"lighten-2\": #ffb74d,\r\n        \"lighten-1\": #ffa726,\r\n        \"darken-1\": #fb8c00,\r\n        \"darken-2\": #f57c00,\r\n        \"darken-3\": #ef6c00,\r\n        \"darken-4\": #e65100,\r\n        \"accent-1\": #ffd180,\r\n        \"accent-2\": #ffab40,\r\n        \"accent-3\": #ff9100,\r\n        \"accent-4\": #ff6d00\r\n);\r\n\r\n$deep-orange: (\r\n        \"base\": #ff5722,\r\n        \"lighten-5\": #fbe9e7,\r\n        \"lighten-4\": #ffccbc,\r\n        \"lighten-3\": #ffab91,\r\n        \"lighten-2\": #ff8a65,\r\n        \"lighten-1\": #ff7043,\r\n        \"darken-1\": #f4511e,\r\n        \"darken-2\": #e64a19,\r\n        \"darken-3\": #d84315,\r\n        \"darken-4\": #bf360c,\r\n        \"accent-1\": #ff9e80,\r\n        \"accent-2\": #ff6e40,\r\n        \"accent-3\": #ff3d00,\r\n        \"accent-4\": #dd2c00\r\n);\r\n\r\n$brown: (\r\n        \"base\": #795548,\r\n        \"lighten-5\": #efebe9,\r\n        \"lighten-4\": #d7ccc8,\r\n        \"lighten-3\": #bcaaa4,\r\n        \"lighten-2\": #a1887f,\r\n        \"lighten-1\": #8d6e63,\r\n        \"darken-1\": #6d4c41,\r\n        \"darken-2\": #5d4037,\r\n        \"darken-3\": #4e342e,\r\n        \"darken-4\": #3e2723\r\n);\r\n\r\n$blue-gray: (\r\n        \"base\": #607d8b,\r\n        \"lighten-5\": #eceff1,\r\n        \"lighten-4\": #cfd8dc,\r\n        \"lighten-3\": #b0bec5,\r\n        \"lighten-2\": #90a4ae,\r\n        \"lighten-1\": #78909c,\r\n        \"darken-1\": #546e7a,\r\n        \"darken-2\": #455a64,\r\n        \"darken-3\": #37474f,\r\n        \"darken-4\": #263238\r\n);\r\n\r\n$gray: (\r\n        \"base\": #9e9e9e,\r\n        \"lighten-5\": #fafafa,\r\n        \"lighten-4\": #f5f5f5,\r\n        \"lighten-3\": #eeeeee,\r\n        \"lighten-2\": #e0e0e0,\r\n        \"lighten-1\": #bdbdbd,\r\n        \"darken-1\": #757575,\r\n        \"darken-2\": #616161,\r\n        \"darken-3\": #424242,\r\n        \"darken-4\": #212121\r\n);\r\n\r\n$shades: (\r\n        \"black\": #000000,\r\n        \"white\": #FFFFFF,\r\n        \"transparent\": transparent\r\n);\r\n\r\n$colors_palette: (\r\n        \"primary\": $primary,\r\n        \"red\": $red,\r\n        \"pink\": $pink,\r\n        \"purple\": $purple,\r\n        \"deep-purple\": $deep-purple,\r\n        \"indigo\": $indigo,\r\n        \"blue\": $blue,\r\n        \"light-blue\": $light-blue,\r\n        \"cyan\": $cyan,\r\n        \"teal\": $teal,\r\n        \"green\": $green,\r\n        \"light-green\": $light-green,\r\n        \"lime\": $lime,\r\n        \"yellow\": $yellow,\r\n        \"amber\": $amber,\r\n        \"orange\": $orange,\r\n        \"deep-orange\": $deep-orange,\r\n        \"brown\": $brown,\r\n        \"blue-grey\": $blue-gray,\r\n        \"grey\": $gray,\r\n        \"shades\": $shades\r\n) !default;\r\n\r\n// Color Classes\r\n\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .bg-#{$color_name} {\r\n        background-color: $color_value !important;\r\n      }\r\n      .text-#{$color_name} {\r\n        color: $color_value !important;\r\n        &.icon-outline {\r\n          border-color: $color_value !important;\r\n        }\r\n      }\r\n    } @else if $color_name != \"shades\" {\r\n      .bg-#{$color_name}.#{$color_type} {\r\n        background-color: $color_value !important;\r\n      }\r\n      .text-#{$color_name}.text-#{$color_type} {\r\n        color: $color_value !important;\r\n        &.icon-outline {\r\n          border-color: $color_value !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Shade classes\r\n@each $color, $color_value in $shades {\r\n  .bg-#{$color} {\r\n    background-color: $color_value !important;\r\n  }\r\n  .text-#{$color} {\r\n    color: $color_value !important;\r\n    &.icon-outline {\r\n      border-color: $color_value !important;\r\n    }\r\n  }\r\n}\r\n\r\n// usage: color(\"name_of_color\", \"type_of_color\")\r\n// to avoid to repeating map-get($colors, ...)\r\n\r\n@function color($color, $type) {\r\n  @if map-has-key($colors_palette, $color) {\r\n    $curr_color: map-get($colors_palette, $color);\r\n    @if map-has-key($curr_color, $type) {\r\n      @return map-get($curr_color, $type);\r\n    }\r\n  }\r\n  @warn \"Unknown `#{$color}` - `#{$type}` in $colors.\";\r\n  @return null;\r\n}\r\n\r\n\r\n","/*Custom Animation*/\r\n\r\n@keyframes flipCenter {\r\n  0% {\r\n    animation-timing-function: ease-in;\r\n    opacity: 0;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);\r\n  }\r\n  40% {\r\n    animation-timing-function: ease-in;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  60% {\r\n    opacity: 1;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  80% {\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  100% {\r\n    transform: perspective(100000px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes flipCenter {\r\n  0% {\r\n    animation-timing-function: ease-in;\r\n    opacity: 0;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 90deg);\r\n  }\r\n  40% {\r\n    animation-timing-function: ease-in;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  60% {\r\n    opacity: 1;\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  80% {\r\n    transform: perspective(100000px) rotate3d(1, 0, 0, 0deg);\r\n  }\r\n  100% {\r\n    transform: perspective(100000px);\r\n  }\r\n}\r\n\r\n.flipCenter {\r\n  animation-name: flipCenter;\r\n  backface-visibility: visible;\r\n}\r\n\r\n@keyframes desployDown {\r\n  0% {\r\n    transform: scaleY(0);\r\n    transform-origin: center top 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scaleY(1);\r\n    transform-origin: center top 0;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes desployDown {\r\n  0% {\r\n    transform: scaleY(0);\r\n    transform-origin: center top 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scaleY(1);\r\n    transform-origin: center top 0;\r\n  }\r\n}\r\n\r\n.desployDown {\r\n  animation-name: desployDown;\r\n  backface-visibility: visible;\r\n}\r\n\r\n@keyframes fadeInRightTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fadeInRightTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.fadeInRightTiny {\r\n  animation-name: fadeInRightTiny;\r\n}\r\n\r\n@keyframes fadeInLeftTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes fadeInLeftTiny {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.fadeInLeftTiny {\r\n  animation-name: fadeInLeftTiny;\r\n}\r\n\r\n@keyframes slideInRightTiny {\r\n  0% {\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideInRightTiny {\r\n  0% {\r\n    transform: translate3d(30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.slideInRightTiny {\r\n  animation-name: slideInRightTiny;\r\n}\r\n\r\n@keyframes slideInLeftTiny {\r\n  0% {\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideInLeftTiny {\r\n  0% {\r\n    transform: translate3d(-30%, 0px, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.slideInLeftTiny {\r\n  animation-name: slideInLeftTiny;\r\n}\r\n\r\n@keyframes slideInUpTiny {\r\n  0% {\r\n    transform: translate3d(0px, 5%, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slideInUpTiny {\r\n  0% {\r\n    transform: translate3d(0px, 5%, 0px);\r\n  }\r\n  100% {\r\n    transform: none;\r\n  }\r\n}\r\n\r\n.slideInUpTiny {\r\n  animation-name: slideInUpTiny;\r\n}\r\n\r\n/*Animation Durations*/\r\n.animation-duration-1 {\r\n  animation-duration: 0.1s;\r\n}\r\n\r\n.animation-duration-2 {\r\n  animation-duration: 0.2s;\r\n}\r\n\r\n.animation-duration-3 {\r\n  animation-duration: 0.3s;\r\n}\r\n\r\n.animation-duration-4 {\r\n  animation-duration: 0.4s;\r\n}\r\n\r\n.animation-duration-5 {\r\n  animation-duration: 0.5s;\r\n}\r\n\r\n.animation-duration-6 {\r\n  animation-duration: 0.6s;\r\n}\r\n\r\n.animation-duration-7 {\r\n  animation-duration: 0.7s;\r\n}\r\n\r\n.animation-duration-8 {\r\n  animation-duration: 0.8s;\r\n}\r\n\r\n.animation-duration-9 {\r\n  animation-duration: 0.9s;\r\n}\r\n\r\n.animation-duration-10 {\r\n  animation-duration: 1s;\r\n}\r\n\r\n.animation-duration-11 {\r\n  animation-duration: 1.1s;\r\n}\r\n\r\n.animation-duration-12 {\r\n  animation-duration: 1.2s;\r\n}\r\n\r\n.animation-duration-13 {\r\n  animation-duration: 1.3s;\r\n}\r\n\r\n.animation-duration-14 {\r\n  animation-duration: 1.4s;\r\n}\r\n\r\n.animation-duration-15 {\r\n  animation-duration: 1.5s;\r\n}\r\n\r\n.animation-duration-16 {\r\n  animation-duration: 1.6s;\r\n}\r\n\r\n.animation-duration-17 {\r\n  animation-duration: 1.7s;\r\n}\r\n\r\n.animation-duration-18 {\r\n  animation-duration: 1.8s;\r\n}\r\n\r\n.animation-duration-19 {\r\n  animation-duration: 1.9s;\r\n}\r\n\r\n.animation-duration-20 {\r\n  animation-duration: 2s;\r\n}\r\n\r\n.animation-duration-21 {\r\n  animation-duration: 2.1s;\r\n}\r\n\r\n.animation-duration-22 {\r\n  animation-duration: 2.2s;\r\n}\r\n\r\n.animation-duration-23 {\r\n  animation-duration: 2.3s;\r\n}\r\n\r\n.animation-duration-24 {\r\n  animation-duration: 2.4s;\r\n}\r\n\r\n.animation-duration-25 {\r\n  animation-duration: 2.5s;\r\n}\r\n\r\n.animation-duration-26 {\r\n  animation-duration: 2.6s;\r\n}\r\n\r\n.animation-duration-27 {\r\n  animation-duration: 2.7s;\r\n}\r\n\r\n.animation-duration-28 {\r\n  animation-duration: 2.8s;\r\n}\r\n\r\n.animation-duration-29 {\r\n  animation-duration: 2.9s;\r\n}\r\n\r\n.animation-duration-30 {\r\n  animation-duration: 3s;\r\n}\r\n\r\n.animation-duration-31 {\r\n  animation-duration: 3.1s;\r\n}\r\n\r\n.animation-duration-32 {\r\n  animation-duration: 3.2s;\r\n}\r\n\r\n.animation-duration-33 {\r\n  animation-duration: 3.3s;\r\n}\r\n\r\n.animation-duration-34 {\r\n  animation-duration: 3.4s;\r\n}\r\n\r\n.animation-duration-35 {\r\n  animation-duration: 3.5s;\r\n}\r\n\r\n.animation-duration-36 {\r\n  animation-duration: 3.6s;\r\n}\r\n\r\n.animation-duration-37 {\r\n  animation-duration: 3.7s;\r\n}\r\n\r\n.animation-duration-38 {\r\n  animation-duration: 3.8s;\r\n}\r\n\r\n.animation-duration-39 {\r\n  animation-duration: 3.9s;\r\n}\r\n\r\n.animation-duration-40 {\r\n  animation-duration: 4s;\r\n}\r\n\r\n//Animation Delay\r\n\r\n.animation-delay-1 {\r\n  animation-delay: 0.1s;\r\n}\r\n\r\n.animation-delay-2 {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.animation-delay-3 {\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.animation-delay-4 {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n.animation-delay-5 {\r\n  animation-delay: 0.5s;\r\n}\r\n\r\n.animation-delay-6 {\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n.animation-delay-7 {\r\n  animation-delay: 0.7s;\r\n}\r\n\r\n.animation-delay-8 {\r\n  animation-delay: 0.8s;\r\n}\r\n\r\n.animation-delay-9 {\r\n  animation-delay: 0.9s;\r\n}\r\n\r\n.animation-delay-10 {\r\n  animation-delay: 1s;\r\n}\r\n\r\n.animation-delay-11 {\r\n  animation-delay: 1.1s;\r\n}\r\n\r\n.animation-delay-12 {\r\n  animation-delay: 1.2s;\r\n}\r\n\r\n.animation-delay-13 {\r\n  animation-delay: 1.3s;\r\n}\r\n\r\n.animation-delay-14 {\r\n  animation-delay: 1.4s;\r\n}\r\n\r\n.animation-delay-15 {\r\n  animation-delay: 1.5s;\r\n}\r\n\r\n.animation-delay-16 {\r\n  animation-delay: 1.6s;\r\n}\r\n\r\n.animation-delay-17 {\r\n  animation-delay: 1.7s;\r\n}\r\n\r\n.animation-delay-18 {\r\n  animation-delay: 1.8s;\r\n}\r\n\r\n.animation-delay-19 {\r\n  animation-delay: 1.9s;\r\n}\r\n\r\n.animation-delay-20 {\r\n  animation-delay: 2s;\r\n}\r\n\r\n.animation-delay-21 {\r\n  animation-delay: 2.1s;\r\n}\r\n\r\n.animation-delay-22 {\r\n  animation-delay: 2.2s;\r\n}\r\n\r\n.animation-delay-23 {\r\n  animation-delay: 2.3s;\r\n}\r\n\r\n.animation-delay-24 {\r\n  animation-delay: 2.4s;\r\n}\r\n\r\n.animation-delay-25 {\r\n  animation-delay: 2.5s;\r\n}\r\n\r\n.animation-delay-26 {\r\n  animation-delay: 2.6s;\r\n}\r\n\r\n.animation-delay-27 {\r\n  animation-delay: 2.6s;\r\n}\r\n\r\n.animation-delay-28 {\r\n  animation-delay: 2.8s;\r\n}\r\n\r\n.animation-delay-29 {\r\n  animation-delay: 2.9s;\r\n}\r\n\r\n.animation-delay-30 {\r\n  animation-delay: 3s;\r\n}\r\n\r\n.animation-delay-31 {\r\n  animation-delay: 3.1s;\r\n}\r\n\r\n.animation-delay-32 {\r\n  animation-delay: 3.2s;\r\n}\r\n\r\n.animation-delay-33 {\r\n  animation-delay: 3.3s;\r\n}\r\n\r\n.animation-delay-34 {\r\n  animation-delay: 3.4s;\r\n}\r\n\r\n.animation-delay-35 {\r\n  animation-delay: 3.5s;\r\n}\r\n\r\n.animation-delay-36 {\r\n  animation-delay: 3.6s;\r\n}\r\n\r\n.animation-delay-37 {\r\n  animation-delay: 3.7s;\r\n}\r\n\r\n.animation-delay-38 {\r\n  animation-delay: 3.8s;\r\n}\r\n\r\n.animation-delay-39 {\r\n  animation-delay: 3.9s;\r\n}\r\n\r\n.animation-delay-40 {\r\n  animation-delay: 4s;\r\n}\r\n\r\n.animation-delay-41 {\r\n  animation-delay: 4.1s;\r\n}\r\n\r\n.animation-delay-42 {\r\n  animation-delay: 4.2s;\r\n}\r\n\r\n.animation-delay-43 {\r\n  animation-delay: 4.3s;\r\n}\r\n\r\n.animation-delay-44 {\r\n  animation-delay: 4.4s;\r\n}\r\n\r\n.animation-delay-45 {\r\n  animation-delay: 4.5s;\r\n}\r\n\r\n.animation-delay-46 {\r\n  animation-delay: 4.6s;\r\n}\r\n\r\n.animation-delay-47 {\r\n  animation-delay: 4.7s;\r\n}\r\n\r\n.animation-delay-48 {\r\n  animation-delay: 4.8s;\r\n}\r\n\r\n.animation-delay-49 {\r\n  animation-delay: 4.9s;\r\n}\r\n\r\n.animation-delay-50 {\r\n  animation-delay: 5s;\r\n}","/* Base\r\n   ========================================================================== */\r\n@import \"base\";\r\n@import \"typography\";","/*Base Styles*/\r\n\r\nhtml {\r\n  height: 100%;\r\n}\r\n\r\nbody {\r\n  font: {\r\n    family: $font-family-base;\r\n    size: $font-size-base;\r\n    weight: $font-weight-base;\r\n  }\r\n  color: $body-color;\r\n  background-color: $body-bg;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\nbody.ios-mobile-view-height {\r\n  height: auto !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n#nprogress .bar {\r\n  z-index: 5000 !important;\r\n  background: $app-primary !important;\r\n}\r\n\r\n#nprogress .peg {\r\n  @include box-shadow(0 0 10px $app-primary, 0 0 5px $app-primary !important);\r\n}\r\n\r\n#nprogress .spinner {\r\n  z-index: 5000 !important;\r\n}\r\n\r\n#nprogress .spinner-icon {\r\n  border-top-color: $app-primary !important;\r\n  border-left-color: $app-primary !important;\r\n}\r\n\r\n.ripple-effect {\r\n  @extend %ripple-effect;\r\n}\r\n\r\n.text-transform-none {\r\n  text-transform: none;\r\n}\r\n\r\n.br-break {\r\n  word-break: break-all !important;\r\n}\r\n\r\n.font-weight-semibold {\r\n  font-weight: 500 !important;\r\n}\r\n\r\n.z-index-20 {\r\n  z-index: 20;\r\n}\r\n\r\n.size-120 {\r\n  @extend %size-120;\r\n}\r\n\r\n.size-100 {\r\n  @extend %size-100;\r\n}\r\n\r\n.size-80 {\r\n  @extend %size-80;\r\n}\r\n\r\n.size-60 {\r\n  @extend %size-60;\r\n}\r\n\r\n.size-50 {\r\n  @extend %size-50;\r\n}\r\n\r\n.size-40 {\r\n  @extend %size-40;\r\n}\r\n\r\n.size-30 {\r\n  @extend %size-30;\r\n}\r\n\r\n.size-20 {\r\n  @extend %size-20;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: solid 1px $gray-300;\r\n}\r\n\r\n.col-with-divider div[class*=\"col-\"] {\r\n  border-left: solid 1px $gray-300;\r\n  &:first-child {\r\n    border: 0 none;\r\n  }\r\n}\r\n\r\n.height-100 {\r\n  height: 100px !important;\r\n}\r\n\r\n.height-150 {\r\n  height: 150px !important;\r\n}\r\n\r\n.height-130 {\r\n  height: 130px !important;\r\n}\r\n\r\n.height-200 {\r\n  height: 200px !important;\r\n}\r\n\r\n.max-width-100 {\r\n  max-width: 100px !important;\r\n}\r\n\r\n.max-height-120 {\r\n  max-height: 120px !important;\r\n}\r\n\r\n.right-arrow {\r\n  display: inline-block;\r\n  color: $app-primary;\r\n  text-transform: capitalize;\r\n  &:after {\r\n    content: \"\\f30f\";\r\n    font-family: \"Material-Design-Iconic-Font\";\r\n    color: $app-primary;\r\n    margin-left: 8px;\r\n    font-size: 20px;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  &:hover,\r\n  &:focus {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n.letter-spacing-base {\r\n  letter-spacing: $letter-spacing-base;\r\n}\r\n\r\n.letter-spacing-lg {\r\n  letter-spacing: $letter-spacing-lg;\r\n}\r\n\r\n.letter-spacing-xl {\r\n  letter-spacing: $letter-spacing-xl;\r\n}\r\n\r\n.page-heading {\r\n  margin-bottom: $jr-card-margin + 4px;\r\n\r\n  & .title {\r\n    text-transform: capitalize;\r\n    font-weight: 600;\r\n  }\r\n\r\n  & .breadcrumb {\r\n    padding: 0;\r\n    background-color: transparent;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.sub-heading {\r\n  font-size: $font-size-base;\r\n  color: $gray-500;\r\n  margin-bottom: 0;\r\n  &:not(:last-child) {\r\n    margin-bottom: 16px !important;\r\n  }\r\n}\r\n\r\n.manage-margin {\r\n  margin-bottom: 0;\r\n  & > * {\r\n    margin-bottom: 6px;\r\n    &:not(:last-child) {\r\n      margin-right: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n//Shadow\r\n.no-shadow {\r\n  @include box-shadow(none !important);\r\n}\r\n\r\n.shadow-sm {\r\n  @include box-shadow($shadow-sm);\r\n}\r\n\r\n.shadow {\r\n  @include box-shadow($shadow);\r\n}\r\n\r\n.shadow-lg {\r\n  @include box-shadow($shadow-lg);\r\n}\r\n\r\n.shadow-xl {\r\n  @include box-shadow($shadow-xl);\r\n}\r\n\r\n.avatar-shadow {\r\n  @include box-shadow($avatar-shadow);\r\n}\r\n\r\n.remove-table-border {\r\n  td, th {\r\n    border: 0 none;\r\n  }\r\n}\r\n\r\n//Media Object list\r\n.media-list {\r\n  margin-bottom: 10px;\r\n  &:not(:last-child) {\r\n    border-bottom: solid 1px $gray-200;\r\n    padding-bottom: 15px;\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n  }\r\n}\r\n\r\n.border-2 {\r\n  border: 2px solid $gray-400 !important;\r\n}\r\n\r\n.border-w2 {\r\n  border-width: 2px;\r\n}\r\n\r\n// Border Color Classes\r\n\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .border-#{$color_name} {\r\n        border-color: $color_value !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n//Center Crop image\r\n\r\n.center-crop-img {\r\n  position: relative;\r\n  width: 100%;\r\n  min-height: 120px;\r\n  overflow: hidden;\r\n\r\n  & img {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    height: 100%;\r\n    width: auto;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    -ms-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  & img.portrait {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n//Bootstrap Components Override\r\n\r\n//Buttons\r\n\r\na.btn-info {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-danger {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-warning {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-success {\r\n  @extend %link-hover;\r\n}\r\n\r\na.btn-dark {\r\n  @extend %link-hover;\r\n}\r\n\r\n//Badges\r\na.badge-success {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-danger {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-warning {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-info {\r\n  @extend %link-hover;\r\n}\r\n\r\na.badge-dark {\r\n  @extend %link-hover;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.icon-btn {\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 48px;\r\n  justify-content: center;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  color: $gray-600;\r\n\r\n  .header-notifications & {\r\n    padding: 0 4px;\r\n  }\r\n}\r\n\r\n.avatar {\r\n  width: 60px;\r\n  height: 60px;\r\n  text-align: center;\r\n  line-height: 60px;\r\n  color: #fafafa;\r\n}\r\n\r\n.avatar-lg {\r\n  width: 80px;\r\n  height: 80px;\r\n  line-height: 80px;\r\n  text-align: center;\r\n  color: #fafafa;\r\n}\r\n\r\n.avatar-sm {\r\n  width: 40px;\r\n  height: 40px;\r\n  text-align: center;\r\n  color: #fafafa;\r\n}\r\n.animated {\r\n  -webkit-animation-fill-mode: none !important;\r\n  animation-fill-mode: none !important\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden;\r\n}\r\n\r\n.icons-showcase > div {\r\n  cursor: pointer;\r\n  padding: 7px 15px;\r\n  @include border-radius($border-radius);\r\n  overflow: hidden;\r\n  text-align: left;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.text-decoration {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.row-5 {\r\n  margin-left: -5px;\r\n  margin-right: -5px;\r\n\r\n  & > [class*='col-'] {\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n  }\r\n}\r\n\r\n.font-size-16 {\r\n  font-size: 16px !important;\r\n}\r\n\r\n.material-icons {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  padding-bottom: 3px;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  -webkit-appearance: none;\r\n  width: 10px;\r\n  height: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  border-radius: 4px;\r\n  background-image: linear-gradient(to bottom right, #ebebeb, #bebebe);\r\n  border: solid 1px #ababab;\r\n}\r\n\r\n::selection {\r\n  background-color:#006FC9;\r\n  color: #fff;\r\n}\r\n\r\nselect {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  padding: 2px 30px 2px 2px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.my-tooltip > .tooltip-inner {\r\n  background-color: #fff;\r\n  color: #808080;\r\n  border: 1px solid #d8dcdf;\r\n}\r\n\r\n.my-tooltip [class$=\"arrow\"] {\r\n  display: none;\r\n  // border-top: 5px solid red !important;\r\n}\r\n\r\n::-ms-clear {\r\n  display: none;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.hs-button {\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  margin:0;\r\n  cursor:pointer;\r\n  display:inline-block;\r\n  font-weight:700;\r\n  line-height:12px;\r\n  position:relative;\r\n  text-align:center;\r\n  transition:all .15s linear;\r\n  background-color:#ff7a59;\r\n  border-color:#ff7a59;\r\n  color:#fff;\r\n  border-radius:3px;\r\n  border-style:solid;\r\n  border-width:1px;\r\n  font-size:14px;\r\n  padding:12px 24px\r\n}\r\n.hs-button:hover,.hs-button:focus {\r\n  background-color:#ff8f73;\r\n  border-color:#ff8f73\r\n}\r\n.hs-button:active {\r\n  background-color:#e66e50;\r\n  border-color:#e66e50\r\n}\r\nlabel {\r\n  font-size:14px;\r\n  width:130px;\r\n  text-align:right;\r\n  color:#33475b;\r\n  display:block;\r\n  float:none;\r\n  width:auto;\r\n  font-weight:500;\r\n  text-align:left;\r\n  line-height:20px;\r\n  padding-top:0;\r\n  margin-bottom:4px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.hs-video-form label {\r\n  color:#fff !important\r\n}\r\n.hs-video-form .hs-back-button{ \r\n  background-color:#fff;\r\n  width:20%;\r\n  height:38px;\r\n  margin-right:10px;\r\n  border:1px solid;\r\n  -webkit-border-radius:3px;\r\n  -moz-border-radius:3px;\r\n  -ms-border-radius:3px;\r\n  border-radius:3px\r\n}\r\n.hs-video-form .hs-button {\r\n  width:70%\r\n}\r\n.hs-video-form .hs-button span {\r\n  font-size:15px\r\n}\r\n.hs-video-form .hs-richtext {\r\n  color:#fff !important\r\n}\r\n.hs-video-form .legal-consent-container {\r\n  max-height:180px !important;\r\n  overflow-y:scroll !important\r\n}\r\n.hs-video-form .legal-consent-container:after {\r\n  content:\"\";\r\n  display:block;\r\n  height:100px;\r\n  width:100%\r\n}.hs-video-form .legal-consent-wrapper {\r\n  position:relative\r\n}\r\n.hs-video-form .legal-consent-overlay {\r\n  position:absolute;\r\n  pointer-events:none;\r\n  left:0;\r\n  bottom:0;\r\n  height:100px;\r\n  width:100%;\r\n  background:linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #292929 100%)\r\n}\r\n.hs-error-msgs label {\r\n  color:#f2545b\r\n}\r\n.hs-input {\r\n  display:inline-block;\r\n  width:90%;\r\n  max-width:500px;\r\n  height:40px;\r\n  padding:9px 10px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  font-size:16px;\r\n  font-weight:normal;\r\n  line-height:22px;\r\n  color:#33475b;\r\n  border:1px solid #cbd6e2;\r\n  box-sizing:border-box;\r\n  -webkit-border-radius:3px;\r\n  -moz-border-radius:3px;\r\n  -ms-border-radius:3px;\r\n  border-radius:3px\r\n}\r\n.hs-input:not([type=file]) {\r\n  background-color:#f5f8fa\r\n}\r\n.hs-input[type=checkbox],.hs-input[type=radio] {\r\n  cursor:pointer;\r\n  width:auto;\r\n  height:auto;\r\n  padding:0;\r\n  margin:3px 5px 3px 0px;\r\n  line-height:normal;\r\n  border:none\r\n}\r\n.hs-input[type=file] {\r\n  padding:initial;\r\n  border:initial;\r\n  line-height:initial;\r\n  box-shadow:none\r\n}\r\nselect.is-placeholder {\r\n  color:#bfbfbf\r\n}\r\nselect.is-placeholder:focus {\r\n  color:#33475b\r\n}\r\n.hs-input:-moz-placeholder {\r\n  color:#bfbfbf\r\n}\r\n.hs-input::-webkit-input-placeholder {\r\n  color:#bfbfbf\r\n}\r\n.hs-input option:disabled {\r\n  color:#bfbfbf\r\n}\r\n.hs-input input,.hs-input textarea {\r\n  transition:border .2s linear\r\n}\r\n.hs-input:focus {\r\n  outline:none;\r\n  border-color:rgba(82,168,236,.8)\r\n}\r\ntextarea.hs-input{height:auto}select[multiple].hs-input {\r\n  height:inherit\r\n}\r\ninput.hs-input.error,div.field.error input,div.field.error textarea,div.field.error .chzn-choices,textarea.hs-input.error,select.hs-input.error {\r\n  border-color:#c87872 !important;\r\n}\r\ninput.hs-input.error:focus,div.field.error input:focus,div.field.error textarea:focus,div.field.error .chzn-choices:focus,textarea.hs-input.error:focus,select.hs-input.error:focus {\r\n  border-color:#b9554d !important;\r\n}\r\n.actions {\r\n  margin-top:18px;\r\n  margin-bottom:18px;\r\n  padding:17px 0px\r\n}\r\n.inputs-list {\r\n  margin:0 0 5px;\r\n  width:100%;\r\n  padding-left:5px\r\n}\r\n.inputs-list>li {\r\n  display:block;\r\n  padding:0;\r\n  width:100%;\r\n  padding-top:0\r\n}\r\n.inputs-list label {\r\n  display:block;\r\n  float:none;\r\n  width:auto;\r\n  padding:0;\r\n  line-height:18px;\r\n  text-align:left;\r\n  white-space:normal;\r\n  font-weight:normal\r\n}\r\n.inputs-list:first-child {\r\n  padding-top:6px\r\n}\r\n.inputs-list>li+li {\r\n  padding-top:2px\r\n}\r\nul.no-list {\r\n  list-style:none\r\n}\r\n.field {\r\n  margin-bottom:18px\r\n}\r\n.hs-field-desc {\r\n  color:#7c98b6;\r\n  margin:0px 0px 6px;\r\n  font-size:14px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.hs-form-required {\r\n  color:red\r\n}\r\n.hs-richtext {\r\n  margin-bottom:3px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;\r\n  line-height:24px;\r\n  font-size:14px;\r\n  color:#33475b\r\n}\r\n.hs-richtext hr {\r\n  text-align:left;\r\n  margin-left:0;\r\n  width:91%\r\n}\r\n.email-correction,.email-validation {\r\n  padding-top:3px;\r\n  font-size:12px;\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.email-correction a,.email-validation a {\r\n  cursor:pointer\r\n}\r\n@media(max-width: 400px),(min-device-width: 320px)and (max-device-width: 480px) {\r\n  .email-correction form .form-columns-2 .hs-form-field,.email-correction form .form-columns-3 .hs-form-field,.email-validation form .form-columns-2 .hs-form-field,.email-validation form .form-columns-3 .hs-form-field {\r\n    float:none;width:100%\r\n  }\r\n  .email-correction form .form-columns-2 .hs-form-field .hs-input,.email-correction form .form-columns-3 .hs-form-field .hs-input,.email-validation form .form-columns-2 .hs-form-field .hs-input,.email-validation form .form-columns-3 .hs-form-field .hs-input {\r\n    width:90%\r\n  }\r\n  .email-correction form .form-columns-2 .hs-form-field input[type=checkbox],.email-correction form .form-columns-2 .hs-form-field input[type=radio],.email-correction form .form-columns-3 .hs-form-field input[type=checkbox],.email-correction form .form-columns-3 .hs-form-field input[type=radio],.email-validation form .form-columns-2 .hs-form-field input[type=checkbox],.email-validation form .form-columns-2 .hs-form-field input[type=radio],.email-validation form .form-columns-3 .hs-form-field input[type=checkbox],.email-validation form .form-columns-3 .hs-form-field input[type=radio] {\r\n    width:24px\r\n  }\r\n}\r\n.hs-button,.hs-form-field input[type=text],.hs-form-field input[type=email],.hs-form-field input[type=phone],.hs-form-field input[type=number],.hs-form-field input[type=tel],.hs-form-field input[type=date],.hs-form-field textarea {\r\n  -webkit-appearance:none;\r\n  -moz-appearance:none\r\n}\r\n.hs-default-font-element,.hs-main-font-element {\r\n  font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif\r\n}\r\n.hs-form label {\r\n  margin: 0!important;\r\n  font-family: 'Poppins', sans-serif!important;\r\n  // font-weight: bold!important;\r\n}\r\n.hs-form input[type=\"checkbox\"] {\r\n  margin: 0 10px 0 0!important;\r\n}\r\n.hs-form fieldset {\r\n  max-width: unset!important;\r\n}\r\n.hs-input {\r\n  max-width: unset!important;\r\n  font-family: 'Poppins', sans-serif!important;\r\n}\r\n.hs-form .input textarea {\r\n  width: 100%!important;\r\n}\r\n.hs-form .input select {\r\n  width: 100%!important;\r\n}\r\n.hs-form select {\r\n  margin: 0!important;\r\n}\r\n.hs-form textarea {\r\n  margin: 0!important;\r\n}\r\n.hs-form input[type=\"text\"], .hs-form input[type=\"email\"], .hs-form input[type=\"tel\"] {\r\n  margin: 0!important;\r\n}\r\n.hs-form input[type=\"file\" i]::-webkit-file-upload-button {\r\n  cursor: pointer!important;\r\n}\r\n.hs-form ::placeholder {\r\n  color: #bfbfbf!important;\r\n  font-weight: 400!important;\r\n  font-size: 14px!important;\r\n}\r\n.hs-form .input input[type=\"file\"] {\r\n  width: 100%!important;\r\n  margin: 0!important;\r\n}\r\n.hs-form .input input[type=\"text\"] {\r\n  width: 100%!important;\r\n  border: 1px solid #cbd6e2;\r\n  border-radius: 3px!important;\r\n}\r\n.hs-form .input input[type=\"text\"]::placeholder {\r\n  font-size: 14px!important;\r\n}\r\n.hs-field-desc {\r\n  text-align: left!important;\r\n}\r\n.hs-form body .hs-button.primary, body input[type=\"submit\"], body input[type=\"button\"] {\r\n  float: none!important;\r\n  margin: 0!important;\r\n}\r\n.hs-form .actions {\r\n  margin: 0!important;\r\n  text-align: left!important;\r\n}\r\n\r\n\r\n// .hs-form input[type=\"text\"],\r\n// .hs-form input[type=\"email\"],\r\n// .hs-form input[type=\"tel\"] {\r\n//     border: none;\r\n//     box-shadow: none;\r\n//     border-radius: 0;\r\n//     padding: '5px 0 5px 0';\r\n//     font-weight: 400;\r\n//     font-size: 14px;\r\n//     font-family: 'Roboto';\r\n//     letter-spacing: 2;\r\n//     line-height: 1.5;\r\n//     margin: 5px 0 10px 0;\r\n//     color: #0071B9;\r\n//     padding-bottom: 5px;\r\n//     border-bottom: solid #d8dcdf 1px;\r\n//     width: 100%;\r\n// }\r\n\r\n// .hs-form input[type=\"checkbox\"] {\r\n//     margin: 10px 10px 10px 0;\r\n// }\r\n\r\n// .hs-form input[type=\"text\"]:focus {\r\n//     outline: 0;\r\n// }\r\n\r\n// .hs-form input[type=\"email\"]:focus {\r\n//     outline: 0;\r\n// }\r\n\r\n// .hs-form input[type=\"tel\"]:focus {\r\n//     outline: 0;\r\n// }\r\n\r\n// .hs-form label {\r\n//     color: #0071B9;\r\n//     font-family: 'Roboto';\r\n//     margin: 10px 0;\r\n// }\r\n// .hs-form .hs-form-field > label {\r\n//     color: #0071B9;\r\n//     font-family: 'Roboto';\r\n//     margin: 10px 0;\r\n// }\r\n\r\n// .hs-form .hs-field-desc {\r\n//     color: #0071B9;\r\n//     font-family: 'Roboto';\r\n//     margin: 5px 0;\r\n// }\r\n\r\n// .hs-form select {\r\n//     background: whitesmoke;\r\n//     margin: 15px 0 25px 0;\r\n//     color: #5e7993;\r\n//     border-radius: 3px;\r\n//     font-family: 'Roboto';\r\n// }\r\n\r\n// .hs-form select:focus {\r\n//     outline: none;\r\n//     border: none;\r\n// }\r\n\r\n// .hs-form select:active {\r\n//     outline: none;\r\n//     border: none;\r\n// }\r\n\r\n\r\n\r\n// .hs-form .hs-richtext {\r\n//     color: #5e7993;\r\n//     font-family: 'Roboto';\r\n//     margin: 5px 0 20px 0;\r\n//     font-size: 14px;\r\n// }\r\n\r\n// .hs-form textarea {\r\n//     margin: 10px 0;\r\n//     color: #0071B9;\r\n//     border: 1px solid #d8dcdf;\r\n//     border-radius: 0.2rem;\r\n//     width: 100%;\r\n// }\r\n\r\n// .hs-form textarea:focus {\r\n//     outline: none;\r\n// }\r\n\r\n// body .hs-button.primary,\r\n// body input[type=\"submit\"],\r\n// body input[type=\"button\"] {\r\n//     background: #0071B9;\r\n//     color: #ffffff;\r\n//     border-radius: .2rem;\r\n//     padding: 1em;\r\n//     font-size: 14px;\r\n//     font-weight: 400;\r\n//     padding: 10px 20px;\r\n//     // margin: 0 5px;\r\n//     margin-bottom: -70px;\r\n//     font-family: 'Roboto';\r\n//     border: 1px solid #0071B9;\r\n//     -webkit-transition: all .3s ease-in-out;\r\n//     -moz-transition: all .3s ease-in-out;\r\n//     -ms-transition: all .3s ease-in-out;\r\n//     -o-transition: all .3s ease-in-out;\r\n//     transition: all .3s ease-in-out;\r\n//     margin: 30px 0 0 10px;\r\n// }\r\n\r\n// body .hs-button.primary:hover,\r\n// body input[type=\"submit\"]:hover,\r\n// body input[type=\"button\"]:hover {\r\n//     cursor: pointer;\r\n//     opacity: .8\r\n// }\r\n\r\n// body input[type=\"file\"] {\r\n//     margin: 25px 0 25px 0;\r\n//     font-family: 'Roboto';\r\n// }\r\n\r\n// .hs-form .hs-error-msgs label {\r\n//     color: #d8000c;\r\n//     font-size: 13px;\r\n//     padding-bottom: 5px;\r\n// }\r\n\r\n/* OVERRIDE DEFAULT REACT-DATES STYLES */\r\n/*# sourceMappingURL=app.css.map */\r\n\r\n/* Will edit everything selected including everything between a range of dates */\r\n.CalendarDay__selected_span {\r\n  background: #3392E6 !important;\r\n  border: 1px double #3392E6 !important;\r\n  color: white !important;\r\n}\r\n\r\n/* Will edit selected date or the endpoints of a range of dates */\r\n.CalendarDay__selected {\r\n  background: #3392E6 !important;\r\n  border: 1px double #3392E6 !important;\r\n  color: white !important;\r\n}\r\n \r\n/* Will edit when hovered over. _span style also has this property */\r\n.CalendarDay__selected:hover {\r\n  opacity: 0.8 !important;\r\n}\r\n \r\n/* Will edit when the second date (end date) in a range of dates */\r\n/* is not yet selected. Edits the dates between your mouse and said date */\r\n.CalendarDay__hovered_span:hover,\r\n.CalendarDay__hovered_span {\r\n  background: #3392E6 !important;\r\n}\r\n\r\n// Help Icon in lower right corner\r\n.DayPickerKeyboardShortcuts_show__bottomRight::before {\r\n  border-right: 33px solid #3392E6 !important;\r\n  border-right-color: #3392E6 !important;\r\n}\r\n\r\n.SingleDatePicker_picker {\r\n  z-index: 100 !important;\r\n}\r\n\r\n.SingleDatePicker {\r\n  display: block !important;\r\n}\r\n\r\n.SingleDatePickerInput {\r\n  display: block !important;\r\n}\r\n\r\n.DateInput {\r\n  display: block !important;\r\n  width: 100% !important;\r\n}\r\n\r\n.DateInput_input {\r\n  font-size: 14px !important;\r\n  color: #808080 !important;\r\n  border: 1px solid #ced4da !important;\r\n  box-shadow: none !important;\r\n  border-radius: .25rem !important;\r\n  padding: 10px 0 5px 10px !important;\r\n  font-weight: 400 !important;\r\n  display: block !important;\r\n  width: 100% !important;\r\n  height: calc(2.25rem + 2px) !important;\r\n}\r\n\r\n.DateInput_input__focused {\r\n  border: 1px solid #ced4da !important;\r\n  border-radius: .25rem !important;\r\n}\r\n\r\n.DateRangePicker {\r\n  display: block !important;\r\n}\r\n\r\n.DateRangePickerInput {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: space-between !important;\r\n}\r\n\r\n.DateRangePickerInput_arrow {\r\n  padding: 0 10px !important;\r\n}\r\n\r\n.DateInput_input__disabled {\r\n  font-style: normal !important\r\n}\r\n\r\n// Hubspot Styling\r\n\r\n.hs-form input[type=\"text\"],\r\n.hs-form input[type=\"email\"],\r\n.hs-form input[type=\"tel\"] {\r\n    border: none;\r\n    box-shadow: none;\r\n    border-radius: 5;\r\n    padding: '5px 0 5px 0';\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    font-family: 'Roboto';\r\n    letter-spacing: 2;\r\n    line-height: 1.5;\r\n    margin: 5px 0 10px 0;\r\n    color: #0071B9;\r\n    padding-bottom: 5px;\r\n    border: 1px solid #cbd6e2;\r\n    width: 100%;\r\n}\r\n\r\n.hs-form input[type=\"checkbox\"] {\r\n    margin: 10px 10px 10px 0;\r\n}\r\n\r\n.hs-form input[type=\"text\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n.hs-form input[type=\"email\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n.hs-form input[type=\"tel\"]:focus {\r\n    outline: 0;\r\n}\r\n\r\n.hs-form label {\r\n    // color: #0071B9;\r\n    font-family: 'Roboto';\r\n    margin: 10px 0;\r\n}\r\n.hs-form .hs-form-field > label {\r\n    color: #0071B9;\r\n    font-family: 'Roboto';\r\n    margin: 10px 0;\r\n}\r\n\r\n.hs-form .hs-field-desc {\r\n    color: #33475b;\r\n    font-family: 'Roboto';\r\n    margin: 5px 0;\r\n}\r\n\r\n.hs-form select {\r\n    background: whitesmoke;\r\n    margin: 15px 0 25px 0;\r\n    color: #5e7993;\r\n    border-radius: 3px;\r\n    font-family: 'Roboto';\r\n}\r\n\r\n.hs-form select:focus {\r\n    outline: none;\r\n}\r\n\r\n.hs-form select:active {\r\n    outline: none;\r\n}\r\n\r\n\r\n\r\n.hs-form .hs-richtext {\r\n    color: #5e7993;\r\n    font-family: 'Roboto';\r\n    margin: 5px 0 20px 0;\r\n    font-size: 14px;\r\n}\r\n\r\n.hs-form textarea {\r\n    margin: 10px 0;\r\n    color: #0071B9;\r\n    border: 1px solid #d8dcdf;\r\n    border-radius: 0.2rem;\r\n    width: 100%;\r\n}\r\n\r\n.hs-form textarea:focus {\r\n    outline: none;\r\n}\r\n\r\nbody .hs-button.primary,\r\nbody input[type=\"submit\"],\r\nbody input[type=\"button\"] {\r\n    background: #0071B9;\r\n    color: #ffffff;\r\n    border-radius: .2rem;\r\n    padding: 1em;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    padding: 10px 20px;\r\n    // margin: 0 5px;\r\n    margin-bottom: -70px;\r\n    font-family: 'Roboto';\r\n    border: 1px solid #0071B9;\r\n    -webkit-transition: all .3s ease-in-out;\r\n    -moz-transition: all .3s ease-in-out;\r\n    -ms-transition: all .3s ease-in-out;\r\n    -o-transition: all .3s ease-in-out;\r\n    transition: all .3s ease-in-out;\r\n    margin: 30px 0 0 10px;\r\n}\r\n\r\nbody .hs-button.primary:hover,\r\nbody input[type=\"submit\"]:hover,\r\nbody input[type=\"button\"]:hover {\r\n    cursor: pointer;\r\n    opacity: .8\r\n}\r\n\r\nbody input[type=\"file\"] {\r\n    margin: 25px 0 25px 0;\r\n    font-family: 'Roboto';\r\n}\r\n\r\n.hs-form .hs-error-msgs label {\r\n    color: #d8000c;\r\n    font-size: 13px;\r\n    padding-bottom: 5px;\r\n}\r\n\r\n.material-icons {\r\n  user-select: none;\r\n}\r\n\r\n.d-inline-block {\r\n  user-select: none;\r\n}\r\n\r\n","/*Typography Styles*/\r\nh1, h2, h3, h4, h5, h6,\r\n.h1, .h2, .h3, .h4, .h5, .h6 {\r\n  font-weight: $headings-font-weight;\r\n  margin: 0 0 $headings-margin-bottom;\r\n  color: $headings-color;\r\n}\r\n\r\nh1, .h1 {\r\n  font-size: $h1-font-size;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\nh2, .h2 {\r\n  font-size: $h2-font-size;\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\nh3, .h3 {\r\n  font-size: $h3-font-size;\r\n}\r\n\r\nh4, .h4 {\r\n  font-size: $h4-font-size;\r\n}\r\n\r\nh5, .h5 {\r\n  font-size: $h5-font-size;\r\n}\r\n\r\nh6, .h6 {\r\n  font-size: $h6-font-size;\r\n}\r\n\r\n.text-strikethrough {\r\n  text-decoration: line-through !important;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  h1, .h1 {\r\n    font-size: $h2-font-size;\r\n    font-family: 'Poppins', sans-serif;\r\n  }\r\n\r\n  h2, .h2 {\r\n    font-size: $h3-font-size;\r\n    font-family: 'Poppins', sans-serif;\r\n  }\r\n\r\n  h3, .h3 {\r\n    font-size: $h4-font-size;\r\n  }\r\n}\r\n\r\n.desc-list {\r\n  margin-bottom: 0;\r\n  li {\r\n    padding: $jr-card-padding;\r\n    border-bottom: 1px solid $gray-400;\r\n    margin-left: -$jr-card-margin + 4px;\r\n    margin-right: -$jr-card-margin + 4px;\r\n\r\n    &:last-child {\r\n      border-bottom: 0 none;\r\n    }\r\n\r\n    & .card-title {\r\n      margin-bottom: 6px;\r\n    }\r\n\r\n  }\r\n\r\n  &.even-odd {\r\n    li {\r\n      border-bottom: 0 none;\r\n\r\n      &:nth-child(2n) {\r\n        background-color: $gray-300;\r\n      }\r\n    }\r\n  }\r\n}","/* Layouts\r\n   ========================================================================== */\r\n@import \"app-layout\";\r\n@import \"sidebar\";\r\n@import \"header\";\r\n@import \"navbar\";\r\n@import \"main-content\";\r\n@import \"footer\";\r\n@import \"right-sidebar\";","/*App Layout Styles*/\r\n\r\n#app-site,\r\n.app-main {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.app-container {\r\n  @include display-flex(flex, row, nowrap);\r\n  width: 100%;\r\n}\r\n\r\n.app-sidebar {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: $side-nav-width;\r\n  min-width: $side-nav-width;\r\n  max-width: $side-nav-width;\r\n}\r\n\r\n.app-main-container {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.app-header {\r\n  min-height: $app-bar-height;\r\n  z-index: 99;\r\n  position: relative;\r\n}\r\n\r\n.app-main-content-wrapper {\r\n  flex: 1;\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.app-container {\r\n  &.fixed-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n  }\r\n\r\n  &.collapsible-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n\r\n    & .app-main-container {\r\n      position: relative;\r\n    }\r\n  }\r\n\r\n  &.mini-drawer {\r\n    & .app-main-header {\r\n      width: auto !important;\r\n      @include transition(all 0.5s $transition-ease-out !important);\r\n    }\r\n\r\n    .app-sidebar {\r\n      width: $mini-drawer-width;\r\n      min-width: $mini-drawer-width;\r\n      max-width: $mini-drawer-width;\r\n    }\r\n  }\r\n}\r\n","/*Sidebar Styles*/\r\n\r\n.side-nav {\r\n  width: $side-nav-width;\r\n  background-color: $sidebar-bg !important;\r\n  color: $sidebar-text-color !important;\r\n  border-right: solid 1px $gray-200 !important;\r\n  z-index: 1250 !important;\r\n  height: 100%;\r\n\r\n  & .user-profile {\r\n    background-color: $sidebar-bg-darken;\r\n    padding: 13px 20px !important;\r\n  }\r\n\r\n  & .user-avatar {\r\n    margin: 0 15px 0 0 !important;\r\n    height: 44px !important;\r\n    width: 44px !important;\r\n    line-height: 44px;\r\n  }\r\n\r\n  & .user-detail {\r\n    & .user-name {\r\n      color: $sidebar-hover-color;\r\n      cursor: pointer;\r\n      font-size: $font-size-base;\r\n      font-weight: 400;\r\n      white-space: nowrap;\r\n    }\r\n  }\r\n}\r\n\r\n.user-detail {\r\n  & .user-name {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n/*Navbar Styles*/\r\nul.nav-menu {\r\n  position: relative;\r\n  font-size: $font-size-base;\r\n  list-style: outside none none;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\nul.nav-menu li {\r\n  position: relative;\r\n  margin-bottom: 1px;\r\n}\r\n\r\nul.nav-menu li.menu {\r\n  & + .nav-header {\r\n    margin-top: 40px;\r\n  }\r\n  & .sub-menu {\r\n    display: none;\r\n  }\r\n  &.open > .sub-menu {\r\n    display: block;\r\n  }\r\n\r\n  &.open {\r\n    & .menu.active > .sub-menu {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\nul.nav-menu li a {\r\n  color: $sidebar-text-color;\r\n  display: block;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  // text-transform: capitalize;\r\n  text-decoration: none;\r\n  @include border-radius(0);\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n    padding: 3px 8px 2px;\r\n  }\r\n}\r\n\r\nul.nav-menu {\r\n  & .nav-header {\r\n    color: $sidebar-text-color;\r\n    padding: 4px 22px;\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n\r\n    &:first-child {\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n}\r\n\r\nul.nav-menu > li.selected > a,\r\nul.nav-menu > li.open > a,\r\nul.nav-menu > li > a:hover,\r\nul.nav-menu > li > a:focus {\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\nul.nav-menu li.menu > a {\r\n  padding: 16px 20px;\r\n  border-left: 2px solid transparent;\r\n}\r\n\r\nul.nav-menu li.menu.open > a {\r\n  border-color: transparent;\r\n}\r\n\r\nul.nav-menu li.menu > a:focus:before,\r\nul.nav-menu li.menu > a:hover:before {\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\nul.nav-menu li i {\r\n  margin-right: 12px;\r\n  font-size: 15px;\r\n}\r\n\r\nul.nav-menu li ul {\r\n  list-style: outside none none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu li > a {\r\n  padding: 7px 20px 7px 56px;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu > li > ul > li > a {\r\n  padding-left: 76px;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu > li > ul > li > ul > li > a {\r\n  padding-left: 96px;\r\n}\r\n\r\nul.nav-menu li ul.sub-menu > li > ul > li > ul > li > ul > li > a {\r\n  padding-left: 116px;\r\n}\r\n\r\nul.nav-menu li.menu > a:before {\r\n  color: $sidebar-text-color;\r\n  content: \"\\f2fb\";\r\n  display: inline-block;\r\n  float: right;\r\n  font: {\r\n    family: 'Material-Design-Iconic-Font';\r\n    size: 15px;\r\n  }\r\n  margin-left: 10px;\r\n  position: relative;\r\n  @include transition(all 300ms ease-in-out);\r\n  font-weight: normal;\r\n}\r\nul.nav-menu li.menu.no-arrow > a:before {\r\n  display: none;\r\n}\r\n\r\nul.nav-menu li.menu.selected > a:before,\r\nul.nav-menu li.menu.open > a:before,\r\nul.nav-menu li.menu > a:focus:before,\r\nul.nav-menu li.menu li > a:hover:before {\r\n  background-color: transparent;\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\nul.nav-menu li.menu.open > a:before,\r\nul.nav-menu li.menu.active > a:before {\r\n  @include rotate(90deg);\r\n}\r\n\r\nul.nav-menu li.menu .sub-menu li > a.active .nav-text {\r\n  padding: 3px 7px;\r\n  margin-left: -7px;\r\n  background-color: $sidebar-hover-color;\r\n  color: $white;\r\n  @include border-radius($border-radius);\r\n  display: inline-block;\r\n}\r\n\r\nul.nav-menu li.menu .sub-menu li > a:hover,\r\nul.nav-menu li.menu .sub-menu li > a:focus,\r\nul.nav-menu li.menu.open .sub-menu li > a.active:before,\r\nul.nav-menu li.menu .sub-menu li > a:focus:before,\r\nul.nav-menu li.menu .sub-menu li > a:hover:before {\r\n  color: $sidebar-hover-color;\r\n}\r\n\r\n.app-container.mini-drawer {\r\n  & .side-nav {\r\n    @include transition($transition-base);\r\n    width: $mini-drawer-width;\r\n\r\n    & .nav-menu li span.nav-text,\r\n    & .customizer {\r\n      display: none;\r\n    }\r\n\r\n    & .user-profile .user-detail {\r\n      display: none !important;\r\n    }\r\n\r\n    & .nav-menu .menu.open > .sub-menu {\r\n      display: none !important;\r\n    }\r\n\r\n    & .nav-menu li {\r\n      text-align: center;\r\n      i {\r\n        margin-right: 0;\r\n      }\r\n\r\n      &.nav-header {\r\n        padding: 4px 5px;\r\n      }\r\n    }\r\n\r\n    & ul.nav-menu {\r\n      & li a {\r\n        padding: 16px 20px;\r\n      }\r\n      & ul.sub-menu li a {\r\n        padding-left: 30px;\r\n      }\r\n    }\r\n\r\n    & ul.nav-menu > li > a {\r\n      &:before {\r\n        display: none;\r\n      }\r\n    }\r\n\r\n    & .mini-logo-img-hover {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.app-container.mini-drawer {\r\n  & .side-nav:hover {\r\n    width: $side-nav-width;\r\n\r\n    & .nav-menu li span.nav-text {\r\n      display: inline-block !important;\r\n    }\r\n\r\n    & .user-profile .user-detail {\r\n      display: flex !important;\r\n    }\r\n\r\n    & .nav-menu .menu.open > .sub-menu {\r\n      display: block !important;\r\n    }\r\n\r\n    & .customizer {\r\n      display: flex !important;\r\n    }\r\n\r\n    & ul.nav-menu {\r\n      & li {\r\n        text-align: left;\r\n        & i {\r\n          margin-right: 16px;\r\n        }\r\n\r\n        & a {\r\n          padding: 16px 20px;\r\n        }\r\n\r\n        &.nav-header {\r\n          padding: 4px 22px;\r\n        }\r\n      }\r\n\r\n      & ul.sub-menu li a {\r\n        padding: 7px 20px 7px 56px;\r\n      }\r\n\r\n      & ul.sub-menu > li > ul > li > a {\r\n        padding-left: 76px;\r\n      }\r\n\r\n      & ul.sub-menu > li > ul > li > ul > li > a {\r\n        padding-left: 96px;\r\n      }\r\n\r\n      & ul.sub-menu > li > ul > li > ul > li > ul > li > a {\r\n        padding-left: 116px;\r\n      }\r\n    }\r\n\r\n    & ul.nav-menu > li > a {\r\n      &:before {\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    & .mini-logo-img {\r\n      display: none;\r\n    }\r\n\r\n    & .mini-logo-img-hover {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n.customizer {\r\n  padding: 20px 35px;\r\n  & img {\r\n    padding: 5px;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.user-info {\r\n  & ul {\r\n    & li {\r\n      font-size: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n.rmc-drawer {\r\n  &-left &-sidebar,\r\n  &-right &-sidebar {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.rmc-drawer-sidebar {\r\n  position: fixed;\r\n  transition: -webkit-transform 0.3s ease-out;\r\n  transition: transform 0.3s ease-out;\r\n  overflow: hidden;\r\n\r\n  .rmc-drawer.rmc-drawer-left & {\r\n    left: 0;\r\n    -webkit-transform: translateX(-100%);\r\n    transform: translateX(-100%);\r\n    z-index: 903;\r\n  }\r\n\r\n  .rmc-drawer.rmc-drawer-right & {\r\n    right: 0;\r\n    -webkit-transform: translateX(100%);\r\n    transform: translateX(100%);\r\n    z-index: 903;\r\n  }\r\n\r\n  .rmc-drawer.rmc-drawer-top & {\r\n    z-index: 903;\r\n  }\r\n\r\n  .rmc-drawer.rmc-drawer-bottom & {\r\n    z-index: 903;\r\n  }\r\n}\r\n\r\n.rmc-drawer-draghandle {\r\n  @media (max-width: 1025px) {\r\n    background-color: transparent;\r\n  }\r\n}\r\n\r\n.drawer-container {\r\n  position: relative;\r\n  & .main {\r\n    position: relative;\r\n    padding: 10px;\r\n    box-sizing: border-box;\r\n  }\r\n}\r\n\r\n.rmc-drawer-overlay {\r\n  z-index: 902;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transition: opacity 0.3s ease-out;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  height: 100%;\r\n  min-width: 100% !important;\r\n}\r\n\r\n.app-sidebar {\r\n  &.rmc-drawer.rmc-drawer-docked {\r\n    position: relative;\r\n  }\r\n}","/*Header Styles*/\r\n.jr-menu-icon {\r\n  outline: none !important;\r\n  @include justify-content(flex-start !important);\r\n  @extend %size-30;\r\n  padding: 0 5px !important;\r\n  @extend %jr-menu-icon;\r\n  margin-right: 15px;\r\n  display: flex;\r\n  cursor: pointer;\r\n  align-items: center;\r\n}\r\n\r\n.app-main-header {\r\n  background-color: $white;\r\n  color: $gray-default;\r\n  max-height: 70px;\r\n  position: relative;\r\n\r\n  & .search-bar input {\r\n    @include transition($transition-base);\r\n    background-color: transparent;\r\n    color: $gray-default;\r\n    // font-size: 18px;\r\n    font-weight: 200;\r\n    & + .search-icon {\r\n      top: 0;\r\n      & i {\r\n        color: rgba($gray-default, 0.8);\r\n        font-size: 32px;\r\n      }\r\n    }\r\n    &::placeholder {\r\n      color: grey;\r\n\r\n    }\r\n\r\n    &:focus {\r\n      background-color: $body-bg;\r\n      color: $gray-default;\r\n      + .search-icon {\r\n        & i {\r\n          color: rgba($gray-default, 0.8);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .app-header & {\r\n    //box-shadow: rgb(222, 226, 230) 1px 1px 10px;\r\n    // border-bottom: 1px solid $border-color;\r\n  }\r\n\r\n  .jr-card & {\r\n    border: 1px solid $gray-400;\r\n    @include border-radius($border-radius-lg);\r\n  }\r\n}\r\n\r\n.app-logo {\r\n  margin-right: 12px;\r\n\r\n  & img {\r\n    height: 35px;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      height: 28px;\r\n    }\r\n  }\r\n\r\n  .app-header & {\r\n    margin-right: 20px;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      margin-right: auto;\r\n    }\r\n  }\r\n}\r\n\r\n//Logo disable condition\r\n.react-logo-white.d-block {\r\n  display: none !important;\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n  .react-logo-white.d-lg-block {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.sidebar-header {\r\n  min-height: 70px;\r\n  padding: 10px 22px;\r\n  // border-bottom: 1px solid $border-color;\r\n}\r\n\r\n.app-toolbar {\r\n  min-height: $app-bar-height;\r\n  padding: 0 17px 0 0;\r\n\r\n  & .search-bar {\r\n    margin-right: auto;\r\n    max-width: 320px;\r\n    width: 300px;\r\n\r\n    @media screen and (max-width: 1199px) {\r\n      width: 240px;\r\n    }\r\n\r\n    @media screen and (max-width: 1099px) {\r\n      width: 200px;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      margin-left: 40px;\r\n      width: 180px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0 17px;\r\n  }\r\n\r\n  @media screen and (max-width: 1199px) {\r\n    padding: 0 17px;\r\n  }\r\n\r\n  .app-top-nav & {\r\n    min-height: 40px;\r\n  }\r\n}\r\n\r\n.app-header-horizontal {\r\n  & .app-toolbar .search-bar {\r\n    @media screen and (max-width: 1199px) {\r\n      margin-right: 10px;\r\n    }\r\n  }\r\n}\r\n\r\n.app-toolbar-special {\r\n  & .search-bar {\r\n    width: 200px;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      width: 280px;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      width: 200px;\r\n    }\r\n  }\r\n}\r\n\r\n.app-toolbar {\r\n  & .nav-searchbox {\r\n    & .search-bar {\r\n      margin-left: 0;\r\n      width: 100%;\r\n    }\r\n\r\n    & .search-bar input {\r\n      @include transition($transition-base);\r\n      background-color: $white;\r\n      color: $body-color;\r\n      & + .search-icon {\r\n        & i {\r\n          color: rgba($body-color, 0.8);\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        background-color: transparent;\r\n        color: $body-color;\r\n        + .search-icon {\r\n          & i {\r\n            color: rgba($body-color, 0.8);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.header-notifications {\r\n  margin-bottom: 0;\r\n\r\n  & li {\r\n    vertical-align: middle;\r\n  }\r\n\r\n  & .list-inline-item:not(:last-child) {\r\n    @media screen and (max-width: 449px) {\r\n      margin-right: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu {\r\n  @include box-shadow(none);\r\n}\r\n\r\n.quick-menu {\r\n\r\n  & .dropdown-menu {\r\n    padding: 5px 10px;\r\n    width: 350px;\r\n\r\n    & .jr-card-header {\r\n      margin: -5px -10px 5px;\r\n      padding: 10px 10px 10px 20px;\r\n      border-bottom: 1px solid $gray-300;\r\n      z-index: 10;\r\n    }\r\n\r\n    &:after {\r\n      border-left: 5px solid transparent;\r\n      border-right: 5px solid transparent;\r\n      border-bottom: 5px solid $white;\r\n      top: -9px;\r\n      content: \"\";\r\n      height: 9px;\r\n      position: absolute;\r\n      right: 8px;\r\n      width: 10px;\r\n    }\r\n\r\n    &:before {\r\n      border-left: 5px solid transparent;\r\n      border-right: 5px solid transparent;\r\n      border-bottom: 5px solid $black;\r\n      top: -10px;\r\n      content: \"\";\r\n      height: 10px;\r\n      position: absolute;\r\n      right: 8px;\r\n      width: 10px;\r\n    }\r\n\r\n    @media screen and (max-width: 449px) {\r\n      width: 230px;\r\n    }\r\n\r\n    @media screen and (max-width: 359px) {\r\n      width: 180px;\r\n    }\r\n  }\r\n\r\n  & .messages-list .user-avatar {\r\n    position: relative;\r\n  }\r\n\r\n  & .messages-list .badge {\r\n    position: absolute;\r\n    left: -4px;\r\n    top: -4px;\r\n    height: 16px;\r\n    width: 16px;\r\n    line-height: 16px;\r\n    text-align: center;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.app-header .nav-searchbox.quick-menu {\r\n  & .dropdown-menu {\r\n    width: 200px;\r\n    left: 0 !important;\r\n    right: auto !important;\r\n  }\r\n\r\n  & .dropdown-menu:after {\r\n    right: auto;\r\n    left: 8px;\r\n  }\r\n\r\n  & .dropdown-menu:before {\r\n    right: auto;\r\n    left: 8px;\r\n  }\r\n\r\n  @media screen and (max-width: 400px) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .app-header .nav-searchbox.quick-menu .dropdown-menu {\r\n    width: 200px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .app-header .nav-searchbox.quick-menu .dropdown-menu {\r\n    width: 100px;\r\n  }\r\n}\r\n\r\n.language-list li {\r\n  display: block !important;\r\n}\r\n\r\n.messages-list.language-list ul li {\r\n  padding: 7px 6px 6px;\r\n}\r\n\r\n.messages-list ul li {\r\n  position: relative;\r\n  padding: 20px 10px 14px;\r\n  border-bottom: 1px solid $gray-300;\r\n\r\n  & .user-name a {\r\n    color: $app-primary;\r\n  }\r\n\r\n  & .sub-heading {\r\n    font-size: 11px;\r\n    margin-bottom: 6px !important;\r\n\r\n    &.mb-0 {\r\n      margin-bottom: 0 !important;\r\n    }\r\n  }\r\n\r\n  &:last-child {\r\n    border-bottom: 0 none;\r\n  }\r\n\r\n  & .jr-btn {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  & .jr-btn-xs {\r\n    font-size: 11px !important;\r\n    padding: 5px !important;\r\n  }\r\n}\r\n\r\n.quick-menu {\r\n  & .icon-btn {\r\n    color: $gray-default;\r\n  }\r\n\r\n  & .icon-alert {\r\n    position: relative;\r\n\r\n    &:after {\r\n      display: block;\r\n      position: absolute;\r\n      content: \"\";\r\n      right: 0;\r\n      top: 0;\r\n      z-index: 10;\r\n      width: 8px;\r\n      height: 8px;\r\n      background-color: $danger;\r\n      @include border-radius(50%);\r\n      @extend %pulse-effect;\r\n    }\r\n  }\r\n\r\n  & i.animated.infinite {\r\n    -moz-animation-iteration-count: 25;\r\n    -webkit-animation-iteration-count: 25;\r\n    -o-animation-iteration-count: 25;\r\n    animation-iteration-count: 25;\r\n  }\r\n}\r\n\r\n.quick-menu {\r\n  & .dropdown-menu {\r\n    display: block;\r\n    visibility: hidden;\r\n    left: auto !important;\r\n    right: 0 !important;\r\n    opacity: 0;\r\n    transform: translate3d(0px, 100px, 0px) !important;\r\n    @include transition(all 200ms linear 0ms);\r\n  }\r\n\r\n  &.show .dropdown-menu {\r\n    opacity: 1;\r\n    transform: translate3d(0px, 30px, 0px) !important;\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n.user-nav .quick-menu {\r\n  & .dropdown-menu {\r\n    width: 200px;\r\n    padding: 0 0 15px;\r\n\r\n    &:after {\r\n      border-bottom-color: $body-bg;\r\n    }\r\n  }\r\n\r\n  & .user-profile {\r\n    position: relative;\r\n    padding: 20px 25px;\r\n    background-color: $body-bg;\r\n    margin-bottom: 15px;\r\n    @include border-radius(0.25rem 0.25rem 0 0);\r\n  }\r\n}\r\n\r\n.module-box-header-right {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n}\r\n\r\n.app-top-header {\r\n  position: relative;\r\n  z-index: 9999;\r\n}\r\n","/*Navbar Styles*/\r\n.app-main-menu {\r\n  & .navbar-nav {\r\n    @include display-flex();\r\n  }\r\n}\r\n\r\n.navbar-nav {\r\n  position: relative;\r\n\r\n  & li {\r\n    position: relative;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      & > ul.sub-menu {\r\n        opacity: 1;\r\n        visibility: visible;\r\n        top: 100%;\r\n      }\r\n\r\n      & > a {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n\r\n    & a {\r\n      display: block;\r\n      color: $sidebar-text-color;\r\n      padding: 10px 0;\r\n      font-size: 14px;\r\n    }\r\n\r\n    & a:hover,\r\n    & a:focus {\r\n      text-decoration: none;\r\n      color: $app-primary;\r\n    }\r\n\r\n    &.mega-menu {\r\n      position: static;\r\n    }\r\n\r\n    &.mega-menu ul.sub-menu {\r\n      @include display-flex();\r\n      width: 85%;\r\n      margin: 0 auto;\r\n      left: 0;\r\n      right: 0;\r\n\r\n      & li {\r\n        width: 25%;\r\n        padding: 0 15px;\r\n      }\r\n    }\r\n  }\r\n\r\n  & > li {\r\n    &:last-child {\r\n      ul.sub-menu {\r\n        left: auto;\r\n        right: 0;\r\n      }\r\n\r\n      ul.sub-menu ul.sub-menu {\r\n        left: auto;\r\n        right: 100%;\r\n        top: 50px;\r\n      }\r\n\r\n      ul.sub-menu li:hover > ul.sub-menu,\r\n      ul.sub-menu li:focus > ul.sub-menu {\r\n        top: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  & li.nav-item {\r\n    padding: 0 10px;\r\n\r\n    & > a {\r\n      padding: 23px 0;\r\n    }\r\n\r\n    &.active > a {\r\n      color: $app-primary;\r\n    }\r\n  }\r\n\r\n  & li.nav-item:hover > a,\r\n  & li.nav-item:focus > a,\r\n  & li.nav-item > a:hover,\r\n  & li.nav-item > a:focus {\r\n    color: $app-primary;\r\n  }\r\n\r\n  ul.sub-menu {\r\n    list-style: none;\r\n    border: solid 1px $gray-400;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 100px;\r\n    opacity: 0;\r\n    padding: 10px 0;\r\n    background-color: $white;\r\n    visibility: hidden;\r\n    @include border-radius(4px);\r\n    @include transition(all 0.5s ease-in-out);\r\n\r\n    & li {\r\n      & a {\r\n        padding: 5px 15px;\r\n        width: 200px;\r\n        font-size: 14px;\r\n\r\n        &.active {\r\n          color: $app-primary;\r\n        }\r\n      }\r\n\r\n      & > ul.sub-menu {\r\n        left: 100%;\r\n        right: auto;\r\n        top: 50px;\r\n      }\r\n\r\n      &:hover > ul.sub-menu,\r\n      &:focus > ul.sub-menu {\r\n        top: 0;\r\n      }\r\n\r\n      & a i {\r\n        margin-right: 10px;\r\n      }\r\n\r\n      &.active > a {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n  }\r\n\r\n  & .nav-arrow {\r\n    & > a {\r\n      position: relative;\r\n\r\n      &:before {\r\n        color: $sidebar-text-color;\r\n        content: \"\\f2fb\";\r\n        display: inline-block;\r\n        float: right;\r\n        font: {\r\n          family: 'Material-Design-Iconic-Font';\r\n          size: 15px;\r\n        }\r\n        margin-left: 10px;\r\n        position: relative;\r\n        @include transition(all 300ms ease-in-out);\r\n        font-weight: normal;\r\n      }\r\n    }\r\n\r\n    & a:hover,\r\n    & a:focus {\r\n      &:before {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &.active {\r\n      & > a:before {\r\n        color: $app-primary;\r\n      }\r\n    }\r\n  }\r\n\r\n  ul.sub-menu-half {\r\n    @include display-flex();\r\n    width: 300px;\r\n\r\n    & li {\r\n      width: 50%;\r\n\r\n      & a {\r\n        width: 100%;\r\n\r\n        @media screen and (max-width: 1099px) {\r\n          font-size: 13px;\r\n        }\r\n      }\r\n    }\r\n\r\n    @media screen and (max-width: 1099px) {\r\n      width: 262px;\r\n    }\r\n  }\r\n}\r\n\r\n.navbar-nav-mega {\r\n  position: static !important;\r\n}\r\n\r\n.app-top-nav {\r\n  background-color: $top-nav-bg;\r\n\r\n  & .navbar-nav {\r\n    & li.nav-item {\r\n      padding: 0 30px;\r\n    }\r\n\r\n    & li.nav-item > a {\r\n      color: $white;\r\n      padding: 13px 0;\r\n    }\r\n\r\n    & li.nav-item:hover > a,\r\n    & li.nav-item:focus > a,\r\n    & li.nav-item > a:hover,\r\n    & li.nav-item > a:focus,\r\n    & li.nav-item.active > a {\r\n      color: $secondary;\r\n    }\r\n\r\n    & ul.sub-menu {\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}","/*Main Content Styles*/\r\n.app-main-content {\r\n  flex: 1;\r\n  width: 100%;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.app-wrapper {\r\n  padding: 36px 40px 0 40px;\r\n  width: 100%;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 20px;\r\n  }\r\n}","/*Footer Styles*/\r\n\r\n.app-footer {\r\n  padding: 0 40px;\r\n  border-top: solid 1px darken($body-bg, 10%);\r\n  background-color: $body-bg;\r\n  color: $sidebar-text-color;\r\n  line-height: $footer-height;\r\n  min-height: $footer-height;\r\n\r\n  & a {\r\n    color: $sidebar-text-color;\r\n    &:hover {\r\n      color: $sidebar-hover-color;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 20px;\r\n  }\r\n\r\n  @media screen and (max-width: 400px) {\r\n    font-size: 12px;\r\n  }\r\n}","/*Right Sidebar Styles*/\r\n.color-theme {\r\n  @include display-flex(flex, column, nowrap);\r\n  max-width: 300px;\r\n  height: 100%;\r\n\r\n  @media screen and (max-width: 499px) {\r\n    max-width: 250px;\r\n  }\r\n}\r\n\r\n.color-theme-header {\r\n  background-color: $app-primary;\r\n  color: $white;\r\n  padding: 19px 25px 20px;\r\n  text-transform: uppercase;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-between);\r\n\r\n  & .color-theme-title {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.color-theme-body {\r\n  padding: 28px 25px;\r\n\r\n  & h3 {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  @media screen and (max-width: 499px) {\r\n    padding: 25px 15px;\r\n  }\r\n}\r\n\r\n.color-option {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  margin: 0 -7px 10px;\r\n\r\n  & li {\r\n    position: relative;\r\n    display: inline-block;\r\n    padding: 0 7px;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  & li a {\r\n    height: 45px;\r\n    width: 45px;\r\n    line-height: 45px;\r\n    display: inline-block;\r\n    color: transparent !important;\r\n    position: relative;\r\n\r\n    &:before {\r\n      content: \"\\f26b\";\r\n      font-family: \"Material-Design-Iconic-Font\";\r\n      font-size: 20px;\r\n      height: 45px;\r\n      width: 45px;\r\n      line-height: 45px;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      color: $white;\r\n      text-align: center;\r\n      display: none;\r\n      z-index: 2;\r\n    }\r\n  }\r\n\r\n  & li a.active {\r\n    &:before {\r\n      display: block;\r\n    }\r\n  }\r\n}\r\n\r\n.cr-op-dark-sidebar {\r\n  & li a {\r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      bottom: 0;\r\n      z-index: 1;\r\n      background-color: $body-color;\r\n      width: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n//Coustomizer css\r\n.theme-option {\r\n  position: fixed;\r\n  top: 10%;\r\n  right: 0;\r\n  z-index: 1500;\r\n  background-color: #0070cd;\r\n  @include border-left-radius($border-radius);\r\n  @include box-shadow(1px 1px 4px rgba($black, 0.5));\r\n  color: $white;\r\n\r\n  & span.icon-btn {\r\n    position: relative;\r\n    z-index: 1505;\r\n  }\r\n}\r\n\r\n.app-sidebar-content.right-sidebar .rmc-drawer-sidebar {\r\n  z-index: 1506;\r\n  color: $body-color;\r\n  background-color: $white;\r\n}\r\n\r\n//Switch button\r\n.material-switch {\r\n  margin-bottom: 24px;\r\n\r\n  & > input[type=\"checkbox\"] {\r\n    display: none;\r\n  }\r\n\r\n  & > label {\r\n    cursor: pointer;\r\n    height: 0;\r\n    position: relative;\r\n    width: 40px;\r\n\r\n    &:before {\r\n      background: rgb(0, 0, 0);\r\n      box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);\r\n      border-radius: 8px;\r\n      content: '';\r\n      height: 16px;\r\n      margin-top: -8px;\r\n      position: absolute;\r\n      opacity: 0.3;\r\n      transition: all 0.4s ease-in-out;\r\n      width: 40px;\r\n    }\r\n\r\n    &:after {\r\n      background: rgb(255, 255, 255);\r\n      border-radius: 16px;\r\n      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\r\n      content: '';\r\n      height: 24px;\r\n      left: -4px;\r\n      margin-top: -8px;\r\n      position: absolute;\r\n      top: -4px;\r\n      transition: all 0.3s ease-in-out;\r\n      width: 24px;\r\n    }\r\n  }\r\n\r\n  & > input[type=\"checkbox\"]:checked + label::before {\r\n    background: $black;\r\n    opacity: 0.5;\r\n  }\r\n\r\n  & > input[type=\"checkbox\"]:checked + label::after {\r\n    background: $gray-700;\r\n    left: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 499px) {\r\n  .color-theme .jr-btn {\r\n    padding: 10px 15px !important;\r\n  }\r\n}\r\n","/* UI Components\r\n   ========================================================================== */\r\n@import \"alert\";\r\n@import \"avatar\";\r\n@import \"badges\";\r\n@import \"blockquotes\";\r\n@import \"bottom-navigation\";\r\n@import \"breadcrumb\";\r\n@import \"button\";\r\n@import \"button-group\";\r\n@import \"callout\";\r\n@import \"card\";\r\n@import \"charts\";\r\n@import \"chip\";\r\n@import \"carousel\";\r\n@import \"color-picker\";\r\n@import \"date-input\";\r\n@import \"drawer\";\r\n@import \"e-commerce\";\r\n@import \"grid-list\";\r\n@import \"icons\";\r\n@import \"label\";\r\n@import \"list\";\r\n@import \"nav\";\r\n@import \"pricing-tables\";\r\n@import \"progressbar\";\r\n@import \"popover\";\r\n@import \"tables\";\r\n@import \"tabs\";\r\n@import \"testimonial\";\r\n@import \"timeline\";\r\n@import \"form\";\r\n@import \"ad-form\";\r\n@import \"input\";","/*Alert Styles*/\r\n.alert {\r\n  border: 0 none;\r\n  padding: 20px 24px;\r\n  @include border-radius($border-radius-lg);\r\n  position: relative;\r\n\r\n  & .close {\r\n    line-height: inherit;\r\n    font-weight: $font-weight-light;\r\n  }\r\n\r\n  & .alert-addon {\r\n    width: $size-60;\r\n    background-color: rgba($black, 0.2);\r\n    @include display-flex(flex, column, nowrap);\r\n    @include justify-content(center);\r\n    @include align-items(center);\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.alert-dismissible {\r\n  padding-right: $size-60;\r\n}\r\n\r\n.alert-addon-card {\r\n  padding-left: $size-80;\r\n}","/*Avatar Styles*/\r\n.user-avatar {\r\n  @extend %size-50;\r\n  display: -webkit-inline-flex;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-flex-direction: row;\r\n  -ms-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-flex-wrap: nowrap;\r\n  -ms-flex-wrap: nowrap;\r\n  flex-wrap: nowrap;\r\n  position: relative;\r\n  overflow: hidden;\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n  -webkit-flex-shrink: 0;\r\n  flex-shrink: 0;\r\n  @include border-radius(50%);\r\n  -moz-user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  border: $jr-border;\r\n\r\n  &.avatar-shadow {\r\n    border: 0 none;\r\n  }\r\n}\r\n\r\n.user-profile {\r\n  @include display-flex();\r\n  @include align-items(flex-start);\r\n\r\n  & .user-detail {\r\n    -webkit-flex: 1;\r\n    flex: 1;\r\n    -ms-flex-align: center;\r\n    -webkit-align-self: center;\r\n    align-self: center;\r\n  }\r\n}\r\n\r\n.user-detail {\r\n  & .user-name {\r\n    margin-bottom: 2px;\r\n    font-weight: 400;\r\n    text-transform: capitalize;\r\n  }\r\n  & .user-description {\r\n    font-size: 12px;\r\n    margin-bottom: 0;\r\n    color: $gray-500;\r\n  }\r\n}\r\n\r\n.user-thumb {\r\n  position: relative;\r\n\r\n  .messages-list & {\r\n    margin-right: 8px;\r\n  }\r\n}\r\n","/*Badges Styles*/\r\n.badge {\r\n  font-weight: 400;\r\n  padding: 3px 8px;\r\n  line-height: inherit;\r\n  margin-bottom: 6px;\r\n  @include border-radius($border-radius-sm);\r\n\r\n  &:not(:last-child) {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  table & {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.badge-pill {\r\n  @include border-radius(20px);\r\n}\r\n\r\n.badge-border {\r\n  border: 2px solid !important;\r\n}\r\n\r\n.badge-outline {\r\n  background-color: transparent;\r\n  border: $jr-border;\r\n}","/*Blockquotes Styles*/\r\nblockquote {\r\n  padding: 10px 0 10px 20px;\r\n  font-size: $font-size-base !important;\r\n\r\n  .blockquote-footer {\r\n    font-size: $font-size-base !important;\r\n  }\r\n}\r\n\r\n.blockquote {\r\n  border-left: 5px solid $gray-200;\r\n}\r\n\r\n.blockquote-reverse {\r\n  border-left: 0 none;\r\n  border-right: 5px solid $gray-200;\r\n  text-align: right;\r\n  padding-left: 0;\r\n  padding-right: 20px;\r\n}","/*Bottom Navigation Styles*/\r\n.bottom-navigation {\r\n  button {\r\n    min-width: 10px !important;\r\n  }\r\n}","/*Breadcrumb Styles*/\r\n.breadcrumb {\r\n  @include border-radius($border-radius-sm);\r\n}\r\n\r\n.breadcrumb-item + .breadcrumb-item::before {\r\n  content: '\\F2FB';\r\n  font: {\r\n    family: 'Material-Design-Iconic-Font';\r\n    size: 16px;\r\n  }\r\n  line-height: 1;\r\n  vertical-align: middle;\r\n}","/*Button Styles*/\r\nbutton {\r\n  outline: 0 none !important;\r\n  cursor: pointer;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.jr-btn {\r\n  position: relative;\r\n  display: inline-block;\r\n  font-size: $btn-font-size;\r\n  font-weight: $btn-font-weight;\r\n  // text-transform: capitalize;\r\n  line-height: $btn-line-height;\r\n  @include border-radius($border-radius);\r\n  vertical-align: top;\r\n  cursor: pointer;\r\n  text-align: center;\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    outline: 0 none;\r\n    text-decoration: none;\r\n    @include box-shadow(none !important);\r\n  }\r\n\r\n  .login-content & {\r\n    padding: 10px 35px;\r\n  }\r\n}\r\n\r\n.btn {\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    outline: 0 none;\r\n    text-decoration: none;\r\n    @include box-shadow(none !important);\r\n  }\r\n\r\n  .login-content & {\r\n    padding: 10px 35px;\r\n  }\r\n}\r\n\r\n.btn,\r\n.btn-info,\r\n.btn-success,\r\n.btn-warning,\r\n.btn-danger,\r\n.btn-light,\r\n.btn-dark,\r\n.btn-primary,\r\n.btn-secondary {\r\n  @extend %btn-no-shadow;\r\n  @include box-shadow(none !important);\r\n}\r\n\r\n.show > {\r\n  .btn,\r\n  .btn-info,\r\n  .btn-success,\r\n  .btn-warning,\r\n  .btn-danger,\r\n  .btn-light,\r\n  .btn-dark,\r\n  .btn-primary,\r\n  .btn-secondary {\r\n    &.dropdown-toggle:focus {\r\n      @include box-shadow(none !important);\r\n    }\r\n  }\r\n}\r\n\r\n.jr-btn,\r\n.jr-fab-btn,\r\n.jr-flat-btn,\r\n.btn {\r\n  margin-bottom: 6px;\r\n  // text-transform: capitalize;\r\n\r\n  &:not(:last-child) {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  .form-inline & {\r\n    margin-bottom: 0;\r\n    min-height: 35px;\r\n  }\r\n\r\n  .navbar & {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.btn-primary:focus, .btn-primary.focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.input-group > .input-group-prepend > .btn,\r\n.input-group > .input-group-append > .btn {\r\n  margin-right: 0;\r\n  margin-bottom: 0;\r\n  line-height: inherit;\r\n}\r\n\r\n.jr-fab-btn {\r\n  position: relative;\r\n  display: inline-flex;\r\n  @extend %size-50;\r\n  @include border-radius($border-radius-circle);\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n  background-color: map_get($gray, lighten-3);\r\n  overflow: hidden;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    outline: 0 none;\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n.jr-btn,\r\n.jr-flat-btn {\r\n  padding: $btn-padding;\r\n\r\n  & i + span,\r\n  & span + i {\r\n    margin-left: 6px;\r\n  }\r\n}\r\n\r\n.jr-flat-btn {\r\n  background-color: transparent;\r\n  color: $body-color;\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    background-color: map_get($gray, lighten-4);\r\n    color: $body-color;\r\n  }\r\n}\r\n\r\n.jr-btn-group {\r\n  margin: 0 -8px;\r\n\r\n  &:not(:last-child) {\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  & .jr-btn,\r\n  & .jr-fab-btn {\r\n    margin: 0 8px 18px;\r\n  }\r\n}\r\n\r\n.jr-btn-rounded {\r\n  @include border-radius(50px !important);\r\n}\r\n\r\n.jr-btn-lg {\r\n  padding: $btn-padding-lg;\r\n}\r\n\r\n.jr-btn-sm {\r\n  padding: $btn-padding-sm;\r\n}\r\n\r\n.jr-btn-xs {\r\n  padding: $btn-padding-xs;\r\n}\r\n\r\n// Fab Button\r\n.jr-btn-fab-lg {\r\n  @extend %size-60;\r\n}\r\n\r\n.jr-btn-fab-sm {\r\n  @extend %size-40;\r\n}\r\n\r\n.jr-btn-fab-xs {\r\n  @extend %size-30;\r\n}\r\n\r\n.jr-btn-fab-lg,\r\n.jr-btn-lg {\r\n  font-size: $btn-font-size-lg;\r\n  & i {\r\n    font-size: ($btn-font-size-lg + 2px);\r\n  }\r\n}\r\n\r\n.jr-btn-fab-sm,\r\n.jr-btn-sm {\r\n  font-size: ($btn-font-size-sm - 2px);\r\n  & i {\r\n    font-size: ($btn-font-size-sm - 2px);\r\n  }\r\n}\r\n\r\n.jr-btn-fab-xs,\r\n.jr-btn-xs {\r\n  font-size: $btn-font-size-xs;\r\n  & i {\r\n    font-size: $btn-font-size-xs;\r\n  }\r\n}\r\n\r\n.complex-btn-wrapper {\r\n  @include display-flex(flex, row, wrap);\r\n  min-width: 200px;\r\n  width: 100%;\r\n}\r\n\r\n.complex-btn {\r\n  position: relative;\r\n  height: 200px;\r\n  overflow: hidden;\r\n  width: 33.333%;\r\n  border: 0 none;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    width: 100%;\r\n    height: 100px;\r\n  }\r\n  &:hover {\r\n    z-index: 1;\r\n    & .img-btn-overlay {\r\n      opacity: 0.15;\r\n    }\r\n\r\n    & .img-marked {\r\n      opacity: 0;\r\n    }\r\n\r\n    & .img-title {\r\n      border: 4px solid currentColor;\r\n    }\r\n  }\r\n\r\n  .img-btn {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    display: flex;\r\n    @include align-items(center);\r\n    @include justify-content(center);\r\n    color: $white;\r\n  }\r\n  .img-src {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background-size: cover;\r\n    background-position: center 40%;\r\n  }\r\n\r\n  .img-btn-overlay {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    bottom: 0;\r\n    background: $black;\r\n    opacity: 0.4;\r\n    @include transition(all 0.5s $transition-ease);\r\n  }\r\n\r\n  .img-title {\r\n    position: relative;\r\n    padding: 16px 32px 14px;\r\n  }\r\n  .img-marked {\r\n    height: 3px;\r\n    width: 18px;\r\n    background: $white;\r\n    position: absolute;\r\n    bottom: -2px;\r\n    left: calc(50% - 9px);\r\n    @include transition(all 0.5s $transition-ease);\r\n  }\r\n}\r\n\r\n.btn-group-mins {\r\n  margin: 0 -5px;\r\n\r\n  & .btn,\r\n  & .jr-btn {\r\n    margin: 0 5px 5px;\r\n  }\r\n}\r\n\r\n//buttons in label\r\n\r\n.jr-btn.jr-btn-label i {\r\n  background-color: rgba($white, 0.2);\r\n  width: $size-40;\r\n  height: 100%;\r\n  line-height: 42px;\r\n  text-align: center;\r\n}\r\n\r\n.jr-btn.jr-btn-label.left i {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.jr-btn.jr-btn-label.right i {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.jr-btn.jr-btn-label.left i + span {\r\n  margin-left: $size-30;\r\n}\r\n\r\n.jr-btn.jr-btn-label.right i + span {\r\n  margin-right: $size-30;\r\n  margin-left: 0;\r\n}\r\n\r\n.jr-btn.jr-btn-label.jr-btn-lg i {\r\n  line-height: 54px;\r\n}\r\n\r\n.jr-btn.jr-btn-label.jr-btn-sm i {\r\n  line-height: 32px;\r\n}\r\n\r\n.jr-btn.jr-btn-label.jr-btn-xs i {\r\n  line-height: 24px;\r\n  width: $size-30;\r\n}\r\n\r\n//Button function\r\n@each $color_name, $color in $colors_palette {\r\n  @each $color_type, $color_value in $color {\r\n    @if $color_type == \"base\" {\r\n      .btn-#{$color_name} {\r\n        background-color: $color_value;\r\n        color: $white;\r\n        &:hover,\r\n        &:focus {\r\n          background-color: darken($color_value, 5%);\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.jr-btn-shadow {\r\n  @include box-shadow(0 1px 5px 0 rgba($black, 0.2), 0 2px 2px 0 rgba($black, 0.14), 0 3px 1px -2px rgba($black, 0.12) !important);\r\n  &:hover,\r\n  &:focus {\r\n    @include box-shadow(0 1px 5px 0 rgba($black, 0.2), 0 2px 2px 0 rgba($black, 0.14), 0 3px 1px -2px rgba($black, 0.12) !important);\r\n  }\r\n\r\n  &:active {\r\n    @include box-shadow(none !important);\r\n  }\r\n}\r\n\r\n.jr-btn.disabled,\r\n.jr-btn.disabled {\r\n  pointer-events: none;\r\n  opacity: 0.65;\r\n}\r\n\r\n.jr-btn-default {\r\n  background-color: $white;\r\n  color: $body-color;\r\n  border: 1px solid $gray-300;\r\n  &:hover,\r\n  &:focus {\r\n    background-color: darken($white, 5%);\r\n    color: $body-color;\r\n  }\r\n}\r\n\r\n.jr-btn-secondary {\r\n  background-color: $secondary;\r\n  color: $white;\r\n  &:hover,\r\n  &:focus {\r\n    background-color: darken($secondary, 5%);\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.jr-flat-btn.jr-btn-primary {\r\n  background-color: transparent;\r\n  color: $app-primary;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    background-color: rgba($app-primary, 0.12);\r\n    color: $app-primary;\r\n  }\r\n}\r\n\r\n.bg-primary {\r\n  & .jr-flat-btn.jr-btn-primary {\r\n    background-color: transparent;\r\n    color: $white;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      background-color: rgba($white, 0.12);\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.jr-flat-btn.jr-btn-secondary {\r\n  background-color: transparent;\r\n  color: $secondary;\r\n\r\n  &:hover,\r\n  &:focus {\r\n    background-color: rgba($secondary, 0.12);\r\n    color: $secondary;\r\n  }\r\n}\r\n\r\n.bg-secondary {\r\n  & .jr-flat-btn.jr-btn-secondary {\r\n    background-color: transparent;\r\n    color: $white;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      background-color: rgba($white, 0.12);\r\n      color: $white;\r\n    }\r\n  }\r\n}\r\n\r\n.jr-btn-hover:hover:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1;\r\n  display: inline-block;\r\n  background-color: rgba($black, 0.06);\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  padding-right: 0.5625rem;\r\n  padding-left: 0.5625rem;\r\n}\r\n\r\n.action-btn {\r\n  height: $size-40;\r\n  width: $size-40;\r\n  display: -webkit-inline-flex;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  @include align-items(center);\r\n  @include justify-content(center);\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n  color: rgba($black, 0.54);\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    text-decoration: none;\r\n    color: rgba($black, 0.64);\r\n  }\r\n\r\n  .circle-check & {\r\n    height: 24px;\r\n    width: 24px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat-main-header & {\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.action-replay .jr-btn-default {\r\n  font-size: 14px;\r\n  padding: 5px 10px;\r\n  border-color: $gray-600 !important;\r\n}\r\n\r\n.btn-outline-primary,\r\n.btn-outline-secondary {\r\n  &:focus {\r\n    @include box-shadow(none !important);\r\n  }\r\n}","/*Button Group Styles*/\r\n\r\n// stylelint-disable selector-no-qualifying-type\r\n\r\n// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: inline-flex;\r\n  vertical-align: middle; // match .btn alignment given font-size hack above\r\n\r\n  > .jr-btn {\r\n    position: relative;\r\n    flex: 0 1 auto;\r\n    border-color: $border-color;\r\n\r\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\r\n    // the borders properly\r\n    @include hover {\r\n      z-index: 2;\r\n    }\r\n    &:focus,\r\n    &:active,\r\n    &.active {\r\n      z-index: 2;\r\n    }\r\n\r\n    &.active {\r\n      background-color: $app-primary;\r\n      color: $white;\r\n      border-color: $app-primary;\r\n    }\r\n\r\n    &.jr-flat-btn {\r\n      border-color: transparent;\r\n      &.active {\r\n        background-color: transparent;\r\n        color: $app-primary;\r\n\r\n        &:hover,\r\n        &:focus {\r\n          background-color: rgba($app-primary, 0.12);\r\n          color: $app-primary;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  // Prevent double borders when buttons are next to each other\r\n  .jr-btn + .jr-btn,\r\n  .jr-btn + .btn-group,\r\n  .btn-group + .jr-btn,\r\n  .btn-group + .btn-group {\r\n    margin-left: -$input-btn-border-width;\r\n  }\r\n}\r\n\r\n.btn-group,\r\n.btn-group-vertical {\r\n\r\n  &.no-border > .btn-group > .jr-btn,\r\n  &.no-border > .btn-group-vertical > .jr-btn,\r\n  &.no-border > .jr-btn {\r\n    border-color: transparent;\r\n  }\r\n}\r\n\r\n// Optional: Group multiple button groups together for a toolbar\r\n.btn-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n\r\n  .input-group {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.btn-group > .jr-btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\r\n  border-radius: 0;\r\n}\r\n\r\n// Set corners individual because sometimes a single button can be in a .btn-group\r\n// and we need :first-child and :last-child to both match\r\n.btn-group > .jr-btn:first-child {\r\n  margin-left: 0;\r\n\r\n  &:not(:last-child):not(.dropdown-toggle) {\r\n    @include border-right-radius(0);\r\n  }\r\n}\r\n\r\n// Need .dropdown-toggle since :last-child doesn't apply given a .dropdown-menu\r\n// immediately after it\r\n.btn-group > .jr-btn:last-child:not(:first-child),\r\n.btn-group > .dropdown-toggle:not(:first-child) {\r\n  @include border-left-radius(0);\r\n}\r\n\r\n// Custom edits for including btn-groups within btn-groups (useful for including\r\n// dropdown buttons within a btn-group)\r\n.btn-group > .btn-group {\r\n  float: left;\r\n}\r\n\r\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .jr-btn {\r\n  border-radius: 0;\r\n}\r\n\r\n.btn-group > .btn-group:first-child:not(:last-child) {\r\n  > .jr-btn:last-child,\r\n  > .dropdown-toggle {\r\n    @include border-right-radius(0);\r\n  }\r\n}\r\n\r\n.btn-group > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {\r\n  @include border-left-radius(0);\r\n}\r\n\r\n\r\n// Sizing\r\n//\r\n// Remix the default button sizing classes into new ones for easier manipulation.\r\n\r\n.btn-group-sm > .jr-btn { @extend .jr-btn-sm; }\r\n.btn-group-lg > .jr-btn { @extend .jr-btn-lg; }\r\n\r\n\r\n//\r\n// Split button dropdowns\r\n//\r\n\r\n.jr-btn + .dropdown-toggle-split {\r\n  padding-right: $input-btn-padding-x * .75;\r\n  padding-left: $input-btn-padding-x * .75;\r\n\r\n  &::after {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.jr-btn-sm + .dropdown-toggle-split {\r\n  padding-right: $input-btn-padding-x-sm * .75;\r\n  padding-left: $input-btn-padding-x-sm * .75;\r\n}\r\n\r\n.jr-btn-lg + .dropdown-toggle-split {\r\n  padding-right: $input-btn-padding-x-lg * .75;\r\n  padding-left: $input-btn-padding-x-lg * .75;\r\n}\r\n\r\n// The clickable button for toggling the menu\r\n// Set the same inset shadow as the :active state\r\n.btn-group.show .dropdown-toggle {\r\n  @include box-shadow($btn-active-box-shadow);\r\n\r\n  // Show no shadow for `.btn-link` since it has no other button styles.\r\n  &.btn-link {\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Vertical button groups\r\n//\r\n\r\n.btn-group-vertical {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n\r\n  .jr-btn,\r\n  .btn-group {\r\n    width: 100%;\r\n  }\r\n\r\n  > .jr-btn + .jr-btn,\r\n  > .jr-btn + .btn-group,\r\n  > .btn-group + .jr-btn,\r\n  > .btn-group + .btn-group {\r\n    margin-top: -$input-btn-border-width;\r\n    margin-left: 0;\r\n  }\r\n\r\n  > .jr-btn {\r\n    &:not(:first-child):not(:last-child) {\r\n      border-radius: 0;\r\n    }\r\n\r\n    &:first-child:not(:last-child) {\r\n      @include border-bottom-radius(0);\r\n    }\r\n\r\n    &:last-child:not(:first-child) {\r\n      @include border-top-radius(0);\r\n    }\r\n  }\r\n\r\n  > .btn-group:not(:first-child):not(:last-child) > .jr-btn {\r\n    border-radius: 0;\r\n  }\r\n\r\n  > .btn-group:first-child:not(:last-child) {\r\n    > .jr-btn:last-child,\r\n    > .dropdown-toggle {\r\n      @include border-bottom-radius(0);\r\n    }\r\n  }\r\n\r\n  > .btn-group:last-child:not(:first-child) > .jr-btn:first-child {\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n\r\n\r\n[data-toggle=\"buttons\"] {\r\n  > .jr-btn,\r\n  > .btn-group > .jr-btn {\r\n    input[type=\"radio\"],\r\n    input[type=\"checkbox\"] {\r\n      position: absolute;\r\n      clip: rect(0,0,0,0);\r\n      //pointer-events: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n\r\n  // Over Write To jr btn Margin\r\n  > .jr-btn,\r\n  > .btn {\r\n    margin-right: 0;\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n","/*Callout Styles*/\r\n\r\n.grid-thumb-equal {\r\n  @extend %thumb-equal;\r\n\r\n  .card-image & {\r\n    padding-bottom: 82%;\r\n  }\r\n}\r\n\r\n.grid-thumb-cover {\r\n  @extend %thumb-cover;\r\n}\r\n\r\n.grid-thumb-cover img {\r\n  @extend %thumb-cover-img;\r\n}\r\n\r\n/*Product listing page style*/\r\n\r\n.product-row {\r\n  position: relative;\r\n  overflow: hidden;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(center);\r\n  text-align: right;\r\n\r\n  &.even {\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.product-col {\r\n  order: 1;\r\n  width: 50%;\r\n}\r\n\r\n.odd .product-thumb {\r\n  order: 2;\r\n}\r\n\r\n.product-content {\r\n  padding: 20px 55px;\r\n}\r\n\r\n.product-row .grid-thumb-equal {\r\n  padding-bottom: 69%;\r\n}\r\n\r\n.product-thumb img {\r\n  width: 100%;\r\n}\r\n\r\n.product-content h4 {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n@media screen and (max-width: 1230px) {\r\n  .product-row .grid-thumb-equal {\r\n    padding-bottom: 71%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .product-content h4 {\r\n    margin-bottom: 10px;\r\n  }\r\n  .product-content {\r\n    padding: 20px 35px;\r\n  }\r\n  .product-row .grid-thumb-equal {\r\n    padding-bottom: 85%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .grid-thumb-equal {\r\n    .card-image & {\r\n      padding-bottom: 120%;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .product-row {\r\n    @include display-flex(flex, column);\r\n    text-align: center;\r\n\r\n    &.even {\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  .product-content {\r\n    padding: 20px 0;\r\n  }\r\n\r\n  .product-col,\r\n  .odd .product-thumb {\r\n    order: 1;\r\n    width: 100%;\r\n  }\r\n  .product-row .grid-thumb-equal {\r\n    padding-bottom: 44%;\r\n  }\r\n\r\n  .grid-thumb-equal {\r\n    .card-image & {\r\n      padding-bottom: 44%;\r\n    }\r\n  }\r\n}","/*Cards Styles*/\r\n.profile-intro {\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  overflow: hidden;\r\n\r\n  img.avatar-circle {\r\n    display: inline-block;\r\n    @extend %size-120;\r\n    @include border-radius(50%);\r\n    @include box-shadow($shadow);\r\n    position: relative;\r\n    margin: 0 auto;\r\n    -webkit-transform: translateY(50px);\r\n    -ms-transform: translateY(50px);\r\n    transform: translateY(50px);\r\n    @include transition(all 0.4s ease-in-out);\r\n    z-index: 1;\r\n  }\r\n\r\n  &:hover {\r\n    & .avatar-circle {\r\n      @include transition(border-radius 0.4s ease 0.1s);\r\n      @include border-radius(25%);\r\n    }\r\n  }\r\n}\r\n\r\n.profile-intro {\r\n  & .card-image {\r\n    position: relative;\r\n    width: 100%;\r\n    min-height: 100%;\r\n    @include background('http://via.placeholder.com/1920x1072', center center);\r\n  }\r\n  & .pi-content {\r\n    padding: 70px 40px 24px;\r\n  }\r\n\r\n  & .pi-footer {\r\n    padding: 0 40px 24px;\r\n  }\r\n  & .icon {\r\n    display: inline-block;\r\n    @include transition(all 0.2s ease 0s);\r\n    color: theme-color(\"primary\");\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      -webkit-transform: scale(1.2);\r\n      -ms-transform: scale(1.2);\r\n      transform: scale(1.2);\r\n    }\r\n  }\r\n\r\n  & .icon:not(:last-child) {\r\n    margin-right: 10px;\r\n  }\r\n}\r\n\r\n.layer {\r\n  &:before {\r\n    display: block;\r\n    content: \"\";\r\n    background-color: rgba($black, 0.3);\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    z-index: 0;\r\n  }\r\n}\r\n\r\n.card.jr-card-full-height,\r\n.jr-card.jr-card-full-height {\r\n  height: calc(100% - #{$jr-card-margin});\r\n\r\n  @media screen and (max-width: 575px) {\r\n    height: auto;\r\n  }\r\n}\r\n\r\n.jr-card {\r\n  @extend %jr-card-style;\r\n\r\n  & > .jr-card-body:first-child {\r\n    margin-top: 6px;\r\n  }\r\n\r\n  &.p-0 > .jr-card-body:first-child {\r\n    margin-top: 0;\r\n  }\r\n\r\n  & .jr-card-thumb {\r\n    margin: -24px -30px 0;\r\n\r\n    & .card-img {\r\n      @include border-radius($border-radius-lg $border-radius-lg 0 0);\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.jr-card-header {\r\n  margin-bottom: 24px;\r\n\r\n  .card-heading {\r\n    margin-bottom: (24px / 6);\r\n  }\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n\r\n    &:last-child {\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.jr-entry-header {\r\n  margin-bottom: 24px;\r\n\r\n  .entry-heading {\r\n    margin-bottom: (24px / 6);\r\n  }\r\n\r\n  .entry-description {\r\n    margin-bottom: 0;\r\n    font-size: 13px;\r\n    color: $gray-600;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.card {\r\n  margin-bottom: $jr-card-margin;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}\r\n\r\n.card-header {\r\n  font-size: 16px;\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n\r\n    &:last-child {\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n}\r\n\r\n.card-title {\r\n  font-size: $h3-font-size;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.card-subtitle {\r\n  font-size: 14px;\r\n  color: $gray-700;\r\n\r\n  &:not(:last-child) {\r\n    margin-bottom: $h3-font-size;\r\n  }\r\n}\r\n\r\n.card-mt-footer {\r\n  padding: 0 15px 20px;\r\n  margin-top: -10px;\r\n}\r\n\r\n.jr-card-social {\r\n  font-size: 22px;\r\n  padding-top: 26px;\r\n}\r\n\r\n.social-link {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin: 0 -5px 10px;\r\n\r\n  & li {\r\n    padding: 0 5px;\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  & li a {\r\n    color: $body-color;\r\n  }\r\n\r\n  & li.active a,\r\n  & li a:hover,\r\n  & li a:focus {\r\n    color: $secondary;\r\n  }\r\n\r\n  .jr-card-social & {\r\n    margin-bottom: 0;\r\n    @include justify-content(space-around);\r\n  }\r\n}\r\n\r\n.jr-cart-ab {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-around);\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  color: $white;\r\n  font-size: $h3-font-size;\r\n\r\n  & i {\r\n    vertical-align: middle;\r\n    font-size: 25px;\r\n  }\r\n}\r\n\r\n.img-overlay-card {\r\n  @include border-radius($border-radius-lg);\r\n  margin-bottom: $jr-card-margin;\r\n\r\n  @media screen and (max-width: 1199px) {\r\n    & .center-crop-img {\r\n      min-height: 135px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 767px) {\r\n    & .center-crop-img {\r\n      min-height: 160px;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 18px;\r\n  }\r\n}","/*Charts Styles*/\r\n\r\n.chart-header {\r\n  padding: 15px 18px;\r\n  & .card-title {\r\n    h4 {\r\n      color: $white;\r\n      margin-bottom: 4px;\r\n    }\r\n  }\r\n\r\n  & .title h4 {\r\n    margin-bottom: 4px;\r\n  }\r\n  & p {\r\n    margin-bottom: 4px;\r\n  }\r\n}","/*Chips Styles*/\r\n.chip-outline {\r\n  background-color: transparent !important;\r\n  border: 1px solid $gray-500 !important;\r\n}\r\n","/*Carousel Styles*/\r\n\r\n.carousel-caption {\r\n  & h3 {\r\n    font-size: $h2-font-size;\r\n  }\r\n}\r\n\r\n.carousel-control-prev {\r\n  @extend %pointer;\r\n}\r\n\r\n.carousel-control-next {\r\n  @extend %pointer;\r\n}\r\n","/*Color Picker Styles*/\r\n\r\n.cp-color {\r\n  width: 36px;\r\n  height: 14px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.cp-swatch {\r\n  padding: 5px;\r\n  background: $white;\r\n  border-radius: 1px;\r\n  @include box-shadow(0 0 0 1px rgba($black, .1));\r\n  display: inline-block;\r\n  cursor: pointer;\r\n}\r\n\r\n.cp-popover {\r\n  position: absolute;\r\n  z-index: 2;\r\n}\r\n\r\n.cp-cover {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n.photoshop-picker,\r\n.swatches-picker,\r\n.alpha-picker,\r\n.hue-picker {\r\n  width: 100% !important;\r\n}\r\n\r\n.material-picker {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n}\r\n\r\n.rc-time-picker-input {\r\n  height: 31px !important;\r\n}\r\n\r\n.date-btn {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n}","// custom styling for the SingleDatePicker from the 'react-dates' package\n\n.dateInputCreateUser .DateInput, \n.dateInputCreateUser .SingleDatePickerInput { \n  background: transparent !important; \n}\n\n// user create form\n.dateInputCreateUser .DateInput_input {\n  font-size: 15px !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  border: none !important;\n  padding: 10px 0 5px 0px !important;\n  font-weight: 400 !important;\n  display: block !important;\n  width: 100% !important;\n  height: calc(2.25rem + 2px) !important;\n  outline: none !important;\n  background-color: transparent !important;\n  transition: .2s all ease-in-out;\n}\n\n.dateInputCreateUserDark .DateInput_input {\n  color: white !important;\n}\n\n.dateInputCreateUserWarn .DateInput_input {\n  color: red !important;\n}\n.dateInputCreateUserWarn .DateInput_input::placeholder {\n  color: red !important;\n}\n\n.dateInputCreateUser .DateInput_input::placeholder {\n  font-size: 15px !important;\n  transition: .2s all ease-in-out;\n  // color: rgb(216, 216, 216) !important;\n}\n\n.dateInputCreateUser .DateInput, \n.dateInputCreateUser .SingleDatePickerInput { \n  background: transparent !important; \n}\n\n// user edit form\n.dateInputEditUser .DateInput_input {\n  font-size: 12px !important;\n  font-family: 'roboto';\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  border: none !important;\n  padding: 5px 0px !important;\n  font-weight: 400 !important;\n  display: block !important;\n  width: 100% !important;\n  height: 28px !important;\n  outline: none !important;\n  background-color: transparent !important;\n  background: transparent !important;\n  transition: .2s all ease-in-out;\n}\n\n.dateInputEditUserDark .DateInput_input {\n  color: white !important;\n  background-color: #1c2938 !important;\n  background: #1c2938 !important;\n}\n\n.dateInputEditUserDark1 .DateInput_input {\n  color: #d5d5d5 !important;\n  background-color: #1C1C1C !important;\n  background: #1C1C1C !important;\n}\n\n.dateInputEditUserDark2 .DateInput_input {\n  color: #ebebed !important;\n  background-color: #333333 !important;\n  background: #333333 !important;\n}\n\n.dateInputEditUserDark3 .DateInput_input {\n  color: #e7e7e7 !important;\n  background-color: #262335 !important;\n  background: #262335 !important;\n}\n\n.dateInputEditUserLight1 .DateInput_input {\n  color: #949494 !important;\n  background-color: #ffffff !important;\n  background: #ffffff !important;\n}\n\n.dateInputEditUserLight2 .DateInput_input {\n  color: #333333 !important;\n  background-color: #fafafa !important;\n  background: #fafafa !important;\n}\n\n.dateInputEditUserContrast .DateInput_input {\n  color: #000000 !important;\n  background-color: transparent !important;\n  background: transparent !important;\n}\n\n.dateInputEditUser .DateInput_input::placeholder {\n  font-size: 12px !important;\n  transition: .2s all ease-in-out;\n  // color: rgb(216, 216, 216) !important;\n}\n","/*Drawer Styles*/\r\n\r\n.drawer {\r\n  width: 250px;\r\n}\r\n\r\n.full-drawer {\r\n  width: 100%;\r\n}","/*E-commerce Styles*/\r\n\r\n.product-item {\r\n  overflow: hidden;\r\n}\r\n\r\n.product-item-vertical {\r\n  @extend .product-item;\r\n\r\n  & .card-image .grid-thumb-equal {\r\n    padding-bottom: 110%;\r\n\r\n    @media screen and (max-width: 1199px) {\r\n      padding-bottom: 74%;\r\n    }\r\n\r\n    @media screen and (max-width: 991px) {\r\n      padding-bottom: 110%;\r\n    }\r\n\r\n    @media screen and (max-width: 829px) {\r\n      padding-bottom: 120%;\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n      padding-bottom: 44%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n","/*Grids List Styles*/\r\n\r\n.gl-image,\r\n.gl-list,\r\n.gl-advanced,\r\n.gl-single-line {\r\n  @include display-flex();\r\n  @include justify-content(space-around);\r\n  overflow: hidden;\r\n}\r\n\r\n.gl {\r\n  max-width: 100%;\r\n  max-height: 360px;\r\n  // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.\r\n  transform: translateZ(0);\r\n\r\n  &.row.no-gutters {\r\n    margin: 0 -2px;\r\n\r\n    & .col,\r\n    & > [class*=\"col-\"] {\r\n      padding-right: 2px;\r\n      padding-left: 2px;\r\n      margin-bottom: 4px;\r\n    }\r\n  }\r\n}\r\n\r\n.gl-single-line {\r\n  & .slg {\r\n    -ms-flex-wrap: nowrap;\r\n    -webkit-flex-wrap: nowrap;\r\n    flex-wrap: nowrap;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n.title-gradient {\r\n  background: -webkit-linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: -o-linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: linear-gradient(to bottom, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n}\r\n\r\n.title-gradient-bottom {\r\n  background: -webkit-linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: -o-linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n  background: linear-gradient(to top, rgba($black, 0.7) 0%, rgba($black, 0.3) 70%, rgba($black, 0) 100%) !important;\r\n}\r\n\r\n.g-title {\r\n  left: 0;\r\n  right: 0;\r\n  height: 48px;\r\n  display: flex;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n}\r\n\r\n.grid {\r\n  height: 100%;\r\n  display: block;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  & > img {\r\n    top: 50%;\r\n    left: 50%;\r\n    position: relative;\r\n    transform: translate(-50%, -50%);\r\n    display: flex;\r\n    padding: 0;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n.g-ul {\r\n  display: flex;\r\n  padding: 0;\r\n  flex-wrap: wrap;\r\n  overflow-y: auto;\r\n  list-style: none;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.gradient-text {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-size: 20px;\r\n  color: white;\r\n}\r\n\r\n.title-gradient-bottom {\r\n  padding: 20px;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 48px;\r\n  display: flex;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  background: -webkit-linear-gradient(0deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n  background: -o-linear-gradient(to top, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent 100%) !important;\r\n  background: linear-gradient(0deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n}\r\n\r\n.title-gradient-top {\r\n  padding: 10px;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 48px;\r\n  display: flex;\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n\r\n  background: -webkit-linear-gradient(180deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n  background: -o-linear-gradient(to bottom, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent 100%) !important;\r\n  background: linear-gradient(180deg, rgba(0, 0, 0, .7) 0, rgba(0, 0, 0, .3) 70%, transparent) !important;\r\n}\r\n\r\n.grid-thumb img {\r\n  max-height: 185px;\r\n}\r\n\r\n.gl-advanced-grid {\r\n  position: relative;\r\n}\r\n","/*Icons Styles*/\r\n\r\n.icon {\r\n  display: inline-block;\r\n  @extend %size-30;\r\n  text-align: center;\r\n}\r\n\r\n.icons-wrapper {\r\n  display: inline-block;\r\n  & + .icons-wrapper {\r\n    margin-left: 25px;\r\n  }\r\n}\r\n\r\n.icon-addon {\r\n  @extend %icon-addon;\r\n}","/*Label Styles*/\r\nlabel {\r\n  margin-bottom: 0;\r\n}\r\n","/*List Styles*/\r\n\r\n.pinned-list {\r\n  position: relative;\r\n  height: 370px;\r\n  overflow: auto;\r\n  width: auto;\r\n}\r\n\r\n.user-list {\r\n  width: 100%;\r\n  padding: 20px 15px 10px;\r\n\r\n  &.card {\r\n    padding-left: 30px;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      padding-left: 15px;\r\n    }\r\n  }\r\n\r\n  & .user-avatar {\r\n    margin-right: 20px;\r\n    margin-bottom: 10px;\r\n    @extend %size-50;\r\n  }\r\n\r\n  & h3 {\r\n    font-weight: 700;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  & a[class*=\"meta-\"] i {\r\n    margin-right: 6px;\r\n  }\r\n\r\n  & a[class*=\"meta-\"]:hover {\r\n    text-decoration: none;\r\n  }\r\n\r\n  & a[class*=\"meta-\"] {\r\n    display: inline-block;\r\n    color: $body-color;\r\n    font-size: $font-size-sm;\r\n    font-weight: 700;\r\n  }\r\n}\r\n\r\n.user-list {\r\n  & .img-section {\r\n    width: 230px;\r\n    @media screen and (max-width: 649px) {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  & .description {\r\n    width: calc(100% - 300px);\r\n    @media screen and (max-width: 649px) {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  & .jr-btn-list {\r\n    & li:not(:last-child) {\r\n      margin-right: 10px;\r\n    }\r\n\r\n    & .btn-light {\r\n      background-color: darken(map_get($gray, lighten-2), 5%);\r\n      border-color: darken(map_get($gray, lighten-2), 5%);\r\n      color: $body-color;\r\n      font-weight: 600;\r\n\r\n      &:hover,\r\n      &:focus,\r\n      &:active {\r\n        background-color: darken(map_get($gray, lighten-2), 10%);\r\n        border-color: darken(map_get($gray, lighten-2), 10%);\r\n      }\r\n    }\r\n\r\n    &.badge-list {\r\n      & li:not(:last-child) {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.list-inline {\r\n  margin-left: -5px;\r\n  margin-right: -5px;\r\n  & li {\r\n    padding: 0 5px;\r\n    display: inline-block;\r\n\r\n    &.media {\r\n      display: flex;\r\n    }\r\n  }\r\n}\r\n\r\n.card-strip {\r\n  border-bottom: solid 1px $gray-300;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.jr-mbtn-list {\r\n  margin-left: -20px;\r\n}\r\n\r\n.img-res {\r\n\r\n    max-width: 100%;\r\n    height: auto;\r\n\r\n}","// Nav Style\r\n.nav-link {\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n}\r\n\r\n.card-header.bg-primary {\r\n  & .nav-link {\r\n    color: $white;\r\n\r\n    &.active,\r\n    &:hover,\r\n    &:focus {\r\n      color: $black;\r\n      background-color: $white;\r\n    }\r\n\r\n    &.disabled {\r\n      color: $gray-100;\r\n    }\r\n\r\n    &.disabled:hover {\r\n      color: $gray-900;\r\n    }\r\n  }\r\n}","/*Pricing Styles*/\r\n.pt-classic,\r\n.pt-default,\r\n.pt-dark,\r\n.pt-circle {\r\n\r\n  & .package {\r\n    position: relative;\r\n    padding: 0;\r\n    overflow: hidden;\r\n    @include border-radius(10px);\r\n    @include transition(all 0.5s ease-in-out);\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n      -webkit-transform: scale(1.05);\r\n      -ms-transform: scale(1.05);\r\n      transform: scale(1.05);\r\n    }\r\n    &.highlight {\r\n      -webkit-transform: scale(1.05);\r\n      -ms-transform: scale(1.05); // IE9 only\r\n      -o-transform: scale(1.05);\r\n      transform: scale(1.05);\r\n      z-index: 2;\r\n    }\r\n  }\r\n  & .package-header {\r\n    padding: 35px;\r\n    text-align: center;\r\n\r\n    & > .price {\r\n      display: inline-block;\r\n      font-size: 36px;\r\n      font-weight: 700;\r\n      margin-left: 0;\r\n      margin-bottom: 12px;\r\n      & > i {\r\n        display: inline-block;\r\n        margin-right: 6px;\r\n        font-weight: bold;\r\n      }\r\n    }\r\n\r\n    & h5 {\r\n      color: inherit;\r\n    }\r\n  }\r\n\r\n  & .package-items {\r\n    list-style: none;\r\n    font-size: 14px;\r\n    margin: 0;\r\n    padding: 50px 50px 120px;\r\n\r\n    & li {\r\n      margin-bottom: 16px;\r\n      @include clearfix();\r\n      line-height: inherit;\r\n      & i {\r\n        float: left;\r\n        min-width: 20px;\r\n        margin-right: 16px;\r\n        line-height: inherit;\r\n      }\r\n\r\n      & span {\r\n        display: block;\r\n        overflow: hidden;\r\n      }\r\n    }\r\n  }\r\n\r\n  & .package-footer {\r\n    bottom: 0;\r\n    left: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    padding: 40px 50px;\r\n    text-align: center;\r\n\r\n    & .btn {\r\n      color: inherit;\r\n      padding: 10px 30px;\r\n      border: 0 none;\r\n    }\r\n  }\r\n}\r\n\r\n.pt-classic .package {\r\n  border: 0 none;\r\n  @include border-radius(0);\r\n}\r\n\r\n.pt-dark {\r\n  & .package {\r\n    &:hover {\r\n      @include border-radius(20px);\r\n    }\r\n  }\r\n}\r\n\r\n.pt-circle {\r\n  & .package-header {\r\n    @include border-radius(50%);\r\n    height: 224px;\r\n    width: 224px;\r\n    margin: 40px auto 0;\r\n    @include align-items(center);\r\n\r\n    & .price {\r\n      margin-top: 30px;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 991px) {\r\n  .pt-classic,\r\n  .pt-default,\r\n  .pt-dark,\r\n  .pt-circle {\r\n    & .package-header {\r\n      padding: 30px 20px;\r\n    }\r\n    & .package-items {\r\n      padding: 30px 20px 120px;\r\n    }\r\n  }\r\n\r\n  .pt-circle {\r\n    & .package-header {\r\n      height: 204px;\r\n      width: 204px;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n  .pt-classic,\r\n  .pt-default,\r\n  .pt-dark,\r\n  .pt-circle {\r\n    & .package {\r\n      &:hover,\r\n      &:focus,\r\n      &:active,\r\n      &.highlight {\r\n        -webkit-transform: scale(1);\r\n        -ms-transform: scale(1);\r\n        transform: scale(1);\r\n      }\r\n    }\r\n  }\r\n}\r\n","/*Progressbar Styles*/\r\n\r\n.pb-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.pb-btn-wrapper {\r\n  margin: 8px;\r\n  position: relative;\r\n  .btn-success {\r\n    background-color: map_get($green, base);\r\n    &:hover {\r\n      background-color: map_get($green, darken-2);\r\n    }\r\n  }\r\n}\r\n\r\n.fab-progress {\r\n  color: map_get($green, base);\r\n  position: absolute;\r\n  top: -6px;\r\n  left: -6px;\r\n  z-index: 1;\r\n}\r\n\r\n.btn-progress {\r\n  color: map_get($green, base);\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-top: -12px;\r\n  margin-left: -12px;\r\n}","/*Popover Styles*/\r\n.popover {\r\n  z-index: 1510;\r\n  max-height: 400px;\r\n}\r\n\r\n.popover-inner {\r\n  max-height: 400px;\r\n}\r\n\r\n.popover-header {\r\n  background-color: transparent;\r\n  border-bottom: 0 none;\r\n  color: $black;\r\n  font-size: $h2-font-size;\r\n  padding: 15px 20px 0;\r\n}\r\n\r\n.popover-body {\r\n  padding: 15px 20px;\r\n  max-height: 355px;\r\n  overflow: auto;\r\n}\r\n\r\n\r\n","/*Tables Styles*/\r\n\r\n.table-header {\r\n  padding-right: 2px !important;\r\n  min-height: 64px;\r\n  padding-left: 24px;\r\n  align-items: center;\r\n\r\n  &.highlight-light {\r\n    color: map_get($gray, darken-2);\r\n    background-color: map_get($gray, lighten-2);\r\n  }\r\n  &.highlight-dark {\r\n    color: $white;\r\n    background-color: map_get($gray, darken-2);\r\n  }\r\n}\r\n\r\n.spacer {\r\n  @include flex(1, 1, 100%);\r\n}\r\n\r\n.actions {\r\n  color: map_get($red, base);\r\n}\r\n\r\n.title {\r\n  @include flex(0, 0, auto);\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n  background-color: rgba($app-primary, 0.075);\r\n}\r\n\r\n.table-material {\r\n  width: 100% !important;\r\n  max-width: 100% !important;\r\n  background-color: $table-bg !important; // Reset for nesting within parents with `background-color`.\r\n\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding !important;\r\n    vertical-align: top !important;\r\n    border-top: $table-border-width solid $table-border-color !important;\r\n  }\r\n\r\n  thead th {\r\n    vertical-align: bottom !important;\r\n    border-bottom: (2 * $table-border-width) solid $table-border-color !important;\r\n  }\r\n\r\n  tbody + tbody {\r\n    border-top: (2 * $table-border-width) solid $table-border-color !important;\r\n  }\r\n\r\n  .table-material {\r\n    background-color: $body-bg !important;\r\n  }\r\n}\r\n\r\n.d-flex-stretch {\r\n  @include align-items(stretch);\r\n  display: -webkit-flex;\r\n  display: -webkit-box;\r\n  display: -moz-flex;\r\n  display: -moz-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-flex-wrap: wrap;\r\n  -ms-flex-wrap: wrap;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.default-table {\r\n  margin-bottom: 0;\r\n  & thead th {\r\n    font-weight: 400;\r\n    font-size: 16px;\r\n  }\r\n  & td {\r\n    vertical-align: middle;\r\n  }\r\n}\r\n\r\n.table-unbordered {\r\n  & th,\r\n  & td {\r\n    border: 0 none !important;\r\n  }\r\n\r\n  & .th-border-b th {\r\n    border-bottom: 2px solid $gray-400 !important;\r\n  }\r\n}\r\n\r\n.table-responsive-material {\r\n  min-height: .01%;\r\n  overflow-x: auto;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .table-responsive-material {\r\n    width: 100%;\r\n    margin-bottom: 15px;\r\n    overflow-y: hidden;\r\n    -ms-overflow-style: -ms-autohiding-scrollbar;\r\n    border: 1px solid #ddd;\r\n  }\r\n  .table-responsive-material > .table {\r\n    margin-bottom: 0;\r\n  }\r\n  .table-responsive-material > .table > thead > tr > th,\r\n  .table-responsive-material > .table > tbody > tr > th,\r\n  .table-responsive-material > .table > tfoot > tr > th,\r\n  .table-responsive-material > .table > thead > tr > td,\r\n  .table-responsive-material > .table > tbody > tr > td,\r\n  .table-responsive-material > .table > tfoot > tr > td {\r\n    white-space: nowrap;\r\n  }\r\n  .table-responsive-material > .table-bordered {\r\n    border: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > thead > tr > th:first-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > th:first-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > th:first-child,\r\n  .table-responsive-material > .table-bordered > thead > tr > td:first-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > td:first-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > td:first-child {\r\n    border-left: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > thead > tr > th:last-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > th:last-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > th:last-child,\r\n  .table-responsive-material > .table-bordered > thead > tr > td:last-child,\r\n  .table-responsive-material > .table-bordered > tbody > tr > td:last-child,\r\n  .table-responsive-material > .table-bordered > tfoot > tr > td:last-child {\r\n    border-right: 0;\r\n  }\r\n  .table-responsive-material > .table-bordered > tbody > tr:last-child > th,\r\n  .table-responsive-material > .table-bordered > tfoot > tr:last-child > th,\r\n  .table-responsive-material > .table-bordered > tbody > tr:last-child > td,\r\n  .table-responsive-material > .table-bordered > tfoot > tr:last-child > td {\r\n    border-bottom: 0;\r\n  }\r\n}\r\n\r\n.fst-td-br-tp-0 tr:first-child {\r\n  & td {\r\n    border-top: 0 none;\r\n  }\r\n}","/*Tabs Styles*/\r\n\r\n.tab {\r\n  min-width: 10px !important;\r\n}\r\n\r\n.tab-icon > span {\r\n  @include display-flex();\r\n}","/*Testimonial Styles*/\r\n\r\n.testimonial-in-bg {\r\n  background-color: rgba($black, 0.8);\r\n  box-shadow: 5px 5px 6px rgba($black, 0.06);\r\n  padding: 30px 30px 30px 150px;\r\n  overflow: hidden;\r\n  position: relative;\r\n\r\n  @media screen and (max-width: 450px) {\r\n    padding-left: 100px;\r\n  }\r\n\r\n  & .pic {\r\n    display: inline-block;\r\n    width: $size-80;\r\n    height: $size-80;\r\n    @include border-radius(50%);\r\n    overflow: hidden;\r\n    position: absolute;\r\n    top: 30px;\r\n    left: 20px;\r\n    border: 4px solid map_get($amber, darken-2);\r\n\r\n    @media screen and (max-width: 450px) {\r\n      width: $size-50;\r\n      height: $size-50;\r\n    }\r\n  }\r\n  & .pic img {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  & .description {\r\n    color: map_get($gray, lighten-1);\r\n    font-style: italic;\r\n    font-weight: 400;\r\n    line-height: 25px;\r\n    margin-bottom: 15px;\r\n    position: relative;\r\n\r\n    &:before {\r\n      content: \"\\f1b2\";\r\n      font: {\r\n        family: 'Material-Design-Iconic-Font';\r\n        size: 24px;\r\n      }\r\n      -moz-transform: scaleX(-1);\r\n      -webkit-transform: scaleX(-1);\r\n      -o-transform: scaleX(-1);\r\n      transform: scaleX(-1);\r\n      position: absolute;\r\n      left: -24px;\r\n    }\r\n  }\r\n  & .title {\r\n    color: map_get($amber, darken-2);\r\n    margin-bottom: 2px;\r\n  }\r\n}\r\n\r\n// Testimonials Simple\r\n.classic-testimonial {\r\n  text-align: center;\r\n\r\n  & .pic {\r\n    margin: 0 auto;\r\n    margin-bottom: 30px;\r\n    width: $size-120;\r\n    height: $size-120;\r\n\r\n    @media screen and (max-width: 500px) {\r\n      width: $size-80;\r\n      height: $size-80;\r\n    }\r\n  }\r\n  & .pic img {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n}\r\n","/*Time Lines Style*/\r\n\r\n.timeline-left {\r\n  float: left;\r\n  margin-right: 20px;\r\n}\r\n\r\n.timeline-right {\r\n  float: right;\r\n  margin-left: 20px;\r\n}\r\n\r\n.timeline-circle {\r\n  @include border-radius(50%);\r\n}\r\n\r\n.timeline-section {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.timeline-item {\r\n  padding-bottom: 25px;\r\n  padding-left: 80px;\r\n  position: relative;\r\n\r\n  &:before {\r\n    border-left: solid 2px $gray-300;\r\n    content: \"\";\r\n    left: 25px;\r\n    position: absolute;\r\n    top: 25px;\r\n    bottom: -20px;\r\n    width: 2px;\r\n    z-index: 1;\r\n  }\r\n  &:first-child:before {\r\n    border-left-style: dashed;\r\n  }\r\n  &:last-child:before {\r\n    border-left-style: dashed;\r\n    bottom: 25px;\r\n  }\r\n}\r\n\r\n.timeline-badge {\r\n  //background-color: $gray-300;\r\n  @extend %size-50;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 16px;\r\n  z-index: 2;\r\n  font-size: 16px;\r\n  color: $white;\r\n  text-align: center;\r\n  @include border-radius($border-radius-circle);\r\n\r\n  &.timeline-img {\r\n    background-color: transparent;\r\n  }\r\n  & svg {\r\n    vertical-align: calc(100% - 56px);\r\n  }\r\n}\r\n\r\n.timeline-badge {\r\n  &.timeline-img:after {\r\n    display: none;\r\n  }\r\n\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 42px;\r\n    height: 42px;\r\n    background-color: transparent;\r\n    border: 4px solid $body-bg;\r\n    @include border-radius($border-radius-circle);\r\n    left: 4px;\r\n    top: 4px;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.timeline-img > img,\r\n.timeline-header-img > img {\r\n  display: inline-block;\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.timeline-panel {\r\n  padding: 20px 30px;\r\n  position: relative;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  border: solid 1px $gray-200;\r\n\r\n  &:after,\r\n  &:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    border-style: solid;\r\n    display: inline-block;\r\n  }\r\n\r\n  &:before {\r\n    border-color: transparent $gray-300;\r\n    border-width: 10px 17px 10px 0;\r\n    left: -17px;\r\n    top: 30px;\r\n  }\r\n\r\n  &:after {\r\n    border-color: transparent $white;\r\n    border-width: 10px 16px 10px 0;\r\n    left: -16px;\r\n    top: 30px;\r\n  }\r\n}\r\n\r\n.timeline-no-padding {\r\n  padding: 0;\r\n}\r\n\r\n.timeline-no-shadow {\r\n  @include box-shadow(none);\r\n  &:before,\r\n  &:after {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.timeline-panel-header, .timeline-header-img {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.timeline-inverted {\r\n  & .timeline-left {\r\n    float: right;\r\n    margin-right: 0;\r\n    margin-left: 20px;\r\n  }\r\n}\r\n\r\n.timeline-heading {\r\n  overflow: hidden;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.timeline-body {\r\n  clear: both;\r\n}\r\n\r\n/*Gxtl Center Style*/\r\n.timeline-center {\r\n  & .timeline-item {\r\n    clear: both;\r\n    float: right;\r\n    width: 50%;\r\n    padding-left: 55px;\r\n\r\n    &:before {\r\n      left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.timeline-center {\r\n  & .timeline-badge {\r\n    left: -25px;\r\n    right: auto;\r\n  }\r\n\r\n  & .timeline-time {\r\n    position: absolute;\r\n    top: 32px;\r\n    left: -150px;\r\n    right: auto;\r\n    z-index: 2;\r\n  }\r\n\r\n  & .timeline-inverted {\r\n    float: left;\r\n    text-align: right;\r\n    padding-left: 0;\r\n    padding-right: 55px;\r\n\r\n    &:before {\r\n      border-left: 0 none;\r\n      border-right: solid 2px $gray-300;\r\n      left: auto;\r\n      right: -2px;\r\n    }\r\n    & .timeline-badge {\r\n      left: auto;\r\n      right: -25px;\r\n    }\r\n\r\n    & .timeline-panel {\r\n      &:before {\r\n        border-width: 10px 0 10px 17px;\r\n        left: auto;\r\n        right: -17px;\r\n      }\r\n\r\n      &:after {\r\n        border-width: 10px 0 10px 16px;\r\n        left: auto;\r\n        right: -16px;\r\n      }\r\n    }\r\n\r\n    & .timeline-time {\r\n      position: absolute;\r\n      top: 32px;\r\n      right: -150px;\r\n      left: auto;\r\n      z-index: 2;\r\n    }\r\n  }\r\n}\r\n\r\n/*Gxtl Zigzag Style*/\r\n.timeline-zigzag {\r\n  & .timeline-item {\r\n    padding-left: 150px;\r\n\r\n    & + .timeline-item {\r\n      margin-top: -80px;\r\n    }\r\n  }\r\n\r\n  & .timeline-img {\r\n    width: 90px;\r\n    height: 90px;\r\n    left: 5px;\r\n    & > img {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  & .timeline-inverted .timeline-img {\r\n    right: 5px !important;\r\n  }\r\n\r\n  & .timeline-item:before {\r\n    @include rotate(35deg);\r\n    top: 20px;\r\n    bottom: 20px;\r\n  }\r\n\r\n  & .timeline-inverted {\r\n    padding-left: 0;\r\n    padding-right: 150px;\r\n    &:before {\r\n      @include rotate(-35deg);\r\n    }\r\n  }\r\n\r\n  & .timeline-item:first-child:before {\r\n    border-left-style: solid;\r\n  }\r\n\r\n  & .timeline-item:last-child:before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.timeline-item:last-child:before {\r\n  bottom: 25px;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .timeline-zigzag .timeline-item + .timeline-item {\r\n    margin-top: -60px;\r\n  }\r\n\r\n  .timeline-zigzag .timeline-item:before {\r\n    bottom: 0;\r\n  }\r\n\r\n  .timeline-zigzag {\r\n    & .timeline-item {\r\n      padding-left: 120px;\r\n    }\r\n\r\n    & .timeline-inverted {\r\n      padding-right: 120px;\r\n      padding-left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .timeline-center {\r\n    & .timeline-item {\r\n      float: none;\r\n      padding-left: 80px;\r\n      width: auto;\r\n      &:before {\r\n        left: 25px;\r\n      }\r\n    }\r\n\r\n    & .timeline-badge {\r\n      left: 0;\r\n    }\r\n\r\n    & .timeline-inverted {\r\n      float: none;\r\n      text-align: left;\r\n      padding-right: 0;\r\n\r\n      &:before {\r\n        border-left: solid 2px $gray-300;\r\n        border-right: 0 none;\r\n        left: 24px;\r\n        right: auto;\r\n      }\r\n      & .timeline-badge {\r\n        right: auto;\r\n        left: 0;\r\n      }\r\n\r\n      & .timeline-panel {\r\n        &:before {\r\n          border-width: 10px 17px 10px 0;\r\n          left: -17px;\r\n          right: auto;\r\n        }\r\n        &:after {\r\n          border-width: 10px 16px 10px 0;\r\n          left: -16px;\r\n          right: auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .timeline-inverted {\r\n    & .timeline-panel-header {\r\n      float: none;\r\n    }\r\n\r\n    & .timeline-left {\r\n      float: left;\r\n      margin-left: 0;\r\n      margin-right: 20px;\r\n    }\r\n  }\r\n\r\n  .timeline-zigzag {\r\n    & .timeline-panel {\r\n      max-height: none;\r\n      min-height: 10px;\r\n      overflow-y: visible;\r\n    }\r\n\r\n    & .timeline-item {\r\n      padding-left: 100px;\r\n      & + .timeline-item {\r\n        margin-top: 0;\r\n      }\r\n\r\n      &:before {\r\n        transform: none;\r\n        top: 25px;\r\n        bottom: -25px;\r\n        left: 45px;\r\n      }\r\n\r\n      &:last-child:before {\r\n        bottom: 0;\r\n      }\r\n    }\r\n    & .timeline-inverted:before {\r\n      transform: none;\r\n    }\r\n  }\r\n\r\n  .timeline-center {\r\n    & .timeline-time,\r\n    & .timeline-inverted .timeline-time {\r\n      position: relative;\r\n      top: auto;\r\n      left: auto;\r\n      right: auto;\r\n      margin-bottom: 6px;\r\n    }\r\n\r\n    .timeline-time-item .timeline-panel::before {\r\n      top: 10px;\r\n    }\r\n\r\n    .timeline-time-item .timeline-panel::after {\r\n      top: 11px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .timeline-left {\r\n    float: none;\r\n    margin-right: 0;\r\n  }\r\n\r\n  .timeline-right {\r\n    float: none;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .timeline-inverted {\r\n    & .timeline-left {\r\n      float: none;\r\n      margin-right: 0;\r\n    }\r\n  }\r\n}","/*Form Styles*/\r\n@media screen and (max-width: 575px) {\r\n  .horizontal-stepper {\r\n    & p,\r\n    & span {\r\n      opacity: 0;\r\n      visibility: hidden;\r\n      font-size: 12px;\r\n    }\r\n\r\n    &.active {\r\n      & p,\r\n      & span {\r\n        opacity: 1;\r\n        visibility: visible;\r\n      }\r\n    }\r\n\r\n    & > *,\r\n    & > button > * {\r\n      @include display-flex(flex, column, nowrap);\r\n    }\r\n\r\n    & .stepperlabel,\r\n    & .stepperbutton,\r\n    & .stepperlabel span:first-child,\r\n    & .stepperbutton span:first-child {\r\n      opacity: 1;\r\n      visibility: visible;\r\n    }\r\n  }\r\n\r\n  .horizontal-stepper-linear {\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n  }\r\n}",".form-checkbox {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.form-checkbox > input {\r\n  height: 18px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  padding: 10px;\r\n  top: 0;\r\n  width: 18px;\r\n  z-index: 2;\r\n  cursor: pointer;\r\n}\r\n\r\n.form-control-checkbox .form-checkbox > input {\r\n  height: 48px;\r\n  width: 48px;\r\n}\r\n\r\n.form-control-checkbox .form-checkbox {\r\n  height: 48px;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 48px;\r\n  justify-content: center;\r\n}\r\n\r\n.form-checkbox > input + .check {\r\n  border: 1px solid $sidebar-text-color;\r\n  border-radius: 2px;\r\n  color: $app-primary;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  height: 18px;\r\n  position: relative;\r\n  width: 18px;\r\n  z-index: -1;\r\n}\r\n\r\n.form-checkbox > input.sm + .check {\r\n  border: 1px solid $sidebar-text-color;\r\n  border-radius: 2px;\r\n  color: $app-primary;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  height: 14px;\r\n  position: relative;\r\n  top: 3px;\r\n  width: 14px;\r\n  z-index: -1;\r\n}\r\n\r\n.form-checkbox > input + .check i {\r\n  display: none;\r\n  left: 1px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 2px;\r\n}\r\n\r\n.form-checkbox > input.sm + .check i {\r\n  display: none;\r\n  left: 1px;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 2px;\r\n}\r\n\r\n.form-checkbox > input:checked + span i {\r\n  display: block;\r\n  opacity: 1;\r\n}\r\n\r\n/*Radio and Checkbox styles*/\r\n\r\n.checkbox-replace {\r\n  padding-left: 20px;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"],\r\n.radio-replace input[type=\"radio\"] {\r\n  margin-left: -20px;\r\n  position: absolute;\r\n}\r\n\r\n.form-inline .checkbox-replace label {\r\n  padding-left: 5px;\r\n}\r\n\r\n.form-inline .checkbox-replace,\r\n.form-inline .radio-replace {\r\n  margin-right: 20px;\r\n}\r\n\r\n.form-inline .checkbox-replace:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.checkbox-replace label {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  padding-left: 5px;\r\n}\r\n\r\n.checkbox-replace label::before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 18px;\r\n  height: 18px;\r\n  left: 0;\r\n  top: 0;\r\n  margin-left: -20px;\r\n  margin-top: 2px;\r\n  border: 1px solid $sidebar-text-color;\r\n  border-radius: 3px;\r\n  background-color: $white;\r\n  @include transition (border 0.15s ease-in-out, color 0.15s ease-in-out);\r\n}\r\n\r\n.checkbox-replace label::after {\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 12px;\r\n  height: 12px;\r\n  left: 3px;\r\n  top: 5px;\r\n  margin-left: -20px;\r\n  font-size: 11px;\r\n  color: $gray-700;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"] {\r\n  opacity: 0;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:focus + label::before {\r\n  outline: 0 none;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:checked + label::after {\r\n  background-color: $gray-400;\r\n  content: \"\";\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:disabled + label {\r\n  opacity: 0.65;\r\n}\r\n\r\n.checkbox-replace input[type=\"checkbox\"]:disabled + label::before {\r\n  background-color: $white;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.checkbox-replace.checkbox-inline {\r\n  margin-top: 0;\r\n}\r\n\r\n.checkbox-primary label::before {\r\n  border-color: $app-primary;\r\n}\r\n\r\n.checkbox-primary input[type=\"checkbox\"]:checked + label::after {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.checkbox-danger label::before {\r\n  border-color: $secondary;\r\n}\r\n\r\n.checkbox-danger input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $secondary;\r\n}\r\n\r\n.checkbox-info label::before {\r\n  border-color: $info;\r\n}\r\n\r\n.checkbox-info input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $info;\r\n}\r\n\r\n.checkbox-warning label::before {\r\n  border-color: $warning;\r\n}\r\n\r\n.checkbox-warning input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $warning;\r\n}\r\n\r\n.checkbox-success label::before {\r\n  border-color: $success;\r\n}\r\n\r\n.checkbox-success input[type=\"checkbox\"]:checked + label::after {\r\n  border-color: $success;\r\n}\r\n\r\n.radio-replace {\r\n  padding-left: 20px;\r\n}\r\n\r\n.radio-replace label {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  padding-left: 5px;\r\n}\r\n\r\n.radio-replace label::before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 18px;\r\n  height: 18px;\r\n  left: 0;\r\n  top: 0;\r\n  margin-left: -20px;\r\n  margin-top: 2px;\r\n  border: 1px solid $gray-400;\r\n  border-radius: 50%;\r\n  background-color: $white;\r\n  @include transition(border 0.15s ease-in-out);\r\n}\r\n\r\n.radio-replace label::after {\r\n  display: inline-block;\r\n  position: absolute;\r\n  content: \" \";\r\n  width: 12px;\r\n  height: 12px;\r\n  left: 3px;\r\n  top: 5px;\r\n  margin-left: -20px;\r\n  border-radius: 50%;\r\n  background-color: $gray-400;\r\n  @include rotate (scale(0, 0));\r\n  @include transition (transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33))\r\n}\r\n\r\n.radio-replace input[type=\"radio\"] {\r\n  opacity: 0;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:focus + label::before {\r\n  outline: 0 none;\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:checked + label::after {\r\n  @include rotate (scale(1, 1));\r\n\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:disabled + label {\r\n  opacity: 0.65;\r\n}\r\n\r\n.radio-replace input[type=\"radio\"]:disabled + label::before {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.radio-replace.radio-inline {\r\n  margin-top: 0;\r\n}\r\n\r\n.radio-primary input[type=\"radio\"] + label::after {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.radio-primary input[type=\"radio\"]:checked + label::before {\r\n  border-color: $app-primary;\r\n}\r\n\r\n.radio-primary input[type=\"radio\"]:checked + label::after {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.radio-danger input[type=\"radio\"] + label::after {\r\n  background-color: $secondary;\r\n}\r\n\r\n.radio-danger input[type=\"radio\"]:checked + label::before {\r\n  border-color: $secondary;\r\n}\r\n\r\n.radio-danger input[type=\"radio\"]:checked + label::after {\r\n  background-color: $secondary;\r\n}\r\n\r\n.radio-info input[type=\"radio\"] + label::after {\r\n  background-color: $info;\r\n}\r\n\r\n.radio-info input[type=\"radio\"]:checked + label::before {\r\n  border-color: $info;\r\n}\r\n\r\n.radio-info input[type=\"radio\"]:checked + label::after {\r\n  background-color: $info;\r\n}\r\n\r\n.radio-warning input[type=\"radio\"] + label::after {\r\n  background-color: $warning;\r\n}\r\n\r\n.radio-warning input[type=\"radio\"]:checked + label::before {\r\n  border-color: $warning;\r\n}\r\n\r\n.radio-warning input[type=\"radio\"]:checked + label::after {\r\n  background-color: $warning;\r\n}\r\n\r\n.radio-success input[type=\"radio\"] + label::after {\r\n  background-color: $success;\r\n}\r\n\r\n.radio-success input[type=\"radio\"]:checked + label::before {\r\n  border-color: $success;\r\n}\r\n\r\n.radio-success input[type=\"radio\"]:checked + label::after {\r\n  background-color: $success;\r\n}\r\n\r\n.form-horizontal .checkbox, .form-horizontal .checkbox-inline, .form-horizontal .radio, .form-horizontal .radio-inline {\r\n  padding-top: 7px;\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.form-horizontal .form-inline .checkbox,\r\n.form-horizontal .form-inline .checkbox-inline,\r\n.form-horizontal .form-inline .radio,\r\n.form-horizontal .form-inline .radio-inline {\r\n  padding-top: 0;\r\n}\r\n\r\n.form-horizontal .checkbox, .form-horizontal .radio {\r\n  min-height: 27px;\r\n}\r\n\r\n.form-wizard .tab-content .pager.wizard .first a {\r\n  margin-right: 8px;\r\n}\r\n\r\n.form-wizard .tab-content .pager.wizard .last a {\r\n  margin-left: 8px;\r\n}\r\n\r\n.wizard-navbar {\r\n  margin: 60px auto 20px;\r\n}\r\n\r\n.wizard-navbar > ul {\r\n  display: table;\r\n  width: 100%;\r\n  text-align: center;\r\n  margin: 0;\r\n  font-weight: 600;\r\n  padding: 0;\r\n  list-style: none outside none;\r\n  table-layout: fixed;\r\n}\r\n\r\n.wizard-navbar > ul li {\r\n  display: table-cell;\r\n  width: 1%;\r\n  position: relative;\r\n}\r\n\r\n.wizard-navbar > ul li a {\r\n  color: $sidebar-text-color;\r\n  position: relative;\r\n  padding: 0 10px;\r\n  display: block;\r\n  text-decoration: none;\r\n}\r\n\r\n.wizard-navbar > ul li a span.wz-number {\r\n  background-color: $gray-200;\r\n  border-radius: 50%;\r\n\r\n  color: $gray-500;\r\n  display: block;\r\n  height: 40px;\r\n  left: 50%;\r\n  line-height: 40px;\r\n  margin-left: -20px;\r\n  margin-top: -50px;\r\n  position: absolute;\r\n  text-align: center;\r\n  @include transition(all 300ms ease-in-out 0s);\r\n  width: 40px;\r\n  z-index: 5;\r\n}\r\n\r\n.wizard-navbar > ul li.completed a span.wz-number {\r\n  background-color: $app-primary;\r\n  color: $white;\r\n}\r\n\r\n.wizard-navbar > ul li a.active span.wz-number {\r\n  background-color: $secondary;\r\n  color: $white;\r\n}\r\n\r\n.wizard-navbar > ul li a.active,\r\n.wizard-navbar > ul li.completed a {\r\n  color: $gray-600;\r\n}\r\n\r\n.wizard-navbar > ul li a:before,\r\n.wizard-navbar > ul li a:after {\r\n  content: '';\r\n  position: absolute;\r\n  height: 4px;\r\n  width: 50%;\r\n  background-color: $gray-200;\r\n  top: -32px;\r\n  left: 0;\r\n}\r\n\r\n.wizard-navbar > ul li a:after {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n\r\n.wizard-navbar > ul li a.active:before,\r\n.wizard-navbar > ul li a.active:after {\r\n  background-color: $secondary;\r\n}\r\n\r\n.wizard-navbar > ul li.completed a:before,\r\n.wizard-navbar > ul li.completed a:after {\r\n  background-color: $app-primary;\r\n}\r\n\r\nlabel.error {\r\n  display: block;\r\n  color: $danger;\r\n  font-weight: 400;\r\n  margin: 5px 0;\r\n}\r\n\r\n@media screen and (max-width: 479px) {\r\n  .wizard-navbar > ul li a span.wz-label {\r\n    visibility: hidden;\r\n  }\r\n\r\n  .wizard-navbar > ul li a.active span.wz-label {\r\n    visibility: visible;\r\n  }\r\n}\r\n\r\n.form-checkbox-custom {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.form-checkbox-custom .check {\r\n  margin-right: 10px;\r\n}\r\n\r\n.react-switch {\r\n  vertical-align: middle;\r\n  margin-left: 4px;\r\n}\r\n","/*Input Styles*/\r\n::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n::-moz-placeholder { /* Firefox 19+ */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n:-ms-input-placeholder { /* IE 10+ */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n:-moz-placeholder { /* Firefox 18- */\r\n  font-size: 12px;\r\n  color: lighten($body-color, 50%);\r\n}\r\n\r\n.module-box-header ::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n  font-size: 14px;\r\n}\r\n\r\n.module-box-header ::-moz-placeholder { /* Firefox 19+ */\r\n  font-size: 14px;\r\n}\r\n\r\n.module-box-header :-ms-input-placeholder { /* IE 10+ */\r\n  font-size: 14px;\r\n}\r\n\r\n.module-box-header :-moz-placeholder { /* Firefox 18- */\r\n  font-size: 14px;\r\n}\r\n\r\n// Search Bar Style\r\n.search-bar {\r\n  background-color: $white;\r\n  position: relative;\r\n  & .form-group {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin-bottom: 0;\r\n  }\r\n  & input[type=\"search\"] {\r\n    padding-right: 50px;\r\n  }\r\n\r\n  & .search-icon {\r\n    background-color: transparent;\r\n    border: 0 none;\r\n    color: lighten($gray-600, 10%);\r\n    height: 36px;\r\n    width: 30px;\r\n  }\r\n\r\n  & .form-control {\r\n    box-shadow: none;\r\n    &.form-control-lg + .search-icon {\r\n      position: absolute;\r\n      right: 14px;\r\n      top: 6px;\r\n    }\r\n  }\r\n\r\n  & .search-icon {\r\n    position: absolute;\r\n    right: 14px;\r\n    top: 3px;\r\n  }\r\n\r\n  &.right-side-icon {\r\n    & input[type=\"search\"] {\r\n      padding-right: 16px;\r\n      padding-left: 50px;\r\n    }\r\n\r\n    & .search-icon {\r\n      position: absolute;\r\n      left: 14px;\r\n      top: 2px;\r\n    }\r\n\r\n    & .form-control {\r\n      box-shadow: none;\r\n      &.form-control-lg + .search-icon {\r\n        position: absolute;\r\n        left: 14px;\r\n        top: 6px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.nav-searchbox .search-bar input {\r\n  & + .search-icon {\r\n    & i {\r\n      color: rgba($body-color, 0.8);\r\n    }\r\n  }\r\n}\r\n\r\n/* Removing arrows for input type number in Chrome, Safari, Edge, Opera */\r\n.inputClassComponent::-webkit-outer-spin-button,\r\n.inputClassComponent::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Removing arrows for input type number in Firefox */\r\n.inputClassComponent[type=number] {\r\n  -moz-appearance: textfield;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .jr-card .app-main-header {\r\n    & .search-bar {\r\n      width: 150px;\r\n    }\r\n  }\r\n}","/* Pages\r\n   ========================================================================== */\r\n@import \"login\";\r\n@import \"error\";\r\n@import \"editor\";\r\n@import \"contact\";\r\n@import \"portfolio\";\r\n@import \"faq\";\r\n@import \"dashboard\";\r\n@import \"dropzone\";","/*Login Styles*/\r\n/*Login Styles*/\r\n\r\n.indexPage {\r\n  background-color: #f4f6f8;\r\n  height: 100vh;\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  padding: 0;\r\n  margin: 0;\r\n  @media screen and (max-width: 575px) {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.landingPage {\r\n  background-color: #fff;\r\n  height: 680px;\r\n  background-position: bottom right;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  @media screen and (max-width: 575px) {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.login-container {\r\n  position: relative;\r\n  height: 100%;\r\n}\r\n\r\n.login-content {\r\n  width: 420px;\r\n  margin: auto;\r\n  padding: 35px 35px 20px;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  border: solid 1px $gray-400;\r\n  font-size: 14px;\r\n  max-width: 94%;\r\n}\r\n\r\n.login-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.login-content .form-control {\r\n  background-color: map_get($gray, lighten-4);\r\n\r\n  &:focus {\r\n    box-shadow: none;\r\n    border-color: $app-primary;\r\n  }\r\n}\r\n\r\n.login-content .btn, .login-content .jr-btn {\r\n  padding: 10px 35px !important;\r\n}\r\n\r\n.app-login-container {\r\n  position: relative;\r\n  max-width: 680px;\r\n  width: 94%;\r\n  margin: 0 auto;\r\n\r\n  & .loader-view {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    text-align: center;\r\n    top: 0;\r\n    bottom: 0;\r\n    z-index: 2;\r\n  }\r\n}\r\n\r\n.app-login-main-content {\r\n  @include display-flex();\r\n  background-color: $white;\r\n  @include box-shadow($shadow);\r\n  @include border-radius(10px);\r\n  font-size: 14px;\r\n  overflow: hidden;\r\n}\r\n\r\n.app-login-content {\r\n  padding: 35px 35px 20px;\r\n  width: 60%;\r\n  order: 1;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    width: 100%;\r\n    order: 2;\r\n  }\r\n}\r\n\r\n.app-login-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.app-login-content .form-control {\r\n  background-color: map_get($gray, lighten-4);\r\n\r\n  &:focus {\r\n    box-shadow: none;\r\n    border-color: $app-primary;\r\n  }\r\n}\r\n\r\n.app-login-content .btn, .login-content .jr-btn {\r\n  padding: 10px 35px !important;\r\n}\r\n\r\n.app-logo-content {\r\n  background-color: $app-primary;\r\n  padding: 35px 35px 20px;\r\n  width: 40%;\r\n  order: 2;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    width: 100%;\r\n    order: 1;\r\n  }\r\n}\r\n\r\n.app-social-block {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-between);\r\n\r\n  & .social-link,\r\n  & .social-link li {\r\n    margin: 0;\r\n  }\r\n\r\n  & .social-link span {\r\n    border: solid 1px $app-primary;\r\n    @include border-radius(50%);\r\n    color: $app-primary;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $white;\r\n      background-color: $app-primary;\r\n    }\r\n  }\r\n\r\n  & p {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n","/*Error Styles*/\r\n\r\n.page-error-container {\r\n  padding: 30px 0;\r\n  position: relative;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 15px 0;\r\n  }\r\n}\r\n\r\n.page-error-content {\r\n  margin: 0 auto;\r\n  padding: 40px 0;\r\n  width: 380px;\r\n  max-width: 94%;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    padding: 15px 0;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.error-code {\r\n  color: $gray-900;\r\n  font-size: 160px;\r\n  text-align: center;\r\n  line-height: 1;\r\n  font-weight: 600;\r\n  text-shadow: 10px 6px 8px rgba(117, 117, 117, 0.8);\r\n\r\n  @media screen and (max-width: 991px) {\r\n    font-size: 130px;\r\n  }\r\n\r\n  @media screen and (max-width: 767px) {\r\n    font-size: 100px;\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    font-size: 80px;\r\n  }\r\n}\r\n\r\n.page-error-content h2 {\r\n  margin-bottom: $size-50;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n","/*Editor Styles*/\r\n.rdw-inline-wrapper {\r\n  @include display-flex();\r\n}\r\n\r\n.rdw-option-wrapper {\r\n  margin-bottom: 6px;\r\n}\r\n","/*Contact Page Styles*/\r\n\r\n.contact-form {\r\n  padding: 60px;\r\n}\r\n\r\n.contact-block {\r\n  & .contact-info {\r\n    list-style: none;\r\n    padding-left: 0;\r\n    margin-bottom: 0;\r\n    @include display-flex();\r\n    @include align-items(center);\r\n    -webkit-align-content: stretch;\r\n    -ms-flex-align: stretch;\r\n    align-content: stretch;\r\n\r\n    & li {\r\n      @include flex(1, 1, 0);\r\n      overflow: hidden;\r\n      padding: 10px 40px;\r\n      border-right: 2px solid $body-color;\r\n      word-wrap: break-word;\r\n\r\n      &:last-child {\r\n        border: 0 none;\r\n      }\r\n\r\n      & > i {\r\n        float: left;\r\n        font-size: 16px;\r\n        margin-right: 5px;\r\n      }\r\n\r\n      & .contact-body {\r\n        overflow: hidden;\r\n        & .icons-wrapper {\r\n          margin-top: 15px;\r\n          margin-left: 0;\r\n        }\r\n\r\n        & .icon {\r\n          background-color: map_get($indigo, 'lighten-1');\r\n          color: $white;\r\n          @include border-radius(50%);\r\n          margin-right: 6px;\r\n          margin-bottom: 6px;\r\n          &:last-child {\r\n            margin-right: 0;\r\n          }\r\n        }\r\n\r\n        & .twitter-icon {\r\n          background-color: map_get($light-blue, accent-2);\r\n        }\r\n\r\n        & .google-icon {\r\n          background-color: map_get($red, lighten-1);\r\n        }\r\n\r\n        & .linkedin-icon {\r\n          background-color: map_get($light-blue, darken-3);\r\n        }\r\n      }\r\n    }\r\n\r\n    &.vertical {\r\n      display: block;\r\n      margin-bottom: 0;\r\n      & li {\r\n        padding: 0 0 24px;\r\n        border-right: 0 none;\r\n        border-bottom: 2px solid $body-color;\r\n        margin-bottom: 24px;\r\n\r\n        &:last-child {\r\n          border: 0 none;\r\n          margin-bottom: 0;\r\n          padding-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .contact-form {\r\n    padding: 30px;\r\n  }\r\n\r\n  .contact-block {\r\n    & .contact-info {\r\n      display: block;\r\n      margin-bottom: 0;\r\n      & li {\r\n        padding: 0 0 24px;\r\n        border-right: 0 none;\r\n        border-bottom: 2px solid $body-color;\r\n        margin-bottom: 24px;\r\n\r\n        &:last-child {\r\n          border: 0 none;\r\n          margin-bottom: 0;\r\n          padding-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .content-section {\r\n    padding: 20px 10px 0;\r\n    text-align: center;\r\n    & h2 {\r\n      font-size: 28px;\r\n    }\r\n    & p {\r\n      font-size: 18px;\r\n    }\r\n  }\r\n}\r\n","/*Portfolio Styles*/\r\n\r\n.portfolio-section {\r\n  & .card-image {\r\n    margin-bottom: 20px;\r\n    & img {\r\n      width: 100%;\r\n      @include transition(all 1200ms ease);\r\n    }\r\n    &:hover {\r\n      & img {\r\n        -webkit-transform: scale(1.08);\r\n        -ms-transform: scale(1.08);\r\n        transform: scale(1.08);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.filter-with-bg-color {\r\n  & ul {\r\n    padding-left: 0;\r\n    margin: 0 -10px 45px;\r\n    & li {\r\n      display: inline-block;\r\n      margin-bottom: 10px;\r\n      padding: 0 10px;\r\n    }\r\n\r\n    & li a {\r\n      text-transform: uppercase;\r\n      font-size: 12px;\r\n      padding: 10px 24px;\r\n      border: 1px solid $app-primary;\r\n      display: block;\r\n      text-decoration: none;\r\n    }\r\n\r\n    & li a:hover,\r\n    & li a:focus,\r\n    & li a.active {\r\n      cursor: pointer;\r\n      background-color: $app-primary;\r\n      border-color: $app-primary;\r\n      color: $white;\r\n    }\r\n\r\n    @media screen and (max-width: 575px) {\r\n      margin-bottom: 15px;\r\n    }\r\n  }\r\n}","/*Faqs Styles*/\r\n\r\n.Collapsible {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n//The content within the collaspable ChatUserList\r\n.Collapsible__contentInner {\r\n  padding: 20px;\r\n  border: 1px solid $gray-200;\r\n  background-color: $white;\r\n  border-top: 0;\r\n\r\n  p {\r\n    margin-bottom: 10px;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n//The link which when clicked opens the collapsable ChatUserList\r\n.Collapsible__trigger {\r\n  display: block;\r\n  cursor: pointer;\r\n  font-weight: 400;\r\n  text-decoration: none;\r\n  position: relative;\r\n  padding: 18px 20px;\r\n  @include border-radius(8px);\r\n  background: theme-color(\"primary\");\r\n  color: $white;\r\n\r\n  &:after {\r\n    content: '\\f2f9';\r\n    font: {\r\n      family: 'Material-Design-Iconic-Font';\r\n      size: 20px;\r\n    }\r\n    position: absolute;\r\n    right: 24px;\r\n    top: 16px;\r\n    display: block;\r\n    transition: transform 300ms;\r\n  }\r\n\r\n  &.is-open {\r\n    @include border-radius(8px 8px 0 0);\r\n    &:after {\r\n      transform: rotateZ(180deg);\r\n    }\r\n  }\r\n}\r\n\r\n//SideNav\r\n.categories-list {\r\n  margin-bottom: 0;\r\n  & li {\r\n    margin-bottom: 10px;\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n  & li.active a {\r\n    color: $app-primary;\r\n  }\r\n  & .badge {\r\n    font-size: 9px;\r\n  }\r\n}\r\n\r\n.articles-section {\r\n  & .articles {\r\n    margin-bottom: 26px;\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.article-image {\r\n  display: block;\r\n  margin-bottom: 12px;\r\n  & > img {\r\n    @include border-radius(8px);\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.article-description {\r\n  & p {\r\n    font-weight: 500;\r\n    margin-bottom: 2px;\r\n  }\r\n}\r\n\r\n.meta-wrapper {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.meta-date,\r\n.meta-comment {\r\n  font-size: 14px;\r\n  color: $gray-500;\r\n  display: inline-block;\r\n  & i {\r\n    display: inline-block;\r\n    margin-right: 6px;\r\n  }\r\n}\r\n\r\n.meta-date {\r\n  & + .meta-comment {\r\n    margin-left: 10px;\r\n  }\r\n}\r\n\r\n\r\n","/*Dashboard Styles*/\r\n.box {\r\n  position: relative;\r\n\r\n  .box-top,\r\n  .box-bottom {\r\n    height: 100px;\r\n    padding: 32px 15px;\r\n    font-size: 40px;\r\n    line-height: 40px;\r\n    text-align: center;\r\n    font-weight: $display1-weight;\r\n    .size-h5 {\r\n      font-size: 24px;\r\n      margin-left: 2px;\r\n    }\r\n    .material-icons {\r\n      font-size: 40px;\r\n      line-height: 40px;\r\n    }\r\n  }\r\n\r\n  .box-bottom {\r\n    border-top: 1px solid rgba($black, .15);\r\n  }\r\n\r\n  .box-info {\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 50%;\r\n    margin-top: -12px;\r\n    text-align: center;\r\n\r\n    span {\r\n      height: 24px;\r\n      display: inline-block;\r\n      padding: 4px 10px;\r\n      text-transform: uppercase;\r\n      line-height: 14px;\r\n      background-color: $white;\r\n      border: 1px solid rgba($black, .15);\r\n      font-size: 12px;\r\n      color: $text-muted;\r\n      border-radius: 1em;\r\n      .material-icons {\r\n        line-height: 14px;\r\n        font-size: 11px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.contact-list {\r\n  margin-bottom: 14px;\r\n\r\n  & i {\r\n    margin-right: 14px;\r\n    color: theme-color(\"primary\");\r\n  }\r\n\r\n  & .media {\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n.temp-section {\r\n\r\n  .temp-point,\r\n  .detail-icon {\r\n    font-size: 54px;\r\n  }\r\n}\r\n\r\n.assignment-table {\r\n  & tbody tr:nth-child(odd) {\r\n    background-color: $gray-300 !important;\r\n  }\r\n  & td {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n}\r\n\r\n.status-cell {\r\n  min-width: 100px;\r\n  max-width: 120px;\r\n  padding-right: 24px !important;\r\n  & .badge {\r\n    min-width: 70px;\r\n  }\r\n}\r\n\r\n.thumbnail-list {\r\n  margin-bottom: 0;\r\n  & .thumbnail-item {\r\n    padding: 0 2.5px;\r\n    display: inline-block;\r\n    width: 33.333%;\r\n    margin-bottom: 5px;\r\n\r\n    @media screen and (max-width: 767px) {\r\n      width: 50%;\r\n    }\r\n\r\n    @media screen and (max-width: 575px) {\r\n      width: 33.333%;\r\n    }\r\n  }\r\n}\r\n\r\n.post-list {\r\n  & .post-image .grid-thumb-equal {\r\n    padding-bottom: 100%;\r\n  }\r\n}\r\n\r\n/*Ecommerce Dashboard Styles*/\r\n.chart-f30 {\r\n  font-size: 30px;\r\n\r\n  @media screen and (max-width: 1099px) {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n.chart-f20 {\r\n  font-size: 20px;\r\n\r\n  @media screen and (max-width: 1099px) {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n.chart-order {\r\n  & .col-5 {\r\n    order: 2;\r\n    text-align: center;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      order: 1;\r\n    }\r\n  }\r\n\r\n  & .col-7 {\r\n    order: 1;\r\n\r\n    @media screen and (max-width: 575px) {\r\n      order: 2;\r\n    }\r\n  }\r\n}\r\n\r\n.tab-notifications {\r\n  margin-left: -$jr-card-margin + 4px;\r\n  margin-right: -$jr-card-margin + 4px;\r\n  border-bottom: 1px solid $gray-500;\r\n\r\n  @media screen and (max-width: 567px) {\r\n    button,\r\n    button * {\r\n      font-size: 12px !important;\r\n    }\r\n  }\r\n}\r\n\r\n.chart-title {\r\n  & h2 {\r\n    font-size: 22px;\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.img-fluid {\r\n  width: 100%;\r\n}\r\n\r\n.comment-footer {\r\n  & button {\r\n    margin-bottom: 6px;\r\n  }\r\n}\r\n\r\n/*Intranet Dashboard Styles*/\r\n.net-chart {\r\n  padding-left: 80px;\r\n  padding-right: 15px;\r\n  min-height: 100px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n\r\n  & .jr-card-thumb {\r\n    margin: 0;\r\n    width: $size-50;\r\n    height: $size-50;\r\n    color: $white;\r\n    font-size: 20px;\r\n    @include border-radius($border-radius-circle);\r\n    @include display-flex(flex, column, nowrap);\r\n    @include justify-content(center);\r\n    @include align-items(center);\r\n    @include transition(all 100ms ease);\r\n    position: absolute;\r\n    left: 15px;\r\n  }\r\n\r\n  &:hover .jr-card-thumb {\r\n    width: 70px;\r\n    height: 100%;\r\n    font-size: 30px;\r\n    @include border-radius(0);\r\n    position: absolute;\r\n    left: 0;\r\n  }\r\n}\r\n\r\n.net-chart-hr {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  min-height: $size-120;\r\n  padding-right: 8px;\r\n  overflow: hidden;\r\n\r\n  & .jr-card-thumb {\r\n    margin: -30px 12px -30px -30px;\r\n    min-width: $size-100 + 5px;\r\n  }\r\n\r\n  & .grid-thumb-equal {\r\n    padding-bottom: 130%;\r\n  }\r\n\r\n  & .jr-card-body {\r\n    width: calc(100% - #{$size-100});\r\n  }\r\n}\r\n\r\n.user-profile {\r\n  padding: 10px 0;\r\n}\r\n\r\n.mh-120 {\r\n  min-height: $size-120;\r\n}\r\n\r\n.jr-card-header-top {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin-right: -16px;\r\n}\r\n\r\n.jr-card-header-color {\r\n  padding: 10px 20px 20px;\r\n  margin: -24px -30px 25px;\r\n}\r\n\r\n.todo-cell-group {\r\n  & .todo-cell {\r\n    &:not(:last-child) {\r\n      margin-bottom: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n.social-list-line {\r\n  position: relative;\r\n\r\n  &:not(:last-child):before {\r\n    border-left: solid 1px $gray-500;\r\n    content: \"\";\r\n    left: 20px;\r\n    position: absolute;\r\n    top: 5px;\r\n    bottom: 0;\r\n    width: 1px;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n\r\n.list-line-item {\r\n  position: relative;\r\n  padding-left: 40px;\r\n\r\n  &:not(:last-child):before {\r\n    border-left: solid 1px $gray-500;\r\n    content: \"\";\r\n    left: 20px;\r\n    position: absolute;\r\n    top: -25px;\r\n    bottom: -25px;\r\n    width: 1px;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.list-line-badge {\r\n  position: absolute;\r\n  left: 16px;\r\n  top: 15px;\r\n  z-index: 2;\r\n  @include border-radius(50%);\r\n  height: 10px;\r\n  width: 10px;\r\n  background-color: $gray-500;\r\n}\r\n\r\n.circle-shape {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  @include border-radius($border-radius-circle);\r\n}\r\n\r\n.project-list {\r\n  line-height: 1;\r\n\r\n  &:not(:last-child) {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  & .circle-shape {\r\n    margin-top: 4px;\r\n    margin-right: 16px;\r\n  }\r\n\r\n  & .project-name {\r\n    display: block;\r\n    margin-bottom: 4px;\r\n    color: $body-color;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $app-primary;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.nav-pill-sales {\r\n  & li + li {\r\n    margin-right: -1px;\r\n  }\r\n  & .nav-link {\r\n    background-color: $gray-200;\r\n    border-radius: 0;\r\n    padding: 6px 15px;\r\n    color: $gray-600;\r\n    font-size: 13px;\r\n    border: $jr-border;\r\n\r\n    &.active {\r\n      background-color: $app-primary;\r\n      color: $white;\r\n      border-color: $app-primary;\r\n\r\n      &:hover,\r\n      &:focus {\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n\r\n  & li:first-child .nav-link {\r\n    @include border-left-radius($border-radius);\r\n  }\r\n\r\n  & li:last-child .nav-link {\r\n    @include border-right-radius($border-radius);\r\n  }\r\n}\r\n\r\n.temp-week-list {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  color: lighten($gray-600, 8%);\r\n\r\n  & li:not(:last-child) {\r\n    margin-bottom: 10px;\r\n    @media screen and (max-width: 340px) {\r\n      margin-bottom: 20px;\r\n    }\r\n  }\r\n\r\n  & img {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n\r\n  & span {\r\n    display: inline-block;\r\n\r\n    &.temp-point {\r\n      margin: 0 20px;\r\n\r\n      @media screen and (max-width: 1199px) {\r\n        margin: 0 10px;\r\n      }\r\n\r\n      @media screen and (max-width: 1050px) {\r\n        margin: 0 5px;\r\n      }\r\n\r\n      @media screen and (max-width: 340px) {\r\n        margin: 0 20px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.temp-section {\r\n\r\n  .temp-point {\r\n    font-size: 36px;\r\n    font-weight: 700;\r\n    margin-bottom: 0;\r\n\r\n    & sub,\r\n    & sup {\r\n      font-size: 70%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n","/*Dropzone Styles*/\r\n.dropzone-card {\r\n  position: relative;\r\n}\r\n\r\n.dropzone {\r\n  margin-bottom: 20px;\r\n\r\n  & > div {\r\n    margin: 0 auto;\r\n    padding: 15px;\r\n    @include display-flex(flex, column, nowrap);\r\n    @include justify-content(center);\r\n\r\n    & :last-child {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  & .btn {\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n.upload-file-list {\r\n  list-style: none;\r\n  padding-left: 0;\r\n\r\n  & li {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.form-group-dropzone {\r\n  & label {\r\n    margin-bottom: 6px;\r\n  }\r\n\r\n  & .form-control {\r\n    max-width: 200px;\r\n    margin: 0 auto;\r\n  }\r\n}\r\n","/* Slider\r\n   ========================================================================== */\r\n.brand-logo {\r\n  @extend %thumb-equal;\r\n  border: 1px solid $gray-300;\r\n  background-color: $white;\r\n  @include border-radius($border-radius-lg);\r\n  margin-bottom: 20px;\r\n  padding-bottom: 75%;\r\n\r\n  & .brand-logo-inner {\r\n    @extend %thumb-cover;\r\n    text-align: center;\r\n\r\n    &:before {\r\n      content: \"\";\r\n      display: inline-block;\r\n      height: 100%;\r\n      vertical-align: middle;\r\n    }\r\n\r\n    & img {\r\n      height: auto;\r\n      max-height: 100%;\r\n      max-width: 100%;\r\n      display: inline-block;\r\n      vertical-align: middle;\r\n      width: auto !important;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    @include transition(all 0.4s ease-in-out 0.1s);\r\n    background-color: darken($white, 5%);\r\n  }\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n.owl-app-frame {\r\n  &.owl-carousel .owl-item img {\r\n    display: inline-block;\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.carousel-item {\r\n  & img {\r\n    max-width: 100%;\r\n  }\r\n}","/* Modules\r\n   ========================================================================== */\r\n@import \"app-module\";\r\n@import \"chat\";\r\n@import \"mail\";\r\n@import \"contact\";\r\n@import \"calendar\";","/* App Module Style */\r\n\r\n.app-wrapper-module {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include align-items(stretch);\r\n  height: 100%;\r\n}\r\n\r\n.app-module {\r\n  position: relative;\r\n  @include display-flex(flex, row, nowrap);\r\n  margin: -36px -40px 0 -40px;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    margin: -20px;\r\n  }\r\n}\r\n\r\n.module-side {\r\n  position: relative;\r\n  z-index: 2;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(0, 1, 230px);\r\n  max-width: 230px;\r\n  min-width: 230px;\r\n}\r\n\r\n.module-side-header {\r\n  border-bottom: solid 1px $gray-200;\r\n  @include display-flex(flex, column, nowrap);\r\n\r\n  & .user-detail {\r\n    padding: 15px 10px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.module-logo {\r\n  padding: 10px;\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(center);\r\n  min-height: 78px;\r\n  font-size: 20px;\r\n  background-color: lighten($gray-100, 0.5%);\r\n  color: darken($gray-800, 2%);\r\n  & .zmdi {\r\n    font-size: 28px;\r\n  }\r\n}\r\n\r\n.module-user-info {\r\n  @include display-flex(flex, column, nowrap);\r\n}\r\n\r\n.module-user-detail {\r\n  font-size: 12px;\r\n}\r\n\r\n.module-side-content {\r\n  @extend .module-user-info;\r\n}\r\n\r\n.module-add-task {\r\n  @include display-flex();\r\n  padding: 24px;\r\n}\r\n\r\n.module-nav {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n\r\n  & li {\r\n    @include display-flex(flex, column, nowrap);\r\n  }\r\n\r\n  & li a {\r\n    padding: 12px 29px;\r\n    color: lighten($body-color, 20%);\r\n    @include display-flex();\r\n    @include align-items(center);\r\n    text-decoration: none;\r\n\r\n    &:hover,\r\n    &:focus {\r\n      color: $body-color;\r\n    }\r\n\r\n    &.active {\r\n      color: $app-primary;\r\n    }\r\n  }\r\n\r\n  & li i {\r\n    margin-right: 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  & li span {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  & li.module-nav-label {\r\n    padding: 12px 29px;\r\n  }\r\n}\r\n\r\n.module-box {\r\n  position: relative;\r\n  z-index: 2;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(1, 1, auto);\r\n  max-width: calc(100% - 231px);\r\n}\r\n\r\n.module-box-header {\r\n  padding: 10px 26px;\r\n  min-height: 79px;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  background-color: $white;\r\n  border-bottom: solid 1px $gray-200;\r\n\r\n  & .search-bar.right-side-icon {\r\n    min-width: 350px;\r\n\r\n    & .form-control {\r\n      @include border-radius(0);\r\n      height: 46px;\r\n      padding: 10px 18px 10px 40px;\r\n\r\n      &:focus {\r\n        background-color: $gray-100;\r\n      }\r\n    }\r\n\r\n    & .search-icon {\r\n      width: 25px;\r\n      height: 46px;\r\n      font-size: 16px;\r\n      left: 10px;\r\n      top: 0;\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.module-box-header-inner {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  @include justify-content(space-between);\r\n}\r\n\r\n.module-box-content {\r\n  background-color: $white;\r\n  @include display-flex(flex, column, nowrap);\r\n}\r\n\r\n.module-box-topbar {\r\n  padding: 8px 12px;\r\n  @include display-flex();\r\n  border-bottom: solid 1px $gray-200;\r\n\r\n  & button + button {\r\n    @include border-radius(0);\r\n  }\r\n}\r\n\r\n.module-box-topbar-todo {\r\n  padding-left: 64px;\r\n\r\n  @media screen and (max-width: 575px) {\r\n    padding-left: 27px;\r\n  }\r\n}\r\n\r\n.module-list-icon {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  padding-right: 10px;\r\n}\r\n\r\n.bar-icon {\r\n  margin-right: 15px;\r\n}\r\n\r\n.toolbar-separator {\r\n  border-left: solid 1px $gray-400;\r\n  height: 100%;\r\n  width: 1px;\r\n  margin: 0 12px;\r\n}\r\n\r\n.toolbar-left {\r\n  margin-left: auto;\r\n}\r\n\r\n.module-list {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n}\r\n\r\n.module-list-item {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  padding: 15px 28px;\r\n  border-bottom: solid 1px $gray-200;\r\n  z-index: 5;\r\n  position: relative;\r\n  cursor: pointer;\r\n\r\n  & > .check-label {\r\n    margin-left: 0;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  &.mail-cell {\r\n    padding-left: 12px;\r\n    @include align-items(start);\r\n  }\r\n}\r\n\r\n.module-detail-header {\r\n  margin-bottom: 10px;\r\n\r\n  & > .check-label {\r\n    margin-right: auto;\r\n  }\r\n}\r\n\r\n.module-list-info {\r\n  @include flex(1, 1, 0);\r\n  @include display-flex(flex, column, nowrap);\r\n  max-width: calc(100% - 169px);\r\n}\r\n\r\n.module-todo-content {\r\n  position: relative;\r\n\r\n  & .subject {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.module-list-actions {\r\n  text-align: right;\r\n}\r\n\r\n.app-module-sidenav {\r\n  background-color: $white;\r\n  border-right: solid 1px $gray-200;\r\n  position: relative;\r\n  z-index: 9;\r\n\r\n  & .chat-sidenav-main {\r\n    max-width: 300px;\r\n    min-width: 300px;\r\n    width: 90%;\r\n  }\r\n}\r\n\r\n.module-date {\r\n  max-width: 160px;\r\n\r\n  & > div:before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.module-detail-item {\r\n  padding: 10px 28px;\r\n}\r\n\r\n.task-title {\r\n  font-size: 18px;\r\n}\r\n\r\n.chat-todo-avatar {\r\n  margin-right: 15px;\r\n}\r\n\r\n.modal-title {\r\n  @include display-flex();\r\n  @include justify-content(space-between);\r\n  @include align-items(center);\r\n  width: 100%;\r\n  font-size: 18px;\r\n}\r\n\r\n.loader-view-block {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n\r\n}\r\n\r\n.loader-view {\r\n  @extend .loader-view-block;\r\n}\r\n\r\n.module-date > div {\r\n  @include align-items(center);\r\n}\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .module-side {\r\n    @include display-flex(block, row, nowrap);\r\n    @include flex(1);\r\n    max-width: $side-nav-width;\r\n    min-width: $side-nav-width;\r\n    background-color: $white;\r\n  }\r\n\r\n  .module-box-header {\r\n    position: relative;\r\n    min-height: 58px;\r\n    padding: 5px 26px 5px 75px;\r\n\r\n    & .drawer-btn {\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      z-index: 1;\r\n      border-right: solid 1px $gray-200;\r\n      height: 58px;\r\n      width: 56px;\r\n      @include border-radius(0);\r\n      font-size: 22px;\r\n    }\r\n\r\n    & .search-bar.right-side-icon .form-control {\r\n      height: 38px;\r\n      padding: 5px 18px 5px 40px;\r\n    }\r\n\r\n    & .search-bar.right-side-icon .search-icon {\r\n      height: 38px;\r\n    }\r\n  }\r\n\r\n  .chat-loader-view {\r\n    height: calc(100vh - 120px);\r\n  }\r\n\r\n  .module-box {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 991px) {\r\n  .modal-dialog {\r\n    max-width: 750px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .app-module {\r\n    padding-top: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 599px) {\r\n  .module-box-header .search-bar {\r\n    margin-left: 0;\r\n    max-width: none;\r\n\r\n    &.right-side-icon {\r\n      min-width: 250px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .module-list-item {\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .module-list-info {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .module-box-header {\r\n    & .nav-searchbox.quick-menu .dropdown-menu {\r\n      right: auto !important;\r\n      left: 0 !important;\r\n    }\r\n\r\n    & .search-bar.right-side-icon {\r\n      min-width: 200px;\r\n\r\n      & .form-control {\r\n        @include border-radius(0.25rem);\r\n      }\r\n    }\r\n\r\n    & .nav-searchbox.quick-menu .dropdown-menu {\r\n      &:after {\r\n        right: auto;\r\n        left: 9px;\r\n      }\r\n\r\n      &:before {\r\n        right: auto;\r\n        left: 9px;\r\n      }\r\n    }\r\n\r\n    & .search-bar {\r\n      padding-right: 2px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .module-box-header {\r\n    & .search-bar.right-side-icon {\r\n      min-width: 100px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 399px) {\r\n  .d-xs-flex {\r\n    display: flex !important;\r\n  }\r\n}\r\n","/*Chat Module Styles*/\r\n\r\n.chat-module {\r\n  @include flex();\r\n\r\n  &:before {\r\n    left: -29px;\r\n  }\r\n}\r\n\r\n.chat-module-box {\r\n  @include display-flex(flex, row, nowrap);\r\n  @include flex(1);\r\n  background-color: $gray-100;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.chat-sidenav {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(0, 1, 315px);\r\n  min-width: 315px;\r\n  border-right: solid 1px $gray-200;\r\n}\r\n\r\n.chat-box {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include flex(1);\r\n  max-width: 100%;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.chat-sidenav-header {\r\n  @include display-flex(flex, column, nowrap);\r\n  padding: 25px 20px 12px;\r\n  background-color: lighten($gray-100, 0.5%);\r\n}\r\n\r\n.chat-user-hd {\r\n  @include display-flex();\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.chat-sidenav-header .search-wrapper {\r\n  @include display-flex(flex, column, nowrap);\r\n  margin-bottom: 0;\r\n\r\n  & .search-bar.right-side-icon {\r\n    @include flex();\r\n\r\n    & .form-control {\r\n      @include box-shadow(none);\r\n      @include border-radius(0);\r\n      padding-left: 42px;\r\n      height: 42px;\r\n    }\r\n\r\n    & .search-icon {\r\n      left: 10px;\r\n      top: 0;\r\n      height: 42px;\r\n      padding: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.chat-avatar {\r\n  min-width: $size-50;\r\n\r\n  .chat-user-item & {\r\n    padding: 0 5px;\r\n    min-width: 10px;\r\n  }\r\n\r\n  .chat-user-hd & {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.chat-avatar-mode {\r\n  position: relative;\r\n  max-width: $size-50;\r\n\r\n  & .chat-mode {\r\n    display: block;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 2px;\r\n    z-index: 1;\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 50%;\r\n\r\n    &.small {\r\n      width: 8px;\r\n      height: 8px;\r\n    }\r\n\r\n    &.online {\r\n      background-color: map_get($green, base);\r\n      @extend %online-effect;\r\n    }\r\n\r\n    &.offline {\r\n      background-color: $white;\r\n      border: solid 1px map_get($green, base);\r\n      @extend %online-effect;\r\n    }\r\n\r\n    &.away {\r\n      background-color: map_get($yellow, darken-1);\r\n      @extend %away-effect;\r\n    }\r\n  }\r\n\r\n  .chat-main-header-info & {\r\n    max-width: $size-60;\r\n  }\r\n}\r\n\r\n.chat-sidenav-content {\r\n  background-color: $white;\r\n}\r\n\r\n.chat-sidenav-title {\r\n  padding: 10px 16px;\r\n  font-size: $font-size-base;\r\n  color: $info;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n}\r\n\r\n.chat-tabs-header {\r\n  background-color: lighten($gray-100, 0.5%) !important;\r\n}\r\n\r\n.chat-user {\r\n  @include display-flex(flex, column, nowrap);\r\n\r\n  &.chat-user-center {\r\n    @include justify-content(center);\r\n    @include align-items(center);\r\n\r\n    & .chat-avatar {\r\n      margin-left: auto;\r\n    }\r\n  }\r\n}\r\n\r\n.chat-user-item {\r\n  border-bottom: solid 1px $gray-200;\r\n  padding: 16px;\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  cursor: pointer;\r\n  max-height: 96px;\r\n\r\n  &.active,\r\n  &:hover {\r\n    background-color: lighten($app-primary, 45%);\r\n  }\r\n}\r\n\r\n.chat-user-row {\r\n  margin: 0 -5px;\r\n  @include align-items(center);\r\n}\r\n\r\n.chat-info {\r\n  padding: 0 5px;\r\n\r\n  & p {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  & .h4 {\r\n    display: block;\r\n    margin-bottom: 3px;\r\n  }\r\n}\r\n\r\n.chat-info-des {\r\n  color: $gray-600;\r\n  font-size: 13px;\r\n}\r\n\r\n.chat-date {\r\n  padding: 0 5px;\r\n  text-align: right;\r\n}\r\n\r\n.chat-contact-col {\r\n  @extend .chat-info;\r\n}\r\n\r\n.chat-box-main {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  height: 100%;\r\n}\r\n\r\n.module-default {\r\n  @include display-flex(flex, column, nowrap);\r\n  @include justify-content(center);\r\n  @include align-items(center);\r\n  height: 100%;\r\n  padding: 15px;\r\n}\r\n\r\n.s-128 {\r\n  font-size: 128px !important;\r\n  width: 128px !important;\r\n  height: 128px !important;\r\n  line-height: 128px !important;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.chat-main {\r\n  @include display-flex(flex, column, nowrap);\r\n}\r\n\r\n.chat-main-header {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  border-bottom: solid 1px $gray-200;\r\n  padding: 16px;\r\n  background-color: $white;\r\n  width: 100%;\r\n}\r\n\r\n.chat-main-header-info {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n  margin-right: auto;\r\n}\r\n\r\n.chat-contact-name {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.chat-main-footer {\r\n  @include display-flex(flex, column, nowrap);\r\n  border-top: solid 1px $gray-200;\r\n  padding: 16px;\r\n  background-color: $white;\r\n  width: 100%;\r\n\r\n  & .form-group {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.todo-main-footer {\r\n  padding: 6px 16px;\r\n}\r\n\r\n.chat-item {\r\n  padding: 16px;\r\n\r\n  & .bubble {\r\n    padding: 8px 12px;\r\n    background-color: $white;\r\n    @include border-radius(20px 20px 20px 0px);\r\n    position: relative;\r\n    margin-left: 16px;\r\n    max-width: 600px;\r\n    border: solid 1px $gray-400;\r\n  }\r\n\r\n  &.flex-row-reverse {\r\n    & .bubble {\r\n      margin-right: 16px;\r\n      margin-left: 0;\r\n      background-color: lighten($app-primary, 45%);\r\n      @include border-radius(20px 20px 0 20px);\r\n    }\r\n  }\r\n}\r\n\r\n.chat-btn {\r\n  font-size: 38px !important;\r\n  margin: 0 10px 0 -8px;\r\n}\r\n\r\n.chat-textarea {\r\n  height: 40px;\r\n  @include box-shadow(none);\r\n  @include border-radius(0);\r\n}\r\n\r\n.last-message-time {\r\n  font-size: 11px;\r\n  color: $gray-500;\r\n}\r\n\r\n@media screen and (max-width: 1399px) {\r\n  .s-128 {\r\n    font-size: 100px !important;\r\n    width: 100px !important;\r\n    height: 100px !important;\r\n    line-height: 100px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1199px) {\r\n  .chat-module {\r\n    margin: -24px -29px -23px;\r\n    padding-top: 0;\r\n  }\r\n\r\n  .chat-main-header {\r\n    padding: 8px 24px;\r\n\r\n    & .size-60 {\r\n      height: 50px !important;\r\n      width: 50px !important;\r\n      line-height: 50px;\r\n    }\r\n\r\n    & button {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n\r\n  .chat-main-header-info {\r\n    & .chat-avatar-mode {\r\n      max-width: 50px;\r\n    }\r\n  }\r\n\r\n  .chat-contact-name,\r\n  .chat-sidenav-title {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat-main-footer {\r\n    padding: 8px 16px;\r\n  }\r\n\r\n  .s-128 {\r\n    font-size: 128px !important;\r\n    width: 128px !important;\r\n    height: 128px !important;\r\n    line-height: 128px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .s-128 {\r\n    font-size: 100px !important;\r\n    width: 100px !important;\r\n    height: 100px !important;\r\n    line-height: 100px !important;\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .chat-sidenav-title,\r\n  .chat-contact-name {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .s-128 {\r\n    font-size: 80px !important;\r\n    width: 80px !important;\r\n    height: 80px !important;\r\n    line-height: 80px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .module-default {\r\n    h1 {\r\n      font-size: 17px;\r\n    }\r\n  }\r\n  .s-128 {\r\n    font-size: 40px !important;\r\n    width: 40px !important;\r\n    height: 40px !important;\r\n    line-height: 40px !important;\r\n  }\r\n}\r\n\r\n","/*Mails Module Styles*/\r\n\r\n.module-box-row {\r\n  @include display-flex();\r\n  width: 100%;\r\n}\r\n\r\n.module-box-column {\r\n  @include display-flex(flex, column, nowrap);\r\n  width: 100%;\r\n}\r\n\r\n.mail-user-info {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n\r\n  & .avatar {\r\n    margin-right: 10px;\r\n  }\r\n\r\n  & .time,\r\n  & button {\r\n    margin-left: auto;\r\n  }\r\n\r\n  & .badge {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.module-list-item.mail-cell {\r\n  @include display-flex();\r\n}\r\n\r\n.mail-detail {\r\n  padding: 24px !important;\r\n}\r\n\r\n.mail-header {\r\n  @include display-flex();\r\n  @include align-items(center);\r\n}\r\n\r\n.mail-header-content {\r\n  @include display-flex(flex, column, nowrap);\r\n\r\n  & .subject {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n\r\n.show-detail {\r\n  cursor: pointer;\r\n}\r\n\r\n.text-truncate {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.module-list-content {\r\n  & .subject {\r\n    @extend .text-truncate;\r\n  }\r\n\r\n  & .message {\r\n    @include display-flex(flex, column, nowrap);\r\n    color: darken($gray-500, 10%);\r\n    font-size: 13px;\r\n\r\n    p {\r\n      @extend .text-truncate;\r\n      margin-bottom: 8px;\r\n    }\r\n  }\r\n}\r\n\r\n.size {\r\n  margin: 5px 0;\r\n}\r\n\r\n.sender-name {\r\n  margin-right: 0;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n}\r\n\r\n.mail-header-actions {\r\n  text-align: right;\r\n  min-width: 100px;\r\n  @include display-flex();\r\n\r\n  & .icon-btn:not(:last-child) {\r\n    margin-right: 3px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .module-list-item.mail-cell {\r\n    padding-right: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 576px) {\r\n  .mail-list {\r\n    @include flex(1, 1, auto);\r\n    max-width: 100%;\r\n    border-right: 0 none;\r\n  }\r\n\r\n  .mail-detail {\r\n    @include flex(1, 1, auto);\r\n    max-width: 100%;\r\n\r\n    & .module-list-scroll {\r\n      padding: 24px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 499px) {\r\n  .mail-header {\r\n    display: block;\r\n    @include align-items(flex-start);\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-flex-wrap: nowrap;\r\n    -ms-flex-wrap: nowrap;\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .mail-header-actions {\r\n    text-align: left;\r\n    min-width: 10px;\r\n  }\r\n\r\n  .MuiDialog-paperWidthSm-99 {\r\n    max-width: 250px !important;\r\n  }\r\n}","/*Contact Module Styles*/\r\n\r\n.contact-item {\r\n  @include align-items(center);\r\n  @include display-flex();\r\n  border-bottom: solid 1px $gray-200;\r\n  padding: 8px 12px;\r\n}\r\n\r\n.contact-name {\r\n  font-size: 15px;\r\n}\r\n\r\n.modal-box {\r\n  position: relative;\r\n}\r\n\r\n.modal-w {\r\n  max-width: 400px;\r\n  min-width: 350px;\r\n\r\n  .modal-box-mail & {\r\n    min-width: 600px;\r\n  }\r\n}\r\n\r\n.modal-box-header {\r\n  color: $white;\r\n  @include border-top-radius(4px);\r\n}\r\n\r\n.modal-box-header h2 {\r\n  color: $white;\r\n  position: relative;\r\n\r\n  & button {\r\n    position: absolute;\r\n    right: 0;\r\n    top: -10px;\r\n    z-index: 1;\r\n    color: $white;\r\n  }\r\n}\r\n\r\n.modal-box-content {\r\n  padding: 24px;\r\n\r\n  & .avatar {\r\n    margin: 0 auto;\r\n  }\r\n}\r\n\r\n.modal-box-footer {\r\n  padding: 0 24px 24px;\r\n\r\n  & .attach-file {\r\n    @include display-flex();\r\n    @include align-items(center);\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n.btn-fixed {\r\n  position: fixed !important;\r\n  right: 40px;\r\n  bottom: 60px;\r\n  z-index: 100;\r\n}\r\n\r\n.draggable-icon {\r\n  cursor: all-scroll;\r\n  color: $gray-600;\r\n\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    cursor: all-scroll;\r\n    color: $gray-900;\r\n  }\r\n}\r\n\r\n.module-side-nav {\r\n  padding: 20px 0;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .modal-w {\r\n    .modal-box-mail & {\r\n      min-width: 500px;\r\n    }\r\n  }\r\n\r\n  .modal-box-header h2 {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n  .modal-w {\r\n    min-width: 300px;\r\n\r\n    .modal-box-mail & {\r\n      min-width: 400px;\r\n    }\r\n  }\r\n\r\n  .modal-box-header h2 {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 419px) {\r\n  .modal-w {\r\n    min-width: 250px;\r\n\r\n    .modal-box-mail & {\r\n      min-width: 250px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 399px) {\r\n  .con-inf-mw-100 {\r\n    min-width: 100% !important;\r\n  }\r\n}\r\n","/* Calendar Module Style */\r\n\r\n.rbc-calendar {\r\n  .app-calendar & {\r\n    @include display-flex(flex, column, nowrap);\r\n    @include flex(1);\r\n    min-height: calc(100vh - 160px);\r\n  }\r\n\r\n  .app-cul-calendar & {\r\n    min-height: calc(100vh - 200px);\r\n  }\r\n}\r\n\r\n.rbc-event {\r\n  background-color: $app-primary;\r\n}\r\n\r\n.rbc-event.rbc-selected {\r\n  background-color: darken($app-primary, 10%);\r\n}\r\n\r\n.rbc-slot-selection {\r\n  background-color: rgba($app-primary, 0.7);\r\n}\r\n\r\n.rbc-toolbar button:active,\r\n.rbc-toolbar button.rbc-active {\r\n  color: $white;\r\n  background-image: none;\r\n  @include box-shadow(none);\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-toolbar button:active:hover,\r\n.rbc-toolbar button.rbc-active:hover,\r\n.rbc-toolbar button:active:focus,\r\n.rbc-toolbar button.rbc-active:focus {\r\n  color: $white;\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-toolbar button:focus {\r\n  color: $white;\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-toolbar button:hover {\r\n  color: $white;\r\n  background-color: rgba($app-primary, 0.9);\r\n  border-color: $app-primary;\r\n}\r\n\r\n.rbc-month-row {\r\n  min-height: 100px;\r\n}\r\n\r\n.rbc-event {\r\n  min-height: 50px;\r\n}\r\n\r\n@media screen and (max-width: 867px) {\r\n  .rbc-toolbar {\r\n    @include display-flex(flex, column, nowrap);\r\n    @include align-items(flex-start);\r\n  }\r\n\r\n  .rbc-toolbar .rbc-toolbar-label {\r\n    margin: 8px 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-height: 600px) {\r\n  .rbc-calendar {\r\n    .app-calendar & {\r\n      min-height: 400px;\r\n    }\r\n\r\n    .app-cul-calendar & {\r\n      min-height: 400px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 467px) {\r\n  .rbc-toolbar {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .rbc-toolbar button {\r\n    padding: 5px 10px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
